import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

export type AclAccess = ApplicationRecord & {
  __typename?: 'ACLAccess';
  aclTemplate?: Maybe<AclTemplateOptions>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  orgId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum AclTemplateOptions {
  Admin = 'ADMIN',
  JobManager = 'JOB_MANAGER',
  Personal = 'PERSONAL',
  ProPlus = 'PRO_PLUS'
}

export type AiAvailableConfigurations = {
  __typename?: 'AiAvailableConfigurations';
  /** A list of materials */
  materials?: Maybe<Array<AiMaterial>>;
  /** A list of paint colors */
  paintColors: Array<AiPaintColor>;
  /** Returns a list of available styles */
  styles?: Maybe<Array<Scalars['String']['output']>>;
};

export type AiDisplayImage = ApplicationRecord & {
  __typename?: 'AiDisplayImage';
  /** The AiGeneratedImage this AiDisplayImage points to */
  aiGeneratedImage: AiGeneratedImage;
  /** The AiOriginalImage this AiDisplayImage belongs to */
  aiOriginalImage?: Maybe<AiOriginalImage>;
  /** The ID of the AiOriginalImage this AiDisplayImage belongs to */
  aiOriginalImageId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The method by which this AiDisplayImage was created. One of "original", "style", or "favorite" */
  createdFrom: Scalars['String']['output'];
  /** Time at which the AiDisplayImage was favorited. If this field is null, it is not favorited */
  favoritedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the given AiDisplayImage */
  id: Scalars['Int']['output'];
  /**
   * Used to indicate that this AiDisplayImage has been soft deleted and replaced by another AiDisplayImage
   * by the reconciliation process. When an AiDisplayImage with created_from "favorite" is opened by the user
   * but a record with created_from "original" (or "style" exists) for the same edits, the created_from
   * "favorite" record is soft deleted and returned with the created_from "original" (or "style") record
   * populated in this field. Otherwise, this field is null.
   */
  replacedBy?: Maybe<AiDisplayImage>;
  /** Space type of the original image */
  spaceType?: Maybe<Scalars['String']['output']>;
  /** Style name of the generated image */
  style?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Paginated results for a given type */
export type AiDisplayImagePaginatedResults = {
  __typename?: 'AiDisplayImagePaginatedResults';
  pagination: Pagination;
  results: Array<Maybe<AiDisplayImage>>;
};

export type AiGeneratedImage = ApplicationRecord & {
  __typename?: 'AiGeneratedImage';
  /** ID of the AiOriginalImage that this AiGeneratedImage was generated from */
  aiOriginalImageId: Scalars['Int']['output'];
  /** Region statistics and segmentation SVGs for the generated image */
  aiSegmentation?: Maybe<AiSegmentation>;
  /** The Id of the AiGeneratedImage used as the base image input when generating this image */
  baseImageId?: Maybe<Scalars['Int']['output']>;
  clientStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The edits applied to this image */
  edits?: Maybe<AiImageEdits>;
  /** If the generated image has been favorited */
  favorite: Scalars['Boolean']['output'];
  /**
   *     If the generated image is from a sample ai original image. This represents
   * if the image is a "sample" that is editable from places
   *     like an embed. It is used to determine embed specific logic.
   */
  fromSample: Scalars['Boolean']['output'];
  /** Image url (or proxy url) for the generated image */
  generatedImagePath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Image url (standard field name for ai original images or ai generated images) */
  imagePath: Scalars['String']['output'];
  /** If the generated image originally came from a job image and is compatible with 3d fusion */
  is3dFusionCompatible: Scalars['Boolean']['output'];
  /**
   *     The metadata of the generated image optionally including the aggregate
   * edits of the image and base image. Metadata is not guaranteed to be present or
   * contain all keys.
   */
  metadata?: Maybe<AiImageMetadata>;
  pollingConsumerId?: Maybe<Scalars['String']['output']>;
  /** The regions detected in the image */
  regions?: Maybe<Scalars['JSON']['output']>;
  /** Space type of the generated image */
  spaceType?: Maybe<Scalars['String']['output']>;
  /** Status of the generated image ("done", "failed", or null if sitll processing) */
  status?: Maybe<Scalars['String']['output']>;
  /** Style name of the generated image */
  style: Scalars['String']['output'];
  /** Image url for the generated image, resized to a maximum dimension of 600px */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The URL for the watermarked variant of the generated image, only available as a subquery of ProjectShare */
  watermarkImageUrl?: Maybe<Scalars['String']['output']>;
};

/** Paginated results for a given type */
export type AiGeneratedImagePaginatedResults = {
  __typename?: 'AiGeneratedImagePaginatedResults';
  pagination: Pagination;
  results: Array<Maybe<AiGeneratedImage>>;
};

export type AiGeneratedWatermarkImage = ApplicationRecord & {
  __typename?: 'AiGeneratedWatermarkImage';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** Image url (standard field name for ai original images or ai generated images) */
  imagePath: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * A url for the watermarked version of the ai generated image, if the watermarked
   * version has not been processed yet, this will return the image url.
   */
  watermarkImageUrl?: Maybe<Scalars['String']['output']>;
};

export type AiImageEdits = {
  __typename?: 'AiImageEdits';
  /** Edits applied to cabinets */
  cabinet?: Maybe<AiImageRegionEdits>;
  /** Edits applied to the ceiling */
  ceiling?: Maybe<AiImageRegionEdits>;
  /** Edits applied to doors */
  door?: Maybe<AiImageRegionEdits>;
  /** Edits applied to fence */
  fence?: Maybe<AiImageRegionEdits>;
  /** Edits applied to the floors */
  floor?: Maybe<AiImageRegionEdits>;
  /** Edits applied to garage doors */
  garageDoor?: Maybe<AiImageRegionEdits>;
  /** Instance edits applied to the image */
  instances?: Maybe<Array<AiImageInstanceEdit>>;
  /** Edits applied to the roof */
  roof?: Maybe<AiImageRegionEdits>;
  /** The schema version of the edits data structure */
  schemaVersion: Scalars['Int']['output'];
  /** Edits applied to shutters */
  shutter?: Maybe<AiImageRegionEdits>;
  /** Edits applied to trim */
  trim?: Maybe<AiImageRegionEdits>;
  /** Edits applied to the walls */
  walls?: Maybe<AiImageWallEdits>;
  /** Edits applied to windows */
  windows?: Maybe<AiImageRegionEdits>;
};

export type AiImageInstanceEdit = {
  __typename?: 'AiImageInstanceEdit';
  /** Localized id of the instance represented as a rgb color */
  id: Scalars['String']['output'];
  /** Material applied to the instance */
  material?: Maybe<AiImageMaterialEdit>;
  /** Material class of the instance */
  materialClass: Scalars['String']['output'];
  /** Paint applied to the instance */
  paint?: Maybe<AiImagePaintEdit>;
  /** Surface class of the instance */
  surfaceClass: Scalars['String']['output'];
};

export type AiImageMaterialEdit = {
  __typename?: 'AiImageMaterialEdit';
  /** The color hex code of the material */
  hex?: Maybe<Scalars['String']['output']>;
  /** The name of the material */
  name: Scalars['String']['output'];
  /** The palette the material is categorized under */
  palette?: Maybe<Scalars['String']['output']>;
  /** Reference to a product catalog variation */
  productCatalogVariationUuid?: Maybe<Scalars['ID']['output']>;
  /** The path to a thumbnail of the material */
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type AiImageMetadata = {
  __typename?: 'AiImageMetadata';
  /** Aggregate edits applied to the image */
  allEdits?: Maybe<AiImageEdits>;
};

export type AiImagePaintEdit = {
  __typename?: 'AiImagePaintEdit';
  /** The color hex code of the paint */
  hex: Scalars['String']['output'];
  /** The manufacturer of the paint */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** The name of the paint */
  name?: Maybe<Scalars['String']['output']>;
  /** Reference to a product catalog variation */
  productCatalogVariationUuid?: Maybe<Scalars['ID']['output']>;
  /** A key used to get an ordering link to a paint sample from samplize */
  samplizeProductKey?: Maybe<Scalars['String']['output']>;
};

export type AiImageRegionEdits = {
  __typename?: 'AiImageRegionEdits';
  /** The material applied to a region */
  material?: Maybe<AiImageMaterialEdit>;
  /** The paint applied to a region */
  paint?: Maybe<AiImagePaintEdit>;
};

export type AiImageWallEdits = {
  __typename?: 'AiImageWallEdits';
  /** The material applied to walls */
  material?: Maybe<AiImageMaterialEdit>;
  /** The paint applied to walls */
  paint?: Maybe<AiImagePaintEdit>;
};

export type AiMaterial = {
  __typename?: 'AiMaterial';
  /** The color hex code of the material */
  hex: Scalars['String']['output'];
  /** The unique id of the material */
  id: Scalars['Int']['output'];
  /** Is the workflow 3d fusion */
  is3dFusion: Scalars['Boolean']['output'];
  /** The name of the material */
  name: Scalars['String']['output'];
  /** A list of palettes the material belongs to */
  palettes: Array<Scalars['String']['output']>;
  /**
   * The name of the prompt, this is used as a key to associate prompts to
   * product catalog variations
   */
  promptName: Scalars['String']['output'];
  /** A list of regions the material can be applied to (e.g. wall) */
  regions: Array<Scalars['String']['output']>;
  /** The name of the space this can be applied to (eg interior vs exterior) */
  spaceType: Scalars['String']['output'];
  /** The path to a thumbnail of the material */
  thumbnail: Scalars['String']['output'];
};

export type AiOriginalImage = ApplicationRecord & {
  __typename?: 'AiOriginalImage';
  /** AiDisplayImages associated with this AiOriginalImage */
  aiDisplayImages?: Maybe<Array<AiDisplayImage>>;
  /** AiGeneratedImages associated with this AiOriginalImage */
  aiGeneratedImages?: Maybe<Array<AiGeneratedImage>>;
  /** Metadata for the project that was created for this image, in the case of a pro created project */
  associatedProject?: Maybe<Project>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** Legacy image url field, Prefer using the "image_path" field. */
  image: Scalars['String']['output'];
  /** Image url (standard field name for ai original images or ai generated images) */
  imagePath: Scalars['String']['output'];
  /** Legacy image url (originally the location on the inspireme server) */
  inputPath: Scalars['String']['output'];
  /**
   *     If the original image is tied to an ai sample image. This represents if the
   * image is a "sample" that is editable from places
   *     like an embed. It is used to determine embed specific logic.
   */
  isSample: Scalars['Boolean']['output'];
  /** Indicates if the image is vertical or horizontal (portrait or landscape) */
  orientation?: Maybe<Scalars['String']['output']>;
  /** Image url (or proxy url) for the original image */
  originalImagePath: Scalars['String']['output'];
  /** Projects associated with this AiOriginalImage */
  projects?: Maybe<Array<Project>>;
  /** Spcae type of the original image */
  spaceType?: Maybe<Scalars['String']['output']>;
  /** Status of the original image */
  status?: Maybe<Scalars['String']['output']>;
  /** Status description of the original image */
  statusDescription?: Maybe<Scalars['String']['output']>;
  /** Image url for the original image, resized to a maximum dimension of 600px */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type AiOriginalImageAiDisplayImagesArgs = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};


export type AiOriginalImageAiGeneratedImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};

export type AiOriginalImagePlaceholder = {
  __typename?: 'AiOriginalImagePlaceholder';
  /** ID of the newly generated AiOriginalImage record */
  aiOriginalImageId?: Maybe<Scalars['Int']['output']>;
  /** Used to look up and associate attachment after succesful upload */
  signedId?: Maybe<Scalars['String']['output']>;
  /** Headers used for upload request */
  uploadHeaders?: Maybe<Scalars['String']['output']>;
  /** URL used for direct upload of image by client */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPaintColor = {
  __typename?: 'AiPaintColor';
  /** The color hex code of the paint */
  hex: Scalars['String']['output'];
  /** The unique id of the paint */
  id: Scalars['Int']['output'];
  /** The manufacturer of the paint */
  manufacturer: Scalars['String']['output'];
  /** The name of the paint */
  name: Scalars['String']['output'];
  /** A list of regions the paint can be applied to (e.g. wall) */
  paintRegions: Array<Scalars['String']['output']>;
  /** A list of palettes the paint belongs to */
  palettes: Array<Scalars['String']['output']>;
  /** A key used to get an ordering link to a paint sample from samplize */
  samplizeProductKey?: Maybe<Scalars['String']['output']>;
};

export type AiSegmentation = {
  __typename?: 'AiSegmentation';
  /** The unique id of the ai_segmentation */
  id: Scalars['Int']['output'];
  /**
   * An SVG representation of the segmentation with instance colors.
   * Colors do not correlate with region name.
   * Distinct regions of the same name will have the different colors.
   */
  instanceSvg?: Maybe<Scalars['String']['output']>;
  /** Statistics of the regions in the segmentation, includes bounding box, name, and appearance percentage information */
  regionStatistics?: Maybe<Scalars['String']['output']>;
  /**
   * An SVG representation of the segmentation with semantic class colors.
   * Distinct regions of the same name will have the same color.
   */
  semanticClassSvg?: Maybe<Scalars['String']['output']>;
};

export type AiSpaceTypes = {
  __typename?: 'AiSpaceTypes';
  /** The available space_types for image uploads */
  spaceTypes: Array<Scalars['String']['output']>;
};

export type AiStyleMetadata = {
  __typename?: 'AiStyleMetadata';
  /**
   * Contains metadata of the styles.  The returned schema looks like:
   * { [style: String!]: { style_name: String!, description: String } }
   */
  metadata: Scalars['JSON']['output'];
};

export type Album = {
  __typename?: 'Album';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  files?: Maybe<Array<AlbumFile>>;
  id: Scalars['ID']['output'];
  jobId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AlbumFile = {
  __typename?: 'AlbumFile';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  file?: Maybe<Media>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /**
   * snappedHeight + 5 inches to account for sash (only for windows with 'W-'
   * name).For other annotation types, this equals to snapped_height. (Unit: inch)
   */
  adjustedHeight: Scalars['Float']['output'];
  /**
   * snappedWidth + 5 inches to account for sash (only for windows with 'W-'
   * name).For other annotation types, this equals to snapped_width. (Unit: inch)
   */
  adjustedWidth: Scalars['Float']['output'];
  /** Database id */
  annotationId: Scalars['ID']['output'];
  /**
   * Actual area of the annotation, as opposed to width x height.For reclangular
   * annotations, this should equal original_width x original_height. (Unit: sqin)
   */
  area: Scalars['Float']['output'];
  /** e.g. Door -> Door Package */
  directFace: Face;
  includeInMeasurements?: Maybe<Scalars['Boolean']['output']>;
  /** e.g. Door -> Siding (via door package) */
  indirectFaces?: Maybe<Array<Face>>;
  labels?: Maybe<Array<Label>>;
  name?: Maybe<Scalars['String']['output']>;
  /** origianl height on 3D model. (Unit: inch) */
  originalHeight: Scalars['Float']['output'];
  /** origianl width on 3D model. (Unit: inch) */
  originalWidth: Scalars['Float']['output'];
  partialAnnotations?: Maybe<Array<PartialAnnotation>>;
  productId: Scalars['Int']['output'];
  /**
   * Windows: snapped height to other windows with a similar dimension;Doors:
   * snapped height to the closest standard door size.If no annotations with
   * similar sizes are found, this equals to original_height (Unit: inch)
   */
  snappedHeight: Scalars['Float']['output'];
  /**
   * Windows: snapped width to other windows with a similar dimension;Doors:
   * snapped width to the closest standard door size.If no annotations with similar
   * sizes are found, this equals to original_width (Unit: inch)
   */
  snappedWidth: Scalars['Float']['output'];
  /** Unique id assigned randomely to all annotations in the model.Sort index Can be found in skp as well */
  sortIndex: Scalars['Int']['output'];
};

export type ApplicationRecord = {
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ApplicationRecordUuid = {
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AppliedDiscount = ApplicationRecord & {
  __typename?: 'AppliedDiscount';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  details: Array<Scalars['String']['output']>;
  expiration: Scalars['String']['output'];
  /** Determines if the discount can still be used */
  expired: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Human readable created at */
  redeemedOn: Scalars['String']['output'];
  /** Remaining number of jobs this discount can be used for. Null means there is no limit. */
  remainingJobsCount?: Maybe<Scalars['Int']['output']>;
  /** Determines if the partner subsidizes the discount */
  subsidy: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Area = {
  __typename?: 'Area';
  /** Combinded area of all facades in order. */
  facades: AreaBy;
  /** Combinded area of all openings in order. */
  openings: AreaBy;
  /** Combinded area of all facades in order. */
  total: AreaBy;
  /** Combinded area of all trim facades in order. */
  trim: AreaBy;
  /** Combinded area of all unknown facades in order. */
  unknown?: Maybe<AreaBy>;
};

export type AreaBy = {
  __typename?: 'AreaBy';
  /** Area of given type that is not siding. */
  other: Scalars['Int']['output'];
  /** Area of given type that is siding. */
  siding: Scalars['Int']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  /** Original full quality url of the file. */
  blobUrl: Scalars['String']['output'];
  byteSize: Scalars['String']['output'];
  checksum: Scalars['String']['output'];
  /** The MIME type of the file. */
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Returns a thumbnail url for the file. */
  thumbUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * The changeset of an update to an attribute. If a widget's name
 *     changed from foo to bar, `attribute` will equal `name`, `old_value` will
 *     equal `foo`, and `new_value` will equal `bar`.
 */
export type AttributeChange = {
  __typename?: 'AttributeChange';
  attributeName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type AuthenticateWithMagicLinkArgs = {
  /** The identifier of the magic link to authenticate with */
  id: Scalars['ID']['input'];
  /** The magic link token to authenticate with */
  token: Scalars['String']['input'];
};

export type AuthenticationInfo = {
  __typename?: 'AuthenticationInfo';
  emailInUse: Scalars['Boolean']['output'];
  ssoEnabled: Scalars['Boolean']['output'];
  ssoSpSigninUrl?: Maybe<Scalars['String']['output']>;
  ssoStrictModeEnabled: Scalars['Boolean']['output'];
};

export type AuthenticationResponse = {
  __typename?: 'AuthenticationResponse';
  jwt: Jwt;
  user: User;
};

export type BasePrice = ApplicationRecord & {
  __typename?: 'BasePrice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  goodType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  partnerSubsidy: Scalars['Int']['output'];
  planId: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type BeaconUser = {
  __typename?: 'BeaconUser';
  beacon_org: Scalars['Boolean']['output'];
  beacon_user: Scalars['Boolean']['output'];
  response: Scalars['Boolean']['output'];
};

export type BeaconUserInput = {
  email: Scalars['String']['input'];
};

export type BillableWallet = {
  __typename?: 'BillableWallet';
  allowedGoodTypes: Array<Scalars['String']['output']>;
  externalIdentifierPatterns?: Maybe<Array<ExternalIdentifierPattern>>;
  org: OrgBasicInfo;
  partnerAccountIdentifiers?: Maybe<Array<PartnerAccountIdentifier>>;
  preferred: Scalars['Boolean']['output'];
  shared: Scalars['Boolean']['output'];
  walletId: Scalars['Int']['output'];
};

export type BlueprintSubmission = {
  __typename?: 'BlueprintSubmission';
  buildAll: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fileAttachments: Array<FileAttachment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  state?: Maybe<BlueprintSubmissionStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

/** Paginated results for a given type */
export type BlueprintSubmissionPaginatedResults = {
  __typename?: 'BlueprintSubmissionPaginatedResults';
  pagination: Pagination;
  results: Array<Maybe<BlueprintSubmission>>;
};

export enum BlueprintSubmissionStates {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Failed = 'FAILED'
}

/**
 * All URLs here are signed S3 URLs for downloading a logo's image with different
 * dimensions or format. Image dimensions are in pixels. Image format is PNG.
 */
export type Brand = ApplicationRecord & {
  __typename?: 'Brand';
  clientBrandingLogoUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /**
   * Dimensions: 200x35
   * <br />
   * Format: png
   */
  logoNonretinaUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 400x70
   * <br />
   * Format: png
   */
  logoRetinaUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 115x20
   * <br />
   * Format: png
   */
  logoThumbUrl?: Maybe<Scalars['String']['output']>;
  /**
   * This field generates a URL which can be used to upload a brand's logo. Only
   * png files are supported. The link expires 10 minutes after being created.
   */
  logoUploadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  mmsConnectInitialUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  mmsConnectReminderUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  placesLogoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  tertiaryColor?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type BulkBackgroundJob = {
  __typename?: 'BulkBackgroundJob';
  id: Scalars['ID']['output'];
  /** A presigned URL to upload a CSV file. HTTP method is Put. */
  presignedUrl: Scalars['String']['output'];
};

export enum CameraIndices {
  Back = 'BACK',
  BackLeft = 'BACK_LEFT',
  BackRight = 'BACK_RIGHT',
  Front = 'FRONT',
  FrontLeft = 'FRONT_LEFT',
  FrontRight = 'FRONT_RIGHT',
  Roof = 'ROOF'
}

export type CameraInput = {
  aspect?: InputMaybe<Scalars['Float']['input']>;
  fov?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<CameraVectorInput>;
  rotation?: InputMaybe<CameraVectorInput>;
};

export type CameraVectorInput = {
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
  z?: InputMaybe<Scalars['Float']['input']>;
};

export type CaptureExpectationsCheckResult = {
  __typename?: 'CaptureExpectationsCheckResult';
  /**
   * Result of this check, indicating if we should request that the user perform an
   * additional capture step with AR-data as a reference for scaling
   */
  resultReferenceCapture: CaptureExpectationsResultReferenceCaptureOptions;
};

export enum CaptureExpectationsResultReferenceCaptureOptions {
  Pending = 'PENDING',
  RequestReferenceCapture = 'REQUEST_REFERENCE_CAPTURE',
  SkipReferenceCapture = 'SKIP_REFERENCE_CAPTURE'
}

/** Location arguments for capture expectations check */
export type CaptureLocationArgs = {
  /** Address of capture in-progress. Expected be parseable by Google Geocoding */
  address: Scalars['String']['input'];
  /**
   * This is any arbitrary string that clients want to use to identify jobs.
   * Clients in this case means the actual software clients that are uploading the
   * job. For example: mobile applications, website, and any software that 3rd
   * parties build to interact with our system. This is typically used to help with
   * the uploading process. Our uploading process is asyncronous and does not
   * return a Job ID when you upload. Including a client_identifier in your upload
   * and checking the client identifier of new jobs that enter your account is the
   * only way to match up what you uploaded with the resulting job. The given value
   * must be globally unique.
   */
  clientIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** True if the contractor has checked the box to remind them to contact the customer. Default is false. */
  customerContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the contractor has checked the box to only contact the customer by email. Default is false. */
  customerContactOnlyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address of the customer. Usually the homeowner. */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer. Usually the homeowner. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** If present, a new Note will be created for this job with the given body */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the customer. Usually the homeowner. */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Refer to 'available_deliverables' in the 'Org' object. */
  deliverableId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** GPS coordinates latitude */
  latitude: Scalars['String']['input'];
  /** The city of this job's address. */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  /** The country of the job's address. */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  /** The latitude of the job's address. */
  locationLat?: InputMaybe<Scalars['String']['input']>;
  /** First line of this job's address. */
  locationLine1?: InputMaybe<Scalars['String']['input']>;
  /** Second line of this job's address. */
  locationLine2?: InputMaybe<Scalars['String']['input']>;
  /** The longitude of the job's address. */
  locationLon?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the job's address. */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state/region of this job's address. */
  locationRegion?: InputMaybe<Scalars['String']['input']>;
  /** GPS coordinates longitude */
  longitude: Scalars['String']['input'];
  /** A name for this job. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Account identifier used by external partner. Will be persisted to allow correct party (org or partner) to be billed */
  partnerAccountIdentifier?: InputMaybe<Scalars['Int']['input']>;
  /** If present, and project id exists, the job will be associated with the project */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of property this job is for. Possible values are SINGLE_FAMILY_RESIDENTIAL, MULTI_FAMILY_RESIDENTIAL, COMMERCIAL */
  propertyType?: InputMaybe<JobPropertyTypes>;
  /** Deprecated. This will always set to false. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set to true, all emails (including capture request emails) related to this job will be suppressed. Default is false. */
  suppressEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This optional parameter causes a job to be a "test" job and to skip our
   * processing pipeline. "COMPLETE" auto completes your job with example results.
   * "FAILED" automatically fails the job. This parameter should not be used on real jobs.
   */
  testState?: InputMaybe<JobTestStates>;
  /** Set the wallet_id to use for this job. Refer to 'billableWallets' in the 'Org' object. */
  walletId?: InputMaybe<Scalars['Int']['input']>;
};

export type CaptureRequest = ApplicationRecord & {
  __typename?: 'CaptureRequest';
  branchLink?: Maybe<Scalars['String']['output']>;
  capturingUser?: Maybe<UserBasicInfo>;
  capturingUserEmail: Scalars['String']['output'];
  capturingUserName: Scalars['String']['output'];
  capturingUserPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayRequestingOrg?: Maybe<OrgBasicInfo>;
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  requestingUser?: Maybe<UserBasicInfo>;
  requestingUserSplitFlags?: Maybe<Scalars['JSON']['output']>;
  signupType: CaptureRequestSignupTypes;
  state?: Maybe<CaptureRequestStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for job attributes when creating a capture request */
export type CaptureRequestJobArgs = {
  /**
   * The capture type of a job.
   * Possible values are SPARSE_EXTERIOR, DENSE_EXTERIOR, DENSE_INTERIOR, ROOMPLAN_INTERIOR, VIDEO_INTERIOR
   */
  captureType?: InputMaybe<JobCaptureTypes>;
  /**
   * This is any arbitrary string that clients want to use to identify jobs.
   * Clients in this case means the actual software clients that are uploading the
   * job. For example: mobile applications, website, and any software that 3rd
   * parties build to interact with our system. This is typically used to help with
   * the uploading process. Our uploading process is asyncronous and does not
   * return a Job ID when you upload. Including a client_identifier in your upload
   * and checking the client identifier of new jobs that enter your account is the
   * only way to match up what you uploaded with the resulting job. The given value
   * must be globally unique.
   */
  clientIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** True if the contractor has checked the box to remind them to contact the customer. Default is false. */
  customerContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the contractor has checked the box to only contact the customer by email. Default is false. */
  customerContactOnlyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address of the customer. Usually the homeowner. */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer. Usually the homeowner. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** If present, a new Note will be created for this job with the given body */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the customer. Usually the homeowner. */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Refer to 'available_deliverables' in the 'Org' object. */
  deliverableId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The city of this job's address. */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  /** The country of the job's address. */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  /** The latitude of the job's address. */
  locationLat?: InputMaybe<Scalars['String']['input']>;
  /** First line of this job's address. */
  locationLine1: Scalars['String']['input'];
  /** Second line of this job's address. */
  locationLine2?: InputMaybe<Scalars['String']['input']>;
  /** The longitude of the job's address. */
  locationLon?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the job's address. */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state/region of this job's address. */
  locationRegion?: InputMaybe<Scalars['String']['input']>;
  /** A name for this job. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Account identifier used by external partner. Will be persisted to allow correct party (org or partner) to be billed */
  partnerAccountIdentifier?: InputMaybe<Scalars['Int']['input']>;
  /** If present, and project id exists, the job will be associated with the project */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of property this job is for. Possible values are SINGLE_FAMILY_RESIDENTIAL, MULTI_FAMILY_RESIDENTIAL, COMMERCIAL */
  propertyType?: InputMaybe<JobPropertyTypes>;
  /** Deprecated. This will always set to false. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set to true, all emails (including capture request emails) related to this job will be suppressed. Default is false. */
  suppressEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This optional parameter causes a job to be a "test" job and to skip our
   * processing pipeline. "COMPLETE" auto completes your job with example results.
   * "FAILED" automatically fails the job. This parameter should not be used on real jobs.
   */
  testState?: InputMaybe<JobTestStates>;
  /** Set the wallet_id to use for this job. Refer to 'billableWallets' in the 'Org' object. */
  walletId?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is provided. */
export type CaptureRequestPaginatedResults = {
  __typename?: 'CaptureRequestPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<CaptureRequest>>;
};

export enum CaptureRequestSignupTypes {
  Homeowner = 'HOMEOWNER',
  Pro = 'PRO'
}

export enum CaptureRequestStates {
  Complete = 'COMPLETE',
  Connected = 'CONNECTED',
  New = 'NEW'
}

export type CaptureSession = {
  __typename?: 'CaptureSession';
  token: Scalars['String']['output'];
};

/** Autogenerated return type of ChecklistQuestionFileUploadCreate. */
export type ChecklistQuestionFileUploadCreatePayload = {
  __typename?: 'ChecklistQuestionFileUploadCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  fileUpload?: Maybe<InspectionChecklistQuestionFileUpload>;
};

/** Autogenerated return type of ChecklistTemplateArchive. */
export type ChecklistTemplateArchivePayload = {
  __typename?: 'ChecklistTemplateArchivePayload';
  checklistTemplate?: Maybe<InspectionConfigChecklistTemplate>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateCopy. */
export type ChecklistTemplateCopyPayload = {
  __typename?: 'ChecklistTemplateCopyPayload';
  checklistTemplate?: Maybe<InspectionConfigChecklistTemplate>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateCreate. */
export type ChecklistTemplateCreatePayload = {
  __typename?: 'ChecklistTemplateCreatePayload';
  checklistTemplate?: Maybe<InspectionConfigChecklistTemplate>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateQuestionCreate. */
export type ChecklistTemplateQuestionCreatePayload = {
  __typename?: 'ChecklistTemplateQuestionCreatePayload';
  checklistTemplateQuestion?: Maybe<InspectionConfigChecklistTemplateQuestion>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateQuestionDelete. */
export type ChecklistTemplateQuestionDeletePayload = {
  __typename?: 'ChecklistTemplateQuestionDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateQuestionUpdate. */
export type ChecklistTemplateQuestionUpdatePayload = {
  __typename?: 'ChecklistTemplateQuestionUpdatePayload';
  checklistTemplateQuestion?: Maybe<InspectionConfigChecklistTemplateQuestion>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateQuestionsSortOrderUpdate. */
export type ChecklistTemplateQuestionsSortOrderUpdatePayload = {
  __typename?: 'ChecklistTemplateQuestionsSortOrderUpdatePayload';
  checklistTemplateSection?: Maybe<InspectionConfigChecklistTemplateSection>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateSectionCreate. */
export type ChecklistTemplateSectionCreatePayload = {
  __typename?: 'ChecklistTemplateSectionCreatePayload';
  checklistTemplateSection?: Maybe<InspectionConfigChecklistTemplateSection>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateSectionDelete. */
export type ChecklistTemplateSectionDeletePayload = {
  __typename?: 'ChecklistTemplateSectionDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateSectionUpdate. */
export type ChecklistTemplateSectionUpdatePayload = {
  __typename?: 'ChecklistTemplateSectionUpdatePayload';
  checklistTemplateSection?: Maybe<InspectionConfigChecklistTemplateSection>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateSectionsSortOrderUpdate. */
export type ChecklistTemplateSectionsSortOrderUpdatePayload = {
  __typename?: 'ChecklistTemplateSectionsSortOrderUpdatePayload';
  checklistTemplate?: Maybe<InspectionConfigChecklistTemplate>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplateUpdate. */
export type ChecklistTemplateUpdatePayload = {
  __typename?: 'ChecklistTemplateUpdatePayload';
  checklistTemplate?: Maybe<InspectionConfigChecklistTemplate>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistTemplatesDefaultsCreate. */
export type ChecklistTemplatesDefaultsCreatePayload = {
  __typename?: 'ChecklistTemplatesDefaultsCreatePayload';
  createdChecklistTemplatesCount: Scalars['Int']['output'];
};

/** Autogenerated return type of ChecklistUpsert. */
export type ChecklistUpsertPayload = {
  __typename?: 'ChecklistUpsertPayload';
  checklist?: Maybe<InspectionChecklist>;
  /** Validation Errors */
  errors: Array<Error>;
};

export enum Complexities {
  Average = 'AVERAGE',
  Complex = 'COMPLEX',
  Simple = 'SIMPLE'
}

export type Consent = ApplicationRecord & {
  __typename?: 'Consent';
  consentPolicy: ConsentPolicy;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasConsent: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a consent */
export type ConsentArgs = {
  /** True if the user accepts the consent policy */
  hasConsent: Scalars['Boolean']['input'];
  /** The ID of Consent for updating one that exists already */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of consent policy shown to the user. */
  policyId: Scalars['Int']['input'];
  /** Arbitrary string used to identify where consent was given. Ex. `mobile:signup:phoneForm`. */
  source: Scalars['String']['input'];
};

export type ConsentPolicy = ApplicationRecord & {
  __typename?: 'ConsentPolicy';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ConsentPolicyKinds {
  OneTimeSms = 'ONE_TIME_SMS',
  Sms = 'SMS',
  SubscriptionAgreement = 'SUBSCRIPTION_AGREEMENT',
  TermsOfUse = 'TERMS_OF_USE'
}

export type CornerData = {
  __typename?: 'CornerData';
  /** Combinded length of inside corners. */
  insideLength: Scalars['Float']['output'];
  /** Count of inside corners. */
  insideNumber: Scalars['Int']['output'];
  /** Combinded length of outside corners. */
  outsideLength: Scalars['Float']['output'];
  /** Count of outside corners. */
  outsideNumber: Scalars['Int']['output'];
};

export type CorniceData = {
  __typename?: 'CorniceData';
  /** Individual group data */
  strips: Array<RoofFeatureData>;
  /** Cumulative feature data */
  totals: RoofFeatureData;
};

/** Arguments for creating an ai original image */
export type CreateAiOriginalImageArgs = {
  agreedToTerms: Scalars['Boolean']['input'];
  aiOriginalImageId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  imageFlexibility: Scalars['Float']['input'];
  imageSignedId: Scalars['String']['input'];
  intensity: Scalars['Int']['input'];
  /** Attributes to create a new project to add the image to */
  project?: InputMaybe<NewProjectArgs>;
  /** Project id to associate the image with, will take precedence over project argument */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  style: Scalars['String']['input'];
};

export type CreateAlbumFile = AlbumFile | CreateAlbumFileError;

export type CreateAlbumFileError = {
  __typename?: 'CreateAlbumFileError';
  /** The blob id of the file that failed to be added to the album. */
  blobId: Scalars['String']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type CreateAlbumFilesPayload = {
  __typename?: 'CreateAlbumFilesPayload';
  /** The album to which the files belong. */
  album: Album;
  /** A list of files belonging to albums. */
  files: Array<CreateAlbumFile>;
};

/** Arguments for creating or updating an album */
export type CreateOrUpdateAlbumWithFilesArgs = {
  /** The signed id of the blob(s) to upload. */
  blobIds: Array<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /** Determines if the mutation should update and insert or insert only. */
  upsert?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CryptomatteRegion = {
  __typename?: 'CryptomatteRegion';
  category: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
};

export type CryptomatteRegions = {
  __typename?: 'CryptomatteRegions';
  regions: Array<CryptomatteRegion>;
  v: Scalars['Int']['output'];
};

/** Arguments for creating a painted AiGeneratedImage */
export type CustomizeAiImageArgs = {
  /** The generated image to customize */
  aiGeneratedImageId: Scalars['Int']['input'];
  /** The name of the material prompt to generate an image */
  aiPromptName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the client making the request */
  appId: Scalars['String']['input'];
  /** The instances to customize */
  instances?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The id of the material queried from AiAvailableConfigurations */
  materialId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the color queried from AiAvailableConfigurations */
  paintColorId?: InputMaybe<Scalars['Int']['input']>;
  /** A hex color for paint image generation */
  paintHexColor?: InputMaybe<Scalars['String']['input']>;
  /** Reference to a product catalog variation */
  productCatalogVariationUuid?: InputMaybe<Scalars['ID']['input']>;
  /** The region to customize */
  region: Scalars['String']['input'];
};

export type DeleteAlbumFilesPayload = {
  __typename?: 'DeleteAlbumFilesPayload';
  /** A list of files that were destroyed. */
  files: Array<AlbumFile>;
};

export type Deliverable = ApplicationRecord & {
  __typename?: 'Deliverable';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DeliverableChangeRequest = ApplicationRecord & {
  __typename?: 'DeliverableChangeRequest';
  /** Time of this change happened at. */
  changedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Error message if this change request failed. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Deliverable that this request will change to. */
  newDeliverable?: Maybe<Deliverable>;
  /** Deliverable that this request will change from. */
  oldDeliverable?: Maybe<Deliverable>;
  state?: Maybe<DeliverableChangeRequestStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user that created this request. */
  user?: Maybe<UserBasicInfo>;
};

export enum DeliverableChangeRequestStates {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  FirstAttempt = 'FIRST_ATTEMPT',
  SecondAttempt = 'SECOND_ATTEMPT',
  WaitingForJobToFinish = 'WAITING_FOR_JOB_TO_FINISH',
  WaitingForNewDeliverable = 'WAITING_FOR_NEW_DELIVERABLE'
}

export enum DeliverableDeliverySpeeds {
  Rush = 'RUSH',
  Standard = 'STANDARD'
}

export type DesignOrder = {
  __typename?: 'DesignOrder';
  /** Additional details */
  additionalDetails?: Maybe<Scalars['String']['output']>;
  /** Color palette to be applied */
  colorPalette?: Maybe<Scalars['String']['output']>;
  /** Scope items to be done */
  scopeItems: Array<ScopeItem>;
  /** Style to be applied */
  style?: Maybe<Scalars['String']['output']>;
  /** Views of home */
  views: Array<Scalars['String']['output']>;
};

export type DesignOrderInput = {
  /** Additional details */
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Color palette to be applied */
  colorPalette?: InputMaybe<Scalars['String']['input']>;
  /** Scope items to be done */
  scopeItems: Array<ScopeItemInput>;
  /** Style to be applied */
  style?: InputMaybe<Scalars['String']['input']>;
  /** Views of home */
  views: Array<Scalars['String']['input']>;
};

export type DesignOrderResponse = {
  __typename?: 'DesignOrderResponse';
  designOrders?: Maybe<Array<DesignOrder>>;
  /** Package type selected */
  packageType?: Maybe<Scalars['String']['output']>;
};

export type DesignOrderResponseInput = {
  /** Design orders */
  designOrders: Array<DesignOrderInput>;
  /** Images associated with design order */
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Package type */
  packageType?: InputMaybe<Scalars['String']['input']>;
};

export type DesignOrderSummary = {
  __typename?: 'DesignOrderSummary';
  designOrderResponse?: Maybe<DesignOrderResponse>;
  jobId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['Int']['output'];
  requestingUserId: Scalars['Int']['output'];
  versionType?: Maybe<RenderingVersion>;
};

export type DesignStudioColor = {
  __typename?: 'DesignStudioColor';
  color: Scalars['String']['output'];
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  trim?: Maybe<Scalars['Boolean']['output']>;
};

export type DesignStudioProductData = {
  __typename?: 'DesignStudioProductData';
  colors?: Maybe<Array<DesignStudioColor>>;
  textures?: Maybe<Array<DesignStudioTexture>>;
  windowColors?: Maybe<Array<DesignStudioColor>>;
};

export type DesignStudioTexture = {
  __typename?: 'DesignStudioTexture';
  category: Scalars['String']['output'];
  colorGroup?: Maybe<Scalars['String']['output']>;
  hasThumbnail?: Maybe<Scalars['Boolean']['output']>;
  isPopular?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shape?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  textureId: Scalars['Int']['output'];
  textureType?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum DesignStudioThemeEnum {
  Default = 'default',
  JamesHardie = 'james_hardie',
  JamesHardieWithMagnolia = 'james_hardie_with_magnolia'
}

/** Autogenerated return type of DiscountCreate. */
export type DiscountCreatePayload = {
  __typename?: 'DiscountCreatePayload';
  discount?: Maybe<EstimationDiscount>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of DiscountDelete. */
export type DiscountDeletePayload = {
  __typename?: 'DiscountDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of DiscountUpdate. */
export type DiscountUpdatePayload = {
  __typename?: 'DiscountUpdatePayload';
  discount?: Maybe<EstimationDiscount>;
  /** Validation Errors */
  errors: Array<Error>;
};

export enum DistributionAuthenticationConnectionStrategyEnum {
  CustomerAuthorizationCode = 'CUSTOMER_AUTHORIZATION_CODE',
  Oauth = 'OAUTH'
}

/**
 * All of the Branches at this distributor that org is able to order from.  A
 * branch usually represents a warehouse or region for a product distributor. All
 * of the data here comes from the Distributor's API.
 */
export type DistributionBranch = {
  __typename?: 'DistributionBranch';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  defaultJobAccount?: Maybe<DistributionJobAccount>;
  /** The DistributionBranch that this DistributionApprovedBranch belongs to. */
  distributionBranchId?: Maybe<Scalars['ID']['output']>;
  distributor: ProductCatalogDistributor;
  email?: Maybe<Scalars['String']['output']>;
  /** The value we need to send to the distributor when using this branch in an API call like order submission. */
  externalIdentifier: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobAccounts: Array<DistributionJobAccount>;
  /** The name of this Branch. */
  name: Scalars['String']['output'];
  /** The org this branch belongs to. */
  orgId: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Contains information about which delivery types are available for a distributor */
export type DistributionDelivery = ApplicationRecordUuid & {
  __typename?: 'DistributionDelivery';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A value from distribution_delivery_types_enum representing the generic delivery type */
  deliveryType: DistributionDeliveryTypeEnum;
  id: Scalars['ID']['output'];
  /** The label for clients to display to users when showing this delivery type for this distributor */
  label: Scalars['String']['output'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Contains information about which delivery methods are available for a distributor */
export type DistributionDeliveryMethod = ApplicationRecordUuid & {
  __typename?: 'DistributionDeliveryMethod';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A value from distribution_delivery_methods_enum representing the generic delivery method */
  deliveryMethod: DistributionDeliveryMethodEnum;
  id: Scalars['ID']['output'];
  /** The label for clients to display to users when showing this delivery method for this distributor */
  label: Scalars['String']['output'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum DistributionDeliveryMethodEnum {
  BranchPickUp = 'BRANCH_PICK_UP',
  DeliverToAddress = 'DELIVER_TO_ADDRESS',
  OnHold = 'ON_HOLD'
}

/** Contains information about which delivery times are available for a distributor */
export type DistributionDeliveryTime = ApplicationRecordUuid & {
  __typename?: 'DistributionDeliveryTime';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A value from distribution_delivery_times_enum representing the generic delivery time */
  deliveryTime: DistributionDeliveryTimeEnum;
  id: Scalars['ID']['output'];
  /** The label for clients to display to users when showing this delivery time for this distributor */
  label: Scalars['String']['output'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum DistributionDeliveryTimeEnum {
  Afternoon = 'AFTERNOON',
  Anytime = 'ANYTIME',
  FirstStop = 'FIRST_STOP',
  Morning = 'MORNING',
  SpecialRequest = 'SPECIAL_REQUEST'
}

export enum DistributionDeliveryTypeEnum {
  GroundDrop = 'GROUND_DROP',
  RoofEdge = 'ROOF_EDGE',
  RoofLoad = 'ROOF_LOAD'
}

/**
 * The job accounts an org has available with a distributor. Job accounts are
 * typically job specific pricing and product availability arrangements between a
 * contractor and product distributor.
 */
export type DistributionJobAccount = {
  __typename?: 'DistributionJobAccount';
  /** The address city configured for this job account. */
  addressCity?: Maybe<Scalars['String']['output']>;
  /** The address country configured for this job account. */
  addressCountry?: Maybe<Scalars['String']['output']>;
  /** The address line 1 configured for this job account. */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** The address line 2 configured for this job account. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The address line 3 configured for this job account. */
  addressLine3?: Maybe<Scalars['String']['output']>;
  /** The address postal code configured for this job account. */
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  /** The address state configured for this job account. */
  addressState?: Maybe<Scalars['String']['output']>;
  /** The name of the job account. */
  displayName: Scalars['String']['output'];
  /** The distributor's identifier for this job account. */
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * A join record that indicates the org has access to order from this JobAccount.
   * This applies to distributors that support ClientCredential authorization.
   */
  jobAccountAuthentications?: Maybe<Array<DistributionJobAccountAuthentication>>;
};

/**
 * For some distributors, authentication is done at a job account by job account
 * level. This table joins authentication to job accounts to represent that relationship.
 */
export type DistributionJobAccountAuthentication = ApplicationRecordUuid & {
  __typename?: 'DistributionJobAccountAuthentication';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobAccount: DistributionJobAccount;
  orgId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a DistributionJobAccountAuthentication record. */
export type DistributionJobAccountAuthenticationCreateInput = {
  /** The distributor's unique auth code for this job account. */
  authCode: Scalars['String']['input'];
  /** The distributor this job_account_credential record relates to. */
  distributorId: Scalars['ID']['input'];
  /** The distributor's identifier for the job account. */
  externalIdentifier: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
};

/** OAuth tokens that give us access to an Org's account on a 3rd party Distributor's API. */
export type DistributionOauthToken = ApplicationRecordUuid & {
  __typename?: 'DistributionOauthToken';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  distributor: ProductCatalogDistributor;
  /** The distributor that this oauth token allows us to talk to. */
  distributorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The Org this oauth token belongs to. This token gives HOVER access to a distributor's system on behalf of the org. */
  orgId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for DistributionOauthToken. */
export type DistributionOauthTokenConnection = {
  __typename?: 'DistributionOauthTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DistributionOauthTokenEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DistributionOauthToken>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DistributionOauthTokenEdge = {
  __typename?: 'DistributionOauthTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DistributionOauthToken>;
};

/** This table keeps track of orders placed with Distributors. And the status of those order. */
export type DistributionOrder = ApplicationRecordUuid & {
  __typename?: 'DistributionOrder';
  accountId?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<DistributionBranch>;
  /**
   * Distributors like ABC issue this confirmation number for submitted orders
   * prior to generating a final order_id, which they send in a post-confirmation
   * webhook update.
   */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The delivery contact email passed to the distributor */
  deliveryContactEmail?: Maybe<Scalars['String']['output']>;
  /** The delivery contact name passed to the distributor */
  deliveryContactName?: Maybe<Scalars['String']['output']>;
  /** The delivery contact phone number passed to the distributor */
  deliveryContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  deliveryMethod?: Maybe<DistributionDeliveryMethodEnum>;
  deliveryTime?: Maybe<DistributionDeliveryTimeEnum>;
  deliveryType?: Maybe<DistributionDeliveryTypeEnum>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']['output']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']['output']>;
  distributor: ProductCatalogDistributor;
  /** The identifier for this order in the distributor's system */
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  /**
   * If an order fails, a string describing the failure will be saved here. This
   * may be an error message directly from the Distributor.
   */
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** An idempotence key to check that requests to product catalog to create an order are only executed once. */
  idempotenceKey?: Maybe<Scalars['String']['output']>;
  jobAccount?: Maybe<DistributionJobAccount>;
  /** The job account number that is sent to the distributor with this order */
  jobAccountNumber?: Maybe<Scalars['String']['output']>;
  lineItems: Array<DistributionOrderLineItem>;
  /** Additional info to be added to order. These notes will be passed on to the Distributor. */
  notes?: Maybe<Scalars['String']['output']>;
  orderCheck?: Maybe<DistributionOrderCheck>;
  /** The order contact email passed to the distributor */
  orderContactEmail?: Maybe<Scalars['String']['output']>;
  /** The order contact name passed to the distributor */
  orderContactName?: Maybe<Scalars['String']['output']>;
  /** The order contact phone number passed to the distributor */
  orderContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * A common UUID between DistributionOrderCheck and DistributionOrder. The
   * process of placing an order can involve many order checks. This ID will be the
   * same for all order checks involved in an order. It is up to clients using the
   * ordering APIs to set the orderSessionId.
   */
  orderSessionId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the org that placed this order */
  orgId: Scalars['ID']['output'];
  pdf?: Maybe<File>;
  /** The user specified identifier for this order */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** City of the shipping address passed to distributor */
  shippingAddressCity?: Maybe<Scalars['String']['output']>;
  /** Country of the shipping address passed to distributor */
  shippingAddressCountry?: Maybe<Scalars['String']['output']>;
  /** First name of the shipping address passed to distributor */
  shippingAddressFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the shipping address passed to distributor */
  shippingAddressLastName?: Maybe<Scalars['String']['output']>;
  /** Line 1 of the shipping address passed to distributor */
  shippingAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Line 2 of the shipping address passed to distributor */
  shippingAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Phone number of the shipping address passed to distributor */
  shippingAddressPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Postal code of the shipping address passed to distributor */
  shippingAddressPostalCode?: Maybe<Scalars['String']['output']>;
  /** State of the shipping address passed to distributor */
  shippingAddressState?: Maybe<Scalars['String']['output']>;
  /** The state of this order */
  state: DistributionOrderStateEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * A URL to this order in the Distributor's system. This url is used for linking
   * end users to their orders on the Distributor's website.
   */
  url?: Maybe<Scalars['String']['output']>;
  /** The User that created this DistributionOrder. */
  user: User;
};

/**
 * A record to record and track the asynchronous process of "checking" a
 * DistributionOrder. Currently includes field validation, product availability,
 * and price checks.
 */
export type DistributionOrderCheck = ApplicationRecordUuid & {
  __typename?: 'DistributionOrderCheck';
  branch?: Maybe<DistributionBranch>;
  /** If this is true then the checking process is complete and there will be no further changes to the results. */
  checkComplete: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  distributionApprovedBranchId?: Maybe<Scalars['ID']['output']>;
  distributionJobAccountId?: Maybe<Scalars['ID']['output']>;
  distributor: ProductCatalogDistributor;
  /** Validation Errors */
  errors: Array<Error>;
  id: Scalars['ID']['output'];
  lineItems: Array<DistributionOrderCheckLineItem>;
  /**
   * A common UUID between DistributionOrderCheck and DistributionOrder. The
   * process of placing an order can involve many order checks. This ID will be the
   * same for all order checks involved in an order. It is up to clients using the
   * ordering APIs to set the orderSessionId.
   */
  orderSessionId?: Maybe<Scalars['ID']['output']>;
  orgId: Scalars['Int']['output'];
  /** The sum of the pretax cost of all line items */
  pretaxCost?: Maybe<Scalars['Float']['output']>;
  /** The sales tax subtotal (calculated as the sales tax multiplier * pretax cost) */
  salesTax?: Maybe<Scalars['Float']['output']>;
  /** The sales tax multiplier used when calculating the total */
  salesTaxMultiplier?: Maybe<Scalars['Float']['output']>;
  /**
   * False if this order has errors that will make order submission fail. True if
   * the order has no errors, or errors that won't prevent order submission.
   */
  submittable: Scalars['Boolean']['output'];
  /** The calculated total cost (including sales tax) for all line items */
  totalCost?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a DistributionOrderCheck */
export type DistributionOrderCheckCreateInput = {
  distributionApprovedBranchId?: InputMaybe<Scalars['ID']['input']>;
  distributionJobAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The distributor to place the order with */
  distributorId: Scalars['ID']['input'];
  /** Attributes for the Order Line Items to be included in this order */
  lineItemsAttributes: Array<DistributionOrderCheckLineItemCreateInput>;
  /**
   * A common UUID between DistributionOrderCheck and DistributionOrder. The
   * process of placing an order can involve many order checks. This ID will be the
   * same for all order checks involved in an order. It is up to clients using the
   * ordering APIs to set the orderSessionId.
   */
  orderSessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type DistributionOrderCheckLineItem = ApplicationRecordUuid & {
  __typename?: 'DistributionOrderCheckLineItem';
  /** The result of checking this line item. */
  checkResult?: Maybe<DistributionOrderCheckLineItemCheckResultEnum>;
  /** Any value the client wants to use for identifying these records */
  clientIdentifier?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Validation Errors */
  errors: Array<Error>;
  id: Scalars['ID']['output'];
  measurement?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<Scalars['String']['output']>;
  /** @deprecated use productName */
  name: Scalars['String']['output'];
  /** The pretax total cost of the item, calculated as unit cost * quantity */
  pretaxCost?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use pretaxCost instead */
  price: Scalars['Float']['output'];
  product?: Maybe<ProductCatalogProduct>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityUnits?: Maybe<Scalars['String']['output']>;
  /**
   * True if the list item is mapped to a productCatalogProduct with variations,
   * but no variation has been selected by the user. Also true if
   * userSetCustomVariationName is true but variation_name is blank. Or if the line
   * item is not mapped to a product and no custom variation name was given. The
   * order is still submittable but this item might not be available at the branch
   * and might be substituted.
   */
  requiresProductVariationSelection: Scalars['Boolean']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  /** When fetching a list of line items from our API, they are returned in this order. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use pretaxCost instead */
  totalCost?: Maybe<Scalars['Float']['output']>;
  tradeType?: Maybe<Scalars['String']['output']>;
  /** The type of the LineItem */
  type?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userSetCustomSku?: Maybe<Scalars['Boolean']['output']>;
  /** True if user edited the variation name. */
  userSetCustomVariationName: Scalars['Boolean']['output'];
  variation?: Maybe<ProductCatalogVariation>;
  variationId?: Maybe<Scalars['ID']['output']>;
  variationName?: Maybe<Scalars['String']['output']>;
};

export enum DistributionOrderCheckLineItemCheckResultEnum {
  Error = 'ERROR',
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

/** Arguments for creating a Distribution Order Check Line Item. */
export type DistributionOrderCheckLineItemCreateInput = {
  /** Any value the client wants to use for identifying these records */
  clientIdentifier?: InputMaybe<Scalars['ID']['input']>;
  measurement?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnits?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  /** When fetching a list of line items from our API, they are returned in this order. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tradeType?: InputMaybe<Scalars['String']['input']>;
  /** The type of the LineItem */
  type?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if user edited the variation name. */
  userSetCustomVariationName?: InputMaybe<Scalars['Boolean']['input']>;
  variationId?: InputMaybe<Scalars['ID']['input']>;
  variationName?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for DistributionOrder. */
export type DistributionOrderConnection = {
  __typename?: 'DistributionOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DistributionOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DistributionOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a Distribution Order */
export type DistributionOrderCreateInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** The delivery contact email passed to the distributor */
  deliveryContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The delivery contact name passed to the distributor */
  deliveryContactName?: InputMaybe<Scalars['String']['input']>;
  /** The delivery contact phone number passed to the distributor */
  deliveryContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  deliveryMethod?: InputMaybe<DistributionDeliveryMethodEnum>;
  deliveryTime?: InputMaybe<DistributionDeliveryTimeEnum>;
  deliveryType?: InputMaybe<DistributionDeliveryTypeEnum>;
  /** The selected branch to send this order to. */
  distributionBranchId?: InputMaybe<Scalars['ID']['input']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The distributor to place the order with */
  distributorId: Scalars['ID']['input'];
  /** A unique key to ensure requests to create the same order are only executed once. */
  idempotenceKey?: InputMaybe<Scalars['String']['input']>;
  jobAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Job this order is for */
  jobId?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes for the Order Line Items to be included in this order */
  lineItemsAttributes: Array<DistributionOrderLineItemInput>;
  /** The description to be saved to Distribution::Order and to be sent to Distributors when placing orders. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The order contact email passed to the distributor */
  orderContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The order contact name passed to the distributor */
  orderContactName?: InputMaybe<Scalars['String']['input']>;
  /** The order contact phone number passed to the distributor */
  orderContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * A common UUID between DistributionOrderCheck and DistributionOrder. The
   * process of placing an order can involve many order checks. This ID will be the
   * same for all order checks involved in an order. It is up to clients using the
   * ordering APIs to set the orderSessionId.
   */
  orderSessionId?: InputMaybe<Scalars['ID']['input']>;
  /** The purchase order number sent to the distributor */
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the shipping address passed to distributor */
  shippingAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** Country of the shipping address passed to distributor */
  shippingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  /** First name of the shipping address passed to distributor */
  shippingAddressFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the shipping address passed to distributor */
  shippingAddressLastName?: InputMaybe<Scalars['String']['input']>;
  /** Line 1 of the shipping address passed to distributor */
  shippingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Line 2 of the shipping address passed to distributor */
  shippingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the shipping address passed to distributor */
  shippingAddressPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the shipping address passed to distributor */
  shippingAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** State of the shipping address passed to distributor */
  shippingAddressState?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DistributionOrderCreate. */
export type DistributionOrderCreatePayload = {
  __typename?: 'DistributionOrderCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrder>;
};

/** An edge in a connection. */
export type DistributionOrderEdge = {
  __typename?: 'DistributionOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DistributionOrder>;
};

/** Order List Item */
export type DistributionOrderLineItem = {
  __typename?: 'DistributionOrderLineItem';
  id: Scalars['ID']['output'];
  product?: Maybe<ProductCatalogProduct>;
  productId?: Maybe<Scalars['ID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The quantity units as given by the client. */
  quantityUnits?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * When fetching a list of line items from our API, they are returned in this
   * order. We also send line items to distributors in this order where applicable.
   */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  userSetCustomSku: Scalars['Boolean']['output'];
  userSetCustomVariationName: Scalars['Boolean']['output'];
  variation: ProductCatalogVariation;
  variationId?: Maybe<Scalars['ID']['output']>;
  variationName?: Maybe<Scalars['String']['output']>;
};

/** Arguments for building a Distribution Order Line Item. */
export type DistributionOrderLineItemInput = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  /** The quantity units as given by the client. */
  quantityUnits?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  /**
   * When fetching a list of line items from our API, they are returned in this
   * order. We also send line items to distributors in this order where applicable.
   */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  userSetCustomVariationName?: InputMaybe<Scalars['Boolean']['input']>;
  variationId?: InputMaybe<Scalars['ID']['input']>;
  variationName?: InputMaybe<Scalars['String']['input']>;
};

export enum DistributionOrderStateEnum {
  Canceled = 'canceled',
  CheckFailed = 'check_failed',
  CheckSuccess = 'check_success',
  Checking = 'checking',
  Created = 'created',
  Failed = 'failed',
  PendingSubmitted = 'pending_submitted',
  Queued = 'queued',
  Submitted = 'submitted'
}

/** Arguments for querying for a Variation or Product */
export type DistributionVariationAttributesInput = {
  /**
   * A client side identifier that will be returned with this variation's data.
   * Useful for matching up results with client side data.
   */
  clientIdentifier?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantityUnits?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  variationId?: InputMaybe<Scalars['ID']['input']>;
  variationName?: InputMaybe<Scalars['String']['input']>;
};

export type DomainClaim = ApplicationRecord & {
  __typename?: 'DomainClaim';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: DomainClaimStatus;
  /** The string to be added the domain's DNS TXT record to verify this domain claim. */
  textRecordValue: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum DomainClaimStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unprocessable = 'UNPROCESSABLE',
  Verified = 'VERIFIED',
  Verifying = 'VERIFYING'
}

export type Downspout = {
  __typename?: 'Downspout';
  length: Scalars['Float']['output'];
  origin: Vector3;
};

export type Drainage = {
  __typename?: 'Drainage';
  gutters: Array<Gutter>;
};

export type EhiFeatureAccess = ApplicationRecord & {
  __typename?: 'EHIFeatureAccess';
  /** The id of the user or org with this feature */
  accessorId?: Maybe<Scalars['Int']['output']>;
  /** An enum representing either user or org */
  accessorType?: Maybe<FeatureAccessAccessor>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Boolean to control access to this feature */
  enabled: Scalars['Boolean']['output'];
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** An enum specifying the feature this record gives access to */
  identifier?: Maybe<EhiFeatureAccessIdentifier>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum EhiFeatureAccessIdentifier {
  Estimation = 'ESTIMATION',
  IncludeInactiveTemplates = 'INCLUDE_INACTIVE_TEMPLATES'
}

/** Arguments for updating OrgSettings */
export type EhiOrgSettingsUpdateInput = {
  /** If this is clients should disable or hide the order submission button on the material list views. */
  disableOrderSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is true clients should hide or disable the save as template button on the material list views. */
  disableSaveAsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If this is true we’ll remove waste factor from our calculations on the
   * backend. And return a neutral value for APIs that return waste factor multipliers.
   */
  disableWasteFactor?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is true clients should hide the unit cost column when showing material list items. */
  hideListItemUnitCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is true clients should hide the high level financial information when showing material lists. */
  hideProductionListFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines whether openings less than 33 square feet should be included when calculating non-siding-wall area. */
  includeNonSidingWallOpeningsLessThan33Sqft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines whether openings trim SQFT should be included when calculating non-siding-wall area. */
  includeNonSidingWallOpeningsTrim?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines whether trim SQFT should be included when calculating non-siding-wall area. */
  includeNonSidingWallTrim?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether openings less than 33 square feet should be included when calculating siding area. */
  includeOpeningsLessThan33Sqft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines when siding openings trim SQFT should be included when calculating siding area. */
  includeSidingOpeningsTrim?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines when siding trim SQFT should be included when calculating siding area. */
  includeSidingTrim?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this is true, template APIs will only return templates that have been configured for use with xactimate. */
  showOnlyXactimateTemplates?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EHIOrgSettingsUpdate. */
export type EhiOrgSettingsUpdatePayload = {
  __typename?: 'EHIOrgSettingsUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgSettings?: Maybe<OrgSettings>;
};

export enum EditedStatusEnum {
  Edited = 'EDITED',
  Unedited = 'UNEDITED'
}

export type ElevationBySide = {
  __typename?: 'ElevationBySide';
  /** List of facades and their areas. */
  areaPerLabel: Array<FacadeArea>;
  /** Sum of areas for all facades on this side. */
  total: Scalars['Int']['output'];
};

export type Elevations = {
  __typename?: 'Elevations';
  /** Elevations for structure's facades. */
  sides: Sides;
};

/** Errors about an attribute of an invalid record */
export type Error = {
  __typename?: 'Error';
  attribute: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
};

/** Estimate */
export type Estimate = ApplicationRecord & {
  __typename?: 'Estimate';
  /** whether or not the estimate is active within an estimate group */
  active: Scalars['Boolean']['output'];
  basePrice?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** total discount in dollars applied to the estimate */
  discount?: Maybe<Scalars['Float']['output']>;
  discounts?: Maybe<Array<EstimationDiscount>>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
  fullMeasurements?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** The job to which the estimate relates. */
  jobId?: Maybe<Scalars['Int']['output']>;
  lineItems?: Maybe<Array<LineItem>>;
  /** The name of the template used when the estimate was created */
  name?: Maybe<Scalars['String']['output']>;
  /** The org to which the estimate relates. */
  orgId?: Maybe<Scalars['Int']['output']>;
  preWasteRoofAreaSquareFeet?: Maybe<Scalars['Float']['output']>;
  /** Was recommended waste selected by user? */
  recommendedWasteSelected?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Template>;
  templateGroups: Array<EstimationTemplateGroup>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The User that created this EstimationEstimate. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  /**
   * The recommended waste factor percentage to apply to the original quantity,
   * expressed as a multiplier >= 1. e.g 1.15 = 15%, 2 = 100%
   */
  wasteFactorMultiplier?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated return type of EstimateGroupCreate. */
export type EstimateGroupCreatePayload = {
  __typename?: 'EstimateGroupCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
};

/** Autogenerated return type of EstimateGroupMultipleMaterialsCreate. */
export type EstimateGroupMultipleMaterialsCreatePayload = {
  __typename?: 'EstimateGroupMultipleMaterialsCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
};

/** Autogenerated return type of EstimateGroupUpdate. */
export type EstimateGroupUpdatePayload = {
  __typename?: 'EstimateGroupUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
};

/** EstimateGroupUserAnswer */
export type EstimateGroupUserAnswer = ApplicationRecordUuid & {
  __typename?: 'EstimateGroupUserAnswer';
  /** The name of the category from this answer's input */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimationConfigInput?: Maybe<EstimationConfigInput>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  inputCategory: EstimationConfigInputCategory;
  /** The type of user_value */
  inputType?: Maybe<EstimationConfigInputInputTypeEnum>;
  /** The units user_value is in, from the unit_formula_measurement_units enum */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The question shown to the user when this answer was entered */
  question?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The value entered by the user */
  userValue?: Maybe<Scalars['String']['output']>;
};

/** Arguments for updating an Estimate */
export type EstimateUpdate = {
  /** whether or not the estimate is active within an estimate group */
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EstimateUpdate. */
export type EstimateUpdatePayload = {
  __typename?: 'EstimateUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimate?: Maybe<Estimate>;
};

/** Estimation Configuration Input */
export type EstimationConfigInput = ApplicationRecord & {
  __typename?: 'EstimationConfigInput';
  /** The argument to pass into the equation when evaluating */
  argument?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dependentInputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  inputCategory?: Maybe<EstimationConfigInputCategory>;
  inputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  inputOptions?: Maybe<Array<EstimationConfigInputOption>>;
  /** Type to validate when a value is provided by the client */
  inputType: EstimationConfigInputInputTypeEnum;
  /** so users know the measurement units when providing an input value */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The name of the estimation_input. */
  name?: Maybe<Scalars['String']['output']>;
  /** The question to ask the client when the input needs a value */
  question?: Maybe<Scalars['String']['output']>;
  /** The default value for the input to show the user. */
  questionDefaultValue?: Maybe<Scalars['String']['output']>;
  /** The order in which to display the input. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  tradeTypeCategories?: Maybe<Array<TradeTypeCategoryEnum>>;
  tradeTypes?: Maybe<Array<TradeTypeEnum>>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


/** Estimation Configuration Input */
export type EstimationConfigInputInputOptionsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

/** Estimation Configuration Input Category */
export type EstimationConfigInputCategory = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigInputCategory';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for EstimationConfigInputCategory. */
export type EstimationConfigInputCategoryConnection = {
  __typename?: 'EstimationConfigInputCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigInputCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigInputCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigInputCategoryEdge = {
  __typename?: 'EstimationConfigInputCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigInputCategory>;
};

/** Estimation Configuration Input Condition */
export type EstimationConfigInputCondition = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigInputCondition';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the estimation_input that the condition relates to. */
  estimationInputId: Scalars['ID']['output'];
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** the parent input that the condition depends on */
  parentInputId: Scalars['ID']['output'];
  /** if the parent input has this value, then show the sales question */
  parentValue: Scalars['String']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum EstimationConfigInputInputTypeEnum {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING'
}

export enum EstimationConfigInputMeasurementUnitEnum {
  CubicFeet = 'CUBIC_FEET',
  Each = 'EACH',
  FormulaUnits = 'FORMULA_UNITS',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  LinearInches = 'LINEAR_INCHES',
  Pieces = 'PIECES',
  SellingUnits = 'SELLING_UNITS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET'
}

/** Estimation Configuration Input Option */
export type EstimationConfigInputOption = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigInputOption';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** label shown to the user */
  label: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** value passed to the estimator for calculation */
  value: Scalars['String']['output'];
};

/** Estimation Configuration Line Item */
export type EstimationConfigLineItem = ApplicationRecord & {
  __typename?: 'EstimationConfigLineItem';
  active: Scalars['Boolean']['output'];
  /** Allow selecting variation for this line item during estimation flow */
  allowVariationSelection: Scalars['Boolean']['output'];
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** margin as a percentage */
  margin?: Maybe<Scalars['Float']['output']>;
  /** the name of the line_item */
  name: Scalars['String']['output'];
  netCoverageLineItemPreset?: Maybe<EstimationConfigLineItemPreset>;
  /** the org to which this line item belongs */
  orgId: Scalars['Int']['output'];
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']['output']>;
  quantityUnits: QuantityUnitsEnum;
  /** sales tax as a percentage */
  salesTax?: Maybe<Scalars['Float']['output']>;
  templatesCount: Scalars['Int']['output'];
  tradeTypes?: Maybe<Array<TradeTypeEnum>>;
  type?: Maybe<LineItemTypeEnum>;
  /** cost per unit in dollars */
  unitCost: Scalars['Float']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vendor?: Maybe<Vendor>;
  xactimateLineItem?: Maybe<EstimationConfigXactimateLineItem>;
};

/** The connection type for EstimationConfigLineItem. */
export type EstimationConfigLineItemConnection = {
  __typename?: 'EstimationConfigLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigLineItemEdge = {
  __typename?: 'EstimationConfigLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigLineItem>;
};

/** Estimation Configuration Line Item Preset */
export type EstimationConfigLineItemPreset = ApplicationRecord & {
  __typename?: 'EstimationConfigLineItemPreset';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

/** Arguments for updating an EstimationConfig LineItem */
export type EstimationConfigLineItemUpdateInput = {
  /** Allow selecting variation for this line item during estimation flow */
  allowVariationSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /** margin as a percentage */
  margin?: InputMaybe<Scalars['Float']['input']>;
  /** the name of the line_item */
  name?: InputMaybe<Scalars['String']['input']>;
  netCoveragePerSellingUnit?: InputMaybe<Scalars['Float']['input']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  quantityUnits?: InputMaybe<QuantityUnitsEnum>;
  /** sales tax as a percentage */
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<LineItemTypeEnum>;
  /** cost per unit in dollars */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the EstimationConfig::Vendor this item will be ordered through */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of EstimationConfigLineItemUpdate. */
export type EstimationConfigLineItemUpdatePayload = {
  __typename?: 'EstimationConfigLineItemUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  lineItem?: Maybe<EstimationConfigLineItem>;
};

/** Estimation Configuration Line Item Version */
export type EstimationConfigLineItemVersion = {
  __typename?: 'EstimationConfigLineItemVersion';
  attributeChanges: Array<AttributeChange>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The User that updated the EstimationConfigLineItem */
  updatedByUser?: Maybe<User>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for EstimationConfigLineItemVersion. */
export type EstimationConfigLineItemVersionConnection = {
  __typename?: 'EstimationConfigLineItemVersionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigLineItemVersionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigLineItemVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigLineItemVersionEdge = {
  __typename?: 'EstimationConfigLineItemVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigLineItemVersion>;
};

/** Estimation Configuration Required Input */
export type EstimationConfigRequiredInput = ApplicationRecord & {
  __typename?: 'EstimationConfigRequiredInput';
  /** The argument to pass into the equation when evaluating */
  argument?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dependentInputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  inputCategory?: Maybe<EstimationConfigInputCategory>;
  inputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  inputOptions?: Maybe<Array<EstimationConfigInputOption>>;
  /** Type to validate when a value is provided by the client */
  inputType: EstimationConfigInputInputTypeEnum;
  /** so users know the measurement units when providing an input value */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The name of the estimation_input. */
  name?: Maybe<Scalars['String']['output']>;
  /** The question to ask the client when the input needs a value */
  question?: Maybe<Scalars['String']['output']>;
  /** The default value for the input to show the user. */
  questionDefaultValue?: Maybe<Scalars['String']['output']>;
  /** The order in which to display the input. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['Int']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  tradeTypeCategories?: Maybe<Array<TradeTypeCategoryEnum>>;
  tradeTypes?: Maybe<Array<TradeTypeEnum>>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


/** Estimation Configuration Required Input */
export type EstimationConfigRequiredInputInputOptionsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for EstimationConfigRequiredInput. */
export type EstimationConfigRequiredInputConnection = {
  __typename?: 'EstimationConfigRequiredInputConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigRequiredInputEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigRequiredInput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigRequiredInputEdge = {
  __typename?: 'EstimationConfigRequiredInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigRequiredInput>;
};

/** Estimation Configuration Template */
export type EstimationConfigTemplate = ApplicationRecord & {
  __typename?: 'EstimationConfigTemplate';
  active: Scalars['Boolean']['output'];
  /**
   * The overall product brand for this template. Some products may be from
   * different brands, but this is the brand for the core products.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  lineItems: Array<EstimationConfigLineItem>;
  /** The name of the template. */
  name: Scalars['String']['output'];
  /** The org to which the template belongs. */
  orgId?: Maybe<Scalars['Int']['output']>;
  /** Templates will be searchable by the content of this field */
  searchText?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<EstimationConfigTemplateSetting>;
  /**
   * Controls visibility of prices in Estimation workflow. When false, clients
   * should not show line item prices. When true, clients should show line item
   * prices. When absent, clients will default to the show_prices_in_estimation
   * value set in org settings.
   */
  showPricesInEstimation?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which to display the templates in the UI. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateGroups: Array<EstimationConfigTemplateGroup>;
  templateImage?: Maybe<EstimationConfigTemplateImage>;
  tradeType: TradeTypeEnum;
  tradeTypeCategoryEnumValue: TradeTypeCategoryEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Estimation Configuration Template Collections For Org */
export type EstimationConfigTemplateCollectionForOrg = {
  __typename?: 'EstimationConfigTemplateCollectionForOrg';
  orgId: Scalars['ID']['output'];
  /** Top level sections of templates */
  templateSections: Array<EstimationConfigTemplateCollectionForOrgSection>;
};

/** Estimation Configuration Template Collection For Org Section */
export type EstimationConfigTemplateCollectionForOrgSection = {
  __typename?: 'EstimationConfigTemplateCollectionForOrgSection';
  collectionType: EstimationConfigTemplateCollectionTypeEnum;
  name: Scalars['String']['output'];
  templatesByTradeType: Array<EstimationConfigTemplateCollectionForOrgSubSection>;
};

/** Estimation Configuration Template Collection For Org Sub Section */
export type EstimationConfigTemplateCollectionForOrgSubSection = {
  __typename?: 'EstimationConfigTemplateCollectionForOrgSubSection';
  templates: Array<EstimationConfigTemplate>;
  tradeType: TradeTypeEnum;
};

export enum EstimationConfigTemplateCollectionTypeEnum {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

/** Estimation Configuration Template from ProductionList Create Request */
export type EstimationConfigTemplateFromProductionListCreateRequest = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTemplateFromProductionListCreateRequest';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  options: Array<EstimationConfigTemplateFromProductionListOption>;
  /** The org that requested this */
  orgId: Scalars['ID']['output'];
  productionList: ProductionList;
  state: EstimationConfigTemplateFromProductionListCreateRequestStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating an EstimationConfig TemplateFromProductionListCreateRequest */
export type EstimationConfigTemplateFromProductionListCreateRequestCreateInput = {
  optionsAttributes: Array<EstimationConfigTemplateFromProductionListOptionCreateInput>;
  /** The production list we should use to generate the production list */
  projectManagementProductionListId: Scalars['ID']['input'];
};

export enum EstimationConfigTemplateFromProductionListCreateRequestStateEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Queued = 'QUEUED',
  Requested = 'REQUESTED'
}

/** Specifies the per template options when creating a template from a production list */
export type EstimationConfigTemplateFromProductionListOption = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTemplateFromProductionListOption';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  destinationTemplate?: Maybe<Template>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originTemplate?: Maybe<Template>;
  /** Overwrite the existing template */
  overwriteExisting: Scalars['Boolean']['output'];
  /** Save the answers the user gave during the estimate questionnaire as template input presets */
  saveInputAnswers: Scalars['Boolean']['output'];
  /** Save the unit cost of each of the list items */
  saveUnitCost: Scalars['Boolean']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for a specific template in a TemplateFromProductionListCreateRequest */
export type EstimationConfigTemplateFromProductionListOptionCreateInput = {
  estimationEstimateGroupTemplateInstanceId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** The original template used to create the production list */
  originEstimationConfigTemplateId: Scalars['ID']['input'];
  /** Overwrite the existing template */
  overwriteExisting: Scalars['Boolean']['input'];
  /** Save the answers the user gave during the estimate questionnaire as template input presets */
  saveInputAnswers: Scalars['Boolean']['input'];
  /** Save the unit cost of each of the list items */
  saveUnitCost: Scalars['Boolean']['input'];
};

/** Estimation Configuration Template Group */
export type EstimationConfigTemplateGroup = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTemplateGroup';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the template group was automatically generated for miscellaneous line items */
  defaultGroup: Scalars['Boolean']['output'];
  /** The description of the template group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Array<EstimationConfigLineItem>>;
  /** The name of the template group */
  name: Scalars['String']['output'];
  /** The order in which the template group is displayed on estimate details and proposals */
  sortOrder: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating an EstimationConfig TemplateGroup */
export type EstimationConfigTemplateGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id?: InputMaybe<Scalars['ID']['input']>;
  lineItemIds: Array<Scalars['ID']['input']>;
  /** The name of the template. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order in which to display the templates in the UI. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Estimation configuration Template Image */
export type EstimationConfigTemplateImage = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTemplateImage';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** Image for thumbnail */
  image?: Maybe<File>;
  template: EstimationConfigTemplate;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Estimation Configuration Template Settings */
export type EstimationConfigTemplateSetting = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTemplateSetting';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Visible externally to API clients and integration partners. Could be shown to customers. */
  description?: Maybe<Scalars['String']['output']>;
  /** If this is false clients should disable editing of the list item context field. The server will enforce it. */
  enableEditingOfListItemContext: Scalars['Boolean']['output'];
  /** If this is false clients should disable editing of the list item coverage field. The server will enforce it. */
  enableEditingOfListItemCoverage: Scalars['Boolean']['output'];
  /** If this is false clients should disable editing of the list item unit of measure field. The server will enforce it. */
  enableEditingOfListItemMeasurementUnits: Scalars['Boolean']['output'];
  /** If this is false clients should disable editing of the list item measurements field. The server will enforce it. */
  enableEditingOfListItemMeasurements: Scalars['Boolean']['output'];
  /** If this is false clients should disable editing of the list item name field. The server will enforce it. */
  enableEditingOfListItemName: Scalars['Boolean']['output'];
  /** If this is false clients should disable editing of the list item waste field. The server will enforce it. */
  enableEditingOfListItemWaste: Scalars['Boolean']['output'];
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /**
   * These settings will be used for many templates. The name will help finding the
   * right settings when configuring templates. Available to API clients and customers.
   */
  name: Scalars['String']['output'];
  /** If this is false clients should hide the list item variation field. */
  showListItemVariation: Scalars['Boolean']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for updating an EstimationConfig Template */
export type EstimationConfigTemplateUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the template. */
  name?: InputMaybe<Scalars['String']['input']>;
  templateGroupsAttributes?: InputMaybe<Array<EstimationConfigTemplateGroupCreateInput>>;
};

/** Autogenerated return type of EstimationConfigTemplateUpdate. */
export type EstimationConfigTemplateUpdatePayload = {
  __typename?: 'EstimationConfigTemplateUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  template?: Maybe<EstimationConfigTemplate>;
};

/** Estimation Configuration Template Version */
export type EstimationConfigTemplateVersion = {
  __typename?: 'EstimationConfigTemplateVersion';
  attributeChanges: Array<AttributeChange>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The User that updated the EstimationConfigTemplate */
  updatedByUser?: Maybe<User>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for EstimationConfigTemplateVersion. */
export type EstimationConfigTemplateVersionConnection = {
  __typename?: 'EstimationConfigTemplateVersionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigTemplateVersionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigTemplateVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigTemplateVersionEdge = {
  __typename?: 'EstimationConfigTemplateVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigTemplateVersion>;
};

/** Autogenerated return type of EstimationConfigTradeTypeCategoryWasteFactorUpdate. */
export type EstimationConfigTradeTypeCategoryWasteFactorUpdatePayload = {
  __typename?: 'EstimationConfigTradeTypeCategoryWasteFactorUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  tradeTypeEnumOrgs: Array<EstimationConfigTradeTypeEnumOrg>;
};

/** Estimation Configuration Trade Type Enum Org */
export type EstimationConfigTradeTypeEnumOrg = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigTradeTypeEnumOrg';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** The org to which this belongs */
  orgId: Scalars['Int']['output'];
  tradeType: TradeTypeEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Waste factor as a percentage (whole numbers > 1, e.g. 10.5%) */
  wasteFactor?: Maybe<Scalars['Float']['output']>;
};

/** The connection type for EstimationConfigTradeTypeEnumOrg. */
export type EstimationConfigTradeTypeEnumOrgConnection = {
  __typename?: 'EstimationConfigTradeTypeEnumOrgConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigTradeTypeEnumOrgEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigTradeTypeEnumOrg>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigTradeTypeEnumOrgEdge = {
  __typename?: 'EstimationConfigTradeTypeEnumOrgEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigTradeTypeEnumOrg>;
};

export type EstimationConfigXactimateLineItem = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigXactimateLineItem';
  /** Xactimate calculation format. Specifies a formula for Xactimate to use to calculate area. */
  calculation?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human readable description for this line item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The key to the values hash on EstimationLineItem. Used together with use_formula_value_for_calculation. */
  formulaValueForCalculation?: Maybe<Scalars['String']['output']>;
  /**
   * Xactimate group id. This references a group of facades on the 3D model.
   * Instructing Xactimate to select some facades by default when the user
   * customizes selected coverage area for material quantity calculation.
   */
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** Human readable name for this line item. */
  name: Scalars['String']['output'];
  /** Xactimate product code */
  productCode: Scalars['String']['output'];
  /**
   * The SEL codes associate with applicable labor, material, margin and tax rates
   * in order to estimate the total cost of each line item based on quantity needed.
   */
  selector?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * If this is true, we'll return one of the values cached on the
   * EstimationLineItem's values field for the calculation field. This overrides
   * the calculation field.
   */
  useFormulaValueForCalculation: Scalars['Boolean']['output'];
};

/** Discount */
export type EstimationDiscount = ApplicationRecord & {
  __typename?: 'EstimationDiscount';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discountType: EstimationDiscountDiscountTypeEnum;
  estimationEstimateId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['Float']['output'];
};

/** Arguments for creating a Discount for an Estimate */
export type EstimationDiscountCreate = {
  discountType: EstimationDiscountDiscountTypeEnum;
  estimationEstimateId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export enum EstimationDiscountDiscountTypeEnum {
  Dollars = 'DOLLARS',
  Percentage = 'PERCENTAGE'
}

/** Arguments for updating a Discount for an Estimate */
export type EstimationDiscountUpdate = {
  discountType: EstimationDiscountDiscountTypeEnum;
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/** Arguments for creating an EstimationConfigLineItem */
export type EstimationEstimateConfigLineItemCreateInput = {
  /** Allow selecting variation for this line item during estimation flow */
  allowVariationSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /** margin as a percentage */
  margin?: InputMaybe<Scalars['Float']['input']>;
  /** the name of the line_item */
  name: Scalars['String']['input'];
  /** Deprecated: This should have never been added. It is ignored. Don't use it. */
  netCoveragePerSellingUnit?: InputMaybe<Scalars['Float']['input']>;
  /** the org to which this line item belongs */
  orgId: Scalars['ID']['input'];
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  quantityUnits: QuantityUnitsEnum;
  /** sales tax as a percentage */
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  type: LineItemTypeEnum;
  /** cost per unit in dollars */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the EstimationConfig::Vendor this item will be ordered through */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Estimate Group */
export type EstimationEstimateGroup = ApplicationRecordUuid & {
  __typename?: 'EstimationEstimateGroup';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  enableVariationMatching: Scalars['Boolean']['output'];
  estimates: Array<Estimate>;
  facets: Array<EstimationEstimateGroupFacet>;
  failureReason?: Maybe<Scalars['String']['output']>;
  hdfId?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  laborTotalCost?: Maybe<Scalars['Float']['output']>;
  materialListType: MaterialListTypeEnum;
  materialSubtotalPretaxCost?: Maybe<Scalars['Float']['output']>;
  materialSubtotalTax?: Maybe<Scalars['Float']['output']>;
  materialTotalCost?: Maybe<Scalars['Float']['output']>;
  monthlyPrice?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  org: Org;
  orgId: Scalars['ID']['output'];
  otherTotalCost?: Maybe<Scalars['Float']['output']>;
  profitAmount?: Maybe<Scalars['Float']['output']>;
  profitMargin?: Maybe<Scalars['Float']['output']>;
  proposalDocuments: Array<ProjectManagementProposalDocument>;
  proposalDocumentsCount: Scalars['Int']['output'];
  requestParams?: Maybe<Scalars['String']['output']>;
  salesOpportunity: SalesOpportunity;
  state: EstimationEstimateGroupStateEnum;
  templateInstances: Array<EstimationEstimateGroupTemplateInstance>;
  totalCost?: Maybe<Scalars['Float']['output']>;
  totalDiscount: Scalars['Float']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: User;
  userAnswers: Array<EstimateGroupUserAnswer>;
  userId: Scalars['ID']['output'];
};


/** Estimate Group */
export type EstimationEstimateGroupEstimatesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for EstimationEstimateGroup. */
export type EstimationEstimateGroupConnection = {
  __typename?: 'EstimationEstimateGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationEstimateGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationEstimateGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating an Estimate Group */
export type EstimationEstimateGroupCreate = {
  facetsAttributes?: InputMaybe<Array<EstimationEstimateGroupFacetNestedAttributesInput>>;
  /** The ID of the HDF file used to generate this EstimateGroup */
  hdfId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  /** The org to which the estimate group relates. */
  orgId: Scalars['ID']['input'];
  /** Which Estimate Group's answers were used to pre-populate the questionnaire's inputs to the user on the questionnaire */
  prepopulatedFromEstimateGroupId?: InputMaybe<Scalars['ID']['input']>;
};

/** Arguments for specifying custom line items when creating estimates */
export type EstimationEstimateGroupCreateCustomLineItem = {
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  tradeType?: InputMaybe<TradeTypeEnum>;
  type?: InputMaybe<LineItemTypeEnum>;
};

/** Arguments for specifying formula input values */
export type EstimationEstimateGroupCreateInput = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** Arguments for specifying which trade types use full measurements */
export type EstimationEstimateGroupCreateTradeTypeAttributeInput = {
  /** if the trade type uses full measurements */
  fullMeasurements: Scalars['Boolean']['input'];
  /** a trade type */
  tradeType: TradeTypeEnum;
};

/** An edge in a connection. */
export type EstimationEstimateGroupEdge = {
  __typename?: 'EstimationEstimateGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationEstimateGroup>;
};

/** A facet that was included when generating an estimate group */
export type EstimationEstimateGroupFacet = ApplicationRecordUuid & {
  __typename?: 'EstimationEstimateGroupFacet';
  /** The total area in square feet of this facet */
  area?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** External identifier of the facet. e.g. SI-4 */
  identifier: Scalars['String']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating an Estimate Group Facet */
export type EstimationEstimateGroupFacetNestedAttributesInput = {
  /** The total area in square feet of this facet */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** External identifier of the facet. e.g. SI-4 */
  identifier: Scalars['String']['input'];
};

export enum EstimationEstimateGroupStateEnum {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Queued = 'QUEUED'
}

/** Arguments used to generate a group of Line Items for a specific Template */
export type EstimationEstimateGroupTemplateInstance = {
  __typename?: 'EstimationEstimateGroupTemplateInstance';
  estimateName: Scalars['String']['output'];
  facetArguments: Array<EstimationEstimateGroupTemplateInstanceFacetArgument>;
  id: Scalars['ID']['output'];
  inputArguments: Array<EstimationEstimateGroupTemplateInstanceInputArgument>;
  preWasteRoofAreaSquareFeet?: Maybe<Scalars['Float']['output']>;
  /** Deprecate this in favor of pre_waste_roof_area_square_feet */
  preWasteRoofSquareFootage?: Maybe<Scalars['Float']['output']>;
  recommendedWasteSelected?: Maybe<Scalars['Boolean']['output']>;
  template: EstimationConfigTemplate;
  wasteFactorMultiplier?: Maybe<Scalars['Float']['output']>;
};

/** A facet that was included when generating an estimate group for a given template */
export type EstimationEstimateGroupTemplateInstanceFacetArgument = {
  __typename?: 'EstimationEstimateGroupTemplateInstanceFacetArgument';
  /** The total area in square feet of this facet */
  area?: Maybe<Scalars['Float']['output']>;
  /** External identifier of the facet. e.g. SI-4 */
  identifier: Scalars['String']['output'];
};

/** Arguments for generating a group of ListItems from a single Template */
export type EstimationEstimateGroupTemplateInstanceInput = {
  facets: Array<EstimationEstimateGroupFacetNestedAttributesInput>;
  inputs: Array<EstimationEstimateGroupCreateInput>;
  /** Which name to save to this ListItem group */
  name: Scalars['String']['input'];
  preWasteRoofAreaSquareFeet?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecate this in favor of pre_waste_roof_area_square_feet */
  preWasteRoofSquareFootage?: InputMaybe<Scalars['Float']['input']>;
  recommendedWasteSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which template was selected for this ListItem group */
  templateId: Scalars['ID']['input'];
  wasteFactorMultiplier?: InputMaybe<Scalars['Float']['input']>;
};

export type EstimationEstimateGroupTemplateInstanceInputArgument = {
  __typename?: 'EstimationEstimateGroupTemplateInstanceInputArgument';
  /** The name of the category from this argument's input */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** The display string or human-readable form of the value shown to the user for the selected option */
  displayValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputCategory?: Maybe<EstimationConfigInputCategory>;
  /** The type (boolean, number, string, select) of Input */
  inputType?: Maybe<EstimationConfigInputInputTypeEnum>;
  /** The machine-parseable string value of the selected option as passed by client */
  inputValue?: Maybe<Scalars['String']['output']>;
  /** The units input_value is in, from the unit_formula_measurement_units enum */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The question shown to the user when this argument was entered */
  questionText?: Maybe<Scalars['String']['output']>;
};

/** Arguments for updating an Estimate Groups values */
export type EstimationEstimateGroupUpdateInput = {
  /** Whether the variations should be matched for items in related categories */
  enableVariationMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provides name for an estimate group */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments for updating a Line Item for an Estimate */
export type EstimationLineItemUpdateInput = {
  /** Foreign key to product_catalog_variation */
  productCatalogVariationId: Scalars['ID']['input'];
  productCatalogVariationName: Scalars['String']['input'];
};

/** EstimationQuantityUnit */
export type EstimationQuantityUnit = {
  __typename?: 'EstimationQuantityUnit';
  abbreviation: Scalars['String']['output'];
  value: QuantityUnitsEnum;
};

export type EstimationSummarizedHdf = {
  __typename?: 'EstimationSummarizedHdf';
  data?: Maybe<Scalars['String']['output']>;
};

/** Estimation Template Group */
export type EstimationTemplateGroup = ApplicationRecordUuid & {
  __typename?: 'EstimationTemplateGroup';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The description of the template group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  lineItems?: Maybe<Array<LineItem>>;
  /** The name of the template group */
  name: Scalars['String']['output'];
  /** The order in which the template group is displayed on estimate details and proposals */
  sortOrder: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EsxAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postal?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Org settings for expedited deliverables. */
export type ExpeditedDeliverablesSettings = {
  __typename?: 'ExpeditedDeliverablesSettings';
  defaultDeliverySpeed: DeliverableDeliverySpeeds;
  deliverable: Deliverable;
  deliverySpeeds: Array<DeliverableDeliverySpeeds>;
};

export type ExternalIdentifierPattern = ApplicationRecord & {
  __typename?: 'ExternalIdentifierPattern';
  /** Regular Expression used for validating external identifier */
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type FacadeArea = {
  __typename?: 'FacadeArea';
  /** Area of facade. */
  area: Scalars['Int']['output'];
  /** Label for facade. */
  label: Scalars['String']['output'];
};

export type FacadeData = {
  __typename?: 'FacadeData';
  /** Area of facade. */
  area: Scalars['Int']['output'];
  /** Facade by facade breakdown of waste data. */
  areaWithWasteFactorCalculation: WastePercentages;
  /** Facade's corner data. */
  corners?: Maybe<CornerData>;
  /** Facade label. */
  facade: Scalars['String']['output'];
  /** Boolean indicating whether or not a facade is labeled on the screenshot. */
  labeledOnScreenshot: Scalars['Boolean']['output'];
  /** Facade's opening data. */
  openings?: Maybe<OpeningsData>;
  /** Facade's roofline data. */
  roofline?: Maybe<RooflineData>;
  /** Shutters on facade. */
  shutters: Scalars['Int']['output'];
  /** Facade's trim data. */
  trim?: Maybe<TrimData>;
  /** Vents on facade. */
  vents: Scalars['Int']['output'];
};

export type Facades = {
  __typename?: 'Facades';
  /** Facade data for brick facades */
  brick?: Maybe<Array<FacadeData>>;
  /** Facade data for metal facades */
  metal?: Maybe<Array<FacadeData>>;
  /** Facade data for siding facades */
  siding?: Maybe<Array<FacadeData>>;
  /** Facade data for stone facades */
  stone?: Maybe<Array<FacadeData>>;
  /** Facade data for stucco facades */
  stucco?: Maybe<Array<FacadeData>>;
  /** Facade data for tudor facades */
  tudor?: Maybe<Array<FacadeData>>;
  /** Facade data for unknown facades */
  unknown?: Maybe<Array<FacadeData>>;
  /** Facade data for wrap facades */
  wrap?: Maybe<Array<FacadeData>>;
};

export type Face = {
  __typename?: 'Face';
  /** (Unit: sqin) */
  area: Scalars['Float']['output'];
  /** Area minus the total area of opening direct annotations. (Unit: sqin) */
  areaMinusAnnotations: Scalars['Float']['output'];
  /** e.g. Door Package -> Door */
  directAnnotations?: Maybe<Array<Annotation>>;
  /**
   * roof or wall edges; when on siding wall,this could be an 'extended' edge
   * (edges that are not part of the wall's loop but on adjacent trims')
   */
  eaves: Array<MEdge>;
  /** All edges that part of any of the face's loops */
  edges: Array<MEdge>;
  /** Database id */
  facadeId: Scalars['ID']['output'];
  /** roof edges */
  flashings: Array<MEdge>;
  /** roof edges */
  hips: Array<MEdge>;
  includeInPerMaterialMeasurements?: Maybe<Scalars['Boolean']['output']>;
  includeInTotalMeasurements?: Maybe<Scalars['Boolean']['output']>;
  /** e.g. Siding -> Door (via door package) */
  indirectAnnotations?: Maybe<Array<Annotation>>;
  /**
   * wall edges; when on siding wall, this could be an 'extended' edge,which is not
   * part of the wall's loop but of an adjacent trim
   */
  insideCorners: Array<MEdge>;
  labels?: Maybe<Array<Label>>;
  /** wall edges */
  levelBases: Array<MEdge>;
  name?: Maybe<Scalars['String']['output']>;
  /** wall edges */
  openingBottoms: Array<MEdge>;
  /** wall edges */
  openingSides: Array<MEdge>;
  /** wall edges */
  openingTops: Array<MEdge>;
  /**
   * wall edges; when on siding wall, this could be an 'extended' edge,which is not
   * part of the wall's loop but of an adjacent trim
   */
  outsideCorners: Array<MEdge>;
  /** wall edges */
  perimeters: Array<MEdge>;
  productId?: Maybe<Scalars['ID']['output']>;
  /**
   * roof or wall edges; when on siding wall,this could be an 'extended' edge
   * (edges that are not part of the wall's loop but on adjacent trims')
   */
  rakes: Array<MEdge>;
  /** roof edges */
  ridges: Array<MEdge>;
  /** wall edges */
  slopedBases: Array<MEdge>;
  /** Unique id assigned randomely to all facades in the model.Sort index Can be found in skp as well */
  sortIndex: Scalars['Int']['output'];
  /** roof edges */
  stepFlashings: Array<MEdge>;
  /** The hex value of the color of the texture applied to a face */
  textureColor?: Maybe<Scalars['String']['output']>;
  /** roof edges */
  transitionLines: Array<MEdge>;
  /** roof edges */
  valleys: Array<MEdge>;
  windowTexture?: Maybe<WindowTexture>;
};

export type FeatureAccess = ApplicationRecord & {
  __typename?: 'FeatureAccess';
  accessorId?: Maybe<Scalars['Int']['output']>;
  accessorType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  identifier?: Maybe<FeatureAccessIdentifier>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum FeatureAccessAccessor {
  Org = 'ORG',
  User = 'USER'
}

export enum FeatureAccessIdentifier {
  AiSettings = 'AI_SETTINGS',
  AllowInteriorDeliverable = 'ALLOW_INTERIOR_DELIVERABLE',
  AllowInteriorLidar = 'ALLOW_INTERIOR_LIDAR',
  AnalyticsOrg = 'ANALYTICS_ORG',
  AnalyticsPartner = 'ANALYTICS_PARTNER',
  Blueprints = 'BLUEPRINTS',
  BlueprintsCommercial = 'BLUEPRINTS_COMMERCIAL',
  BlueprintsInteriorJobType = 'BLUEPRINTS_INTERIOR_JOB_TYPE',
  BlueprintsRoofOnly = 'BLUEPRINTS_ROOF_ONLY',
  BulkCreateCaptureRequests = 'BULK_CREATE_CAPTURE_REQUESTS',
  CompleteWithPaymentEmailWithPdfReceipt = 'COMPLETE_WITH_PAYMENT_EMAIL_WITH_PDF_RECEIPT',
  ConnectRecipientAddressLock = 'CONNECT_RECIPIENT_ADDRESS_LOCK',
  DesignViewMeasurementsTool = 'DESIGN_VIEW_MEASUREMENTS_TOOL',
  EhiProjectManagementProduct = 'EHI_PROJECT_MANAGEMENT_PRODUCT',
  EmailSendReceipt = 'EMAIL_SEND_RECEIPT',
  EmailShowReceiptAggregateDiscountsAndBasePriceSubsidy = 'EMAIL_SHOW_RECEIPT_AGGREGATE_DISCOUNTS_AND_BASE_PRICE_SUBSIDY',
  EmailShowReceiptBasePriceSubsidy = 'EMAIL_SHOW_RECEIPT_BASE_PRICE_SUBSIDY',
  EsxCreateWallsV3 = 'ESX_CREATE_WALLS_V3',
  EsxDeductOpeningsFromWalls = 'ESX_DEDUCT_OPENINGS_FROM_WALLS',
  EsxUseBarrelRoofStructure = 'ESX_USE_BARREL_ROOF_STRUCTURE',
  EsxUseGableRoofStructure = 'ESX_USE_GABLE_ROOF_STRUCTURE',
  ExpediteCompleteJobsAutomatically = 'EXPEDITE_COMPLETE_JOBS_AUTOMATICALLY',
  ExpediteRoofOnlyJobsAutomatically = 'EXPEDITE_ROOF_ONLY_JOBS_AUTOMATICALLY',
  ExportAdvancedJob = 'EXPORT_ADVANCED_JOB',
  ExportEsx = 'EXPORT_ESX',
  ExteriorReferenceMeasurement = 'EXTERIOR_REFERENCE_MEASUREMENT',
  GalleryAndScreenshotMode = 'GALLERY_AND_SCREENSHOT_MODE',
  GroupedJobs = 'GROUPED_JOBS',
  GuttersAndDownspouts = 'GUTTERS_AND_DOWNSPOUTS',
  HiDefRendering = 'HI_DEF_RENDERING',
  HomeownerMeasurementAccess = 'HOMEOWNER_MEASUREMENT_ACCESS',
  HoverNow = 'HOVER_NOW',
  InspectionChecklist = 'INSPECTION_CHECKLIST',
  Integrations = 'INTEGRATIONS',
  InteriorsMeasurementsApi = 'INTERIORS_MEASUREMENTS_API',
  InteriorReferenceMeasurement = 'INTERIOR_REFERENCE_MEASUREMENT',
  LeadAutoAssign = 'LEAD_AUTO_ASSIGN',
  LeadHomeownerCapture = 'LEAD_HOMEOWNER_CAPTURE',
  LoanCallToAction = 'LOAN_CALL_TO_ACTION',
  MaterialOrdering = 'MATERIAL_ORDERING',
  MaterialOrderingBeacon = 'MATERIAL_ORDERING_BEACON',
  MeasurementsCoBrand = 'MEASUREMENTS_CO_BRAND',
  MeasurementsFilesAccess = 'MEASUREMENTS_FILES_ACCESS',
  OnDemandExpeditedDeliverables = 'ON_DEMAND_EXPEDITED_DELIVERABLES',
  OrgJobsDailyZipExport = 'ORG_JOBS_DAILY_ZIP_EXPORT',
  OutOfTheBoxMaterialLists = 'OUT_OF_THE_BOX_MATERIAL_LISTS',
  Prospect = 'PROSPECT',
  ProPage = 'PRO_PAGE',
  RequireInspectionChecklist = 'REQUIRE_INSPECTION_CHECKLIST',
  SalesEstimation = 'SALES_ESTIMATION',
  SequentialCapture = 'SEQUENTIAL_CAPTURE',
  ShowDesignStudio = 'SHOW_DESIGN_STUDIO',
  SingleSignOn = 'SINGLE_SIGN_ON',
  SkipTlaScreens = 'SKIP_TLA_SCREENS',
  TeamManagementAdvanced = 'TEAM_MANAGEMENT_ADVANCED',
  TeamManagementBasic = 'TEAM_MANAGEMENT_BASIC',
  UpgradeToPro = 'UPGRADE_TO_PRO',
  VirtualWalkthrough = 'VIRTUAL_WALKTHROUGH'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  identifier: Scalars['String']['output'];
};

export type File = {
  __typename?: 'File';
  byteSize: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  /**
   * A stable, non-expiring URL for the file. This is a HOVER API endpoint that
   * redirects to the actual file location. Requires authenticated.
   */
  redirectUrl: Scalars['String']['output'];
  /**
   * A temporary, direct URL for the file. This URL includes authorization
   * information that expires. It will need to be used quickly.
   * @deprecated Use redirectUrl instead.
   */
  url: Scalars['String']['output'];
};

export type FileAttachment = ApplicationRecord & {
  __typename?: 'FileAttachment';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  url: Scalars['String']['output'];
};

/** Arguments for creating a FileAttachment */
export type FileAttachmentArgs = {
  /** The name for this file */
  filename: Scalars['String']['input'];
  /** The mimetype of this file */
  mimetype?: InputMaybe<Scalars['String']['input']>;
  /** The provider for this file */
  provider: Scalars['String']['input'];
  /** The size of the file in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** The url for this file */
  url: Scalars['String']['input'];
};

export enum FileStorageScopes {
  DesignStudio = 'DESIGN_STUDIO',
  ProgressiveUploads = 'PROGRESSIVE_UPLOADS'
}

export type FileStorageToken = {
  __typename?: 'FileStorageToken';
  token: Scalars['String']['output'];
};

/** Holds credentials needed to upload files any model. And a reference to the uploaded file. */
export type FileUpload = ApplicationRecordUuid & {
  __typename?: 'FileUpload';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * JSON encoded headers that are needed in the request to upload the file. These
   * headers provide the authentication for the upload request.
   */
  headers: Scalars['String']['output'];
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** A reference to the uploaded file. This can be used in mutations to associate with a model */
  signedBlobId: Scalars['ID']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Upload the file to this URL */
  url: Scalars['String']['output'];
};

export type FileUploadCreateInput = {
  byteSize: Scalars['Int']['input'];
  /** Base64 encoded MD5 checksum */
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of FileUploadCreate. */
export type FileUploadCreatePayload = {
  __typename?: 'FileUploadCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  fileUpload?: Maybe<FileUpload>;
};

export type GenAiConfigAiPrompt = ApplicationRecordUuid & {
  __typename?: 'GenAiConfigAiPrompt';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Associates gen_ai_config_ai_prompts with hyperion ai_prompts */
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating an AiGeneratedImage and AiDisplayImage */
export type GenerateAiImageArgs = {
  /** The AiOriginalImage that the AiGeneratedImage was created from */
  aiOriginalImageId: Scalars['Int']['input'];
  /** Name of the client making the request */
  appId: Scalars['String']['input'];
  /** Style of the home (e.g Midcentury) or 'Original' for image upload when no style is selected */
  style: Scalars['String']['input'];
};

/** Autogenerated return type of GenerateRemoteJWT. */
export type GenerateRemoteJwtPayload = {
  __typename?: 'GenerateRemoteJWTPayload';
  jwt?: Maybe<Scalars['String']['output']>;
};

export type GmlAnonymousSession = {
  __typename?: 'GmlAnonymousSession';
  jwt: Scalars['String']['output'];
};

export type GoodWallet = ApplicationRecord & {
  __typename?: 'GoodWallet';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  walletId?: Maybe<Scalars['Int']['output']>;
  walletShareId?: Maybe<Scalars['Int']['output']>;
};

export type Gutter = {
  __typename?: 'Gutter';
  downspouts: Array<Downspout>;
  elevationGroup: Scalars['Int']['output'];
  length: Scalars['Float']['output'];
  maxDistanceFromGround: Scalars['Float']['output'];
  parentFacadeId: Scalars['Int']['output'];
  pointA: Vector3;
  pointB: Vector3;
};

export type GutterData = {
  __typename?: 'GutterData';
  /** Individual group data */
  byGroup: Array<RoofFeatureData>;
  /** Returns true if there are any features longer than 20ft. */
  featuresAbove20Ft?: Maybe<Scalars['Boolean']['output']>;
  /** Cumulative feature data */
  totals: RoofFeatureData;
};

export type HiDefRendering = ApplicationRecord & {
  __typename?: 'HiDefRendering';
  additionsRequestFormUrl: Scalars['String']['output'];
  canCreateRevision: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  jobId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  requestFormRedirect: Scalars['String']['output'];
  requestFormUrl: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uuid: Scalars['String']['output'];
  /** Returns HiDefRenderingVersions associated with this rendering */
  versions: Array<HiDefRenderingVersion>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type HiDefRenderingFile = ApplicationRecord & {
  __typename?: 'HiDefRenderingFile';
  combinedLightingPass?: Maybe<Attachment>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cryptomattePass?: Maybe<Attachment>;
  cryptomatteRegions?: Maybe<CryptomatteRegions>;
  hiDefRenderingVersion: HiDefRenderingVersion;
  id: Scalars['Int']['output'];
  image: Attachment;
  productVariations?: Maybe<Array<HiDefRenderingFileProductVariation>>;
  textureScale: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uvPass?: Maybe<Attachment>;
};

export type HiDefRenderingFileProductVariation = ApplicationRecord & {
  __typename?: 'HiDefRenderingFileProductVariation';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** Deprecated. Please use productCatalogVariationUUID. */
  productCatalogVariationId?: Maybe<Scalars['Int']['output']>;
  productCatalogVariationUuid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type HiDefRenderingVersion = ApplicationRecord & {
  __typename?: 'HiDefRenderingVersion';
  artistComment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  designOrderResponse?: Maybe<DesignOrderResponse>;
  /** @deprecated This is contained in files */
  fileUrls: Array<Scalars['String']['output']>;
  files: Array<Attachment>;
  hiDefRenderingFiles: Array<HiDefRenderingFile>;
  hiDefRenderingId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  requestFormUrl: Scalars['String']['output'];
  state?: Maybe<HiDefRenderingVersionState>;
  submissionUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated This is contained in files */
  thumbnailFileUrls: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  versionType?: Maybe<RenderingVersion>;
};

export enum HiDefRenderingVersionState {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Paying = 'PAYING',
  Working = 'WORKING'
}

export type HomeownerMeasurements = {
  __typename?: 'HomeownerMeasurements';
  /** Calculated homeowner measurement report full JSON */
  fullJson?: Maybe<Scalars['JSON']['output']>;
  /** Single line address formatted */
  singleLineAddress?: Maybe<Scalars['String']['output']>;
  /** Calculated homeowner measurement report summary JSON */
  summaryJson?: Maybe<Scalars['JSON']['output']>;
};

export type Image = Media & {
  __typename?: 'Image';
  /** Public url of file. */
  blobUrl: Scalars['String']['output'];
  byteSize: Scalars['String']['output'];
  checksum: Scalars['String']['output'];
  /** The MIME type of the file. */
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  filename: Scalars['String']['output'];
  /**
   * Returns the height of the image in pixels after file has been analyzed. File
   * is analyzed asynchronously, so this field may return null if the job is still running.
   */
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  variants?: Maybe<ImageVariants>;
  /**
   * Returns the width of the image in pixels after file has been analyzed. File is
   * analyzed asynchronously, so this field may return null if the job is still running.
   */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for creating an image placeholder */
export type ImagePlaceholderArgs = {
  /** Tracks whether image capture was explicitly from auto capture */
  autoCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  /** This represents the direction of the photo with regards to the property */
  cubeFace?: InputMaybe<Scalars['Int']['input']>;
  /** Represents the kind of image. STANDARD for EHI (3D and measurements); DAMAGE/UNDERWRITING/EXTRA for insurance. */
  kind?: InputMaybe<JobImageKinds>;
  /** Exterior or interior image */
  viewpoint?: InputMaybe<JobImageViewpoints>;
};

export enum ImageSizes {
  Thumbnail = 'THUMBNAIL'
}

/** Arguments for transforming an image */
export type ImageTransformArgs = {
  /** Defined sizes for images */
  size?: InputMaybe<ImageSizes>;
};

export type ImageUploadInfo = {
  __typename?: 'ImageUploadInfo';
  imageId: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type ImageVariants = {
  __typename?: 'ImageVariants';
  /** A variant of the original image. To return multiple variants, use graphql aliases. */
  variant?: Maybe<Image>;
};


export type ImageVariantsVariantArgs = {
  transform?: InputMaybe<ImageTransformArgs>;
};

export type IndividualWindowData = {
  __typename?: 'IndividualWindowData';
  /** Window area adjusted to account for sash/openings trim. */
  area: Scalars['Int']['output'];
  /** Label of face with window on it. */
  face: Scalars['String']['output'];
  /** Rounded height of window in inches. */
  height?: Maybe<Scalars['Int']['output']>;
  /** Window label. */
  label: Scalars['String']['output'];
  /** Rounded sum of width and height in inches. */
  unitedInches: Scalars['Int']['output'];
  /** Rounded width of window in inches. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Checklist questions for orgs to record property info */
export type InspectionChecklist = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklist';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** The Job this InspectionChecklist is for. */
  job: Job;
  /** the job for this checklist */
  jobId: Scalars['Int']['output'];
  /** the user ID of the last user to update the checklist */
  lastSavedByUserId?: Maybe<Scalars['Int']['output']>;
  /** Provides name for inspection checklist */
  name?: Maybe<Scalars['String']['output']>;
  /** The Org this InspectionChecklist belongs to. */
  org: Org;
  /** the org that owns this checklist */
  orgId: Scalars['Int']['output'];
  questions: Array<InspectionChecklistQuestion>;
  /** The PDF file associated with this inspection checklist. */
  reportPdf?: Maybe<File>;
  sections: Array<InspectionChecklistSection>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for InspectionChecklist. */
export type InspectionChecklistConnection = {
  __typename?: 'InspectionChecklistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectionChecklistEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InspectionChecklist>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InspectionChecklistEdge = {
  __typename?: 'InspectionChecklistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectionChecklist>;
};

/** Questions to be answered with InspectionChecklists */
export type InspectionChecklistQuestion = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklistQuestion';
  /** The answer provided by the user */
  answerValue?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Which estimationConfigInput this question maps to in the Estimator */
  estimationConfigInputId?: Maybe<Scalars['Int']['output']>;
  estimationConfigInputOptionId?: Maybe<Scalars['ID']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  images: Array<File>;
  options?: Maybe<Array<InspectionConfigChecklistTemplateQuestionOption>>;
  /** The text of the question to be answered by the user */
  questionText: Scalars['String']['output'];
  /** The type of question */
  questionType?: Maybe<InspectionConfigChecklistQuestionTypeEnum>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  supportsImageUploads: InspectionChecklistQuestionSupportsImageUploadsEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Holds credentials needed to upload files to inspection checklist questions. And a reference to the uploaded file. */
export type InspectionChecklistQuestionFileUpload = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklistQuestionFileUpload';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * JSON encoded headers that are needed in the request to upload the file. These
   * headers provide the authentication for the upload request.
   */
  headers: Scalars['String']['output'];
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /**
   * A reference to the uploaded file. This can be used in mutations that update
   * inspection checklist questions to associate an uploaded file with a question.
   */
  signedBlobId: Scalars['ID']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Upload the file to this URL */
  url: Scalars['String']['output'];
};

export type InspectionChecklistQuestionFileUploadCreateInput = {
  byteSize: Scalars['Int']['input'];
  /** Base64 encoded MD5 checksum */
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export enum InspectionChecklistQuestionSupportsImageUploadsEnum {
  No = 'NO',
  Optional = 'OPTIONAL'
}

/** Arguments for upserting InspectionChecklistQuestions from ChecklistTemplateQuestions */
export type InspectionChecklistQuestionUpsertInput = {
  /**
   * This is only needed if you are creating new questions and you want to specify
   * the database ID of the record that will be created. See the 'id' argument.
   */
  _create?: InputMaybe<Scalars['Boolean']['input']>;
  /** The answer provided by the user */
  answerValue?: InputMaybe<Scalars['String']['input']>;
  estimationConfigInputOptionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If you want to specify the ID when creating a checklist question, you must
   * also send the _create argument with a true value. Must be a UUID.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * An array of signed blob ids for attaching images to this question. Use the
   * inspectionChecklistQuestionFileUploadCreate mutation to create a signed blob id.
   */
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The TemplateChecklistQuestion that copied this question */
  templateQuestionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Sections for Checklists */
export type InspectionChecklistSection = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklistSection';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** Name of section */
  name: Scalars['String']['output'];
  questions: Array<InspectionChecklistQuestion>;
  /** The order in which the section is meant to be displayed */
  sortOrder: Scalars['Int']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for upserting InspectionChecklist from ChecklistTemplateSections */
export type InspectionChecklistSectionUpsertInput = {
  /**
   * This is only needed if you are creating new sections and you want to specify
   * the database ID of the record that will be created. See the 'id' argument.
   */
  _create?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If you want to specify the ID when creating a checklist section, you must also
   * send the _create argument with a true value. Must be a UUID.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  questionsAttributes: Array<InspectionChecklistQuestionUpsertInput>;
  templateSectionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum InspectionConfigChecklistQuestionTypeEnum {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING'
}

/** InspectionConfig template for Checklists */
export type InspectionConfigChecklistTemplate = ApplicationRecordUuid & {
  __typename?: 'InspectionConfigChecklistTemplate';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** name of the template */
  name: Scalars['String']['output'];
  /** the org to which this template belongs */
  orgId?: Maybe<Scalars['Int']['output']>;
  questions: Array<InspectionConfigChecklistTemplateQuestion>;
  sections: Array<InspectionConfigChecklistTemplateSection>;
  state: InspectionConfigChecklistTemplateStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for InspectionConfigChecklistTemplate. */
export type InspectionConfigChecklistTemplateConnection = {
  __typename?: 'InspectionConfigChecklistTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectionConfigChecklistTemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InspectionConfigChecklistTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a Checklist Template */
export type InspectionConfigChecklistTemplateCreateInput = {
  /** name of the template */
  name: Scalars['String']['input'];
  /** the org to which this template belongs */
  orgId: Scalars['ID']['input'];
};

/** An edge in a connection. */
export type InspectionConfigChecklistTemplateEdge = {
  __typename?: 'InspectionConfigChecklistTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectionConfigChecklistTemplate>;
};

/** InspectionConfig questions for ChecklistTemplates */
export type InspectionConfigChecklistTemplateQuestion = ApplicationRecordUuid & {
  __typename?: 'InspectionConfigChecklistTemplateQuestion';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimationConfigInputId?: Maybe<Scalars['Int']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  options?: Maybe<Array<InspectionConfigChecklistTemplateQuestionOption>>;
  questionText: Scalars['String']['output'];
  questionType?: Maybe<InspectionConfigChecklistQuestionTypeEnum>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  supportsImageUploads: InspectionChecklistQuestionSupportsImageUploadsEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a Checklist template question */
export type InspectionConfigChecklistTemplateQuestionCreateInput = {
  estimationConfigInputId?: InputMaybe<Scalars['ID']['input']>;
  questionText: Scalars['String']['input'];
  questionType: InspectionConfigChecklistQuestionTypeEnum;
  sectionId: Scalars['ID']['input'];
  selectOptionsAttributes?: InputMaybe<Array<InspectionConfigChecklistTemplateQuestionSelectOptionInput>>;
  sortOrder: Scalars['Int']['input'];
  supportsImageUploads?: InputMaybe<InspectionChecklistQuestionSupportsImageUploadsEnum>;
};

/** Options for Checklist Question */
export type InspectionConfigChecklistTemplateQuestionOption = {
  __typename?: 'InspectionConfigChecklistTemplateQuestionOption';
  id: Scalars['String']['output'];
  /** label shown to the user */
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** Arguments for creating a Checklist template question select option */
export type InspectionConfigChecklistTemplateQuestionSelectOptionInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** template option value for multiple choice question */
  label: Scalars['String']['input'];
  /** the order in which the question option is displayed */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Arguments for updating a Checklist template question */
export type InspectionConfigChecklistTemplateQuestionUpdateInput = {
  estimationConfigInputId?: InputMaybe<Scalars['ID']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<InspectionConfigChecklistQuestionTypeEnum>;
  selectOptionsAttributes?: InputMaybe<Array<InspectionConfigChecklistTemplateQuestionSelectOptionInput>>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  supportsImageUploads?: InputMaybe<InspectionChecklistQuestionSupportsImageUploadsEnum>;
};

/** Inspection Config sections for Checklist Templates */
export type InspectionConfigChecklistTemplateSection = ApplicationRecordUuid & {
  __typename?: 'InspectionConfigChecklistTemplateSection';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** name of template section */
  name: Scalars['String']['output'];
  questions: Array<InspectionConfigChecklistTemplateQuestion>;
  /** The order in which the checklist template section is displayed on a checklist template */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a Checklist Template Section */
export type InspectionConfigChecklistTemplateSectionCreateInput = {
  /** name of template section */
  name: Scalars['String']['input'];
  /** The order in which the checklist template section is displayed on a checklist template */
  sortOrder: Scalars['Int']['input'];
  /** template that the section belongs to */
  templateId: Scalars['ID']['input'];
};

/** Arguments for updating a Checklist Template Section */
export type InspectionConfigChecklistTemplateSectionUpdateInput = {
  /** name of template section */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the checklist template section is displayed on a checklist template */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export enum InspectionConfigChecklistTemplateStateEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

/** Arguments for updating a Checklist Template */
export type InspectionConfigChecklistTemplateUpdateInput = {
  logo?: InputMaybe<Scalars['ID']['input']>;
  /** name of the template */
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<InspectionConfigChecklistTemplateStateEnum>;
};

export type InspectionDamageInspection = ApplicationRecord & {
  __typename?: 'InspectionDamageInspection';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  failedUploads?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  inspectorId: Scalars['ID']['output'];
  job: Job;
  jobId: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  workflow: InspectionWorkflow;
};

/** Arguments for the Inspection Detail payload */
export type InspectionDamageInspectionDetailArgs = {
  /** The overarching set of inspection sections that the inspection was subdivided into */
  inspectionSections: Array<InspectionDamageInspectionSectionArgs>;
};

/** A section that the inspection was subdivided into */
export type InspectionDamageInspectionSectionArgs = {
  /** The display order of the inspection section */
  displayOrder: Scalars['Int']['input'];
  /** The name of the group of tasks */
  groupName: Scalars['String']['input'];
  /** A list of the task groups within this inspection section */
  taskGroups: Array<InspectionTaskGroupArgs>;
  /** The type of the inspection section */
  type: Scalars['String']['input'];
};

/** Arguments for creating an inspection upload request */
export type InspectionDamageInspectionUploadRequestArgs = {
  /** The metadata of the files to upload */
  files?: InputMaybe<Array<InspectionFileUploadRequestArgs>>;
  /** The ID of the Inspection, if already available */
  inspectionId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the Inspection workflow that this inspection is based off */
  inspectionWorkflowId: Scalars['ID']['input'];
  /** The ID of the job with which the inspection is to be associated */
  jobId: Scalars['ID']['input'];
};

/** Arguments for creating an image upload request */
export type InspectionFileUploadRequestArgs = {
  /** The size of the file in bytes */
  byteSize: Scalars['Int']['input'];
  /** Base64 encoded MD5 checksum */
  checksum: Scalars['String']['input'];
  /** The content type of the file */
  contentType: Scalars['String']['input'];
  /** A client-persistent, unique identifier for the file */
  uuid: Scalars['String']['input'];
};

export type InspectionFormCaptureTaskArgs = {
  /** The answer to the question provided by the user */
  answer: Array<Scalars['String']['input']>;
  /** The unit of measurement for the answer */
  answerUnit?: InputMaybe<InspectionResponseUnits>;
  /** The order in which the task was displayed */
  displayOrder: Scalars['Int']['input'];
  /** Format of the response */
  presentationFormat: InspectionFormCaptureTaskPresentationFormats;
  /** Whether multiple selections were permitted */
  questionMultipleSelectionsPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the 'Other' was enable */
  questionOtherToTextSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Response options presented */
  questionSelectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The text of the question shown to the user */
  questionText: Scalars['String']['input'];
};

export enum InspectionFormCaptureTaskPresentationFormats {
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Measurement = 'MEASUREMENT',
  MultiLine = 'MULTI_LINE',
  NumericalInput = 'NUMERICAL_INPUT',
  Radio = 'RADIO',
  SingleLine = 'SINGLE_LINE',
  Stepper = 'STEPPER',
  Toggle = 'TOGGLE'
}

/** The details of a captured and uploaded photo */
export type InspectionPhotoCaptureTaskPhotoArgs = {
  /** The details about each photo captured, provided in a question and answer format */
  photoDetails?: InputMaybe<Array<InspectionPhotoCaptureTaskPhotoDetailArgs>>;
  /** Character-string provided to client application previously to perform upload */
  signedId: Scalars['String']['input'];
  /** The order in which the photo was taken */
  sortOrder: Scalars['Int']['input'];
};

/** Detail about captured photo, provided by the inspector in a question and answer format */
export type InspectionPhotoCaptureTaskPhotoDetailArgs = {
  /** The answer to the question provided by the user */
  questionAnswer: Scalars['String']['input'];
  /** The text of the question shown to the user */
  questionText: Scalars['String']['input'];
  /** The sort order of the question */
  sortOrder: Scalars['Int']['input'];
};

export enum InspectionResponseUnits {
  Cm = 'CM',
  Each = 'EACH',
  In = 'IN'
}

/** The details of a particular inspection task */
export type InspectionTaskArgs = {
  /** The name/label of the task */
  displayName: Scalars['String']['input'];
  /** The order in which the task was displayed */
  displayOrder: Scalars['Int']['input'];
  /** The description of the task provided as guidance to the user */
  guidanceDescription?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the workflow task this task comes from */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind of task */
  kind: Scalars['String']['input'];
  /** The number of photos needed to complete the task */
  numberOfPhotosRequired?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not the task was required to be completed */
  required: Scalars['Boolean']['input'];
  /** The answers to the form capture questions */
  submittedFormAnswers?: InputMaybe<Array<InspectionFormCaptureTaskArgs>>;
  /** The data for each photo captured and uploaded */
  submittedPhotos?: InputMaybe<Array<InspectionPhotoCaptureTaskPhotoArgs>>;
};

/** A list of tasks belonging to this group */
export type InspectionTaskGroupArgs = {
  /** Whether or not this task group was included in the default workflow */
  default: Scalars['Boolean']['input'];
  /** The display order of the task group */
  displayOrder: Scalars['Int']['input'];
  /** The name of the task group */
  groupName: Scalars['String']['input'];
  /** The list of tasks */
  tasks: Array<InspectionTaskArgs>;
  /** The type of the task group */
  type: Scalars['String']['input'];
};

export type InspectionUploadParams = {
  __typename?: 'InspectionUploadParams';
  checksum: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Used to look up and associate attachment after succesful upload */
  signedId?: Maybe<Scalars['String']['output']>;
  /** Headers used for upload request */
  uploadHeaders?: Maybe<Scalars['String']['output']>;
  /** URL used for direct upload of image by client */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type InspectionUploadRequest = {
  __typename?: 'InspectionUploadRequest';
  /** The ID of the Inspection record this upload payload is associated with */
  inspectionId: Scalars['Int']['output'];
  /** An array of upload parameters for the requested file uploads */
  uploadParams: Array<InspectionUploadParams>;
};

export type InspectionWorkflow = ApplicationRecord & {
  __typename?: 'InspectionWorkflow';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  inspectionSections: Array<InspectionWorkflowSection>;
  name: Scalars['String']['output'];
  owningOrg: Org;
  situation: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InspectionWorkflowFormCaptureTaskQuestion = ApplicationRecord & {
  __typename?: 'InspectionWorkflowFormCaptureTaskQuestion';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  multipleSelectionsPermitted?: Maybe<Scalars['Boolean']['output']>;
  otherToTextSupport?: Maybe<Scalars['Boolean']['output']>;
  presentationFormat: InspectionFormCaptureTaskPresentationFormats;
  required: Scalars['Boolean']['output'];
  responseMaximum?: Maybe<Scalars['Int']['output']>;
  responseMinimum?: Maybe<Scalars['Int']['output']>;
  responseUnit?: Maybe<InspectionResponseUnits>;
  selectOptions?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InspectionWorkflowPhotoCaptureTaskQuestion = ApplicationRecord & {
  __typename?: 'InspectionWorkflowPhotoCaptureTaskQuestion';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  selectOptions?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InspectionWorkflowSection = ApplicationRecord & {
  __typename?: 'InspectionWorkflowSection';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customTaskGroups?: Maybe<Array<InspectionWorkflowTaskGroup>>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  taskGroups?: Maybe<Array<InspectionWorkflowTaskGroup>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InspectionWorkflowTask = ApplicationRecord & {
  __typename?: 'InspectionWorkflowTask';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayOrder: Scalars['Int']['output'];
  formQuestions?: Maybe<Array<InspectionWorkflowFormCaptureTaskQuestion>>;
  guidanceDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfPhotosRequired?: Maybe<Scalars['Int']['output']>;
  photoQuestions?: Maybe<Array<InspectionWorkflowPhotoCaptureTaskQuestion>>;
  required: Scalars['Boolean']['output'];
  samplePhotos?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InspectionWorkflowTaskGroup = ApplicationRecord & {
  __typename?: 'InspectionWorkflowTaskGroup';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  default: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  tasks: Array<InspectionWorkflowTask>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Integration::ManualSync */
export type IntegrationManualSync = {
  __typename?: 'IntegrationManualSync';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The record that was synced */
  recordId: Scalars['ID']['output'];
  recordType: Scalars['String']['output'];
};

export type Jwt = {
  __typename?: 'JWT';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Job = ApplicationRecord & {
  __typename?: 'Job';
  /** Return all the image albums for this job */
  albums: Array<Album>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  approvingUser?: Maybe<UserBasicInfo>;
  archived: Scalars['Boolean']['output'];
  /**
   * Returns an array of deliverables that the current_user can request an upgrade
   * for this job using the createDeliverableChangeRequest mutation.
   */
  availableDeliverableUpgrades: Array<Deliverable>;
  /**
   * Return the best front-view image that we could find for this job. If there
   * isn't any front-view image for this job, it will return one of job's images
   * (if there is any).
   */
  bestFrontImage?: Maybe<JobImage>;
  blueprint: Scalars['Boolean']['output'];
  /** Returns a boolean indicating whether the user can access/view renderings for this job */
  canAccessRendering: Scalars['Boolean']['output'];
  /** Returns a boolean indicating whether the user has permission to order renderings for this job */
  canOrderRendering: Scalars['Boolean']['output'];
  /**
   * Returns a boolean indicating whether the user has permission to order
   * renderings and if the job is in a state such that renderings can be requested
   */
  canRequestRendering: Scalars['Boolean']['output'];
  /**
   * Returns a boolean indicating whether the user can request rendering revisions for this job
   * @deprecated Unused, use can_create_revision on the specific HiDefRendering instead
   */
  canRequestRenderingRevision: Scalars['Boolean']['output'];
  /** Returns a boolean indicating whether the user has permission to upgrade this job */
  canUpgrade: Scalars['Boolean']['output'];
  captureRequest?: Maybe<CaptureRequest>;
  /** Returns capture type which identifies capture as being made for interiors vs exteriors, dense or sparse. */
  captureType?: Maybe<JobCaptureTypes>;
  capturedBy?: Maybe<UserBasicInfo>;
  /** @deprecated This is contained in capturedBy */
  capturedUserId?: Maybe<Scalars['Int']['output']>;
  clientIdentifier?: Maybe<Scalars['String']['output']>;
  /** Returns a boolean indicating if the job is a complete expedited job. */
  completeExpedited: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<UserBasicInfo>;
  /** Contain information of this job related to the current_user. */
  currentUserContext: JobCurrentUserContext;
  deliverable?: Maybe<Deliverable>;
  /** Return all deliverable change requests for this job. */
  deliverableChangeRequests: Array<DeliverableChangeRequest>;
  /** DistributionOrders placed for this job. */
  distributionOrders: Array<DistributionOrder>;
  /** True if at least one DistributionOrder has been placed for this job. */
  distributionOrdersExist: Scalars['Boolean']['output'];
  /** Returns a calculated ETA for job completion */
  estimatedCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  estimatedHoursToCompletion?: Maybe<Scalars['Float']['output']>;
  estimationEstimateGroups: Array<EstimationEstimateGroup>;
  example?: Maybe<Scalars['Boolean']['output']>;
  exports?: Maybe<JobExports>;
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  /** Returns true if the job has at least one Room with at least one failure reason. */
  failedRooms: Scalars['Boolean']['output'];
  /** Returns a list of file attachments */
  fileAttachments?: Maybe<Array<FileAttachment>>;
  /** Returns the selected wallet that will be used to pay for this job */
  goodWallet?: Maybe<GoodWallet>;
  hasInspectionChecklists?: Maybe<Scalars['Boolean']['output']>;
  /** When the HDF was last updated */
  hdfCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Returns a list of HiDefRenderings, their versions and files. */
  hiDefRenderings?: Maybe<Array<HiDefRendering>>;
  /** Returns a subset of the model's measurements that are available to homeowners. */
  homeownerMeasurements?: Maybe<HomeownerMeasurements>;
  id: Scalars['Int']['output'];
  /** Return all the images for this job */
  images: Array<JobImage>;
  inspectionChecklists?: Maybe<Array<InspectionChecklist>>;
  interiorFloorPlan: Scalars['Boolean']['output'];
  is3dAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Returns a list of job assignments for this job. */
  jobAssignments: Array<JobAssignment>;
  jobGroups?: Maybe<Array<JobGroup>>;
  /** Returns a list of invitations for users invited to access this job */
  jobUserInvites?: Maybe<Array<JobUserInvite>>;
  /**
   * Contains job labels that represents various job status and states. This acts
   * as a translation of internal states and properties of a job into labels that
   * FE can consume easier.
   */
  labels: Array<JobLabels>;
  /**
   * Returns a boolean indicating whether the last payment for this job failed. The
   * good type of the failed payment would either be Job or BlueprintJob. If the
   * last payment of a job has failed, and the model is in a paying state, this
   * indicates that the customer needs to update their payment method in order to
   * continue processing the job.
   */
  lastPaymentFailed: Scalars['Boolean']['output'];
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationLat?: Maybe<Scalars['String']['output']>;
  locationLine1?: Maybe<Scalars['String']['output']>;
  locationLine2?: Maybe<Scalars['String']['output']>;
  locationLon?: Maybe<Scalars['String']['output']>;
  locationPostalCode?: Maybe<Scalars['String']['output']>;
  locationRegion?: Maybe<Scalars['String']['output']>;
  /** Returns the manowar identifier for the job's model. */
  manowarIdentifier?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<JobMeasurements>;
  /** Reason of modeling failure. Will be null unless state field is FAILED. */
  modelFailureReason?: Maybe<Scalars['String']['output']>;
  /** ID of the model if it exists. */
  modelId?: Maybe<Scalars['Int']['output']>;
  /** Returns the modeling status for the job. */
  modelingStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Returns job notes that are visible to current user ordered by job created_at
   * timestamp. If current user is a pro, current user can see their own notes plus
   * all the homeowner notes on this job.
   */
  notes: NotePaginatedResults;
  /**
   * A jwt that can be sent in the x-order-data-jwt header when requesting
   * measurement data. This will not be available for example jobs or clone jobs.
   */
  orderDataJwt?: Maybe<Scalars['String']['output']>;
  /**
   * The org who created the job, which can (in cases of a wallet share) be
   *                                    different than the payment_org
   */
  org?: Maybe<OrgBasicInfo>;
  orgId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Prefer using paint measurements within measurements field */
  paintMeasurements?: Maybe<PaintMeasurements>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  /** Returns the org that will pay for this job. */
  paymentOrg?: Maybe<OrgBasicInfo>;
  /** HOVER Now details */
  roofEstimate?: Maybe<RoofEstimate>;
  roofEstimateAccessLevel: RoofEstimateAccessLevels;
  salesOpportunity?: Maybe<SalesOpportunity>;
  state?: Maybe<JobModelStates>;
  threeDFiles?: Maybe<JobThreeDFiles>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated This is contained in createdBy */
  userId?: Maybe<Scalars['Int']['output']>;
  virtualWalkthroughAvailable?: Maybe<Scalars['Boolean']['output']>;
  xactProjectUploads?: Maybe<Array<XactProjectUpload>>;
  xactProjects?: Maybe<Array<XactProject>>;
};


export type JobDistributionOrdersArgs = {
  orgId: Scalars['ID']['input'];
};


export type JobDistributionOrdersExistArgs = {
  orgId: Scalars['ID']['input'];
};


export type JobEstimationEstimateGroupsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type JobHasInspectionChecklistsArgs = {
  orgId: Scalars['ID']['input'];
};


export type JobInspectionChecklistsArgs = {
  orgId: Scalars['ID']['input'];
};


export type JobNotesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type JobSalesOpportunityArgs = {
  orgId: Scalars['ID']['input'];
};

/** Autogenerated return type of JobAccountAuthenticationCreate. */
export type JobAccountAuthenticationCreatePayload = {
  __typename?: 'JobAccountAuthenticationCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  jobAccountAuthentication?: Maybe<DistributionJobAccountAuthentication>;
};

/** Autogenerated return type of JobAccountAuthenticationDelete. */
export type JobAccountAuthenticationDeletePayload = {
  __typename?: 'JobAccountAuthenticationDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
  jobAccountAuthentication?: Maybe<Array<DistributionJobAccountAuthentication>>;
};

export type JobAssignment = ApplicationRecord & {
  __typename?: 'JobAssignment';
  assignedByUser?: Maybe<UserBasicInfo>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  kind: JobAssignmentKind;
  shareJobMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: UserBasicInfo;
  userId: Scalars['Int']['output'];
};

/** Arguments to create a job assignment */
export type JobAssignmentArgs = {
  /** Job assignment assigner's user ID */
  assignedById?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['Int']['input'];
  kind: JobAssignmentKind;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  shareJobMessage?: InputMaybe<Scalars['String']['input']>;
  /** Job assignment assignee's user ID */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobAssignmentKind {
  Assignment = 'ASSIGNMENT',
  CaptureRequest = 'CAPTURE_REQUEST',
  ClonedJob = 'CLONED_JOB',
  Creator = 'CREATOR',
  Example = 'EXAMPLE',
  JobInvite = 'JOB_INVITE'
}

export type JobBasePrice = ApplicationRecord & {
  __typename?: 'JobBasePrice';
  complexity: Complexities;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliverable: Deliverable;
  /** The number of facets or polygons that a job requires to model */
  facetRange: Scalars['String']['output'];
  goodType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  partnerSubsidy: Scalars['Int']['output'];
  planId: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum JobCaptureTypes {
  DenseExterior = 'DENSE_EXTERIOR',
  DenseInterior = 'DENSE_INTERIOR',
  RoomplanInterior = 'ROOMPLAN_INTERIOR',
  SparseExterior = 'SPARSE_EXTERIOR',
  VideoInterior = 'VIDEO_INTERIOR'
}

/** Arguments for creating a job */
export type JobCreateArgs = {
  /**
   * This is any arbitrary string that clients want to use to identify jobs.
   * Clients in this case means the actual software clients that are uploading the
   * job. For example: mobile applications, website, and any software that 3rd
   * parties build to interact with our system. This is typically used to help with
   * the uploading process. Our uploading process is asyncronous and does not
   * return a Job ID when you upload. Including a client_identifier in your upload
   * and checking the client identifier of new jobs that enter your account is the
   * only way to match up what you uploaded with the resulting job. The given value
   * must be globally unique.
   */
  clientIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** True if the contractor has checked the box to remind them to contact the customer. Default is false. */
  customerContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the contractor has checked the box to only contact the customer by email. Default is false. */
  customerContactOnlyByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The email address of the customer. Usually the homeowner. */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer. Usually the homeowner. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** If present, a new Note will be created for this job with the given body */
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the customer. Usually the homeowner. */
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Refer to 'available_deliverables' in the 'Org' object. */
  deliverableId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The city of this job's address. */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  /** The country of the job's address. */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  /** The latitude of the job's address. */
  locationLat?: InputMaybe<Scalars['String']['input']>;
  /** First line of this job's address. */
  locationLine1?: InputMaybe<Scalars['String']['input']>;
  /** Second line of this job's address. */
  locationLine2?: InputMaybe<Scalars['String']['input']>;
  /** The longitude of the job's address. */
  locationLon?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the job's address. */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state/region of this job's address. */
  locationRegion?: InputMaybe<Scalars['String']['input']>;
  /** A name for this job. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Account identifier used by external partner. Will be persisted to allow correct party (org or partner) to be billed */
  partnerAccountIdentifier?: InputMaybe<Scalars['Int']['input']>;
  /** If present, and project id exists, the job will be associated with the project */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  /** The type of property this job is for. Possible values are SINGLE_FAMILY_RESIDENTIAL, MULTI_FAMILY_RESIDENTIAL, COMMERCIAL */
  propertyType?: InputMaybe<JobPropertyTypes>;
  /** Deprecated. This will always set to false. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set to true, all emails (including capture request emails) related to this job will be suppressed. Default is false. */
  suppressEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This optional parameter causes a job to be a "test" job and to skip our
   * processing pipeline. "COMPLETE" auto completes your job with example results.
   * "FAILED" automatically fails the job. This parameter should not be used on real jobs.
   */
  testState?: InputMaybe<JobTestStates>;
  /** Set the wallet_id to use for this job. Refer to 'billableWallets' in the 'Org' object. */
  walletId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobCurrentUserContext = {
  __typename?: 'JobCurrentUserContext';
  /** Return true if current_user is assigned to this job. */
  assignedToMe: Scalars['Boolean']['output'];
  /** Return true if the current_user can approve this job. */
  canApprove: Scalars['Boolean']['output'];
  /** Return true if the current_user can archive this job. */
  canArchive: Scalars['Boolean']['output'];
  /** Return true if the current_user can choose delivery speed for this job. */
  canChooseDeliverySpeed: Scalars['Boolean']['output'];
  /** Returns true if the current user can update this job. */
  canUpdate: Scalars['Boolean']['output'];
  /** Return true if a pending capture request is sent by the current_user. */
  captureRequestSentByMe: Scalars['Boolean']['output'];
  /** Return true if a pending capture request is sent to the current_user. */
  captureRequestSentToMe: Scalars['Boolean']['output'];
  /** Return true if current_user created this job. */
  createdByMe: Scalars['Boolean']['output'];
};

/**
 * The export files associated with a job. For HOVER Now (roof_estimate), all urls
 * will return null. Access to certain urls is gated behind feature access, and if
 * the org does not have the required feature access, the url will return null.
 */
export type JobExports = {
  __typename?: 'JobExports';
  /** If the org has access to advanced exports such as skp, dxf and dwg. */
  canAccessAdvancedExports: Scalars['Boolean']['output'];
  /** If the org has access to the esx export. */
  canAccessEsx: Scalars['Boolean']['output'];
  /** A URL to download the exports dwg file. */
  dwgUrl?: Maybe<Scalars['String']['output']>;
  /** A URL to download the exports dxf file. */
  dxfUrl?: Maybe<Scalars['String']['output']>;
  /** A URL to download the exports esx file. */
  esxUrl?: Maybe<Scalars['String']['output']>;
  /** A URL to download the exports skp file. */
  skpUrl?: Maybe<Scalars['String']['output']>;
};

export type JobGroup = ApplicationRecord & {
  __typename?: 'JobGroup';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  jobsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImage = {
  __typename?: 'JobImage';
  /** Tracks whether image capture was explicitly from auto capture */
  autoCaptured?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Represents the position of the image being taken in respective of the building.
   * Values other than the ones listed below can be ignored.
   *
   * - FRONT: 0
   * - FRONT_RIGHT: 1
   * - RIGHT: 2
   * - BACK_RIGHT: 3
   * - BACK: 4
   * - BACK_LEFT: 5
   * - LEFT: 6
   * - FRONT_LEFT: 7
   */
  cubeFace?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: 50
   */
  imageLowQualityUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 800x800
   * <br />
   * Quality: 60
   */
  imageMediumUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 200x200
   * <br />
   * Quality: 60
   */
  imageSmallUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: as originally uploaded
   */
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageVersion: Scalars['Int']['output'];
  /** Represents the kind of image. STANDARD for EHI (3D and measurements); DAMAGE/UNDERWRITING/EXTRA for insurance. */
  kind?: Maybe<JobImageKinds>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: 50
   */
  rotatedImageLowQualityUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 800x800
   * <br />
   * Quality: 60
   */
  rotatedImageMediumUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: 200x200
   * <br />
   * Quality: 60
   */
  rotatedImageSmallUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: as originally uploaded
   */
  rotatedImageUrl?: Maybe<Scalars['String']['output']>;
  rotatedImageVersion: Scalars['Int']['output'];
  /** Represents whether this is an exterior or interior image. */
  viewpoint: JobImageViewpoints;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageImageLowQualityUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageImageMediumUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageImageSmallUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageImageUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageRotatedImageLowQualityUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageRotatedImageMediumUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageRotatedImageSmallUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation
 * and we attempt to correct them when we process the images.
 *
 * You may use the rotated_image_url, rotated_image_small_size_url,
 * rotated_image_medium_size_url, or rotated_image_low_quality_url
 * to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as
 * 1 (lowest image quality and highest compression) to
 * 100 (best quality but least effective compression).
 *
 * The with_signed_url argument has been deprecated.
 * It is always treated as false.
 */
export type JobImageRotatedImageUrlArgs = {
  withSignedUrl?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum JobImageKinds {
  ArReference = 'AR_REFERENCE',
  Damage = 'DAMAGE',
  Entrance = 'ENTRANCE',
  Extra = 'EXTRA',
  /** @deprecated MISC is replaced by enum EXTRA */
  Misc = 'MISC',
  Standard = 'STANDARD',
  Underwriting = 'UNDERWRITING'
}

export enum JobImageViewpoints {
  Exterior = 'EXTERIOR',
  Interior = 'INTERIOR'
}

export enum JobLabels {
  /** When job requires approval, and current_user is not an Org admin. */
  AwaitingApproval = 'AWAITING_APPROVAL',
  /** When job state is CANCELLED. */
  Cancelled = 'CANCELLED',
  /** When job state is COMPLETE. */
  Done = 'DONE',
  /**
   * When the difference between now and job's completedAt exceeds the number of days of historical job access the
   * plan of the current user's org includes.
   */
  LimitedAccess = 'LIMITED_ACCESS',
  /**
   * When job state is FAILED, and job is uploaded manually by HOVER
   * support.
   */
  ManualUploadFailed = 'MANUAL_UPLOAD_FAILED',
  /** When job requires approval, and current_user is an Org admin. */
  NeedsApproval = 'NEEDS_APPROVAL',
  /** When job state is PAYING, and job payment failed. */
  PaymentFailed = 'PAYMENT_FAILED',
  /**
   * When job state is not in one of the states:
   * COMPLETE,
   * FAILED,
   * CANCELLED.
   */
  Processing = 'PROCESSING',
  /** When job state is FAILED, and job is uploaded by user. */
  UserUploadFailed = 'USER_UPLOAD_FAILED'
}

/**
 * For HOVER Now (roof_estimate), all urls will return null. TLA/TLA+ only support
 * pdfUrl, summarizedJsonUrl and sketchJsonUrl. All other urls for TLA/TLA+ will return null.
 */
export type JobMeasurements = {
  __typename?: 'JobMeasurements';
  /** If the org has access to measurement export files like XML. */
  canAccessMeasurementExports?: Maybe<Scalars['Boolean']['output']>;
  /** Full version of the measurements JSON file. */
  fullJsonUrl?: Maybe<Scalars['String']['output']>;
  /** A signed URL to download the measurements JSON file. The URL will expire in 10 minutes from the time of the request. */
  jsonUrl?: Maybe<Scalars['String']['output']>;
  /** Calculated paint report JSON */
  paintMeasurements?: Maybe<PaintMeasurements>;
  /** A signed URL to download the measurements PDF file. The URL will expire in 10 minutes from the time of the request. */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Sketch version of the measurements JSON file. Only TLA/TLA+ are supported. Returns nil for other deliverables. */
  sketchJsonUrl?: Maybe<Scalars['String']['output']>;
  /** A signed URL to download the measurements xlsx file. The URL will expire in 10 minutes from the time of the request. */
  spreadsheetUrl?: Maybe<Scalars['String']['output']>;
  /** Summarized version of the measurements JSON file. */
  summarizedJsonUrl?: Maybe<Scalars['String']['output']>;
  /**
   * A URL to download the Symbility specific version of the measurements xml file.
   * This file format is intended for use with Symbility applications.
   */
  symbilityXmlUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  /** A signed URL to download the measurements xml file. The URL will expire in 10 minutes from the time of the request. */
  xmlUrl?: Maybe<Scalars['String']['output']>;
};

export enum JobModelStates {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  HoldingForCaptureSessionPayment = 'HOLDING_FOR_CAPTURE_SESSION_PAYMENT',
  Paying = 'PAYING',
  Processing = 'PROCESSING',
  ProcessingUpload = 'PROCESSING_UPLOAD',
  ProcessingUploadForImprovements = 'PROCESSING_UPLOAD_FOR_IMPROVEMENTS',
  ReleasedWithoutPayment = 'RELEASED_WITHOUT_PAYMENT',
  RequestingCorrections = 'REQUESTING_CORRECTIONS',
  RequestingImprovements = 'REQUESTING_IMPROVEMENTS',
  Retrieving = 'RETRIEVING',
  Submitting = 'SUBMITTING',
  Uploading = 'UPLOADING',
  WaitingApproval = 'WAITING_APPROVAL',
  /** @deprecated Waitlist is no longer supported */
  Waitlisted = 'WAITLISTED',
  Working = 'WORKING'
}

/** Paginated results for a given type */
export type JobPaginatedResults = {
  __typename?: 'JobPaginatedResults';
  pagination: Pagination;
  results: Array<Maybe<Job>>;
};

export enum JobPropertyTypes {
  Commercial = 'COMMERCIAL',
  MultiFamilyResidential = 'MULTI_FAMILY_RESIDENTIAL',
  SingleFamilyResidential = 'SINGLE_FAMILY_RESIDENTIAL'
}

export enum JobSearchFilters {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NeedsApproval = 'NEEDS_APPROVAL',
  PhotosNeeded = 'PHOTOS_NEEDED',
  Processing = 'PROCESSING'
}

export type JobSharedPaintMeasurements = {
  __typename?: 'JobSharedPaintMeasurements';
  /** ID of the Job associated with the shared Paint Measurements. */
  id?: Maybe<Scalars['Int']['output']>;
  jobThreeDFiles?: Maybe<JobThreeDFiles>;
  paintMeasurements?: Maybe<PaintMeasurements>;
};

export type JobSharedRenderings = {
  __typename?: 'JobSharedRenderings';
  /** A list of capture requests where this user is the capturing user. */
  captureRequest?: Maybe<SharedCaptureRequest>;
  /** Returns a list of HiDefRenderings, their versions and files. */
  hiDefRenderings?: Maybe<Array<HiDefRendering>>;
  /** ID of the job associated with the rendering */
  id?: Maybe<Scalars['Int']['output']>;
  /** ID of the org associated to the rendering's job */
  orgId?: Maybe<Scalars['Int']['output']>;
  /** ID of the partner associated to the rendering's job's org */
  partnerId?: Maybe<Scalars['Int']['output']>;
  /** ID of the user that created the rendering's job */
  userId?: Maybe<Scalars['Int']['output']>;
};

/**
 * All URLs here are pre-signed S3 URLs for downloading a job's 3D files.
 * The URLs will expire in 10 minutes from the time of the request.
 *
 * The URLs will return null if the 3D files are not available yet.
 *
 * JobThreeDFiles will return null if:
 *
 * <ul>
 *   <li>the job has not been paid for</li>
 * </ul>
 */
export type JobSharedThreeDFiles = {
  __typename?: 'JobSharedThreeDFiles';
  /** An auth token used to include with firestore requests and queries versions */
  authToken?: Maybe<Scalars['String']['output']>;
  /** A signed URL to download the 3D geometry data of this job in JSON format */
  geometryUrl?: Maybe<Scalars['String']['output']>;
  /** A signed URL to download the 3D metadata of this job in JSON format */
  metadataUrl?: Maybe<Scalars['String']['output']>;
};

export enum JobSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum JobTestStates {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  No = 'NO'
}

/**
 * All URLs here are pre-signed S3 URLs for downloading a job's 3D files.
 * The URLs will expire in 10 minutes from the time of the request.
 *
 * The URLs will return null if the 3D files are not available yet.
 *
 * JobThreeDFiles will return null if:
 *
 * <ul>
 *   <li>the job has not been paid for</li>
 * </ul>
 */
export type JobThreeDFiles = {
  __typename?: 'JobThreeDFiles';
  /** A signed URL to download the 3D geometry data of this job in JSON format */
  geometryUrl?: Maybe<Scalars['String']['output']>;
  /** A signed URL to download the 3D metadata of this job in JSON format */
  metadataUrl?: Maybe<Scalars['String']['output']>;
};

export enum JobTypeFilters {
  Blueprint = 'BLUEPRINT',
  Connect = 'CONNECT',
  Prospect = 'PROSPECT',
  Standard = 'STANDARD'
}

/** Arguments for updating a job */
export type JobUpdateArgs = {
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The city of this job's address. */
  locationCity?: InputMaybe<Scalars['String']['input']>;
  /** The country of the job's address. */
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  /** The latitude of the job's address. */
  locationLat?: InputMaybe<Scalars['String']['input']>;
  /** First line of this job's address. */
  locationLine1?: InputMaybe<Scalars['String']['input']>;
  /** Second line of this job's address. */
  locationLine2?: InputMaybe<Scalars['String']['input']>;
  /** The longitude of the job's address. */
  locationLon?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the job's address. */
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state/region of this job's address. */
  locationRegion?: InputMaybe<Scalars['String']['input']>;
  /** A name for this job. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobUserInvite = ApplicationRecord & {
  __typename?: 'JobUserInvite';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  invitingUserId: Scalars['Int']['output'];
  jobId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userActivated: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
  /** @deprecated Unused, switching to user aasm state to determine visited state. */
  visitedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum JobsViewableBy {
  All = 'ALL',
  Me = 'ME',
  Team = 'TEAM'
}

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** LineItem */
export type LineItem = ApplicationRecord & {
  __typename?: 'LineItem';
  allowVariationSelection: Scalars['Boolean']['output'];
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  custom: Scalars['Boolean']['output'];
  equation?: Maybe<Scalars['String']['output']>;
  estimationConfigLineItem?: Maybe<EstimationConfigLineItem>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  isAuto?: Maybe<Scalars['Boolean']['output']>;
  /** A margin specific to the line item (as a whole percent, e.g., `8.0'  = 8%) */
  margin?: Maybe<Scalars['Float']['output']>;
  measurement?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<MeasurementUnit>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  /** The product assigned to this line item */
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']['output']>;
  /** Foreign key to product_catalog_variation */
  productCatalogVariationId?: Maybe<Scalars['ID']['output']>;
  productCatalogVariationName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The measurement of unit being ordered (can be any value in the `line_item_quantity_units' enum) */
  quantityUnits?: Maybe<QuantityUnit>;
  results: Scalars['String']['output'];
  /** A sales tax specific to the line item (as a whole percent, e.g., `10.0'  = 10%) */
  salesTax?: Maybe<Scalars['Float']['output']>;
  /** The variation assigned to this line item */
  selectedVariation?: Maybe<ProductCatalogVariation>;
  /** The category of goods being ordered in this line item (can be any value in the `estimation_line_item_type' enum) */
  type?: Maybe<LineItemTypeEnum>;
  /** The per-unit cost of a line item (multiplied by the `quantity' */
  unitCost?: Maybe<Scalars['Float']['output']>;
  unitFormulaResults?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  values?: Maybe<Scalars['String']['output']>;
  wasteFactor?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated return type of LineItemCreate. */
export type LineItemCreatePayload = {
  __typename?: 'LineItemCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  lineItem?: Maybe<EstimationConfigLineItem>;
};

/** Autogenerated return type of LineItemDelete. */
export type LineItemDeletePayload = {
  __typename?: 'LineItemDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

export enum LineItemTypeEnum {
  Labor = 'LABOR',
  Material = 'MATERIAL',
  Other = 'OTHER'
}

/** Autogenerated return type of LineItemUpdate. */
export type LineItemUpdatePayload = {
  __typename?: 'LineItemUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  lineItem?: Maybe<LineItem>;
  matchedLineItems?: Maybe<Array<LineItem>>;
};

/** Production List Item */
export type ListItem = ApplicationRecord & {
  __typename?: 'ListItem';
  /** The quantity that was calculated for the list item, which will be rounded to the next integer for material items. */
  calculatedQuantity?: Maybe<Scalars['Float']['output']>;
  /** The name of the color of this product. For example 'Light Blue' */
  color?: Maybe<Scalars['String']['output']>;
  /** Net coverarge per seeling UoM, originally passed from the line item value. */
  coverage?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The DistributionOrders this list item has been included in */
  distributionOrders: Array<DistributionOrder>;
  /** Indicates if a list item was changed/edited by a user after being created. */
  editedStatus: EditedStatusEnum;
  estimationConfigLineItem?: Maybe<EstimationConfigLineItem>;
  /** @deprecated Replaced By productCatalogProductId */
  externalProductId?: Maybe<Scalars['ID']['output']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  isManualMeasurement?: Maybe<Scalars['Boolean']['output']>;
  lineItem?: Maybe<LineItem>;
  /** The optional id of the estimation_line_item this list item refers to */
  lineItemId?: Maybe<Scalars['Int']['output']>;
  listItemContext?: Maybe<Scalars['String']['output']>;
  listItemGroupId?: Maybe<Scalars['ID']['output']>;
  listItemGroupName?: Maybe<Scalars['String']['output']>;
  manualAdjustment?: Maybe<ProjectManagementListItemManualAdjustment>;
  /** The float amount for this list item */
  measurement?: Maybe<Scalars['Float']['output']>;
  /** The label for units that the measurement describes */
  measurementUnits?: Maybe<Scalars['String']['output']>;
  /** The name label of this list item */
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** If this list item has been ordered it'll have an entry in this array for every order it was included in. */
  orderListItems: Array<ProjectManagementOrderListItem>;
  pretaxCost: Scalars['Float']['output'];
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']['output']>;
  productCatalogVariationId?: Maybe<Scalars['ID']['output']>;
  productionList: ProductionList;
  /** The integer quantity of the list item */
  quantity: Scalars['Float']['output'];
  quantityUnits?: Maybe<QuantityUnitsEnum>;
  /**
   * True if the list item is mapped to a productCatalogProduct with variations,
   * but no variation has been selected by the user. Also true if
   * userSetCustomVariationName is true but variation_name is blank. Or if the line
   * item is not mapped to a product and no custom variation name was given. The
   * order is still submittable but this item might not be available at the branch
   * and might be substituted.
   */
  requiresProductVariationSelection: Scalars['Boolean']['output'];
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: Maybe<Scalars['String']['output']>;
  /** @deprecated replaced by userSetCustomSku */
  skuChangedByUser?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the sort order of ListItems on the ProductionList */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Deprecated. Use requiresProductVariationSelection instead
   * @deprecated Use requiresProductVariationSelection instead
   */
  submittable: Scalars['Boolean']['output'];
  /** The tax % between 0 and 1 that will be applied to this item */
  taxPercent: Scalars['Float']['output'];
  /** The list items that are part of the same estimation config template list item group, but are not active. */
  templateListItemGroupListItems: Array<ListItem>;
  /** The calculated total COST, including sales tax, for this item */
  totalCost: Scalars['Float']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
  tradeType: TradeTypeEnum;
  /** The LineItemType of this ListItem */
  type: LineItemTypeEnum;
  /** The unit cost of the list item */
  unitCost: Scalars['Float']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userSetCustomColor: Scalars['Boolean']['output'];
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku: Scalars['Boolean']['output'];
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost: Scalars['Boolean']['output'];
  variation?: Maybe<ProductCatalogVariation>;
  vendor?: Maybe<Vendor>;
  /** The waste factor of the measurement between 0 and 1 */
  wasteFactor?: Maybe<Scalars['Float']['output']>;
  xactimateListItem?: Maybe<ProjectManagementXactimateListItem>;
};

/** Arguments for creating a List Item */
export type ListItemCreate = {
  /** The name of the color of this product. For example 'Light Blue' */
  color?: InputMaybe<Scalars['String']['input']>;
  externalProductId?: InputMaybe<Scalars['ID']['input']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupName?: InputMaybe<Scalars['String']['input']>;
  /** The float amount for this list item */
  measurement?: InputMaybe<Scalars['Float']['input']>;
  /** The label for units that the measurement describes */
  measurementUnits?: InputMaybe<Scalars['String']['input']>;
  /** The name label of this list item */
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  /** The integer quantity of the list item */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnits?: InputMaybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: InputMaybe<Scalars['String']['input']>;
  skuChangedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  tradeType?: InputMaybe<TradeTypeEnum>;
  /** The LineItemType of this ListItem */
  type?: InputMaybe<LineItemTypeEnum>;
  /** The unit cost of the list item */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  userSetCustomColor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** the vendor that this item will be fulfilled through */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ListItemCreate. */
export type ListItemCreatePayload = {
  __typename?: 'ListItemCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItem?: Maybe<ListItem>;
  matchedListItems?: Maybe<Array<ListItem>>;
};

/** Autogenerated return type of ListItemDelete. */
export type ListItemDeletePayload = {
  __typename?: 'ListItemDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ListItemManualAdjustmentCreate. */
export type ListItemManualAdjustmentCreatePayload = {
  __typename?: 'ListItemManualAdjustmentCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItemManualAdjustment?: Maybe<ProjectManagementListItemManualAdjustment>;
};

/** Autogenerated return type of ListItemManualAdjustmentDelete. */
export type ListItemManualAdjustmentDeletePayload = {
  __typename?: 'ListItemManualAdjustmentDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItem?: Maybe<ListItem>;
};

/** Arguments for updating a List Item */
export type ListItemUpdate = {
  /** If this is true then this list item will be returned in the top level list items for this production list */
  activeForTemplateLineItemGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the color of this product. For example 'Light Blue' */
  color?: InputMaybe<Scalars['String']['input']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupName?: InputMaybe<Scalars['String']['input']>;
  /** The float amount for this list item */
  measurement?: InputMaybe<Scalars['Float']['input']>;
  /** The label for units that the measurement describes */
  measurementUnits?: InputMaybe<Scalars['String']['input']>;
  /** The name label of this list item */
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  /** The integer quantity of the list item */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnits?: InputMaybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: InputMaybe<Scalars['String']['input']>;
  skuChangedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls the sort order of ListItems on the ProductionList */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tradeType?: InputMaybe<TradeTypeEnum>;
  /** The LineItemType of this ListItem */
  type?: InputMaybe<LineItemTypeEnum>;
  /** The unit cost of the list item */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  userSetCustomColor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** the vendor that this item will be fulfilled through */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ListItemUpdate. */
export type ListItemUpdatePayload = {
  __typename?: 'ListItemUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItem?: Maybe<ListItem>;
  matchedListItems?: Maybe<Array<ListItem>>;
};

export enum Locale {
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  EsUs = 'ES_US',
  FrCa = 'FR_CA'
}

export type MEdge = {
  __typename?: 'MEdge';
  /** This id does not persist but is guaranteed to beconsistent as long as the geometry doesn't change. */
  id: Scalars['ID']['output'];
  /** (Unit: inch) */
  length: Scalars['Float']['output'];
  vertices: Array<Vertex>;
};

/** Arguments for attaching a marketing campaign */
export type MarketingCampaignArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MatchGroupCreate. */
export type MatchGroupCreatePayload = {
  __typename?: 'MatchGroupCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  matchGroup?: Maybe<ProductCatalogMatchGroup>;
};

/** Autogenerated return type of MatchGroupDelete. */
export type MatchGroupDeletePayload = {
  __typename?: 'MatchGroupDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of MatchGroupUpdate. */
export type MatchGroupUpdatePayload = {
  __typename?: 'MatchGroupUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  matchGroup?: Maybe<ProductCatalogMatchGroup>;
};

export enum MaterialListTypeEnum {
  MultipleMaterialTypes = 'MULTIPLE_MATERIAL_TYPES',
  SingleMaterialType = 'SINGLE_MATERIAL_TYPE'
}

export type MeasurementFootprint = {
  __typename?: 'MeasurementFootprint';
  area: Scalars['Float']['output'];
  perimeter: Scalars['Float']['output'];
};

export enum MeasurementUnit {
  CubicFeet = 'CUBIC_FEET',
  LinearFeet = 'LINEAR_FEET',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET'
}

export type Measurements = {
  __typename?: 'Measurements';
  summary: Summary;
};

export type MeasurementsCornice = {
  __typename?: 'MeasurementsCornice';
  end: Vector3;
  kind: MeasurementsCorniceKind;
  length: Scalars['Float']['output'];
  start: Vector3;
};

export enum MeasurementsCorniceKind {
  /** The cornice returns towards the center of the rake */
  Return = 'RETURN',
  /** The cornice spans across the entire rake */
  Strip = 'STRIP'
}

export type MeasurementsSoffit = {
  __typename?: 'MeasurementsSoffit';
  area: Scalars['Float']['output'];
  depthRange: MeasurementsSoffitDepthRange;
  kind: MeasurementsSoffitKind;
  length: Scalars['Float']['output'];
};

export enum MeasurementsSoffitDepthRange {
  Depth_0To_1Inches = 'DEPTH_0_TO_1_INCHES',
  Depth_1To_6Inches = 'DEPTH_1_TO_6_INCHES',
  Depth_6To_12Inches = 'DEPTH_6_TO_12_INCHES',
  Depth_12To_18Inches = 'DEPTH_12_TO_18_INCHES',
  Depth_18To_24Inches = 'DEPTH_18_TO_24_INCHES',
  Depth_24To_48Inches = 'DEPTH_24_TO_48_INCHES',
  Depth_48ToInfInches = 'DEPTH_48_TO_INF_INCHES'
}

export enum MeasurementsSoffitKind {
  /** Horizontal soffit */
  Eave = 'EAVE',
  /** Sloped soffit */
  Rake = 'RAKE'
}

export type Media = {
  /** Public url of file. */
  blobUrl: Scalars['String']['output'];
  byteSize: Scalars['String']['output'];
  checksum: Scalars['String']['output'];
  /** The MIME type of the file. */
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum MobileApplicationOs {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type MobileClientArgs = {
  /** The version of the Hover app */
  appVersion: Scalars['String']['input'];
  /** Whether the device is AR capable */
  arCapable: Scalars['Boolean']['input'];
  /** The operating system of the device */
  os: Scalars['String']['input'];
  /** The version of the operating system */
  osVersion: Scalars['String']['input'];
};

export type MobileDevice = ApplicationRecord & {
  __typename?: 'MobileDevice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /**
   * The token from registering device with ios - Apple Push Notification(APN) or android - Firebase Cloud Messaging(FCM).
   * It's an app-specific device token.
   */
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** UUID of the mobile device. */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Arguments for registering a mobile device for push notifications */
export type MobileDeviceArgs = {
  /**
   * The token from registering device with ios - Apple Push Notification(APN) or android - Firebase Cloud Messaging(FCM).
   * It's an app-specific device token.
   */
  token: Scalars['String']['input'];
  /** UUID of the mobile device. */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type Model = {
  __typename?: 'Model';
  cornices: Array<MeasurementsCornice>;
  drainage: Drainage;
  faces: Array<Face>;
  footprint?: Maybe<MeasurementFootprint>;
  orderId: Scalars['Int']['output'];
  soffits: Array<MeasurementsSoffit>;
  totalLivingArea?: Maybe<Scalars['Float']['output']>;
  version: Scalars['String']['output'];
};

export type ModelScreenshot = {
  __typename?: 'ModelScreenshot';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobId: Scalars['Int']['output'];
  placeholderUrl: Scalars['String']['output'];
  rendering: Rendering;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDiscountFromCode: AppliedDiscount;
  /** Approve a job with the given ID. Only an Org Admin can approve jobs. */
  approveJob: Job;
  /**
   * Archive a job with the given ID. Example jobs cannot be archived. Only jobs in
   * the following JobModelStates can be archived: UPLOADING, PROCESSING_UPLOAD,
   * WAITING_APPROVAL, PAYING, COMPLETE, FAILED, CANCELLED
   */
  archiveJob: Job;
  authenticate: AuthenticationResponse;
  authenticateWithCookie: AuthenticationResponse;
  /**
   * Validates a magic link token and ID and returns an authentication response if
   * valid. Once used, the existing magic link will be invalidated.
   */
  authenticateWithMagicLink: AuthenticationResponse;
  /**
   * Authenticate using a previously issued user signin token. Each user signin
   * token is only valid to be used once and will be deleted after successful
   * authentication.
   */
  authenticateWithUserSigninToken: AuthenticationResponse;
  createAiDisplayImage: AiDisplayImage;
  createAiGeneratedImageAsync: AiGeneratedImage;
  /** Creates a AI original image */
  createAiOriginalImage: AiOriginalImage;
  createAiOriginalImagePlaceholder: AiOriginalImagePlaceholder;
  /** Create an album for grouping media files */
  createAlbum: Album;
  createAlbumFiles: CreateAlbumFilesPayload;
  /** Create a blueprint submission */
  createBlueprintSubmission: BlueprintSubmission;
  /** Create a bulk background job. */
  createBulkBackgroundJob: BulkBackgroundJob;
  createCaptureRequest: CaptureRequest;
  /**
   * Create a capture session token for the current_user so that the FE client may
   * forward this token to the service that handles our photo captures.
   */
  createCaptureSessionToken: CaptureSession;
  /**
   * Create a deliverable change request for a job. Upgrade only. A job can only
   * have 1 pending (not complete or failed) deliverable change request at a time.
   */
  createDeliverableChangeRequest: DeliverableChangeRequest;
  createDesignerAnonymousSession: GmlAnonymousSession;
  /**
   * Create a domain claim record. An error will return if domain argument is
   * blank, current user cannot manage org, org does not have single sign on
   * feature enabled, or org has 10 number of domain claims.
   */
  createDomainClaim: DomainClaim;
  /** Creates a storage scope session token for the current_user so that the FE client may forward this token to the service. */
  createFileStorageToken: FileStorageToken;
  /** Creates a hi def rendering record */
  createHiDefRendering: HiDefRendering;
  /** Creates a hi def rendering version record */
  createHiDefRenderingVersion: HiDefRenderingVersion;
  createHomeowner: AuthenticationResponse;
  /** This mutation will create an image metadata record and give you an upload URL where you will send the actual image binary. */
  createImagePlaceholder: ImageUploadInfo;
  createInsuranceUser: AuthenticationResponse;
  createModelScreenshot?: Maybe<ModelScreenshot>;
  /** Create a note for the job with the given ID. Users can only create notes for jobs their org has access to. */
  createNote: Note;
  /** Create or update an album for grouping media files. Searches by album's name. */
  createOrUpdateAlbumWithFiles: CreateAlbumFilesPayload;
  /** Creates an org survey qualifier using the org the user is authenticated under. */
  createOrgSurveyQualifier: OrgSurveyQualifier;
  /**
   * This mutation adds a user in an org with the given orgId.
   * It also sends an invitation email to the new user.
   *
   * Requires the current user to have permission to add users in the given org, i.e., org admin.
   *
   * If a user with the given email already exists, it will return an error message.
   *
   * If aclTemplate is given, and the current user does not have permission to manage permissions,
   * it will return an error message.
   */
  createOrgUser: User;
  createProUser: AuthenticationResponse;
  /** Creates a project record */
  createProject: Project;
  /** Creates a ProjectAsset record */
  createProjectAsset: ProjectAsset;
  /** Create a project share */
  createProjectShare: ProjectShare;
  createSignedUrlForScreenshot?: Maybe<SignedUrl>;
  /** Creates an AI original image for a job */
  createSolvedAiOriginalImage: AiOriginalImage;
  /**
   * Create a single sign on configuration for the given org. An error will be
   * returned if one already exists, if the org does not have access to signle sign
   * on, or if the current user is not an org admin.
   */
  createSsoConfig: SsoConfig;
  createUploadRequest: UploadRequest;
  /** Creates an AiGeneratedImage with the requested customizations */
  customizeAiImage: AiGeneratedImage;
  /**
   * Deletes an AiOriginalImage with the given ID and all AiGeneratedImage records.
   * The user requesting deletion must be the user who created the AI Original Image.
   */
  deleteAiOriginalImage: AiOriginalImage;
  deleteAlbumFiles: DeleteAlbumFilesPayload;
  /**
   * Delete a capture request with the given ID. A capture request can only be
   * deleted by its requesting user. Capture requests in the COMPLETE state cannot be deleted.
   */
  deleteCaptureRequest: CaptureRequest;
  /**
   * Delete a domain claim record. An error will return if current user cannot
   * manage creator org, or if org does not have single sign on feature enabled.
   */
  deleteDomainClaim: DomainClaim;
  /**
   * Delete a job assignment with the given ID, the user must be an admin or a job
   * manager of the job assignment's org, or the creator of the job. User cannot
   * delete their own job assignment.
   */
  deleteJobAssignment: JobAssignment;
  deleteModelScreenshot?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a note with the given ID. The user must have access to the note's job and org. */
  deleteNote: Note;
  /** Deletes a project with the given ID. The user requesting deletion must be the user who created the project. */
  deleteProject: Project;
  /**
   * Deletes a project asset with the given Project ID and Addable ID. The user
   * requesting deletion must be the user who created the project.
   */
  deleteProjectAsset: ProjectAsset;
  /** Runs region detection on an AiGeneratedImage if region detection has not already been run */
  detectAiRegions: AiGeneratedImage;
  /**
   * Create a JobAccountAuthentication for the selected Distributor by validating
   * the externalIdentifier and authCode are valid. The distributor must support
   * ClientCredentials authorization.
   */
  distributionJobAccountAuthenticationCreate?: Maybe<JobAccountAuthenticationCreatePayload>;
  /**
   * Deletes JobAccountAuthentication records that match the input ids and belong
   * to the given org. This removes the ability for the org to order with the input
   * job account. If all the job accounts available for the org are removed, the
   * org will no longer be able to order with the distributor the job accounts relate to.
   */
  distributionJobAccountAuthenticationDelete?: Maybe<JobAccountAuthenticationDeletePayload>;
  /** Deletes an oauth token. Removing the connection between an org and distributor. */
  distributionOauthTokenDelete?: Maybe<OauthTokenDeletePayload>;
  /** Set up an order with given distributor and trigger order checking asynchronously */
  distributionOrderCheckCreate?: Maybe<OrderCheckCreatePayload>;
  /** Create a DistributionOrder */
  distributionOrderCreate?: Maybe<DistributionOrderCreatePayload>;
  /** Set up an order with given distributor and trigger order checking asynchronously */
  distributionOrderSetup?: Maybe<OrderSetupPayload>;
  /** Submit a DistributionOrder to associated distributor for fulfillment */
  distributionOrderSubmit?: Maybe<OrderSubmitPayload>;
  /** Updates an OrgSettings in ehi-api */
  ehiOrgSettingsUpdate?: Maybe<EhiOrgSettingsUpdatePayload>;
  /** Create an EstimationConfigLineItem */
  estimationConfigLineItemCreate?: Maybe<LineItemCreatePayload>;
  estimationConfigLineItemDelete?: Maybe<LineItemDeletePayload>;
  estimationConfigLineItemUpdate?: Maybe<EstimationConfigLineItemUpdatePayload>;
  estimationConfigTemplateCopy?: Maybe<TemplateCopyPayload>;
  /** Create an EstimationConfigTemplate from a ProjectManagementProductionList */
  estimationConfigTemplateFromProductionListCreateRequestCreate?: Maybe<TemplateFromProductionListCreateRequestCreatePayload>;
  estimationConfigTemplateUpdate?: Maybe<EstimationConfigTemplateUpdatePayload>;
  estimationConfigTradeTypeCategoryWasteFactorUpdate?: Maybe<EstimationConfigTradeTypeCategoryWasteFactorUpdatePayload>;
  /** This mutation can be used to create a discount/promotion. */
  estimationDiscountCreate?: Maybe<DiscountCreatePayload>;
  /** This mutation can be used to delete a discount/promotion. */
  estimationDiscountDelete?: Maybe<DiscountDeletePayload>;
  /** This mutation can be used to update a discount/promotion. */
  estimationDiscountUpdate?: Maybe<DiscountUpdatePayload>;
  /** Creates an Estimate Group */
  estimationEstimateGroupCreate?: Maybe<EstimateGroupCreatePayload>;
  estimationEstimateGroupMultipleMaterialsCreate?: Maybe<EstimateGroupMultipleMaterialsCreatePayload>;
  estimationEstimateGroupUpdate?: Maybe<EstimateGroupUpdatePayload>;
  /** This mutation can be used to update an estimate. */
  estimationEstimateUpdate?: Maybe<EstimateUpdatePayload>;
  /** This mutation can be used to update a line item. */
  estimationLineItemUpdate?: Maybe<LineItemUpdatePayload>;
  /**
   * This mutation updates the AiDisplayImage favorite_at and returns either an
   * AiDisplayImage record or nil. When favorite is true, a new AiDisplayImage is
   * created if a record is not found. Otherwise, the favorite_at is updated with a
   * timestamp. When favorite is false and an AiDisplayImage is not found, nil is
   * returned. If a record is found, favorite_at is updated with nil and, if the
   * create_from is 'favorite', the record is soft deleted.
   */
  favoriteAiCustomizedImage?: Maybe<AiDisplayImage>;
  /** This mutation allows creation of a job. Or looks up an existing job if it exists */
  findOrCreateJob: Job;
  /** Notify us the CSV file for bulk job has finished uploading and we will start processing. */
  finishedUploadingBulkBackgroundJob: Scalars['Boolean']['output'];
  /** Creates an AiGeneratedImage and AiDisplayImage */
  generateAiImage: AiDisplayImage;
  /** Generates a JSON Web Token for the authenticated user for remote services */
  generateRemoteJWT?: Maybe<GenerateRemoteJwtPayload>;
  /** Invite new & existing homeowners, grant job access, and send notifications. */
  homeownerJobInvite: JobUserInvite;
  /** Returns credentials needed to upload files that will be associated with inspection checklist questions. */
  inspectionChecklistQuestionFileUploadCreate?: Maybe<ChecklistQuestionFileUploadCreatePayload>;
  /** This mutation is used to create or update an inspection checklist, based on a provided id */
  inspectionChecklistUpsert?: Maybe<ChecklistUpsertPayload>;
  /** Archives a Checklist Template */
  inspectionConfigChecklistTemplateArchive?: Maybe<ChecklistTemplateArchivePayload>;
  inspectionConfigChecklistTemplateCopy?: Maybe<ChecklistTemplateCopyPayload>;
  /** Create an Inspection checklist template */
  inspectionConfigChecklistTemplateCreate?: Maybe<ChecklistTemplateCreatePayload>;
  /** Create an Inspection checklist template question */
  inspectionConfigChecklistTemplateQuestionCreate?: Maybe<ChecklistTemplateQuestionCreatePayload>;
  /** Deletes a checklist template question. */
  inspectionConfigChecklistTemplateQuestionDelete?: Maybe<ChecklistTemplateQuestionDeletePayload>;
  /** Update a Checklist Template Question */
  inspectionConfigChecklistTemplateQuestionUpdate?: Maybe<ChecklistTemplateQuestionUpdatePayload>;
  /**
   * Updates the sort order of a checklist template's questions to the order of the
   * checklist template's question ids provided in the array input
   */
  inspectionConfigChecklistTemplateQuestionsSortOrderUpdate?: Maybe<ChecklistTemplateQuestionsSortOrderUpdatePayload>;
  /** Create an Inspection Checklist Template Section */
  inspectionConfigChecklistTemplateSectionCreate?: Maybe<ChecklistTemplateSectionCreatePayload>;
  /** Deletes a checklist template section */
  inspectionConfigChecklistTemplateSectionDelete?: Maybe<ChecklistTemplateSectionDeletePayload>;
  /** Update a Checklist Template Section */
  inspectionConfigChecklistTemplateSectionUpdate?: Maybe<ChecklistTemplateSectionUpdatePayload>;
  /**
   * Updates the sort order of an checklist template's sections to the order of the
   * checklist template's section ids provided in the array input
   */
  inspectionConfigChecklistTemplateSectionsSortOrderUpdate?: Maybe<ChecklistTemplateSectionsSortOrderUpdatePayload>;
  /** Update a Checklist Template */
  inspectionConfigChecklistTemplateUpdate?: Maybe<ChecklistTemplateUpdatePayload>;
  /** Create default Inspection checklist templates */
  inspectionConfigChecklistTemplatesDefaultsCreate?: Maybe<ChecklistTemplatesDefaultsCreatePayload>;
  /** Bulk creates the image upload urls for an inspection's images */
  inspectionCreateDamageInspectionUpload: InspectionUploadRequest;
  /**
   * Completes an inspection previously initiated by the CreateDamageInspectionUpload mutation, and connects
   * all of the files have been uploaded by the client to this completed inspection record.
   */
  inspectionSubmitDamageInspection: InspectionDamageInspection;
  /** Sends a magic link for authentication to an email address if it exists. */
  magicLinkSignin: Scalars['Boolean']['output'];
  /** Creates a homeowner user (user is coming from /designer) along with an org */
  onboardingCreateHomeownerUser?: Maybe<OnboardingCreateUserResponse>;
  /** Creates an org for a user if they do not have one. */
  onboardingCreateOrgForUser?: Maybe<OnboardingCreateOrgForUserResponse>;
  /** Creates org users and sends invites. */
  onboardingCreateOrgUsers: Array<User>;
  /** Creates a user without an org, role or ACL. */
  onboardingCreateUser?: Maybe<OnboardingCreateUserResponse>;
  /** Process a single uploaded image */
  processAdditionalImage: JobImage;
  /** Adds a product to an Org's catalog */
  productCatalogConfigOrgProductCreate?: Maybe<OrgProductCreatePayload>;
  /** Disable or enable all variations of a product for an org */
  productCatalogConfigOrgVariationsToggle?: Maybe<OrgVariationsTogglePayload>;
  productCatalogMatchGroupCreate?: Maybe<MatchGroupCreatePayload>;
  productCatalogMatchGroupDelete?: Maybe<MatchGroupDeletePayload>;
  productCatalogMatchGroupUpdate?: Maybe<MatchGroupUpdatePayload>;
  /** Change an organization's product catalog related settings */
  productCatalogOrgSettingsUpdate?: Maybe<OrgSettingsUpdatePayload>;
  /** Updates an org proposal settings. */
  projectManagementConfigOrgProposalSettingUpdate?: Maybe<OrgProposalSettingUpdatePayload>;
  /**
   * Creates a proposal template page. Must be an html page type and it will be
   * sorted at the end of the current orgs proposal template.
   */
  projectManagementConfigProposalTemplatePageCreate?: Maybe<ProposalTemplatePageCreatePayload>;
  /** Deletes a proposal template page. */
  projectManagementConfigProposalTemplatePageDelete?: Maybe<ProposalTemplatePageDeletePayload>;
  /** Updates a proposal template page. */
  projectManagementConfigProposalTemplatePageUpdate?: Maybe<ProposalTemplatePageUpdatePayload>;
  /**
   * Updates the sort order of a proposal template's pages to the order of the
   * proposal template page ids provided in the array input.
   */
  projectManagementConfigProposalTemplatesPagesSortOrderUpdate?: Maybe<ProposalTemplatesPagesSortOrderUpdatePayload>;
  /** Updates the settings associated with the Scope of Work document. */
  projectManagementConfigScopeOfWorkSettingsUpdate?: Maybe<ScopeOfWorkSettingsUpdatePayload>;
  projectManagementListItemCreate?: Maybe<ListItemCreatePayload>;
  projectManagementListItemDelete?: Maybe<ListItemDeletePayload>;
  /**
   * Creates a manual adjustment to list/line item calculations. Once created the
   * list item, and its estimation line item will be re-calculated using the values
   * set in the manual adjustment. Then the production list and estimate will have
   * their totals updated.
   */
  projectManagementListItemManualAdjustmentCreate?: Maybe<ListItemManualAdjustmentCreatePayload>;
  /**
   * Deletes a manual adjustment to list/line item calculations. Once deleted the
   * list item, and its estimation line item will be re-calculated using original
   * values. Then the production list and estimate will have their totals updated.
   */
  projectManagementListItemManualAdjustmentDelete?: Maybe<ListItemManualAdjustmentDeletePayload>;
  projectManagementListItemUpdate?: Maybe<ListItemUpdatePayload>;
  /** This mutation is used to set-up an order */
  projectManagementOrderCreate?: Maybe<OrderCreatePayload>;
  /** This mutation is used to setup an order and immediately submit to the specified distributor */
  projectManagementOrderCreateAndSubmitToDistributor?: Maybe<OrderCreateAndSubmitToDistributorPayload>;
  /** Create an OrderDocument */
  projectManagementOrderDocumentCreate?: Maybe<OrderDocumentCreatePayload>;
  /** This mutation is used to set-up an order for fulfillment with a distributor */
  projectManagementOrderFulfillmentStart?: Maybe<OrderFulfillmentStartPayload>;
  projectManagementProductionListManualSyncCreate?: Maybe<ProductionListManualSyncCreatePayload>;
  projectManagementProductionListUpdate?: Maybe<ProductionListUpdatePayload>;
  /** Creates proposal document */
  projectManagementProposalDocumentCreate?: Maybe<ProposalDocumentCreatePayload>;
  /** Creates proposal document preview */
  projectManagementProposalDocumentPreviewCreate?: Maybe<ProposalDocumentPreviewCreatePayload>;
  /** Creates a signature request */
  projectManagementSignatureRequestCreate?: Maybe<SignatureRequestCreatePayload>;
  refreshJwt: Jwt;
  /**
   * This mutation registers user's mobile device for push notifications. It will
   * look for existing mobile device records by the UUID, then by token. If there
   * isn't a matching mobile device record, it creates a new mobile device record.
   * If the attempt is successful, the mobile device is ready to receive push
   * notifications. If the attempt is not successful, it will return an error message.
   */
  registerMobileDevice: MobileDevice;
  /**
   * Removes a team member's access to the org given their user_id and org_id. It
   * returns user details on successful removal. This will log the removed user out of the app.
   */
  removeTeamMember: User;
  resetCurrentUserPassword: AuthenticationResponse;
  resetPassword: AuthenticationResponse;
  /**
   * Revokes the access token sent in the X-JWT-AUTH request header. This can be
   * used to sign out a user. Does nothing if the access token is invalid.
   */
  revokeAccessToken: Scalars['Boolean']['output'];
  runCaptureExpectationsCheck: CaptureExpectationsCheckResult;
  /** Updates a Sales Opportunity */
  salesOpportunityUpdate?: Maybe<SalesOpportunityUpdatePayload>;
  /** Returns credentials needed to upload files. */
  salesPresentationFileUploadCreate?: Maybe<FileUploadCreatePayload>;
  /** Archives a Sales Presentation */
  salesPresentationPresentationArchive?: Maybe<PresentationArchivePayload>;
  /** Creates Sales Presentation */
  salesPresentationPresentationCreate?: Maybe<PresentationCreatePayload>;
  /** Activates or deactivates a Sales Presentation based on its current state */
  salesPresentationPresentationStateToggle?: Maybe<PresentationStateTogglePayload>;
  /** Updates the name of a Sales Presentation */
  salesPresentationPresentationUpdate?: Maybe<PresentationUpdatePayload>;
  /** Sends a sms to the specified phone number with a link to the app download */
  sendAppDownloadSms: Scalars['Boolean']['output'];
  /** Sends an email invite and an SMS, if a phone number of the capturing user is provided, for capturing property */
  sendCaptureRequestNotification: CaptureRequest;
  /** Sends an email to the specified email address with a link to the rendering */
  sendRenderingShareEmail: Scalars['String']['output'];
  /**
   * Sends a reset password email to a user with the given email address if it
   * exists. In the email, a Branch IO link is included with action=reset_password
   * and reset_password_token={some_reset_password_token} for deep linking
   * purposes. The reset_password_token can then be used in the resetPassword
   * mutation. A reset_password_token can only be used for one time. If you are
   * requesting this mutation for more than one time for the same email address,
   * only the latest reset_password_token will be valid. This mutation will always return true.
   */
  sendResetPasswordInstructions: Scalars['Boolean']['output'];
  /**
   * Grants access to a job for a user and sends a notification to the recipient.
   * If the user does not exist, this mutation will create a new user and org
   * according to the signup type. This relates to the "Job Invite" feature.
   */
  shareJob: Scalars['Boolean']['output'];
  /** Stops an impersonation session. */
  stopImpersonation: UserImpersonator;
  /** Creates a design order response for a HiDefRenderingVersion */
  submitDesignOrderResponse: SubmitDesignOrderResponsePayload;
  /** Un-archive a job with the given ID. Only Org Admin can un-archive a job. */
  unarchiveJob: Job;
  updateAiDisplayImage: AiDisplayImage;
  /** This mutation allows the AiGeneratedImage to be updated. */
  updateAiGeneratedImage: AiGeneratedImage;
  /** Updates an album */
  updateAlbum: Album;
  /** This mutation allows updating the hi def rendering file cryptomatte regions for use in interactive renderings. */
  updateHiDefRenderingFile: HiDefRenderingFile;
  /** This mutation allows updating a job. */
  updateJob: Job;
  /**
   * This mutation allows updating the body of a note. Only the owner of the note
   * can perform this action (the user_id on note record needs to match
   * current_user id).
   */
  updateNote: Note;
  /** This mutation allows a user to update an org's name if that user has permission to manage that org, i.e. org admin. */
  updateOrg: Org;
  /** This mutation allows for the update of org preferences. Only admins are able to edit org preferences. */
  updateOrgPreferences: OrgPreferences;
  /** Updates a project record */
  updateProject: Project;
  /**
   * Update a single sign on configuration. An error will be returned if current
   * user cannot manage org, org is not the creator of the SSO config, org SSO
   * feature access is disabled, or one of the required SSO config arguments is missing.
   */
  updateSsoConfig: SsoConfig;
  /**
   * This mutation allows the current user to update a user's firstName, lastName,
   * mobilePhone, officePhone, and/or requireJobApproval. If the id argument is
   * given, it will attempt to update the target user with the given id provided
   * that the current_user is an Org admin of the target user. If the id argument
   * is not given, it will update the current_user. Only Org admin can modify
   * requireJobApproval. If requireJobApproval arg is given and the user does not
   * have permission to modify it, it will return an error message and no update
   * will be performed.
   */
  updateUser: User;
  /** This mutation allows an org admin to update a user's ACL template */
  updateUserAclTemplate: User;
  /** This mutation allows the current user to update its own settings for an Org. */
  updateUserOrgSettings: User;
  updateWallet: Wallet;
  upgradeToPro: UpgradeUserResponse;
  /** Allows user to upload image file and creates an AI original image */
  uploadAiOriginalImage: AiOriginalImage;
  /** This mutation updates the brand record once the logo has been successfully uploaded using the generated logo upload url */
  uploadedBrandLogo: Brand;
  /**
   * This mutation updates the user record once the profile picture has been
   * sucessfully uploaded using the generated profile picture upload url
   */
  uploadedProfilePicture: User;
  /**
   * Verify a domain claim record. It does nothing if the domain claim record has
   * been verified or if it's unprocessable. It marks the domain claim record
   * unprocessable if the domain has been claimed. It fails the domain claim record
   * if the requested text value cannot be found on the domain DNS. An error will
   * return if current user cannot manage org or org does not have single sign on
   * feature enabled.
   */
  verifyDomainClaim: DomainClaim;
  /** Create an Xactimate schema file with line items for a Jobs based on a Production List */
  xactGenerateSchemaWithLineItems: XactSchemaWithLineItemsGenerationRequestResponse;
};


export type MutationAddDiscountFromCodeArgs = {
  code: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
};


export type MutationApproveJobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationArchiveJobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAuthenticateArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthenticateWithMagicLinkArgs = {
  authenticateWithMagicLinkArgs: AuthenticateWithMagicLinkArgs;
};


export type MutationAuthenticateWithUserSigninTokenArgs = {
  userSigninToken: Scalars['String']['input'];
};


export type MutationCreateAiDisplayImageArgs = {
  aiGeneratedImageId: Scalars['ID']['input'];
  aiOriginalImageId: Scalars['ID']['input'];
  createdFrom: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  style: Scalars['String']['input'];
};


export type MutationCreateAiGeneratedImageAsyncArgs = {
  aiOriginalImageId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  imageFlexibility: Scalars['Float']['input'];
  intensity: Scalars['Int']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  style: Scalars['String']['input'];
};


export type MutationCreateAiOriginalImageArgs = {
  aiOriginalImage: CreateAiOriginalImageArgs;
};


export type MutationCreateAiOriginalImagePlaceholderArgs = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  jobClientIdentifier?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAlbumArgs = {
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateAlbumFilesArgs = {
  albumId: Scalars['ID']['input'];
  blobIds: Array<Scalars['ID']['input']>;
};


export type MutationCreateBlueprintSubmissionArgs = {
  buildAll?: InputMaybe<Scalars['Boolean']['input']>;
  fileAttachmentsAttributes: Array<FileAttachmentArgs>;
  jobsAttributes?: InputMaybe<Array<JobCreateArgs>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBulkBackgroundJobArgs = {
  bulkBackgroundJobName: Scalars['String']['input'];
};


export type MutationCreateCaptureRequestArgs = {
  capturingUserEmail: Scalars['String']['input'];
  capturingUserName: Scalars['String']['input'];
  capturingUserPhone?: InputMaybe<Scalars['String']['input']>;
  job: CaptureRequestJobArgs;
  requestingUserSplitFlags?: InputMaybe<Scalars['JSON']['input']>;
  signupType?: InputMaybe<CaptureRequestSignupTypes>;
};


export type MutationCreateDeliverableChangeRequestArgs = {
  jobId: Scalars['Int']['input'];
  newDeliverableId: Scalars['Int']['input'];
};


export type MutationCreateDomainClaimArgs = {
  domain: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
};


export type MutationCreateFileStorageTokenArgs = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  storageScope: FileStorageScopes;
};


export type MutationCreateHiDefRenderingArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCreateHiDefRenderingVersionArgs = {
  hiDefRenderingId: Scalars['ID']['input'];
  versionType: RenderingVersion;
};


export type MutationCreateHomeownerArgs = {
  distinctId?: InputMaybe<Scalars['String']['input']>;
  orgCode?: InputMaybe<Scalars['String']['input']>;
  user: UserArgs;
};


export type MutationCreateImagePlaceholderArgs = {
  imageParams: ImagePlaceholderArgs;
  isAdditional?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
};


export type MutationCreateInsuranceUserArgs = {
  distinctId?: InputMaybe<Scalars['String']['input']>;
  org: OrgArgs;
  user: UserArgs;
};


export type MutationCreateModelScreenshotArgs = {
  aspectRatio: Scalars['Float']['input'];
  camera: CameraInput;
  jobId: Scalars['Int']['input'];
  uploadKey: Scalars['String']['input'];
};


export type MutationCreateNoteArgs = {
  jobId: Scalars['Int']['input'];
  note: NoteArgs;
};


export type MutationCreateOrUpdateAlbumWithFilesArgs = {
  album: CreateOrUpdateAlbumWithFilesArgs;
};


export type MutationCreateOrgSurveyQualifierArgs = {
  orgSurveyQualifier: OrgSurveyQualifierCreateArgs;
};


export type MutationCreateOrgUserArgs = {
  aclTemplate?: InputMaybe<AclTemplateOptions>;
  orgId: Scalars['Int']['input'];
  user: OrgUserCreateArgs;
};


export type MutationCreateProUserArgs = {
  distinctId?: InputMaybe<Scalars['String']['input']>;
  org: OrgArgs;
  orgCode?: InputMaybe<Scalars['String']['input']>;
  orgLocale?: InputMaybe<Locale>;
  parentOrgCode?: InputMaybe<Scalars['String']['input']>;
  signupVersion?: InputMaybe<Scalars['String']['input']>;
  user: UserArgs;
};


export type MutationCreateProjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  scopeItems?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateProjectAssetArgs = {
  assetId: Scalars['Int']['input'];
  assetType: ProjectAssetTypes;
  projectId: Scalars['ID']['input'];
};


export type MutationCreateProjectShareArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationCreateSolvedAiOriginalImageArgs = {
  jobId: Scalars['Int']['input'];
};


export type MutationCreateSsoConfigArgs = {
  orgId: Scalars['Int']['input'];
  ssoConfig: SsoConfigArgs;
};


export type MutationCreateUploadRequestArgs = {
  fileInfo: UploadRequestArgs;
};


export type MutationCustomizeAiImageArgs = {
  params: CustomizeAiImageArgs;
};


export type MutationDeleteAiOriginalImageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAlbumFilesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCaptureRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDomainClaimArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteJobAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteModelScreenshotArgs = {
  id: Scalars['String']['input'];
  jobId: Scalars['Int']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProjectAssetArgs = {
  addableId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationDetectAiRegionsArgs = {
  aiGeneratedImageId: Scalars['Int']['input'];
};


export type MutationDistributionJobAccountAuthenticationCreateArgs = {
  attributes: DistributionJobAccountAuthenticationCreateInput;
};


export type MutationDistributionJobAccountAuthenticationDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
  orgId: Scalars['Int']['input'];
};


export type MutationDistributionOauthTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDistributionOrderCheckCreateArgs = {
  attributes: DistributionOrderCheckCreateInput;
  orgId: Scalars['ID']['input'];
};


export type MutationDistributionOrderCreateArgs = {
  orderAttributes: DistributionOrderCreateInput;
  orgId: Scalars['ID']['input'];
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDistributionOrderSetupArgs = {
  orderAttributes: DistributionOrderCreateInput;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDistributionOrderSubmitArgs = {
  distributionOrderId: Scalars['ID']['input'];
};


export type MutationEhiOrgSettingsUpdateArgs = {
  orgId: Scalars['ID']['input'];
  orgSettingsAttributes: EhiOrgSettingsUpdateInput;
};


export type MutationEstimationConfigLineItemCreateArgs = {
  lineItemAttributes: EstimationEstimateConfigLineItemCreateInput;
};


export type MutationEstimationConfigLineItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEstimationConfigLineItemUpdateArgs = {
  id: Scalars['ID']['input'];
  lineItemAttributes: EstimationConfigLineItemUpdateInput;
};


export type MutationEstimationConfigTemplateCopyArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationEstimationConfigTemplateFromProductionListCreateRequestCreateArgs = {
  attributes: EstimationConfigTemplateFromProductionListCreateRequestCreateInput;
};


export type MutationEstimationConfigTemplateUpdateArgs = {
  id: Scalars['ID']['input'];
  templateAttributes: EstimationConfigTemplateUpdateInput;
};


export type MutationEstimationConfigTradeTypeCategoryWasteFactorUpdateArgs = {
  orgId: Scalars['ID']['input'];
  tradeTypeCategory: TradeTypeCategoryEnum;
  wasteFactor: Scalars['Float']['input'];
};


export type MutationEstimationDiscountCreateArgs = {
  discountAttributes: EstimationDiscountCreate;
};


export type MutationEstimationDiscountDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEstimationDiscountUpdateArgs = {
  discountAttributes: EstimationDiscountUpdate;
  id: Scalars['ID']['input'];
};


export type MutationEstimationEstimateGroupCreateArgs = {
  customLineItems?: InputMaybe<Array<EstimationEstimateGroupCreateCustomLineItem>>;
  customizedProductionList?: InputMaybe<Scalars['Boolean']['input']>;
  estimateGroupAttributes: EstimationEstimateGroupCreate;
  inputs: Array<EstimationEstimateGroupCreateInput>;
  markAsSoldAndActivate?: InputMaybe<Scalars['Boolean']['input']>;
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradeTypeAttributes?: InputMaybe<Array<EstimationEstimateGroupCreateTradeTypeAttributeInput>>;
};


export type MutationEstimationEstimateGroupMultipleMaterialsCreateArgs = {
  estimateGroupTemplateInstances: Array<EstimationEstimateGroupTemplateInstanceInput>;
  hdfId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  prepopulatedFromEstimateGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEstimationEstimateGroupUpdateArgs = {
  estimateGroupAttributes: EstimationEstimateGroupUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationEstimationEstimateUpdateArgs = {
  estimateAttributes: EstimateUpdate;
  id: Scalars['ID']['input'];
};


export type MutationEstimationLineItemUpdateArgs = {
  id: Scalars['ID']['input'];
  lineItemAttributes: EstimationLineItemUpdateInput;
};


export type MutationFavoriteAiCustomizedImageArgs = {
  aiGeneratedImageId: Scalars['Int']['input'];
  favorited: Scalars['Boolean']['input'];
};


export type MutationFindOrCreateJobArgs = {
  job: JobCreateArgs;
};


export type MutationFinishedUploadingBulkBackgroundJobArgs = {
  bulkBackgroundJobId: Scalars['ID']['input'];
};


export type MutationGenerateAiImageArgs = {
  generateAiImageParams: GenerateAiImageArgs;
};


export type MutationGenerateRemoteJwtArgs = {
  orgId: Scalars['ID']['input'];
  remoteService: RemoteService;
};


export type MutationHomeownerJobInviteArgs = {
  distinctId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['Int']['input'];
  orgCode?: InputMaybe<Scalars['String']['input']>;
  user: UnregisteredUserArgs;
};


export type MutationInspectionChecklistQuestionFileUploadCreateArgs = {
  fileAttributes: InspectionChecklistQuestionFileUploadCreateInput;
};


export type MutationInspectionChecklistUpsertArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orgId: Scalars['ID']['input'];
  questionsAttributes?: InputMaybe<Array<InspectionChecklistQuestionUpsertInput>>;
  sectionsAttributes?: InputMaybe<Array<InspectionChecklistSectionUpsertInput>>;
};


export type MutationInspectionConfigChecklistTemplateArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateCopyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateCreateArgs = {
  checklistTemplateAttributes: InspectionConfigChecklistTemplateCreateInput;
};


export type MutationInspectionConfigChecklistTemplateQuestionCreateArgs = {
  checklistTemplateQuestionAttributes: InspectionConfigChecklistTemplateQuestionCreateInput;
};


export type MutationInspectionConfigChecklistTemplateQuestionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateQuestionUpdateArgs = {
  checklistTemplateQuestionAttributes: InspectionConfigChecklistTemplateQuestionUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateQuestionsSortOrderUpdateArgs = {
  checklistTemplateQuestionIds: Array<Scalars['ID']['input']>;
  checklistTemplateSectionId: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateSectionCreateArgs = {
  checklistTemplateSectionAttributes: InspectionConfigChecklistTemplateSectionCreateInput;
};


export type MutationInspectionConfigChecklistTemplateSectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateSectionUpdateArgs = {
  checklistTemplateSectionAttributes: InspectionConfigChecklistTemplateSectionUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplateSectionsSortOrderUpdateArgs = {
  checklistTemplateId: Scalars['ID']['input'];
  checklistTemplateSectionIds: Array<Scalars['ID']['input']>;
};


export type MutationInspectionConfigChecklistTemplateUpdateArgs = {
  checklistTemplateAttributes: InspectionConfigChecklistTemplateUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationInspectionConfigChecklistTemplatesDefaultsCreateArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationInspectionCreateDamageInspectionUploadArgs = {
  requestInfo: InspectionDamageInspectionUploadRequestArgs;
};


export type MutationInspectionSubmitDamageInspectionArgs = {
  inspectionDetail: InspectionDamageInspectionDetailArgs;
  inspectionId: Scalars['Int']['input'];
};


export type MutationMagicLinkSigninArgs = {
  email: Scalars['String']['input'];
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  redirectToMobile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOnboardingCreateHomeownerUserArgs = {
  args: OnboardingCreateHomeownerUserArgs;
};


export type MutationOnboardingCreateOrgForUserArgs = {
  createOrgForUserArgs: OnboardingCreateOrgForUserArgs;
};


export type MutationOnboardingCreateOrgUsersArgs = {
  createOrgUsersArgs: OnboardingCreateOrgUsersArgs;
};


export type MutationOnboardingCreateUserArgs = {
  createUserArgs: OnboardingCreateUserArgs;
};


export type MutationProcessAdditionalImageArgs = {
  imageId: Scalars['Int']['input'];
};


export type MutationProductCatalogConfigOrgProductCreateArgs = {
  attributes: ProductCatalogConfigOrgProductCreateInput;
  enableAllVariations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProductCatalogConfigOrgVariationsToggleArgs = {
  enable: Scalars['Boolean']['input'];
  orgId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationProductCatalogMatchGroupCreateArgs = {
  matchGroupAttributes: ProductCatalogMatchGroupCreateInput;
  orgId: Scalars['ID']['input'];
};


export type MutationProductCatalogMatchGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductCatalogMatchGroupUpdateArgs = {
  matchGroupAttributes?: InputMaybe<ProductCatalogMatchGroupUpdateInput>;
  matchGroupId: Scalars['ID']['input'];
};


export type MutationProductCatalogOrgSettingsUpdateArgs = {
  enableAllVariationsByProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orgId: Scalars['ID']['input'];
  orgVariationsAttributes?: InputMaybe<Array<ProductCatalogOrgVariationNestedInput>>;
  productFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectManagementConfigOrgProposalSettingUpdateArgs = {
  attributes: ProjectManagementConfigOrgProposalSettingUpdate;
  orgId: Scalars['ID']['input'];
};


export type MutationProjectManagementConfigProposalTemplatePageCreateArgs = {
  orgId: Scalars['ID']['input'];
  proposalTemplatePageAttributes: ProjectManagementConfigProposalTemplatePageCreateInput;
};


export type MutationProjectManagementConfigProposalTemplatePageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProjectManagementConfigProposalTemplatePageUpdateArgs = {
  attributes: ProjectManagementConfigProposalTemplatePageCreateInput;
  id: Scalars['ID']['input'];
};


export type MutationProjectManagementConfigProposalTemplatesPagesSortOrderUpdateArgs = {
  orgId: Scalars['ID']['input'];
  proposalTemplatePageIds: Array<Scalars['ID']['input']>;
};


export type MutationProjectManagementConfigScopeOfWorkSettingsUpdateArgs = {
  orgProposalSettingAttributes: ProjectManagementConfigOrgProposalSettingUpdate;
  proposalTemplatePageAttributes: ProjectManagementConfigProposalTemplatePageCreateInput;
  proposalTemplatePageId: Scalars['ID']['input'];
};


export type MutationProjectManagementListItemCreateArgs = {
  listItemAttributes: ListItemCreate;
  productionListId: Scalars['Int']['input'];
};


export type MutationProjectManagementListItemDeleteArgs = {
  listItemId: Scalars['Int']['input'];
};


export type MutationProjectManagementListItemManualAdjustmentCreateArgs = {
  attributes: ProjectManagementListItemManualAdjustmentCreate;
};


export type MutationProjectManagementListItemManualAdjustmentDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  projectManagementListItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProjectManagementListItemUpdateArgs = {
  listItemAttributes: ListItemUpdate;
  listItemId: Scalars['Int']['input'];
  preventAutoMatch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectManagementOrderCreateArgs = {
  orderAttributes: ProjectManagementOrderCreateInput;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProjectManagementOrderCreateAndSubmitToDistributorArgs = {
  orderAttributes: ProjectManagementOrderCreateInput;
  orgId: Scalars['ID']['input'];
};


export type MutationProjectManagementOrderDocumentCreateArgs = {
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  listItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderDocumentAttributes: OrderDocumentCreate;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProjectManagementOrderFulfillmentStartArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationProjectManagementProductionListManualSyncCreateArgs = {
  productionListId: Scalars['ID']['input'];
};


export type MutationProjectManagementProductionListUpdateArgs = {
  productionListAttributes: ProjectManagementProductionListUpdateInput;
  productionListId: Scalars['ID']['input'];
};


export type MutationProjectManagementProposalDocumentCreateArgs = {
  proposalDocumentAttributes: ProjectManagementProposalDocumentCreate;
};


export type MutationProjectManagementProposalDocumentPreviewCreateArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationProjectManagementSignatureRequestCreateArgs = {
  signatureRequestAttributes: ProjectManagementSignatureRequestCreate;
};


export type MutationRefreshJwtArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterMobileDeviceArgs = {
  identifier: Scalars['String']['input'];
  mobileDevice: MobileDeviceArgs;
  os: MobileApplicationOs;
};


export type MutationRemoveTeamMemberArgs = {
  orgId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationResetCurrentUserPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationRunCaptureExpectationsCheckArgs = {
  jobClientIdentifier: Scalars['String']['input'];
  location: CaptureLocationArgs;
  mobileClientAppVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSalesOpportunityUpdateArgs = {
  id: Scalars['ID']['input'];
  salesOpportunityAttributes: SalesOpportunityUpdate;
};


export type MutationSalesPresentationFileUploadCreateArgs = {
  fileAttributes: FileUploadCreateInput;
};


export type MutationSalesPresentationPresentationArchiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSalesPresentationPresentationCreateArgs = {
  presentationAttributes: SalesPresentationPresentationCreateInput;
};


export type MutationSalesPresentationPresentationStateToggleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSalesPresentationPresentationUpdateArgs = {
  presentationAttributes: SalesPresentationPresentationUpdateInput;
};


export type MutationSendAppDownloadSmsArgs = {
  consentPolicyId: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};


export type MutationSendCaptureRequestNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendRenderingShareEmailArgs = {
  email: Scalars['String']['input'];
  shareToken: Scalars['String']['input'];
};


export type MutationSendResetPasswordInstructionsArgs = {
  email: Scalars['String']['input'];
};


export type MutationShareJobArgs = {
  jobAssignment: JobAssignmentArgs;
  user: UnregisteredUserArgs;
};


export type MutationSubmitDesignOrderResponseArgs = {
  designOrderResponse: DesignOrderResponseInput;
  hiDefRenderingVersionId: Scalars['ID']['input'];
  versionType?: InputMaybe<RenderingVersion>;
};


export type MutationUnarchiveJobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateAiDisplayImageArgs = {
  aiGeneratedImageId?: InputMaybe<Scalars['Int']['input']>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateAiGeneratedImageArgs = {
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateAlbumArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHiDefRenderingFileArgs = {
  cryptomatteRegions: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  shareToken: Scalars['String']['input'];
  textureScale?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateJobArgs = {
  id: Scalars['Int']['input'];
  job: JobUpdateArgs;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['Int']['input'];
  note: NoteArgs;
};


export type MutationUpdateOrgArgs = {
  org: OrgArgs;
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateOrgPreferencesArgs = {
  deliverableId?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopeItems?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateSsoConfigArgs = {
  ssoConfig: SsoConfigArgs;
  ssoConfigId: Scalars['Int']['input'];
};


export type MutationUpdateUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user: UserUpdateArgs;
};


export type MutationUpdateUserAclTemplateArgs = {
  aclTemplate: AclTemplateOptions;
  orgId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateUserOrgSettingsArgs = {
  ccAdminOnEmails?: InputMaybe<Scalars['Boolean']['input']>;
  orgId: Scalars['Int']['input'];
};


export type MutationUpdateWalletArgs = {
  wallet: WalletArgs;
  walletId: Scalars['Int']['input'];
};


export type MutationUpgradeToProArgs = {
  input?: InputMaybe<UpgradeToProInput>;
};


export type MutationUploadAiOriginalImageArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['Upload']['input'];
  jobClientIdentifier?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<NewProjectArgs>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadedBrandLogoArgs = {
  orgId: Scalars['Int']['input'];
};


export type MutationVerifyDomainClaimArgs = {
  id: Scalars['Int']['input'];
};


export type MutationXactGenerateSchemaWithLineItemsArgs = {
  generationArgs: XactSchemaWithLineItemGenerationRequestArgs;
};

/** Arguments for creating a new project */
export type NewProjectArgs = {
  /** Project name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Affiliated Org id */
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type Note = ApplicationRecord & {
  __typename?: 'Note';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Information on whether current_user can update or delete the note */
  currentUserContext: NoteCurrentUserContext;
  id: Scalars['Int']['output'];
  org?: Maybe<OrgBasicInfo>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<UserBasicInfo>;
};

/** Arguments for creating a note */
export type NoteArgs = {
  /** The note's text */
  body: Scalars['String']['input'];
};

export type NoteCurrentUserContext = {
  __typename?: 'NoteCurrentUserContext';
  canDeleteNote: Scalars['Boolean']['output'];
  canUpdateNote: Scalars['Boolean']['output'];
};

/** Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is provided. */
export type NotePaginatedResults = {
  __typename?: 'NotePaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<Note>>;
};

/** Autogenerated return type of OauthTokenDelete. */
export type OauthTokenDeletePayload = {
  __typename?: 'OauthTokenDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

export type OnboardingCreateHomeownerUserArgs = {
  /** A unique identifier for the user. This is used for analytics purposes. */
  distinctId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for an associated lead used to create the user, if applicable. Attaches lead to user if provided. */
  leadId?: InputMaybe<Scalars['Int']['input']>;
  /** Where to send the user after they sign up */
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  /** The args passed to createUser */
  user: OnboardingUserArgs;
  /** If true the user will be sent an email with the magic link. */
  withMagicLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingCreateOrgForUserArgs = {
  org?: InputMaybe<OnboardingOrgArgs>;
  signupType?: InputMaybe<OnboardingSignupTypes>;
};

export type OnboardingCreateOrgForUserResponse = {
  __typename?: 'OnboardingCreateOrgForUserResponse';
  org?: Maybe<Org>;
};

export type OnboardingCreateOrgUserArgs = {
  /** User email */
  email: Scalars['String']['input'];
};

/** Arguments for creating/inviting multiple users to an org */
export type OnboardingCreateOrgUsersArgs = {
  /** ID of the org */
  orgId?: InputMaybe<Scalars['Int']['input']>;
  /** Arguments for user creation/invitation */
  users: Array<OnboardingCreateOrgUserArgs>;
};

export type OnboardingCreateUserArgs = {
  /** A unique identifier for the user. This is used for analytics purposes. */
  distinctId?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true and with_magic_link is true, the user will be sent a magic link that redirects to the mobile app.
   * If false and with_magic_link is true, the user will be sent a magic link that redirects to the web app.
   */
  magicLinkRedirectToMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Where to send the user after they sign up. This is not applied if magic_link_redirect_to_mobile is true,
   * as the user will be sent to the mobile app. This is not required if with_magic_link is false.
   */
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  user: OnboardingUserArgs;
  /** If true the user will be sent an email with the magic link. */
  withMagicLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingCreateUserResponse = {
  __typename?: 'OnboardingCreateUserResponse';
  jwt?: Maybe<Jwt>;
  user?: Maybe<User>;
};

/** Arguments for creating/updating an org */
export type OnboardingOrgArgs = {
  custServCity?: InputMaybe<Scalars['String']['input']>;
  custServCountry?: InputMaybe<Scalars['String']['input']>;
  custServLine1?: InputMaybe<Scalars['String']['input']>;
  custServLine2?: InputMaybe<Scalars['String']['input']>;
  custServName?: InputMaybe<Scalars['String']['input']>;
  custServPhone?: InputMaybe<Scalars['String']['input']>;
  custServPostalCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OnboardingSignupTypes {
  Construction = 'CONSTRUCTION',
  Homeowner = 'HOMEOWNER',
  Insurance = 'INSURANCE'
}

/** Arguments for creating a user */
export type OnboardingUserArgs = {
  appLogin?: InputMaybe<Scalars['Boolean']['input']>;
  branchMatchIdentifier?: InputMaybe<Scalars['String']['input']>;
  captureRequestIdentifier?: InputMaybe<Scalars['String']['input']>;
  consents?: InputMaybe<Array<ConsentArgs>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The locale of the user in BCP-47 standard, i.e. en-US or en-GB. */
  locale?: InputMaybe<Locale>;
  marketingCampaign?: InputMaybe<MarketingCampaignArgs>;
  marketingCampaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  /** Type of user, i.e. estimator, owner, installer. */
  persona?: InputMaybe<UserPersonas>;
  /** Used to allow user to enter their own persona when they specify `other`. */
  personaDescription?: InputMaybe<Scalars['String']['input']>;
  preferredIdentifier?: InputMaybe<Scalars['String']['input']>;
  requireJobApproval?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Openings = {
  __typename?: 'Openings';
  /** Opening data by face. */
  perFace: Array<OpeningsPerFace>;
  /** Count of siding and other openings. */
  quantity: OpeningsCount;
  /** Length of siding and other sides. */
  sidesLength: OpeningsLengths;
  /** Length of siding and other sills. */
  sillsLength: OpeningsLengths;
  /** Length of siding and other tops. */
  topsLength: OpeningsLengths;
  /** Total length of siding and other opening sides. */
  totalPerimeter: OpeningsLengths;
  /** Cumulative window data */
  windows: WindowData;
};

export type OpeningsCount = {
  __typename?: 'OpeningsCount';
  /** Length of siding and other tops. */
  other: Scalars['Int']['output'];
  /** Count of siding and other openings. */
  siding: Scalars['Int']['output'];
};

export type OpeningsData = {
  __typename?: 'OpeningsData';
  /** List of each opinings' labels. */
  labels?: Maybe<Array<Scalars['String']['output']>>;
  /** Count of openings lengths. */
  openingsTotal?: Maybe<Scalars['Int']['output']>;
  /** Total length of opening sides. */
  sides?: Maybe<Scalars['Float']['output']>;
  /** Length of bottom of opening. */
  sills?: Maybe<Scalars['Float']['output']>;
  /** Length of top of opening. */
  tops?: Maybe<Scalars['Float']['output']>;
};

export type OpeningsLengths = {
  __typename?: 'OpeningsLengths';
  /** Length of siding and other tops. */
  other: Scalars['Float']['output'];
  /** Count of siding and other openings. */
  siding: Scalars['Float']['output'];
};

export type OpeningsPerFace = {
  __typename?: 'OpeningsPerFace';
  /** Label of face */
  face: Scalars['String']['output'];
  /** Number of openings on this face. */
  quantity: Scalars['Int']['output'];
  /** Sum of opening sides lengths on this face. */
  sidesLength: Scalars['Float']['output'];
  /** Sum of opening bottoms lengths on this face. */
  sillLength: Scalars['Float']['output'];
  /** Sum of opening top lengths on this face. */
  topLength: Scalars['Float']['output'];
  /** Type of face; siding or other. */
  type: Scalars['String']['output'];
};

/** Autogenerated return type of OrderCheckCreate. */
export type OrderCheckCreatePayload = {
  __typename?: 'OrderCheckCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrderCheck>;
};

/** Autogenerated return type of OrderCreateAndSubmitToDistributor. */
export type OrderCreateAndSubmitToDistributorPayload = {
  __typename?: 'OrderCreateAndSubmitToDistributorPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<ProjectManagementOrder>;
};

/** Autogenerated return type of OrderCreate. */
export type OrderCreatePayload = {
  __typename?: 'OrderCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<ProjectManagementOrder>;
};

/** Order Document */
export type OrderDocument = ApplicationRecordUuid & {
  __typename?: 'OrderDocument';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  csv?: Maybe<File>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  order: ProjectManagementOrder;
  /** Which system originated the call? mobile | ehi_frontend */
  origin?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<File>;
  productionList: ProductionList;
  /** Defines if the HTML was generated by the backend instead of using the input_html argument */
  serverRenderedHtml: Scalars['Boolean']['output'];
  /** Includes cost details per list item */
  showItemCostDetails: Scalars['Boolean']['output'];
  /** Includes item measurements and waste factor */
  showItemMeasurements: Scalars['Boolean']['output'];
  /** If this and server_rendered_html is true, then we will include list item notes in the PDF. */
  showListItemNotes: Scalars['Boolean']['output'];
  /** Includes subtotal, sales tax and total cost. */
  showTotalCost: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  /** @deprecated To be replaced by state as an enum */
  stateDeprecated: Scalars['String']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The User that created this ProjectManagementOrderDocument. */
  user: User;
  /** The ID of the user that created this order document */
  userId: Scalars['Int']['output'];
};

/** Arguments for creating an OrderDocument */
export type OrderDocumentCreate = {
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  footerHtml?: InputMaybe<Scalars['String']['input']>;
  /**
   * The front-end generates an HTML representation of the document. Then sends
   * that to the backend to be rendered into a PDF. This is the HTML string that
   * the front-end generates.
   */
  inputHtml: Scalars['String']['input'];
  /** The description to be saved to ProjectManagement::Order and to be included in OrderDocument */
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  /** Which system originated the call? mobile | ehi_frontend */
  origin?: InputMaybe<Scalars['String']['input']>;
  productionListId: Scalars['ID']['input'];
  /** Defines if the HTML was generated by the backend instead of using the input_html argument */
  serverRenderedHtml?: InputMaybe<Scalars['Boolean']['input']>;
  /** Includes cost details per list item */
  showItemCostDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Includes item measurements and waste factor */
  showItemMeasurements?: InputMaybe<Scalars['Boolean']['input']>;
  /** If this and server_rendered_html is true, then we will include list item notes in the PDF. */
  showListItemNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Includes subtotal, sales tax and total cost. */
  showTotalCost?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of OrderDocumentCreate. */
export type OrderDocumentCreatePayload = {
  __typename?: 'OrderDocumentCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orderDocument?: Maybe<OrderDocument>;
};

/** Autogenerated return type of OrderFulfillmentStart. */
export type OrderFulfillmentStartPayload = {
  __typename?: 'OrderFulfillmentStartPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<ProjectManagementOrder>;
};

/** Autogenerated return type of OrderSetup. */
export type OrderSetupPayload = {
  __typename?: 'OrderSetupPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrder>;
};

/** Autogenerated return type of OrderSubmit. */
export type OrderSubmitPayload = {
  __typename?: 'OrderSubmitPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrder>;
};

export type Org = ApplicationRecord & OrgNames & {
  __typename?: 'Org';
  ancestralName?: Maybe<Scalars['String']['output']>;
  /** A list of discounts that has been applied to this org. */
  appliedDiscounts?: Maybe<Array<AppliedDiscount>>;
  /**
   * Returns the deliverables available for this org / user. First it checks org
   * settings. If there is no deliverable under settings then it returns partner
   * deliverables, else it returns an empty array. If the org's plan allows instant
   * estimate then the roof estimate deliverable (HOVER Now) is included too. But
   * if jobs require approval for the user than HOVER Now is removed, unless the
   * org setting has auto approve roof estimate.
   */
  availableDeliverables: Array<Deliverable>;
  /** A list of wallets that this org can use for billing. */
  billableWallets: Array<BillableWallet>;
  /** The brand of this org. It includes company logo and RGB color scheme */
  brand?: Maybe<Brand>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Contains information of this org related to the current_user. */
  currentUserContext: OrgCurrentUserContext;
  /** The organization's address city */
  custServCity?: Maybe<Scalars['String']['output']>;
  /** The organization's address country */
  custServCountry?: Maybe<Scalars['String']['output']>;
  /** The organization's address line 1 */
  custServLine1?: Maybe<Scalars['String']['output']>;
  /** The organization's address line 2 */
  custServLine2?: Maybe<Scalars['String']['output']>;
  /** The organization's mailing address name */
  custServName?: Maybe<Scalars['String']['output']>;
  /** The phone number for the organization */
  custServPhone?: Maybe<Scalars['String']['output']>;
  /** The organization's address postal code */
  custServPostalCode?: Maybe<Scalars['String']['output']>;
  /** The organization's address state or region */
  custServRegion?: Maybe<Scalars['String']['output']>;
  customerDisplayName?: Maybe<Scalars['String']['output']>;
  domainClaims?: Maybe<Array<DomainClaim>>;
  featureAccesses?: Maybe<Array<FeatureAccess>>;
  id: Scalars['Int']['output'];
  /** Returns whether interior lidar is allowed. Also considers potential user level override. */
  interiorLidar: Scalars['Boolean']['output'];
  /** Whether the organization is directly managed by the sales team or not. */
  isManaged?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the org is part of the new onboarding experience or not. This is
   * temporary and will be removed once the new onboarding experience is fully rolled out.
   */
  isNewOnboardingExperience: Scalars['Boolean']['output'];
  /**
   * Whether the organization has already completed a self qualification survey or
   * not, and has an associated org survey qualifier record.
   */
  isSurveyed?: Maybe<Scalars['Boolean']['output']>;
  jobsCount: Scalars['Int']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  /** The locale of the org in BCP-47 standard, i.e. en-US or en-GB. */
  locale: Locale;
  manufacturerIds?: Maybe<Array<Scalars['Int']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** Next billing date for upcoming SaaS payment */
  nextBillingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Determines if the organization is on waitlist. */
  onWaitlist?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this Org's settings have own_wallet_billable is set to true */
  ownWalletBillable?: Maybe<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  paymentBanner?: Maybe<PaymentBanner>;
  /** The plan this org is on. Only available for org admins */
  plan?: Maybe<Plan>;
  /** Whether a plan is on a yearly or monthly billing cycle */
  planBillingCycle?: Maybe<Scalars['String']['output']>;
  /** Determines if CaptureOnly checkbox on the User's client should be pre-checked by default. */
  preSelectCaptureOnlyForUsers: Scalars['Boolean']['output'];
  preferences?: Maybe<OrgPreferences>;
  /** The organization's job priority. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** This org's single sign on configuration if it exists */
  ssoConfig?: Maybe<SsoConfig>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A list of users which have access to this org ordered by user.createdAt in descending order. */
  users: UserBasicInfoPaginatedResults;
  usersCount: Scalars['Int']['output'];
  /** This Org's Wallet */
  wallet?: Maybe<Wallet>;
  /** The Xact integration details for this org */
  xactIntegration?: Maybe<XactIntegration>;
};


export type OrgAppliedDiscountsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type OrgUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Arguments for creating/updating an org */
export type OrgArgs = {
  custServCity?: InputMaybe<Scalars['String']['input']>;
  custServCountry?: InputMaybe<Scalars['String']['input']>;
  custServLine1?: InputMaybe<Scalars['String']['input']>;
  custServLine2?: InputMaybe<Scalars['String']['input']>;
  custServName?: InputMaybe<Scalars['String']['input']>;
  custServPhone?: InputMaybe<Scalars['String']['input']>;
  custServPostalCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type OrgBasePrice = ApplicationRecord & {
  __typename?: 'OrgBasePrice';
  billingCycle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  goodType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  partnerSubsidy: Scalars['Int']['output'];
  planId: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type OrgBasicInfo = ApplicationRecord & OrgNames & {
  __typename?: 'OrgBasicInfo';
  /**
   * Returns the available deliverables based on Org settings. See the
   * `available_deliverables` field documentation on the `Org` type for more details.
   */
  availableDeliverables: Array<Deliverable>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerDisplayName?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the org's expedited deliverable settings for their available
   * deliverables. It returns null if the org does not have on demand expedited
   * deliverables feature access enabled.
   */
  expeditedDeliverablesSettings?: Maybe<Array<ExpeditedDeliverablesSettings>>;
  /** Returns the org's wallet's external_identifier_patterns. */
  externalIdentifierPatterns?: Maybe<Array<ExternalIdentifierPattern>>;
  /** Returns whether the org requires an external identifier to be present when creating a job. */
  externalIdentifierRequired: Scalars['Boolean']['output'];
  /**
   * Returns whether the org has external identifier strict validation. If enabled,
   * incorrect external identifier will prevent job from updating and submitting.
   */
  externalIdentifierStrictValidation: Scalars['Boolean']['output'];
  /** Returns whether the org has hi def rendering feature */
  hiDefRendering: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** The manufacturer_ids associated with the org. */
  manufacturerIds?: Maybe<Array<Scalars['Int']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** Returns whether the org is using invoicing for billing purposes. */
  onInvoicing: Scalars['Boolean']['output'];
  /** Returns the org's setting for whether capture requests should always see Design Pro */
  onlyDesignProForCaptureRequest: Scalars['Boolean']['output'];
  /** The brand logo url of this org, as originally uploaded */
  orgBrandLogoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Unique code used for putting users in a specific org on signup. Refer to the
   * orgCode argument in createHomeowner/createProUser mutations. This is only used
   * in the context of AffiliateOrgsForPartner. This will always return null otherwise.
   */
  orgCode?: Maybe<OrgCode>;
  /** Returns the org's partner id */
  partnerId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is provided. */
export type OrgBasicInfoPaginatedResults = {
  __typename?: 'OrgBasicInfoPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<OrgBasicInfo>>;
};

export type OrgCode = {
  __typename?: 'OrgCode';
  code?: Maybe<Scalars['String']['output']>;
};

export type OrgCurrentUserContext = {
  __typename?: 'OrgCurrentUserContext';
  /** Return the aclTemplate the current_user has for this org. */
  aclTemplate?: Maybe<AclTemplateOptions>;
  /** Return true if the user has access to org billing information. */
  canManageBilling: Scalars['Boolean']['output'];
  /** Return true if the user can manage the org. */
  canManageOrg: Scalars['Boolean']['output'];
  /** Return true if the user has access to manage permissions for other users in their orgs */
  canManageUserPermissions: Scalars['Boolean']['output'];
  /** Returns true if the user can manage org and org has single_sign_on enabled */
  canReadSsoConfig: Scalars['Boolean']['output'];
  /**
   * Return true if the user should be cc'ed on all emails within the org.
   *
   * This field will only have effect for Org admin.
   */
  ccAdminOnEmails?: Maybe<Scalars['Boolean']['output']>;
};

export type OrgNames = {
  customerDisplayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrgPreferences = ApplicationRecord & {
  __typename?: 'OrgPreferences';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deliverable?: Maybe<Deliverable>;
  externalIdentifierLabel?: Maybe<Scalars['String']['output']>;
  externalIdentifierRequired?: Maybe<Scalars['Boolean']['output']>;
  externalIdentifierStrictValidation: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of OrgProductCreate. */
export type OrgProductCreatePayload = {
  __typename?: 'OrgProductCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgProduct?: Maybe<ProductCatalogConfigOrgProduct>;
};

/** Autogenerated return type of OrgProposalSettingUpdate. */
export type OrgProposalSettingUpdatePayload = {
  __typename?: 'OrgProposalSettingUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgProposalSetting?: Maybe<ProjectManagementConfigOrgProposalSetting>;
};

/** OrgSettings */
export type OrgSettings = ApplicationRecord & {
  __typename?: 'OrgSettings';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** the default sales tax for LABOR estimation line items in for this org */
  defaultLaborSalesTax?: Maybe<Scalars['Float']['output']>;
  /** the default margin for EstimationConfig::LineItems in this org */
  defaultMargin?: Maybe<Scalars['Float']['output']>;
  /** the default sales tax for MATERIAL and OTHER estimation line items in for this org */
  defaultSalesTax?: Maybe<Scalars['Float']['output']>;
  /** If this is clients should disable or hide the order submission button on the material list views. */
  disableOrderSubmission: Scalars['Boolean']['output'];
  /** If this is true clients should hide or disable the save as template button on the material list views. */
  disableSaveAsTemplate: Scalars['Boolean']['output'];
  /**
   * If this is true we’ll remove waste factor from our calculations on the
   * backend. And return a neutral value for APIs that return waste factor multipliers.
   */
  disableWasteFactor: Scalars['Boolean']['output'];
  /** Enables separate facet selection page for non-widing-walls in estimation */
  estimationNonSidingWallSupport: Scalars['Boolean']['output'];
  /** If this is true clients should hide the unit cost column when showing material list items. */
  hideListItemUnitCost: Scalars['Boolean']['output'];
  /** If this is true clients should hide the high level financial information when showing material lists. */
  hideProductionListFinancials: Scalars['Boolean']['output'];
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** Defines whether openings less than 33 square feet should be included when calculating non-siding-wall area. */
  includeNonSidingWallOpeningsLessThan33Sqft: Scalars['Boolean']['output'];
  /** Defines whether openings trim SQFT should be included when calculating non-siding-wall area. */
  includeNonSidingWallOpeningsTrim: Scalars['Boolean']['output'];
  /** Defines whether trim SQFT should be included when calculating non-siding-wall area. */
  includeNonSidingWallTrim: Scalars['Boolean']['output'];
  /** Indicates whether openings less than 33 square feet should be included when calculating siding area. */
  includeOpeningsLessThan33Sqft: Scalars['Boolean']['output'];
  /** Defines when siding openings trim SQFT should be included when calculating siding area. */
  includeSidingOpeningsTrim: Scalars['Boolean']['output'];
  /** Defines when siding trim SQFT should be included when calculating siding area. */
  includeSidingTrim: Scalars['Boolean']['output'];
  /** The Annual Percentage Rate (APR) used to calculate monthly payments for estimates. */
  monthlyPaymentApr?: Maybe<Scalars['Float']['output']>;
  /** The duration in months for calculating monthly payments for estimates. */
  monthlyPaymentDuration?: Maybe<Scalars['Float']['output']>;
  /** Controls visibility of the toggle which shows/hides the line item details on an estimate */
  showEstimateLineItemDetailsToggle: Scalars['Boolean']['output'];
  /** Whether to show the profit breakdown in the estimate summary */
  showEstimationProfitInSummary: Scalars['Boolean']['output'];
  /**
   * This field is used to control who has access to view inspection checklist
   * @deprecated Replaced by hyperion feature access flag (ie: feature.identifier === 'INSPECTION_CHECKLIST')
   */
  showInspectionChecklist?: Maybe<Scalars['Boolean']['output']>;
  /** If this is true, template APIs will only return templates that have been configured for use with xactimate. */
  showOnlyXactimateTemplates: Scalars['Boolean']['output'];
  /** Controls whether the org sees the full ordering flow in Estimation */
  showOrderingFlow?: Maybe<Scalars['Boolean']['output']>;
  /** Controls visibility of prices in Estimation workflow. If false clients should not show line item prices. */
  showPricesInEstimation: Scalars['Boolean']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of OrgSettingsUpdate. */
export type OrgSettingsUpdatePayload = {
  __typename?: 'OrgSettingsUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgSettings?: Maybe<ProductCatalogOrgSettings>;
};

export type OrgSurveyQualifier = ApplicationRecord & {
  __typename?: 'OrgSurveyQualifier';
  /** The type of work this org does, for example, [“Roofing, Siding”]. */
  businessDescription?: Maybe<Array<Scalars['String']['output']>>;
  /** The name of this organization at the time the org was surveyed. */
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** The vertical or industry this org works in, for example, 'Insurance'. */
  industryType?: Maybe<Scalars['String']['output']>;
  /** A numerical lower bound of an org’s estimated estimate count for the year. */
  jobEstimateLowerBound?: Maybe<Scalars['Int']['output']>;
  /** A numerical upper bound of an org’s estimated estimate count for the year. */
  jobEstimateUpperBound?: Maybe<Scalars['Int']['output']>;
  /** A numerical lower bound of an org’s estimated install count for the year. */
  jobInstallLowerBound?: Maybe<Scalars['Int']['output']>;
  /** A numerical upper bound of an org’s estimated install count for the year. */
  jobInstallUpperBound?: Maybe<Scalars['Int']['output']>;
  org: Org;
  /** The source of the qualifier, for example, “Mobile Self Qualification Survey”. */
  source?: Maybe<Scalars['String']['output']>;
  surveyedUser: User;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a org survey qualifier */
export type OrgSurveyQualifierCreateArgs = {
  /** The type of work this org does, for example, [“Roofing, Siding”]. */
  businessDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The name of this organization at the time the org was surveyed. */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** The vertical or industry this org works in, for example, "Insurance". */
  industryType?: InputMaybe<Scalars['String']['input']>;
  /** A numerical lower bound of an org’s estimated estimate count for the year. */
  jobEstimateLowerBound?: InputMaybe<Scalars['Int']['input']>;
  /** A numerical upper bound of an org’s estimated estimate count for the year. */
  jobEstimateUpperBound?: InputMaybe<Scalars['Int']['input']>;
  /** A numerical lower bound of an org’s estimated install count for the year. */
  jobInstallLowerBound?: InputMaybe<Scalars['Int']['input']>;
  /** A numerical upper bound of an org’s estimated install count for the year. */
  jobInstallUpperBound?: InputMaybe<Scalars['Int']['input']>;
  /** The source of the qualifier, for example, “Mobile Self Qualification Survey”. */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments for creating a user under a specific org */
export type OrgUserCreateArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  requireJobApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of OrgVariationsToggle. */
export type OrgVariationsTogglePayload = {
  __typename?: 'OrgVariationsTogglePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgVariations: Array<ProductCatalogOrgVariation>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  /** @deprecated Pagination with count is no longer supported */
  totalPages: Scalars['Int']['output'];
};

export type PaginationWithoutCount = {
  __typename?: 'PaginationWithoutCount';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaintMeasurements = {
  __typename?: 'PaintMeasurements';
  /** Calculated paint report full JSON */
  fullJson?: Maybe<Scalars['JSON']['output']>;
  /** Single line address formatted */
  singleLineAddress?: Maybe<Scalars['String']['output']>;
  /** Calculated paint report summary JSON */
  summaryJson?: Maybe<Scalars['JSON']['output']>;
};

export type PartialAnnotation = {
  __typename?: 'PartialAnnotation';
  annotationId: Scalars['ID']['output'];
  area: Scalars['Float']['output'];
  facadeId: Scalars['ID']['output'];
  /** Database id */
  id?: Maybe<Scalars['ID']['output']>;
};

export type Partner = ApplicationRecord & {
  __typename?: 'Partner';
  allowInsuranceDamageCapture?: Maybe<Scalars['Boolean']['output']>;
  allowInsuranceUnderwritingCapture?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a partner has co-branding enabled for the App */
  appCoBrand: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The deliverables available to this partner */
  deliverables: Array<Deliverable>;
  id: Scalars['Int']['output'];
  /** Unique identifier for a partner. */
  identifier?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<PartnerKind>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type PartnerAccountIdentifier = ApplicationRecord & {
  __typename?: 'PartnerAccountIdentifier';
  /** Unique identifier of the account associated with the partner */
  accountId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum PartnerKind {
  Insurance = 'INSURANCE',
  Standard = 'STANDARD'
}

export enum PartnersWithAffiliateOrgsIdentifiers {
  Beacon = 'BEACON'
}

export type PaymentBanner = {
  __typename?: 'PaymentBanner';
  body: Scalars['String']['output'];
  daysRemaining: Scalars['Int']['output'];
  kind: PaymentBannerKinds;
  title: Scalars['String']['output'];
};

export enum PaymentBannerKinds {
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Trial = 'TRIAL'
}

export type PerFace = {
  __typename?: 'PerFace';
  /** Area of facet */
  area?: Maybe<Scalars['Int']['output']>;
  /** Facet name */
  facet?: Maybe<Scalars['String']['output']>;
  /** Facet's pitch */
  pitch?: Maybe<Scalars['Int']['output']>;
};

export type PitchData = {
  __typename?: 'PitchData';
  /** Area of roof facade in square feet */
  area: Scalars['Int']['output'];
  /** Facade's percentage of total roof area */
  percentage: Scalars['String']['output'];
  /** Inches of vertical rise over 12 inches of horzontal run */
  roofPitch: Scalars['String']['output'];
};

export type Plan = ApplicationRecord & {
  __typename?: 'Plan';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The number of days that the users in the Org under this plan can access the
   * property information of a job since it's completed. The typical values are 365
   * or 0. If the value is 0, the access is unlimited.
   * @deprecated Users can access all of their jobs regardless when the jobs were created
   */
  daysOfHistoricalJobAccess: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jobBasePrices: Array<JobBasePrice>;
  name: Scalars['String']['output'];
  orgBasePrices: Array<OrgBasePrice>;
  /** Base price for HOVER Now */
  roofEstimateBasePrice: BasePrice;
  /** @deprecated non_saas plans no longer exists. All plans are SaaS. */
  saas: Scalars['Boolean']['output'];
  tier: Scalars['String']['output'];
  upchargeBasePrices: Array<UpchargeBasePrice>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated return type of PresentationArchive. */
export type PresentationArchivePayload = {
  __typename?: 'PresentationArchivePayload';
  /** Validation Errors */
  errors: Array<Error>;
  salesPresentation?: Maybe<SalesPresentationPresentation>;
};

/** Autogenerated return type of PresentationCreate. */
export type PresentationCreatePayload = {
  __typename?: 'PresentationCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  presentation?: Maybe<SalesPresentationPresentation>;
};

/** Autogenerated return type of PresentationStateToggle. */
export type PresentationStateTogglePayload = {
  __typename?: 'PresentationStateTogglePayload';
  /** Validation Errors */
  errors: Array<Error>;
  salesPresentation?: Maybe<SalesPresentationPresentation>;
};

/** Autogenerated return type of PresentationUpdate. */
export type PresentationUpdatePayload = {
  __typename?: 'PresentationUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  presentation?: Maybe<SalesPresentationPresentation>;
};

export type ProductCatalogCategory = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogCategory';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The product catalog category */
  name: Scalars['String']['output'];
  orgProductsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for ProductCatalogCategory. */
export type ProductCatalogCategoryConnection = {
  __typename?: 'ProductCatalogCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogCategoryEdge = {
  __typename?: 'ProductCatalogCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogCategory>;
};

export type ProductCatalogColor = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogColor';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hex: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for ProductCatalogColor. */
export type ProductCatalogColorConnection = {
  __typename?: 'ProductCatalogColorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogColorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogColor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogColorEdge = {
  __typename?: 'ProductCatalogColorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogColor>;
};

/** A table of settings for orgs to filtering generic product selection. */
export type ProductCatalogConfigGenericProductSetting = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogConfigGenericProductSetting';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A list of Distributors an Org works with. */
export type ProductCatalogConfigOrgDistributor = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogConfigOrgDistributor';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  distributor: ProductCatalogDistributor;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ProductCatalogConfigOrgProduct = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogConfigOrgProduct';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  product: ProductCatalogProduct;
  productId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a ProductCatalogConfigOrgProduct */
export type ProductCatalogConfigOrgProductCreateInput = {
  orgId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductCatalogDistributor = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogDistributor';
  authenticationConnectionStrategy?: Maybe<DistributionAuthenticationConnectionStrategyEnum>;
  capabilities?: Maybe<ProductCatalogDistributorCapabilities>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The programmaticaly accessible name for this Distributor. This is used for
   * code to refer to certain Distributor when the database ID is not known.
   */
  identifier?: Maybe<ProductCatalogDistributorIdentifierEnum>;
  /**
   * The distributor's complete logo. By default this is returned in svg format.
   * Use the format argument to request other common image formats. If arguments
   * for width, height, or both are given the image will be resized to fit within
   * those constraints while maintain original image's aspect ratio.
   */
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  oauthAuthorizationUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The authenticated user's org's OAuth token for this distributor.If the
   * authenticated user's org has not authorized a connection to this distributor
   * the field will be null. If the request is un-authenticated this will be null.
   * @deprecated Deprecated: This requester dependent field hinders caching. Instead make a separate query to DistributionOauthTokens to get a list of connections between an org and a distributor.
   */
  oauthToken?: Maybe<DistributionOauthToken>;
  /** If this is true order submission will work normally. If it's false, the client should disable order submission. */
  orderSubmissionEnabled: Scalars['Boolean']['output'];
  /**
   * If this is true then this Distributor has given us access to their product
   * catalog and we've implemented it. With that we can use these products in
   * Design Pro and EHI's estimation feature.
   */
  supportsProductCatalog: Scalars['Boolean']['output'];
  /**
   * If this is true then this Distributor has given us access  to their product
   * ordering API and we've implemented it. With that you can order products from this provider.
   */
  supportsProductOrdering: Scalars['Boolean']['output'];
  /**
   * If this is true then clients should show a dialog presenting any errors
   * resulting from the order check process. That dialog should have a button to
   * cancel the order process. And another to continue with submitting the order,
   * despite any errors. If this setting is false then clients should ignore the
   * order check results and submit the order immediately.
   */
  supportsShowingOrderCheckResults: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * A URL to the Distributor's homepage/landing page. This may be used by the
   * front-end to provide a link to the Distributor's page. That can make it easy
   * for HOVER users to find out about new Distributors.
   */
  url?: Maybe<Scalars['String']['output']>;
  /** The name to use when referring to the distributor's website */
  websiteDisplayName?: Maybe<Scalars['String']['output']>;
};


export type ProductCatalogDistributorCapabilitiesArgs = {
  distributionApprovedBranchId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProductCatalogDistributorLogoArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information about what is supported by a distributor */
export type ProductCatalogDistributorCapabilities = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogDistributorCapabilities';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Whether this distributor supports specifying delivery date when submitting an order
   * @deprecated Replaced with supportsDeliveryDate
   */
  deliveryDate: Scalars['Boolean']['output'];
  /** @deprecated Replaced with supportsDeliveryMethod */
  deliveryMethod: Scalars['Boolean']['output'];
  deliveryMethods: Array<DistributionDeliveryMethod>;
  /**
   * Whether this distributor supports specifying delivery time when submitting an order
   * @deprecated Replaced with supportsDeliveryTime
   */
  deliveryTime: Scalars['Boolean']['output'];
  deliveryTimes: Array<DistributionDeliveryTime>;
  /**
   * Whether this distributor supports specifying delivery type when submitting an order
   * @deprecated Replaced with supportsDeliveryType
   */
  deliveryType: Scalars['Boolean']['output'];
  deliveryTypes: Array<DistributionDelivery>;
  id: Scalars['ID']['output'];
  /** Whether the distributor requires a job account to be specified to place an order */
  requiresOrderJobAccount: Scalars['Boolean']['output'];
  /** Some distributors allow contact information during when submitting an order. This flag indicates that ability */
  supportsDeliveryContact: Scalars['Boolean']['output'];
  supportsDeliveryDate: Scalars['Boolean']['output'];
  supportsDeliveryMethod: Scalars['Boolean']['output'];
  supportsDeliveryTime: Scalars['Boolean']['output'];
  supportsDeliveryType: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for ProductCatalogDistributor. */
export type ProductCatalogDistributorConnection = {
  __typename?: 'ProductCatalogDistributorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogDistributorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogDistributor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogDistributorEdge = {
  __typename?: 'ProductCatalogDistributorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogDistributor>;
};

export enum ProductCatalogDistributorIdentifierEnum {
  Abc = 'ABC',
  Beacon = 'BEACON',
  Srs = 'SRS',
  SrsV2 = 'SRS_V2',
  Wimsatt = 'WIMSATT'
}

/** The ProductCatalogDistributors attributes for this variation */
export type ProductCatalogDistributorVariationAttributes = {
  __typename?: 'ProductCatalogDistributorVariationAttributes';
  clientIdentifier?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['Float']['output']>;
};

export type ProductCatalogExternalProductIdentifier = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogExternalProductIdentifier';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<ProductCatalogDistributor>;
  /** current distributor order for the external product identifier */
  distributorId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  product: ProductCatalogProduct;
  productId: Scalars['ID']['output'];
  /** @deprecated Replaced by distributor */
  provider?: Maybe<ProductCatalogProvider>;
  /**
   * The ID of the distributor that sells this product. A distributor is a type of Provider.
   * @deprecated Replaced by distributor
   */
  providerId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for ProductCatalogExternalProductIdentifier. */
export type ProductCatalogExternalProductIdentifierConnection = {
  __typename?: 'ProductCatalogExternalProductIdentifierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogExternalProductIdentifierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogExternalProductIdentifier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogExternalProductIdentifierEdge = {
  __typename?: 'ProductCatalogExternalProductIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogExternalProductIdentifier>;
};

export type ProductCatalogExternalVariationIdentifier = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogExternalVariationIdentifier';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distributor?: Maybe<ProductCatalogDistributor>;
  /** current distributor order for the external variation identifier */
  distributorId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  /**
   * What kind of ExternalIdentifier is this? Currently this is only 'SKU' and a
   * couple of legacy values that shouldn't be used anymore.
   */
  kind: ProductCatalogExternalVariationIdentifierKindEnum;
  /** The distributor's identifier for this product. */
  productIdentifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by distributor */
  provider?: Maybe<ProductCatalogProvider>;
  /**
   * The ID of the distributor that sells this Variation of this Product. A distributor is a type of Provider.
   * @deprecated Replaced by distributorId
   */
  providerId?: Maybe<Scalars['ID']['output']>;
  /** The distributor's SKU for this product variation */
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variation: ProductCatalogVariation;
  variationId: Scalars['ID']['output'];
};

/** The connection type for ProductCatalogExternalVariationIdentifier. */
export type ProductCatalogExternalVariationIdentifierConnection = {
  __typename?: 'ProductCatalogExternalVariationIdentifierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogExternalVariationIdentifierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogExternalVariationIdentifier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogExternalVariationIdentifierEdge = {
  __typename?: 'ProductCatalogExternalVariationIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogExternalVariationIdentifier>;
};

export enum ProductCatalogExternalVariationIdentifierKindEnum {
  DistributorJson = 'DISTRIBUTOR_JSON',
  ManufacturerProductId = 'MANUFACTURER_PRODUCT_ID',
  Sku = 'SKU'
}

/** A table for holding facets as part of a faceted search, https://en.wikipedia.org/wiki/Faceted_search , data model. */
export type ProductCatalogFacet = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogFacet';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The name of the facet */
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ProductCatalogFacetTypeEnum {
  Color = 'COLOR',
  Composition = 'COMPOSITION',
  MaterialTexture = 'MATERIAL_TEXTURE',
  NoTypeSeeFacetValue = 'NO_TYPE_SEE_FACET_VALUE',
  OrderingUnitOfMeasure = 'ORDERING_UNIT_OF_MEASURE',
  Sizing = 'SIZING'
}

export type ProductCatalogFacetValue = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogFacetValue';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  facet: ProductCatalogFacet;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

export type ProductCatalogGrouping = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogGrouping';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Replaced by id */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variations: Array<ProductCatalogVariation>;
};

/** The connection type for ProductCatalogGrouping. */
export type ProductCatalogGroupingConnection = {
  __typename?: 'ProductCatalogGroupingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogGroupingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogGrouping>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogGroupingEdge = {
  __typename?: 'ProductCatalogGroupingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogGrouping>;
};

export type ProductCatalogLabel = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogLabel';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A grouping of categories whose colors will auto-match */
export type ProductCatalogMatchGroup = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogMatchGroup';
  /** Whether the match group is enabled/disabled */
  active: Scalars['Boolean']['output'];
  categories: Array<ProductCatalogCategory>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The description of the match group */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The name of the match group */
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a ProductCatalogMatchGroupCategory */
export type ProductCatalogMatchGroupCategoryNestedAttributesCreateInput = {
  productCatalogCategoryId: Scalars['ID']['input'];
};

/** The connection type for ProductCatalogMatchGroup. */
export type ProductCatalogMatchGroupConnection = {
  __typename?: 'ProductCatalogMatchGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogMatchGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogMatchGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a ProductCatalogMatchGroup */
export type ProductCatalogMatchGroupCreateInput = {
  /** Whether the match group is enabled/disabled */
  active: Scalars['Boolean']['input'];
  /** The description of the match group */
  description?: InputMaybe<Scalars['String']['input']>;
  matchGroupCategoriesAttributes?: InputMaybe<Array<ProductCatalogMatchGroupCategoryNestedAttributesCreateInput>>;
  /** The name of the match group */
  name: Scalars['String']['input'];
};

/** An edge in a connection. */
export type ProductCatalogMatchGroupEdge = {
  __typename?: 'ProductCatalogMatchGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogMatchGroup>;
};

/** Arguments for updating a ProductCatalogMatchGroup */
export type ProductCatalogMatchGroupUpdateInput = {
  /** Whether the match group is enabled/disabled */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The description of the match group */
  description?: InputMaybe<Scalars['String']['input']>;
  matchGroupCategoriesAttributes?: InputMaybe<Array<ProductCatalogMatchGroupCategoryNestedAttributesCreateInput>>;
  /** The name of the match group */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCatalogOrgSettings = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogOrgSettings';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  orgVariations: Array<ProductCatalogOrgVariation>;
  productFilteringEnabled: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type ProductCatalogOrgSettingsOrgVariationsArgs = {
  productId: Scalars['ID']['input'];
};

/** This table is used for variation level product filtering */
export type ProductCatalogOrgVariation = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogOrgVariation';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variation: ProductCatalogVariation;
  variationId: Scalars['ID']['output'];
};

/** Arguments for creating or deleting ProductCatalogOrgVariations */
export type ProductCatalogOrgVariationNestedInput = {
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  variationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductCatalogProduct = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogProduct';
  /** Legacy. Whether product is considered 'active' */
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** An optional more consumer friendly product name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated For backwards compatibility */
  firstVariation?: Maybe<ProductCatalogVariation>;
  fromProductSync: Scalars['Boolean']['output'];
  groupings?: Maybe<Array<ProductCatalogGrouping>>;
  id: Scalars['ID']['output'];
  /** Whether product is paintable or not */
  isPaintable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<ProductCatalogLabel>;
  labelId?: Maybe<Scalars['Int']['output']>;
  legacyId: Scalars['Int']['output'];
  /** A url to the product on the manufacturer's website */
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgVariationsCount?: Maybe<Scalars['Int']['output']>;
  productCatalogCategories: Array<ProductCatalogCategory>;
  productCatalogCategory?: Maybe<ProductCatalogCategory>;
  productType?: Maybe<ProductCatalogProductTypeEnum>;
  provider?: Maybe<ProductCatalogProvider>;
  /** The ID of the manufacturer that makes this Product. A manufacturer is a type of Provider. */
  providerId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated For backwards compatibility */
  ungroupedVariations: Array<ProductCatalogVariation>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variations: Array<ProductCatalogVariation>;
  variationsCount: Scalars['Int']['output'];
};


export type ProductCatalogProductOrgVariationsCountArgs = {
  orgId: Scalars['ID']['input'];
};


export type ProductCatalogProductVariationsArgs = {
  filterByOrg?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  renderable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductCatalogProductVariationsCountArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for ProductCatalogProduct. */
export type ProductCatalogProductConnection = {
  __typename?: 'ProductCatalogProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogProductEdge = {
  __typename?: 'ProductCatalogProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogProduct>;
};

export enum ProductCatalogProductTypeEnum {
  Color = 'COLOR',
  Material = 'MATERIAL',
  Opening = 'OPENING'
}

export type ProductCatalogProvider = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogProvider';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for ProductCatalogProvider. */
export type ProductCatalogProviderConnection = {
  __typename?: 'ProductCatalogProviderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogProviderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogProvider>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogProviderEdge = {
  __typename?: 'ProductCatalogProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogProvider>;
};

export enum ProductCatalogProviderProviderTypeEnum {
  Distributor = 'DISTRIBUTOR',
  Manufacturer = 'MANUFACTURER'
}

export type ProductCatalogTexture = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogTexture';
  aoMap?: Maybe<File>;
  aoMapResized?: Maybe<File>;
  aoMapThumbnail?: Maybe<File>;
  basecolorMap?: Maybe<File>;
  basecolorMapResized?: Maybe<File>;
  basecolorMapThumbnail?: Maybe<File>;
  bumpMap?: Maybe<File>;
  bumpMapResized?: Maybe<File>;
  bumpMapThumbnail?: Maybe<File>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  diffuseMap?: Maybe<File>;
  diffuseMapResized?: Maybe<File>;
  diffuseMapThumbnail?: Maybe<File>;
  hasTransparency?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated For backwards compatibility */
  legacyDefault?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by id */
  legacyId?: Maybe<Scalars['Int']['output']>;
  metalMap?: Maybe<File>;
  metalMapResized?: Maybe<File>;
  metalMapThumbnail?: Maybe<File>;
  name: Scalars['String']['output'];
  normalMap?: Maybe<File>;
  normalMapResized?: Maybe<File>;
  normalMapThumbnail?: Maybe<File>;
  pbrMap?: Maybe<File>;
  pbrMapResized?: Maybe<File>;
  pbrMapThumbnail?: Maybe<File>;
  repeatable: Scalars['Boolean']['output'];
  roughMap?: Maybe<File>;
  roughMapResized?: Maybe<File>;
  roughMapThumbnail?: Maybe<File>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** The connection type for ProductCatalogTexture. */
export type ProductCatalogTextureConnection = {
  __typename?: 'ProductCatalogTextureConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogTextureEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogTexture>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogTextureEdge = {
  __typename?: 'ProductCatalogTextureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogTexture>;
};

export type ProductCatalogVariation = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogVariation';
  /**
   * Legacy. Whether variation is considered 'active'
   * @deprecated For backwards compatibility
   */
  active: Scalars['Boolean']['output'];
  aiPrompt?: Maybe<GenAiConfigAiPrompt>;
  /** True if this product is available from a distributor. False if it's not. */
  available: Scalars['Boolean']['output'];
  color?: Maybe<ProductCatalogColor>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Defaults to DISTRIBUTOR_JSON if kind is not specified. */
  externalVariationIdentifiers: Array<ProductCatalogExternalVariationIdentifier>;
  /** @deprecated Use groupingLegacyId instead */
  groupingId?: Maybe<Scalars['Int']['output']>;
  groupingLegacyId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated replaced by texture height */
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  imageThumbnail?: Maybe<File>;
  legacyId: Scalars['Int']['output'];
  /** Stores a link to the variation on the manufacturers website */
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** A record adding a variation to an org's filters. */
  orgVariation?: Maybe<ProductCatalogOrgVariation>;
  product: ProductCatalogProduct;
  /**
   * Legacy. Whether product is considered 'renderable'
   * @deprecated For backwards compatibility
   */
  renderable: Scalars['Boolean']['output'];
  texture?: Maybe<ProductCatalogTexture>;
  textureId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  variationFacets?: Maybe<Array<ProductCatalogVariationFacet>>;
  /** @deprecated replaced by texture width */
  width?: Maybe<Scalars['Float']['output']>;
};


export type ProductCatalogVariationExternalVariationIdentifiersArgs = {
  kind?: InputMaybe<ProductCatalogExternalVariationIdentifierKindEnum>;
};


export type ProductCatalogVariationOrgVariationArgs = {
  orgId: Scalars['ID']['input'];
};

/** The connection type for ProductCatalogVariation. */
export type ProductCatalogVariationConnection = {
  __typename?: 'ProductCatalogVariationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogVariationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogVariation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogVariationEdge = {
  __typename?: 'ProductCatalogVariationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogVariation>;
};

/** This table joins a product variation with a facet and stores the variation's value for that facet. */
export type ProductCatalogVariationFacet = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogVariationFacet';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  facetType: ProductCatalogFacetTypeEnum;
  facetValue?: Maybe<ProductCatalogFacetValue>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['String']['output'];
};

/** Production List */
export type ProductionList = ApplicationRecord & {
  __typename?: 'ProductionList';
  contractLaborTotal?: Maybe<Scalars['Float']['output']>;
  /** The original contract subtotal of all material list item total costs */
  contractMaterialSubtotal?: Maybe<Scalars['Float']['output']>;
  /** The original contract total of all list item tax amounts */
  contractMaterialTax?: Maybe<Scalars['Float']['output']>;
  /** The original contract sum of material_subtotal and material_tax */
  contractMaterialTotal?: Maybe<Scalars['Float']['output']>;
  contractOtherTotal?: Maybe<Scalars['Float']['output']>;
  contractPreDiscountPrice?: Maybe<Scalars['Float']['output']>;
  contractTotalCost?: Maybe<Scalars['Float']['output']>;
  /** The original contract total price (with discounts subtracted) */
  contractTotalPrice?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The DistributionOrders created from this ProductionList */
  distributionOrders: Array<DistributionOrder>;
  /** Whether the variations should be matched for items in related categories */
  enableVariationMatching: Scalars['Boolean']['output'];
  estimateGroup?: Maybe<EstimationEstimateGroup>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /**
   * A field that can be set by an external integration to store information like a
   * label or a state, which will be displayed to the user in HOVER's ui
   */
  integrationExternalLabel?: Maybe<Scalars['String']['output']>;
  /** The most recent time the user has instructed integrations to sync this record. */
  integrationLastManuallySyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * True if a user has instructed third party integrations to sync this record.
   * True no matter how many times the manual sync has been initiated.
   */
  integrationManuallySynced: Scalars['Boolean']['output'];
  /** @deprecated replaced by laborTotalCost */
  laborTotal?: Maybe<Scalars['Float']['output']>;
  /** The total cost, including tax, of all labor list items */
  laborTotalCost?: Maybe<Scalars['Float']['output']>;
  /**
   * The last XactProjectUpload the authenticated user made for the specified
   * ProductionList. If will be NULL if the user has made no uploads for the
   * ProductionList. Or if there is no authenticated user.
   */
  lastXactProjectUpload?: Maybe<XactProjectUpload>;
  listItems?: Maybe<Array<ListItem>>;
  /** The total pretax cost of all material list items */
  materialPretaxCost?: Maybe<Scalars['Float']['output']>;
  /** The total of all material list item tax amounts */
  materialSalesTax?: Maybe<Scalars['Float']['output']>;
  /** @deprecated replaced by materialPretaxCost */
  materialSubtotal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated replaced by materialSalesTax */
  materialTax?: Maybe<Scalars['Float']['output']>;
  /** @deprecated replaced by materialTotalCost */
  materialTotal?: Maybe<Scalars['Float']['output']>;
  /** The total cost, including tax, of all material list items */
  materialTotalCost?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orders: Array<ProjectManagementOrder>;
  /** @deprecated replaced by otherTotalCost */
  otherTotal?: Maybe<Scalars['Float']['output']>;
  /** The total cost, including tax, of all other list items */
  otherTotalCost?: Maybe<Scalars['Float']['output']>;
  profitAmount?: Maybe<Scalars['Float']['output']>;
  profitMargin?: Maybe<Scalars['Float']['output']>;
  salesOpportunity: SalesOpportunity;
  /** The id of the sales opportunity this production list is related to. */
  salesOpportunityId: Scalars['Int']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  /** total discount in dollars applied to the production list */
  totalDiscount: Scalars['Float']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user: User;
  /** The User that created this Production List */
  userId?: Maybe<Scalars['Int']['output']>;
};


/** Production List */
export type ProductionListListItemsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<LineItemTypeEnum>>;
};

/** The connection type for ProductionList. */
export type ProductionListConnection = {
  __typename?: 'ProductionListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductionListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductionList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductionListEdge = {
  __typename?: 'ProductionListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductionList>;
};

/** Autogenerated return type of ProductionListManualSyncCreate. */
export type ProductionListManualSyncCreatePayload = {
  __typename?: 'ProductionListManualSyncCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  integrationManualSync?: Maybe<IntegrationManualSync>;
};

/** Autogenerated return type of ProductionListUpdate. */
export type ProductionListUpdatePayload = {
  __typename?: 'ProductionListUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  productionList?: Maybe<ProductionList>;
};

export type Profile = {
  __typename?: 'Profile';
  impersonator?: Maybe<UserImpersonator>;
  user: User;
};

export type Project = ApplicationRecord & {
  __typename?: 'Project';
  /** The assets added to the project */
  addables?: Maybe<Array<AiDisplayImage>>;
  /** The time at which the project was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The action (or situation) that created the project */
  createdFrom: Scalars['String']['output'];
  /** The ID of the project */
  id: Scalars['Int']['output'];
  /** The scans added to the project */
  jobs?: Maybe<Array<Job>>;
  /** Which 'linkouts' and org has enabled */
  links?: Maybe<Array<Scalars['String']['output']>>;
  /** The user-defined name of the project */
  name: Scalars['String']['output'];
  /**
   * The organization that is associated with the project for branding. If the
   * authenticated user does not have access to the org, only the ID will be returned.
   * @deprecated Use project.publicOrgInfo instead.
   */
  org?: Maybe<Org>;
  /** The public information of the organization */
  publicOrgInfo?: Maybe<PublicOrgInfo>;
  /** The scope items associated with the project */
  scopeItems: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ProjectAsset = ApplicationRecord & {
  __typename?: 'ProjectAsset';
  /** The ID of the asset type */
  addableId: Scalars['Int']['output'];
  /** The model type for this asset (ie AI_DISPLAY_IMAGE) */
  addableType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the asset */
  id: Scalars['Int']['output'];
  /** The ID of the project this asset is associated with */
  projectId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ProjectAssetTypes {
  AiDisplayImage = 'AI_DISPLAY_IMAGE',
  Job = 'JOB'
}

/** Attributes for a list time that come from the vendor */
export type ProjectManagementConfigOrgProposalSetting = {
  __typename?: 'ProjectManagementConfigOrgProposalSetting';
  allowDefaultOverrideIncludeAllEstimateItems: Scalars['Boolean']['output'];
  allowDefaultOverrideIncludeItemCost: Scalars['Boolean']['output'];
  allowDefaultOverrideIncludeItemQuantities: Scalars['Boolean']['output'];
  allowDefaultOverrideIncludeTotalPrice: Scalars['Boolean']['output'];
  allowDefaultOverrideIncludeTradePrice: Scalars['Boolean']['output'];
  defaultNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includeAllEstimateItemsDefault: Scalars['Boolean']['output'];
  includeItemCostDefault: Scalars['Boolean']['output'];
  includeItemQuantitiesDefault: Scalars['Boolean']['output'];
  includeTotalPriceDefault: Scalars['Boolean']['output'];
  includeTradePriceDefault: Scalars['Boolean']['output'];
  maxSigneeCount: Scalars['Int']['output'];
  orgId: Scalars['Int']['output'];
  proposalsEnabled: Scalars['Boolean']['output'];
  scopeOfWorkDisclaimer?: Maybe<Scalars['String']['output']>;
  scopeOfWorkShowLogo: Scalars['Boolean']['output'];
  scopeOfWorkShowTitle: Scalars['Boolean']['output'];
  scopeOfWorkTitle?: Maybe<Scalars['String']['output']>;
};

/** Arguments for updating a ProjectManagementConfigOrgProposalSetting */
export type ProjectManagementConfigOrgProposalSettingUpdate = {
  /** allow users to edit proposal_documents.include_all_estimate_items setting */
  allowDefaultOverrideIncludeAllEstimateItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** allow users to edit proposal_documents.include_item_cost setting */
  allowDefaultOverrideIncludeItemCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** allow users to edit proposal_documents.include_item_quantities setting */
  allowDefaultOverrideIncludeItemQuantities?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, when generating a proposal document users can select if it will include total price */
  allowDefaultOverrideIncludeTotalPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** allow users to edit proposal_documents.include_trade_price setting */
  allowDefaultOverrideIncludeTradePrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default note for each new proposal document created by the org */
  defaultNote?: InputMaybe<Scalars['String']['input']>;
  /** default value for proposal_documents.include_all_estimate_items */
  includeAllEstimateItemsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** default value for proposal_documents.include_item_cost */
  includeItemCostDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** default value for proposal_documents.include_item_quantities */
  includeItemQuantitiesDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include the total price on a proposal document's scope of work page */
  includeTotalPriceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** default value for proposal_documents.include_trade_price */
  includeTradePriceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximumn number of signees that can be added to this org's proposal documents */
  maxSigneeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not proposals are enabled for the org */
  proposalsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disclaimer to be displayed on the scope of work */
  scopeOfWorkDisclaimer?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not logos should be shown for the scope of work */
  scopeOfWorkShowLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the title should be shown for the scope of work */
  scopeOfWorkShowTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the scope of work */
  scopeOfWorkTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectManagementConfigProposalTemplate = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementConfigProposalTemplate';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  orgId: Scalars['Int']['output'];
  pages: Array<ProjectManagementConfigProposalTemplatePage>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ProjectManagementConfigProposalTemplatePage = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementConfigProposalTemplatePage';
  /** The user-customizable HTML content for this page */
  content?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  pageType: ProjectManagementConfigProposalTemplatePageTypeEnum;
  /** If true, show org logo on rendered ProposalDocument page */
  showOrgLogo?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the title on this page */
  showTitle: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  /** The title of the page */
  title?: Maybe<Scalars['String']['output']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a ProjectManagementConfigProposalTemplatePage */
export type ProjectManagementConfigProposalTemplatePageCreateInput = {
  /** The user-customizable HTML content for this page */
  content?: InputMaybe<Scalars['String']['input']>;
  /** If true, show org logo on rendered ProposalDocument page */
  showOrgLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show the title on this page */
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the page */
  title?: InputMaybe<Scalars['String']['input']>;
  tradeType: TradeTypeEnum;
};

export enum ProjectManagementConfigProposalTemplatePageTypeEnum {
  Html = 'HTML',
  ListItems = 'LIST_ITEMS'
}

export type ProjectManagementListItemManualAdjustment = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementListItemManualAdjustment';
  context?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  listItem: ListItem;
  netCoveragePerSellingUnit?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  wasteFactor?: Maybe<Scalars['Float']['output']>;
};

/** Arguments for creating a List Item Manual Adjustment */
export type ProjectManagementListItemManualAdjustmentCreate = {
  context?: InputMaybe<Scalars['String']['input']>;
  netCoveragePerSellingUnit?: InputMaybe<Scalars['Float']['input']>;
  projectManagementListItemId: Scalars['ID']['input'];
  wasteFactor?: InputMaybe<Scalars['Float']['input']>;
};

/** Arguments for updating a List Item */
export type ProjectManagementListItemNestedAttributesUpdateInput = {
  /** If this is true then this list item will be returned in the top level list items for this production list */
  activeForTemplateLineItemGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the color of this product. For example 'Light Blue' */
  color?: InputMaybe<Scalars['String']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: InputMaybe<Scalars['ID']['input']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  listItemGroupName?: InputMaybe<Scalars['String']['input']>;
  /** The float amount for this list item */
  measurement?: InputMaybe<Scalars['Float']['input']>;
  /** The label for units that the measurement describes */
  measurementUnits?: InputMaybe<Scalars['String']['input']>;
  /** The name label of this list item */
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  /** The integer quantity of the list item */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnits?: InputMaybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: InputMaybe<Scalars['String']['input']>;
  skuChangedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls the sort order of ListItems on the ProductionList */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tradeType?: InputMaybe<TradeTypeEnum>;
  /** The LineItemType of this ListItem */
  type?: InputMaybe<LineItemTypeEnum>;
  /** The unit cost of the list item */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  userSetCustomColor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** the vendor that this item will be fulfilled through */
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

/** Project Management Order */
export type ProjectManagementOrder = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementOrder';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  distributionBranch?: Maybe<DistributionBranch>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']['output']>;
  distributionJobAccount?: Maybe<DistributionJobAccount>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']['output']>;
  /**
   * If this order has been submitted to a ProductCatalogDistributor for
   * fullfillment the DistributionOrder record keeps track of the order submission
   * and processing status.
   */
  distributionOrder?: Maybe<DistributionOrder>;
  /** The ID of the distribution order in Product Catalog */
  distributionOrderId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Replaced by purchase order number */
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** Documents related to this order. */
  orderDocuments: Array<OrderDocument>;
  orderListItems: Array<ProjectManagementOrderListItem>;
  /**
   * A common UUID between DistributionOrderCheck, DistributionOrder, and
   * ProjectManagementOrder. The process of placing an order can involve many order
   * checks. This ID will be the same for all order checks involved in an order. It
   * is up to clients using the ordering APIs to set the orderSessionId.
   */
  orderSessionId?: Maybe<Scalars['ID']['output']>;
  /** The org this ProjectManagementOrder belongs to. */
  org: Org;
  /** The ID of the Org this ProjectManagementOrder belongs to. */
  orgId: Scalars['Int']['output'];
  productionList: ProductionList;
  /** User specified identifier for this order */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  vendor?: Maybe<Vendor>;
};

/** The connection type for ProjectManagementOrder. */
export type ProjectManagementOrderConnection = {
  __typename?: 'ProjectManagementOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectManagementOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectManagementOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating an Order */
export type ProjectManagementOrderCreateInput = {
  /** The delivery contact email */
  deliveryContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The delivery contact name */
  deliveryContactName?: InputMaybe<Scalars['String']['input']>;
  /** The delivery contact phone number */
  deliveryContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The delivery date requested by the user */
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * The delivery method requested by the user. This should be a value from the
   * DistributionDeliveryMethodEnum from product-catalog
   */
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  /** The delivery time requested by the user. This should be a value from the DistributionDeliveryTimeEnum from product-catalog */
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  /** The delivery type requested by the user. This should be a value from the DistributionDeliveryTypeEnum from product-catalog */
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  /** The selected branch to send this order to. */
  distributionBranchId?: InputMaybe<Scalars['ID']['input']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The distributor to place the order with. If not specified, will use the
   * associated vendor of one of the specified list items.
   */
  distributorId?: InputMaybe<Scalars['ID']['input']>;
  /** DEPRECATED: replaced by purchase order number */
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The list of ProjectManagement::ListItem ids that should be included in this order */
  listItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The description to be saved to ProjectManagement::Order and to be sent to Distributors when placing orders. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The order contact email */
  orderContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The order contact name */
  orderContactName?: InputMaybe<Scalars['String']['input']>;
  /** The order contact phone number */
  orderContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * An array of attributes for order list items. If this is given, the listItemIds
   * argument will be ignored. And the attributes given will beused to create the
   * order's list items.
   */
  orderListItemsAttributes?: InputMaybe<Array<ProjectManagementOrderListItemCreateInput>>;
  /**
   * A common UUID between DistributionOrderCheck, DistributionOrder, and
   * ProjectManagementOrder. The process of placing an order can involve many order
   * checks. This ID will be the same for all order checks involved in an order. It
   * is up to clients using the ordering APIs to set the orderSessionId.
   */
  orderSessionId?: InputMaybe<Scalars['ID']['input']>;
  productionListId?: InputMaybe<Scalars['ID']['input']>;
  /** The user specified identifier that will be sent to Distributors when placing orders. */
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the shipping address passed to order provider */
  shippingAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** Country of the shipping address passed to order provider */
  shippingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  /** First name of the shipping address passed to order provider */
  shippingAddressFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the shipping address passed to order provider */
  shippingAddressLastName?: InputMaybe<Scalars['String']['input']>;
  /** Line 1 of the shipping address passed to order provider */
  shippingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Line 2 of the shipping address passed to order provider */
  shippingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the shipping address passed to order provider */
  shippingAddressPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the shipping address passed to order provider */
  shippingAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** State of the shipping address passed to order provider */
  shippingAddressState?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ProjectManagementOrderEdge = {
  __typename?: 'ProjectManagementOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectManagementOrder>;
};

/** Order List Item */
export type ProjectManagementOrderListItem = {
  __typename?: 'ProjectManagementOrderListItem';
  /** If this list item was ordered via a distributor, this is the order record. */
  distributionOrder?: Maybe<DistributionOrder>;
  /** @deprecated Replaced By productCatalogProductId */
  externalProductId?: Maybe<Scalars['ID']['output']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  listItem: ListItem;
  listItemId: Scalars['Int']['output'];
  /** Name of the order list item. */
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']['output']>;
  /** The quantity that was calculated for the list item. */
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnits?: Maybe<QuantityUnit>;
  /** The SKU for this product in the provider catalog. Can be used for automatic ordering */
  sku?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The last unit cost calculated before this order was created. */
  unitCost?: Maybe<Scalars['Float']['output']>;
  userSetCustomColor: Scalars['Boolean']['output'];
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku: Scalars['Boolean']['output'];
  /** The manufacturer's name for the variant, i.e. color */
  variantName?: Maybe<Scalars['String']['output']>;
  variation?: Maybe<ProductCatalogVariation>;
};

/** Arguments for creating an Order List Item */
export type ProjectManagementOrderListItemCreateInput = {
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the product */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: InputMaybe<Scalars['ID']['input']>;
  projectManagementListItemId: Scalars['ID']['input'];
  /** The quantity that was calculated for the list item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnits?: InputMaybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider catalog. Can be used for automatic ordering */
  sku?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type: LineItemTypeEnum;
  /** The last unit cost calculated before this order was created. */
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the product variation */
  variantName?: InputMaybe<Scalars['String']['input']>;
};

/** Arguments for updating a Production List */
export type ProjectManagementProductionListUpdateInput = {
  /** Whether the variations should be matched for items in related categories */
  enableVariationMatching?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A field that can be set by an external integration to store information like a
   * label or a state, which will be displayed to the user in HOVER's ui
   */
  integrationExternalLabel?: InputMaybe<Scalars['String']['input']>;
  listItemsAttributes?: InputMaybe<Array<ProjectManagementListItemNestedAttributesUpdateInput>>;
};

/** Proposal Document */
export type ProjectManagementProposalDocument = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementProposalDocument';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The email address of the customer requesting the document */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /** The full name of the customer requesting the document */
  customerName?: Maybe<Scalars['String']['output']>;
  customers: Array<ProjectManagementProposalDocumentCustomer>;
  estimateGroup: EstimationEstimateGroup;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** If true, will itemize all selected line items; if false, will only display totals for each line item category */
  includeAllEstimateItems?: Maybe<Scalars['Boolean']['output']>;
  /** Optional job-specific notes added by the customer */
  notes?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<File>;
  salesOpportunity: SalesOpportunity;
  signatureRequest?: Maybe<ProjectManagementSignatureRequest>;
  state: ProjectManagementProposalDocumentStateEnum;
  /** The price the homeowner will pay for this proposal. */
  totalPrice?: Maybe<Scalars['Float']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The User that created the ProjectManagementProposalDocument. */
  user: User;
  userId: Scalars['Int']['output'];
};

/** The connection type for ProjectManagementProposalDocument. */
export type ProjectManagementProposalDocumentConnection = {
  __typename?: 'ProjectManagementProposalDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectManagementProposalDocumentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectManagementProposalDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a ProposalDocument */
export type ProjectManagementProposalDocumentCreate = {
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressState?: InputMaybe<Scalars['String']['input']>;
  /** A public URL for a logo to be included on the proposal. */
  contractorLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the person sending this document. The contractor. */
  contractorName: Scalars['String']['input'];
  contractorPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The email of the person sending this document. The contractor. */
  contractorRepresentativeEmail: Scalars['String']['input'];
  /** The name of the person sending this document. The contractor. */
  contractorRepresentativeName: Scalars['String']['input'];
  /** The phone number of the person sending this document. The contractor. */
  contractorRepresentativePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The website URL of the contractor sending this proposal document. */
  contractorWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressState?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the customer requesting the document */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the customer requesting the document */
  customerName: Scalars['String']['input'];
  customerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  customersAttributes?: InputMaybe<Array<ProjectManagementProposalDocumentCustomerCreateInput>>;
  estimateGroupId: Scalars['ID']['input'];
  /** If true, will itemize all selected line items; if false, will only display totals for each line item category */
  includeAllEstimateItems?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemCost?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemQuantities?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the total price will be included on this document's scope of work page */
  includeTotalPrice?: InputMaybe<Scalars['Boolean']['input']>;
  includeTradePrice?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The name of this document. Will be included in the document header prefixed with 'Proposal
   * '. So a value of 'HOVER Residence' here will produce a header 'Proposal
   * HOVER Residence'.
   */
  name: Scalars['String']['input'];
  /** Optional job-specific notes added by the customer */
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectManagementProposalDocumentCustomer = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementProposalDocumentCustomer';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The email address of this customer. Any email sigature requests for this
   * proposal document will be sent to this email address
   */
  emailAddress: Scalars['String']['output'];
  /** Full name of the customer */
  fullName: Scalars['String']['output'];
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a Customer associated with a Project Management Proposal Document */
export type ProjectManagementProposalDocumentCustomerCreateInput = {
  /**
   * The email address of this customer. Any email sigature requests for this
   * proposal document will be sent to this email address
   */
  email: Scalars['String']['input'];
  /** Full name of the customer */
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ProjectManagementProposalDocumentEdge = {
  __typename?: 'ProjectManagementProposalDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectManagementProposalDocument>;
};

/** Proposal Document Preview */
export type ProjectManagementProposalDocumentPreview = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementProposalDocumentPreview';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** The org ID associated with the proposal document preview */
  orgId: Scalars['ID']['output'];
  pdf?: Maybe<File>;
  state: ProjectManagementProposalDocumentStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ProjectManagementProposalDocumentStateEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Queued = 'QUEUED',
  Requested = 'REQUESTED'
}

/** SignatureRequest */
export type ProjectManagementSignatureRequest = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementSignatureRequest';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** This is the unique identifier for the signature request in external systems. */
  externalIdentifier?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  proposalDocument: ProjectManagementProposalDocument;
  /** The proposal document for this signature request */
  proposalDocumentId: Scalars['ID']['output'];
  requestType: ProjectManagementSignatureRequestRequestTypeEnum;
  /** Datetime that the signature request was signed */
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current state of the signature request. */
  state: ProjectManagementSignatureRequestStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a SignatureRequest */
export type ProjectManagementSignatureRequestCreate = {
  /** The proposal document for this signature request */
  proposalDocumentId: Scalars['ID']['input'];
  requestType: ProjectManagementSignatureRequestRequestTypeEnum;
};

/** Embedded Signature Url */
export type ProjectManagementSignatureRequestEmbeddedUrl = {
  __typename?: 'ProjectManagementSignatureRequestEmbeddedUrl';
  expiresAt: Scalars['ISO8601DateTime']['output'];
  signUrl: Scalars['String']['output'];
};

export enum ProjectManagementSignatureRequestRequestTypeEnum {
  Email = 'EMAIL',
  Embed = 'EMBED'
}

export enum ProjectManagementSignatureRequestStateEnum {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Queued = 'QUEUED',
  Requested = 'REQUESTED',
  Signed = 'SIGNED'
}

/** Xactimate List Item */
export type ProjectManagementXactimateListItem = {
  __typename?: 'ProjectManagementXactimateListItem';
  /** Xactimate calculation format. Specifies a formula or quantity(double) for Xactimate. */
  calculation: Scalars['String']['output'];
  /** Xactimate category code */
  categoryCode: Scalars['String']['output'];
  /** Human readable description for this list item. Built from sku, product, and variation name */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Xactimate group id. This references a group of facades on the 3D model.
   * Instructing Xactimate to select some facades by default when the user
   * customizes selected coverage area for material quantity calculation.
   */
  groupIdentifier: Scalars['String']['output'];
  /** The Xactimate SEL code that specifies a product */
  selectorCode: Scalars['String']['output'];
};

export type ProjectShare = {
  __typename?: 'ProjectShare';
  aiDisplayImages: Array<AiDisplayImage>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creatingUser?: Maybe<ProjectShareCreatingUser>;
  id: Scalars['ID']['output'];
  orgBrandLogoUrl?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  shareCtaPath?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProjectShareCreatingUser = {
  __typename?: 'ProjectShareCreatingUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of ProposalDocumentCreate. */
export type ProposalDocumentCreatePayload = {
  __typename?: 'ProposalDocumentCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalDocument?: Maybe<ProjectManagementProposalDocument>;
};

/** Autogenerated return type of ProposalDocumentPreviewCreate. */
export type ProposalDocumentPreviewCreatePayload = {
  __typename?: 'ProposalDocumentPreviewCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalDocumentPreview?: Maybe<ProjectManagementProposalDocumentPreview>;
};

/** Autogenerated return type of ProposalTemplatePageCreate. */
export type ProposalTemplatePageCreatePayload = {
  __typename?: 'ProposalTemplatePageCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
};

/** Autogenerated return type of ProposalTemplatePageDelete. */
export type ProposalTemplatePageDeletePayload = {
  __typename?: 'ProposalTemplatePageDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ProposalTemplatePageUpdate. */
export type ProposalTemplatePageUpdatePayload = {
  __typename?: 'ProposalTemplatePageUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
};

/** Autogenerated return type of ProposalTemplatesPagesSortOrderUpdate. */
export type ProposalTemplatesPagesSortOrderUpdatePayload = {
  __typename?: 'ProposalTemplatesPagesSortOrderUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplate?: Maybe<ProjectManagementConfigProposalTemplate>;
};

/** Publicly available information regarding an org. */
export type PublicOrgInfo = {
  __typename?: 'PublicOrgInfo';
  brandLogoUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum QuantityUnit {
  Bags = 'BAGS',
  Boxes = 'BOXES',
  Bundles = 'BUNDLES',
  Cans = 'CANS',
  Cartons = 'CARTONS',
  CubicFeet = 'CUBIC_FEET',
  Drums = 'DRUMS',
  Each = 'EACH',
  Gallons = 'GALLONS',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  Packages = 'PACKAGES',
  Pails = 'PAILS',
  Pairs = 'PAIRS',
  Pallets = 'PALLETS',
  Panels = 'PANELS',
  Pieces = 'PIECES',
  Pounds = 'POUNDS',
  Quarts = 'QUARTS',
  Rolls = 'ROLLS',
  Sheets = 'SHEETS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET',
  Tubes = 'TUBES',
  UnitedInches = 'UNITED_INCHES'
}

export enum QuantityUnitsEnum {
  Bags = 'BAGS',
  Boxes = 'BOXES',
  Bundles = 'BUNDLES',
  Cans = 'CANS',
  Cartons = 'CARTONS',
  CubicFeet = 'CUBIC_FEET',
  Drums = 'DRUMS',
  Each = 'EACH',
  Gallons = 'GALLONS',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  Packages = 'PACKAGES',
  Pails = 'PAILS',
  Pairs = 'PAIRS',
  Pallets = 'PALLETS',
  Panels = 'PANELS',
  Pieces = 'PIECES',
  Pounds = 'POUNDS',
  Quarts = 'QUARTS',
  Rolls = 'ROLLS',
  Sheets = 'SHEETS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET',
  Tubes = 'TUBES',
  UnitedInches = 'UNITED_INCHES'
}

export type Query = {
  __typename?: 'Query';
  /** Returns all orgs with kind affiliate under the given partner. */
  affiliateOrgsForPartner: OrgBasicInfoPaginatedResults;
  aiAvailableConfigurations?: Maybe<AiAvailableConfigurations>;
  aiDisplayImage?: Maybe<AiDisplayImage>;
  aiDisplayImages?: Maybe<AiDisplayImagePaginatedResults>;
  aiGeneratedImage?: Maybe<AiGeneratedImage>;
  aiGeneratedImages: AiGeneratedImagePaginatedResults;
  aiGeneratedWatermarkImage?: Maybe<AiGeneratedWatermarkImage>;
  aiOriginalImage?: Maybe<AiOriginalImage>;
  aiOriginalImageAnonymous?: Maybe<AiOriginalImage>;
  aiOriginalImages?: Maybe<Array<AiOriginalImage>>;
  /**
   * Returns space types for an org. Orgs may set which space types their leads can
   * use in the Client Settings section of the admin area. If no org is provided,
   * returns all space types.
   */
  aiSpaceTypes: AiSpaceTypes;
  aiStylesMetadata?: Maybe<AiStyleMetadata>;
  /**
   * Looks up an SSO config, returns ssoSpSigninUrl and SSO config attributes
   * corresponding to the email. If SSO is not enabled, ssoSpSigninUrl will be nil.
   * Also checks whether or not given email is already in use by an existing Hover account.
   */
  authenticationInfo: AuthenticationInfo;
  beaconUser: BeaconUser;
  blueprintSubmissions?: Maybe<BlueprintSubmissionPaginatedResults>;
  /** Returns the latest consent policies for the specified kinds. */
  consentPolicies: Array<Maybe<ConsentPolicy>>;
  /** Returns all the damage inspection workflows that a user has access to */
  damageInspectionWorkflows?: Maybe<Array<InspectionWorkflow>>;
  /** Return all of the damage inspections associated with a job and/or inspector (user) */
  damageInspections: Array<InspectionDamageInspection>;
  /**
   * Returns all deliverables that exist in our database. Each org may have
   * restriction on which deliverables are allowed. Please refer to
   * availableDeliverables under Org object.
   */
  deliverables: Array<Deliverable>;
  designOrderSummary: DesignOrderSummary;
  /** Returns the products for the given theme for Design Studio */
  designStudioProductData?: Maybe<DesignStudioProductData>;
  distributionApprovedBranches: Array<DistributionBranch>;
  /**
   * Returns the JobAccountAuthentication records that are available to a given
   * org. A JobAccountAuthentication record indicates that the org has access to
   * order from the distributor using the associated job account. This applies to
   * distributors that support ClientCredential authorization.
   */
  distributionJobAccountAuthentications: Array<DistributionJobAccountAuthentication>;
  /** Returns the job accounts that are available to a given org. */
  distributionJobAccounts: Array<DistributionJobAccount>;
  distributionOauthTokens: DistributionOauthTokenConnection;
  distributionOrder?: Maybe<DistributionOrder>;
  distributionOrderCheck?: Maybe<DistributionOrderCheck>;
  distributionOrders?: Maybe<DistributionOrderConnection>;
  ehiFeatureAccesses: Array<EhiFeatureAccess>;
  ehiOrgSettings?: Maybe<OrgSettings>;
  estimationConfigInputCategories: EstimationConfigInputCategoryConnection;
  estimationConfigLineItemVersions: EstimationConfigLineItemVersionConnection;
  estimationConfigLineItems: EstimationConfigLineItemConnection;
  estimationConfigRequiredInputs: EstimationConfigRequiredInputConnection;
  estimationConfigRequiredInputsForTemplate: Array<EstimationConfigRequiredInput>;
  estimationConfigTemplate: EstimationConfigTemplate;
  estimationConfigTemplateCollectionsForOrg: EstimationConfigTemplateCollectionForOrg;
  estimationConfigTemplateFromProductionListCreateRequest?: Maybe<EstimationConfigTemplateFromProductionListCreateRequest>;
  estimationConfigTemplateVersions: EstimationConfigTemplateVersionConnection;
  estimationConfigTemplates: TemplateConnection;
  estimationConfigTemplatesRecentlyUsed: Array<Template>;
  estimationConfigTradeTypeEnumOrgs: EstimationConfigTradeTypeEnumOrgConnection;
  estimationEstimate?: Maybe<Estimate>;
  estimationEstimateGroup?: Maybe<EstimationEstimateGroup>;
  estimationEstimateGroups: EstimationEstimateGroupConnection;
  /** Returns all allowed Quantity Units */
  estimationQuantityUnits?: Maybe<Array<EstimationQuantityUnit>>;
  estimationSummarizedHdf?: Maybe<EstimationSummarizedHdf>;
  esxUri?: Maybe<Scalars['String']['output']>;
  getHiDefRendering?: Maybe<HiDefRendering>;
  getTreatment?: Maybe<Scalars['String']['output']>;
  getTreatmentWithConfig?: Maybe<TreatmentWithConfig>;
  gltf?: Maybe<Scalars['String']['output']>;
  inspectionChecklist?: Maybe<InspectionChecklist>;
  inspectionChecklists: InspectionChecklistConnection;
  inspectionConfigChecklistTemplate: InspectionConfigChecklistTemplate;
  inspectionConfigChecklistTemplateQuestion: InspectionConfigChecklistTemplateQuestion;
  inspectionConfigChecklistTemplateSection: InspectionConfigChecklistTemplateSection;
  inspectionConfigChecklistTemplates: InspectionConfigChecklistTemplateConnection;
  /** Returns information about a Job's Paint Measurements given a valid Share Token and Job ID. */
  jobSharedPaintMeasurements: JobSharedPaintMeasurements;
  /** Returns information about a job's renderings given a valid share token */
  jobSharedRenderings: JobSharedRenderings;
  /** Returns 3d files for a job share given a valid token and job id */
  jobSharedThreeDFiles: JobSharedThreeDFiles;
  jobs: JobPaginatedResults;
  measurementsForOrder: Model;
  measurementsService?: Maybe<Measurements>;
  obj?: Maybe<Scalars['String']['output']>;
  productCatalogCategories: ProductCatalogCategoryConnection;
  productCatalogColors: ProductCatalogColorConnection;
  /** Returns the generic product setting an org has configured. */
  productCatalogConfigGenericProductSetting?: Maybe<ProductCatalogConfigGenericProductSetting>;
  /** Returns the distributors an org works with. */
  productCatalogConfigOrgDistributors: Array<ProductCatalogConfigOrgDistributor>;
  productCatalogDistributor: ProductCatalogDistributor;
  productCatalogDistributorVariationAttributes: ProductCatalogDistributorVariationAttributes;
  productCatalogDistributorVariationsAttributes: Array<ProductCatalogDistributorVariationAttributes>;
  productCatalogDistributors: ProductCatalogDistributorConnection;
  productCatalogExternalProductIdentifiers: ProductCatalogExternalProductIdentifierConnection;
  productCatalogExternalVariationIdentifiers: ProductCatalogExternalVariationIdentifierConnection;
  productCatalogGroupings: ProductCatalogGroupingConnection;
  productCatalogMatchGroup: ProductCatalogMatchGroup;
  productCatalogMatchGroups: ProductCatalogMatchGroupConnection;
  productCatalogMatchingVariations: Array<ProductCatalogVariation>;
  productCatalogOrgSettings?: Maybe<ProductCatalogOrgSettings>;
  /** Returns null if the requested product is not found */
  productCatalogProduct?: Maybe<ProductCatalogProduct>;
  /**
   * Returns the top matches for your searchTerm. Default behavior is to return all
   * real(synced) products + products in this org's OrgProducts/filters. If the org
   * is connected to a distributor, then results are filtered by the distributors
   * they're connected to as well as the branches from that distributor that have been approved.
   */
  productCatalogProductSearch: Array<ProductCatalogProduct>;
  productCatalogProducts: ProductCatalogProductConnection;
  /** Returns [] if the requested products by tag is not found */
  productCatalogProductsByTag: ProductCatalogProductConnection;
  /**
   * Returns the top matches for your searchTerm. Default behavior is to return all
   * real(synced) products + products in this org's OrgProducts/filters. If the org
   * is connected to a distributor, then results are filtered by the distributors
   * they're connected to as well as the branches from that distributor that have been approved.
   */
  productCatalogProductsSearch: ProductCatalogProductConnection;
  productCatalogProviders: ProductCatalogProviderConnection;
  productCatalogTexture: ProductCatalogTexture;
  productCatalogTextures: ProductCatalogTextureConnection;
  productCatalogVariationSearch: ProductCatalogVariationConnection;
  productCatalogVariations: ProductCatalogVariationConnection;
  profile: Profile;
  /** Returns a project with the relevant ID */
  project?: Maybe<Project>;
  projectManagementConfigOrgProposalSetting?: Maybe<ProjectManagementConfigOrgProposalSetting>;
  projectManagementConfigProposalTemplate?: Maybe<ProjectManagementConfigProposalTemplate>;
  projectManagementConfigProposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
  projectManagementOrderDocument: OrderDocument;
  projectManagementOrderDocuments: Array<OrderDocument>;
  projectManagementOrders: ProjectManagementOrderConnection;
  projectManagementProductionList: ProductionList;
  projectManagementProductionListById: ProductionList;
  projectManagementProductionLists: ProductionListConnection;
  projectManagementProposalDocument?: Maybe<ProjectManagementProposalDocument>;
  projectManagementProposalDocumentPreview?: Maybe<ProjectManagementProposalDocumentPreview>;
  projectManagementProposalDocuments?: Maybe<ProjectManagementProposalDocumentConnection>;
  projectManagementSignatureRequest?: Maybe<ProjectManagementSignatureRequest>;
  projectManagementSignatureRequestEmbeddedUrl?: Maybe<ProjectManagementSignatureRequestEmbeddedUrl>;
  projectShare?: Maybe<ProjectShare>;
  /** Returns all the projects for a given user */
  projects?: Maybe<Array<Project>>;
  /** Returns public information regarding an org. */
  publicOrgInfo?: Maybe<PublicOrgInfo>;
  referenceMeasurementType: ReferenceMeasurement;
  revision?: Maybe<Scalars['String']['output']>;
  roofMeasurements?: Maybe<RoofMeasurements>;
  roofWasteData?: Maybe<RoofWasteData>;
  salesOpportunities: Array<SalesOpportunity>;
  /** This resolver returns the sales presentations an org has available to them. */
  salesPresentationPresentations: Array<SalesPresentationPresentation>;
  screenshots?: Maybe<Array<Maybe<ModelScreenshot>>>;
  /** Returns all Trade Types in sorted order */
  tradeTypes?: Maybe<Array<Trade>>;
  vendors: Array<Vendor>;
  vrsceneZipUri?: Maybe<Scalars['String']['output']>;
  wasteFactorRoof: WasteFactorRoof;
  xactApiStatus: XactApiStatus;
  /** Returns a Xact project upload matching the relevant ID */
  xactProjectUploadById?: Maybe<XactProjectUpload>;
};


export type QueryAffiliateOrgsForPartnerArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  partnerIdentifier: PartnersWithAffiliateOrgsIdentifiers;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiAvailableConfigurationsArgs = {
  orgId?: InputMaybe<Scalars['Int']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiDisplayImageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAiDisplayImagesArgs = {
  aiGeneratedImageId?: InputMaybe<Scalars['Int']['input']>;
  aiOriginalImageId?: InputMaybe<Scalars['Int']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiGeneratedImageArgs = {
  id: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiGeneratedImagesArgs = {
  aiOriginalImageId?: InputMaybe<Scalars['Int']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  jobClientIdentifier?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiGeneratedWatermarkImageArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiOriginalImageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  jobClientIdentifier?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiOriginalImageAnonymousArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiSpaceTypesArgs = {
  orgId?: InputMaybe<Scalars['Int']['input']>;
  publicIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiStylesMetadataArgs = {
  spaceType: Scalars['String']['input'];
};


export type QueryAuthenticationInfoArgs = {
  email: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBeaconUserArgs = {
  input?: InputMaybe<BeaconUserInput>;
};


export type QueryBlueprintSubmissionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<BlueprintSubmissionStates>>;
};


export type QueryConsentPoliciesArgs = {
  kinds: Array<ConsentPolicyKinds>;
};


export type QueryDamageInspectionsArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDesignOrderSummaryArgs = {
  id: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type QueryDesignStudioProductDataArgs = {
  themeName?: InputMaybe<DesignStudioThemeEnum>;
};


export type QueryDistributionApprovedBranchesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  distributorId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type QueryDistributionJobAccountAuthenticationsArgs = {
  distributorId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryDistributionJobAccountsArgs = {
  distributorId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryDistributionOauthTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDistributionOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDistributionOrderCheckArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDistributionOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEstimationConfigInputCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEstimationConfigLineItemVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineItemId: Scalars['ID']['input'];
};


export type QueryEstimationConfigLineItemsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  withProductsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEstimationConfigRequiredInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryEstimationConfigRequiredInputsForTemplateArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type QueryEstimationConfigTemplateArgs = {
  id: Scalars['ID']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEstimationConfigTemplateCollectionsForOrgArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryEstimationConfigTemplateFromProductionListCreateRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEstimationConfigTemplateVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
};


export type QueryEstimationConfigTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryEstimationConfigTemplatesRecentlyUsedArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryEstimationConfigTradeTypeEnumOrgsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryEstimationEstimateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEstimationEstimateGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEstimationEstimateGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  salesOpportunityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEstimationSummarizedHdfArgs = {
  jobId: Scalars['Int']['input'];
};


export type QueryEsxUriArgs = {
  address?: InputMaybe<EsxAddressInput>;
  alignSketchTopLeft?: InputMaybe<Scalars['Boolean']['input']>;
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  createWallsMethod2?: InputMaybe<Scalars['Boolean']['input']>;
  createWallsV3?: InputMaybe<Scalars['Boolean']['input']>;
  deductOpeningsFromWalls?: InputMaybe<Scalars['Boolean']['input']>;
  esxPutUri?: InputMaybe<Scalars['String']['input']>;
  geometryUri?: InputMaybe<Scalars['String']['input']>;
  measurementJsonUri?: InputMaybe<Scalars['String']['input']>;
  metadataUri?: InputMaybe<Scalars['String']['input']>;
  newPricingStructure?: InputMaybe<Scalars['Boolean']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  truncateClaimNumber?: InputMaybe<Scalars['Boolean']['input']>;
  useBarrelRoofStructure?: InputMaybe<Scalars['Boolean']['input']>;
  useConsistentLabels?: InputMaybe<Scalars['Boolean']['input']>;
  useConsistentLabelsSiding?: InputMaybe<Scalars['Boolean']['input']>;
  useGableRoofStructure?: InputMaybe<Scalars['Boolean']['input']>;
  x1Compatibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetHiDefRenderingArgs = {
  hiDefRenderingId: Scalars['ID']['input'];
};


export type QueryGetTreatmentArgs = {
  flagName: Scalars['String']['input'];
};


export type QueryGetTreatmentWithConfigArgs = {
  flagName: Scalars['String']['input'];
};


export type QueryGltfArgs = {
  geometryUri?: InputMaybe<Scalars['String']['input']>;
  highResTextures?: InputMaybe<Scalars['Boolean']['input']>;
  metadataUri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInspectionChecklistArgs = {
  jobId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type QueryInspectionChecklistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInspectionConfigChecklistTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectionConfigChecklistTemplateQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectionConfigChecklistTemplateSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInspectionConfigChecklistTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
  state?: InputMaybe<InspectionConfigChecklistTemplateStateEnum>;
};


export type QueryJobSharedPaintMeasurementsArgs = {
  jobId: Scalars['Int']['input'];
  shareToken: Scalars['String']['input'];
};


export type QueryJobSharedRenderingsArgs = {
  shareToken: Scalars['String']['input'];
};


export type QueryJobSharedThreeDFilesArgs = {
  jobId: Scalars['Int']['input'];
  shareToken: Scalars['String']['input'];
};


export type QueryJobsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  creatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliverableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  example?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<JobSearchFilters>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  inJobGroup?: InputMaybe<Scalars['ID']['input']>;
  jobTypes?: InputMaybe<Array<JobTypeFilters>>;
  orgIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<JobSortOrder>;
  updatedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  viewableBy?: InputMaybe<JobsViewableBy>;
};


export type QueryObjArgs = {
  geometryUri?: InputMaybe<Scalars['String']['input']>;
  metadataUri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCatalogCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogColorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductCatalogConfigGenericProductSettingArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogConfigOrgDistributorsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogDistributorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductCatalogDistributorVariationAttributesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  distributionBranchId?: InputMaybe<Scalars['ID']['input']>;
  distributionJobAccountId?: InputMaybe<Scalars['ID']['input']>;
  distributorId: Scalars['ID']['input'];
  lineItemAttributes: DistributionVariationAttributesInput;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductCatalogDistributorVariationsAttributesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  distributionBranchId?: InputMaybe<Scalars['ID']['input']>;
  distributionJobAccountId?: InputMaybe<Scalars['ID']['input']>;
  distributorId: Scalars['ID']['input'];
  lineItemsAttributes: Array<DistributionVariationAttributesInput>;
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogDistributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  integrated?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductCatalogExternalProductIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};


export type QueryProductCatalogExternalVariationIdentifiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<ProductCatalogExternalVariationIdentifierKindEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  variationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProductCatalogGroupingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductCatalogMatchGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductCatalogMatchGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogMatchingVariationsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  selectedVariationId: Scalars['ID']['input'];
};


export type QueryProductCatalogOrgSettingsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryProductCatalogProductArgs = {
  distributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};


export type QueryProductCatalogProductSearchArgs = {
  distributionBranchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  distributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCatalogProductsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distributionBranchId?: InputMaybe<Scalars['ID']['input']>;
  distributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByOrg?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manufacturerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  productCatalogCategoryId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProductCatalogProductsByTagArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tag: Scalars['String']['input'];
};


export type QueryProductCatalogProductsSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  distributionBranchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  distributorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCatalogProvidersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRenderableProducts?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerType?: InputMaybe<ProductCatalogProviderProviderTypeEnum>;
};


export type QueryProductCatalogTextureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductCatalogTexturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryProductCatalogVariationSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labelId?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  renderable?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  textureName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductCatalogVariationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectManagementConfigOrgProposalSettingArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryProjectManagementConfigProposalTemplateArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryProjectManagementConfigProposalTemplatePageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementOrderDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementOrderDocumentsArgs = {
  orderDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productionListId: Scalars['ID']['input'];
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectManagementOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryProjectManagementProductionListArgs = {
  jobId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type QueryProjectManagementProductionListByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementProductionListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QueryProjectManagementProposalDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementProposalDocumentPreviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementProposalDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  estimateGroupId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  salesOpportunityId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<ProjectManagementProposalDocumentStateEnum>;
};


export type QueryProjectManagementSignatureRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectManagementSignatureRequestEmbeddedUrlArgs = {
  signatureRequestId: Scalars['ID']['input'];
};


export type QueryProjectShareArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicOrgInfoArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryReferenceMeasurementTypeArgs = {
  jobClientIdentifier: Scalars['String']['input'];
  mobileClient: MobileClientArgs;
};


export type QueryRoofMeasurementsArgs = {
  geometryUri?: InputMaybe<Scalars['String']['input']>;
  metadataUri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoofWasteDataArgs = {
  hipsLinearFeet: Scalars['Float']['input'];
  rakesLinearFeet: Scalars['Float']['input'];
  roofSquareFeet: Scalars['Float']['input'];
  stepFlashingLinearFeet: Scalars['Float']['input'];
  valleysLinearFeet: Scalars['Float']['input'];
};


export type QuerySalesOpportunitiesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
};


export type QuerySalesPresentationPresentationsArgs = {
  orgId: Scalars['ID']['input'];
  state?: InputMaybe<SalesPresentationPresentationStateEnum>;
};


export type QueryScreenshotsArgs = {
  jobId: Scalars['Int']['input'];
};


export type QueryVendorsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryVrsceneZipUriArgs = {
  gltfFileName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWasteFactorRoofArgs = {
  roofAttributes: WasteFactorRoofInput;
};


export type QueryXactProjectUploadByIdArgs = {
  id: Scalars['Int']['input'];
};

export type ReferenceMeasurement = {
  __typename?: 'ReferenceMeasurement';
  type: ReferenceMeasurementTypes;
};

export enum ReferenceMeasurementTypes {
  ArReference = 'AR_REFERENCE',
  ManualReference = 'MANUAL_REFERENCE',
  NoReference = 'NO_REFERENCE'
}

export enum RemoteService {
  TinyMce = 'TINY_MCE'
}

export type Rendering = {
  __typename?: 'Rendering';
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  noiseThreshold?: Maybe<Scalars['Float']['output']>;
  percentDone?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  versionUrls?: Maybe<RenderingVersions>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum RenderingState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Rendering = 'RENDERING'
}

export enum RenderingVersion {
  Correction = 'CORRECTION',
  FirstRendering = 'FIRST_RENDERING',
  Revision = 'REVISION'
}

export type RenderingVersions = {
  __typename?: 'RenderingVersions';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type RoofData = {
  __typename?: 'RoofData';
  /** Data for cornices */
  cornices?: Maybe<CorniceData>;
  /** Data for downspouts */
  downspouts?: Maybe<GutterData>;
  /** Count and total length of eaves */
  eaves?: Maybe<RoofFeatureData>;
  /** Total and individual facade data */
  facets?: Maybe<RoofFacetData>;
  /** Count and total length of flashing */
  flashing?: Maybe<RoofFeatureData>;
  /** Data for gutters */
  gutters?: Maybe<GutterData>;
  /** Count and total length of hips */
  hips?: Maybe<RoofFeatureData>;
  /** Facade data for wrap facades */
  pitches?: Maybe<Array<PitchData>>;
  /** Count and total length of rakes */
  rakes?: Maybe<RoofFeatureData>;
  /** Count and total length of ridges */
  ridges?: Maybe<RoofFeatureData>;
  /** Data for soffits */
  soffits?: Maybe<SoffitData>;
  /** Count and total length of step flashing */
  stepFlashing?: Maybe<RoofFeatureData>;
  /** Count and total length of valleys */
  valleys?: Maybe<RoofFeatureData>;
};

export type RoofEstimate = {
  __typename?: 'RoofEstimate';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The pitch of the roof formatted as x/12 */
  predominantPitch?: Maybe<Scalars['String']['output']>;
  /** The total area of the roof measured in roof squares */
  totalRoofSquares?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum RoofEstimateAccessLevels {
  Instant = 'INSTANT',
  InstantUnsupported = 'INSTANT_UNSUPPORTED',
  None = 'NONE',
  Refined = 'REFINED',
  RefinedUnsupported = 'REFINED_UNSUPPORTED',
  VerifiedRefined = 'VERIFIED_REFINED'
}

export type RoofFacetData = {
  __typename?: 'RoofFacetData';
  /** Area of roof facets */
  area?: Maybe<Scalars['Int']['output']>;
  /** Count of facets */
  count?: Maybe<Scalars['Int']['output']>;
  /** Count of facets with a square footage greater than 4 */
  countAbove4Sqft?: Maybe<Scalars['Int']['output']>;
  /** List of area and pitch data by face */
  perFace?: Maybe<Array<PerFace>>;
};

export type RoofFeatureData = {
  __typename?: 'RoofFeatureData';
  /** Count of feature */
  count: Scalars['Int']['output'];
  /** Group name */
  group?: Maybe<Scalars['String']['output']>;
  /** Sum of feature lengths */
  length: Scalars['Float']['output'];
};

export type RoofMeasurements = {
  __typename?: 'RoofMeasurements';
  segments?: Maybe<RoofSegments>;
};

export type RoofSegments = {
  __typename?: 'RoofSegments';
  eaves?: Maybe<SegmentData>;
  flashings?: Maybe<SegmentData>;
  hips?: Maybe<SegmentData>;
  rakes?: Maybe<SegmentData>;
  /** Ridges are the things on the top of a roof */
  ridges?: Maybe<SegmentData>;
  stepFlashings?: Maybe<SegmentData>;
  valleys?: Maybe<SegmentData>;
};

export type RoofWasteData = {
  __typename?: 'RoofWasteData';
  recommendedRoofWastePercentage: Scalars['Float']['output'];
  roofWasteFactors: Array<Scalars['Float']['output']>;
};

export type RooflineData = {
  __typename?: 'RooflineData';
  /** Length of horizontal connection between bottom of roof and structure. */
  levelFriezeBoard: Scalars['Float']['output'];
  /** Length of slanted connection between bottom of roof and structure. */
  slopedFriezeBoard: Scalars['Float']['output'];
};

/** Sales Opportunity */
export type SalesOpportunity = ApplicationRecord & {
  __typename?: 'SalesOpportunity';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** The Job this SalesOpportunity is for. */
  job: Job;
  /** The job to which the estimate relates. */
  jobId: Scalars['Int']['output'];
  /** The Org this SalesOpportunity belongs to. */
  org: Org;
  /** The org to which the sales opportunity relates. */
  orgId: Scalars['Int']['output'];
  productionList?: Maybe<ProductionList>;
  soldEstimateGroup?: Maybe<EstimationEstimateGroup>;
  soldEstimateGroupId?: Maybe<Scalars['ID']['output']>;
  /** Whether the sale was made outside of HOVER */
  soldExternally: Scalars['Boolean']['output'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for updating a Sales Opportunity */
export type SalesOpportunityUpdate = {
  soldEstimateGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the sale was made outside of HOVER */
  soldExternally?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SalesOpportunityUpdate. */
export type SalesOpportunityUpdatePayload = {
  __typename?: 'SalesOpportunityUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  salesOpportunity?: Maybe<SalesOpportunity>;
};

/**
 * A Sales Presentation record that stores the pdf representation of the
 * presentation. An org can have one to many presentations.
 */
export type SalesPresentationPresentation = ApplicationRecordUuid & {
  __typename?: 'SalesPresentationPresentation';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID']['output'];
  /** The name of this presentation. */
  name: Scalars['String']['output'];
  /** The org this presentation belongs to. */
  orgId: Scalars['ID']['output'];
  /** The PDF file associated with this presentation. */
  pdf?: Maybe<File>;
  /** The state of this presentation. */
  state: SalesPresentationPresentationStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SalesPresentationPresentationCreateInput = {
  /** The name of this presentation. */
  name: Scalars['String']['input'];
  /** The org this presentation belongs to. */
  orgId: Scalars['ID']['input'];
  /**
   * Signed blob id for attaching pdf to sales presentation. Use the
   * salesPresentationFileUploadCreate mutation to create a signed blob id.
   */
  pdf: Scalars['ID']['input'];
};

export enum SalesPresentationPresentationStateEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

/** Arguments for updating a Sales Presentation */
export type SalesPresentationPresentationUpdateInput = {
  id: Scalars['ID']['input'];
  /** The name of this presentation. */
  name: Scalars['String']['input'];
};

export type ScopeItem = {
  __typename?: 'ScopeItem';
  /** Additional details */
  additionalDetails?: Maybe<Scalars['String']['output']>;
  /** Extent of scope */
  extent?: Maybe<Scalars['String']['output']>;
  /** Image files */
  images?: Maybe<Array<Scalars['String']['output']>>;
  /** Trade for specified instruction */
  trade: Scalars['String']['output'];
};

export type ScopeItemInput = {
  /** Additional details */
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Extent of work */
  extent?: InputMaybe<Scalars['String']['input']>;
  /** Name of images associated with scope item */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Trade for specified instruction */
  trade: Scalars['String']['input'];
};

/** Autogenerated return type of ScopeOfWorkSettingsUpdate. */
export type ScopeOfWorkSettingsUpdatePayload = {
  __typename?: 'ScopeOfWorkSettingsUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgProposalSetting?: Maybe<ProjectManagementConfigOrgProposalSetting>;
  proposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
};

export type SegmentData = {
  __typename?: 'SegmentData';
  data?: Maybe<Array<Maybe<ThreeDLine>>>;
  metadata?: Maybe<ThreeDMetaData>;
};

export type SharedCaptureRequest = ApplicationRecord & {
  __typename?: 'SharedCaptureRequest';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayRequestingOrg?: Maybe<OrgBasicInfo>;
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Sides = {
  __typename?: 'Sides';
  /** Elevations for back facing facades. */
  back: ElevationBySide;
  /** Elevations for front facing facades. */
  front: ElevationBySide;
  /** Elevations for left facing facades. */
  left: ElevationBySide;
  /** Elevations for facades not associated with the front, back left or right sides. */
  other: ElevationBySide;
  /** Elevations for right facing facades. */
  right: ElevationBySide;
};

/** Autogenerated return type of SignatureRequestCreate. */
export type SignatureRequestCreatePayload = {
  __typename?: 'SignatureRequestCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  signatureRequest?: Maybe<ProjectManagementSignatureRequest>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  archiveUrl: Scalars['String']['output'];
  screenshotUrl: Scalars['String']['output'];
  uploadKey: Scalars['String']['output'];
};

export type SoffitData = {
  __typename?: 'SoffitData';
  /** Total soffit area */
  area: Scalars['Float']['output'];
  /** Count of soffits */
  count: Scalars['Int']['output'];
  /** Soffit data by face */
  perFace: Array<SoffitFace>;
};

export type SoffitFace = {
  __typename?: 'SoffitFace';
  /** Soffit's color */
  color: Scalars['String']['output'];
  /** Depth of soffit */
  depth: Scalars['String']['output'];
  /** Number of faces on soffit */
  facesCount: Scalars['Int']['output'];
  /** Soffit's total area */
  totalArea: Scalars['Int']['output'];
  /** Soffit's total length */
  totalLength: Scalars['Float']['output'];
  /** Type of soffit */
  type: Scalars['String']['output'];
};

export type SsoConfig = ApplicationRecord & {
  __typename?: 'SsoConfig';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** This can only be seen by admins of the org that created this config. */
  idpCertBase64?: Maybe<Scalars['String']['output']>;
  /** This can only be seen by admins of the org that created this config. */
  idpEntityId?: Maybe<Scalars['String']['output']>;
  /** This can only be seen by admins of the org that created this config. */
  idpSsoTargetUrl?: Maybe<Scalars['String']['output']>;
  ssoEnabled: Scalars['Boolean']['output'];
  strictModeEnabled: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating a single sign on configuration */
export type SsoConfigArgs = {
  /** Public certificate provided by the IdP. Must be Base64 encoded. */
  idpCertBase64: Scalars['String']['input'];
  idpEntityId: Scalars['String']['input'];
  idpSsoTargetUrl: Scalars['String']['input'];
  /** SSO will be enabled for this org if true. Defaults to false */
  ssoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Users in this org will be required to log in using SSO if true. Defaults to false. */
  strictModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SubmitDesignOrderResponse. */
export type SubmitDesignOrderResponsePayload = {
  __typename?: 'SubmitDesignOrderResponsePayload';
  hiDefRenderingVersion?: Maybe<HiDefRenderingVersion>;
};

export type Summary = {
  __typename?: 'Summary';
  /** Areas by type */
  area: Area;
  /** Waste data for brick facades */
  brickWaste: WasteData;
  /** Elevation data by side */
  elevations: Elevations;
  /** Data for labeled facades */
  facades: Facades;
  /** Waste data for metal facades */
  metalWaste: WasteData;
  /** Data about roof facades */
  openings: Openings;
  /** Data about roof facades */
  roof: RoofData;
  /** Waste data for siding facades */
  sidingWaste: WasteData;
  /** Waste data for stone facades */
  stoneWaste: WasteData;
  /** Waste data for stucco facades */
  stuccoWaste: WasteData;
  /** Waste data for tudor facades */
  tudorWaste: WasteData;
  /** Waste data for unknown facades */
  unknownWaste: WasteData;
  /** Waste data for wrap facades */
  wrapWaste: WasteData;
};

/** Estimation Configuration Template */
export type Template = ApplicationRecord & {
  __typename?: 'Template';
  active: Scalars['Boolean']['output'];
  /**
   * The overall product brand for this template. Some products may be from
   * different brands, but this is the brand for the core products.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  lineItems: Array<EstimationConfigLineItem>;
  /** The name of the template. */
  name: Scalars['String']['output'];
  /** The org to which the template belongs. */
  orgId?: Maybe<Scalars['Int']['output']>;
  /** Templates will be searchable by the content of this field */
  searchText?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<EstimationConfigTemplateSetting>;
  /**
   * Controls visibility of prices in Estimation workflow. When false, clients
   * should not show line item prices. When true, clients should show line item
   * prices. When absent, clients will default to the show_prices_in_estimation
   * value set in org settings.
   */
  showPricesInEstimation?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which to display the templates in the UI. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  templateGroups: Array<EstimationConfigTemplateGroup>;
  templateImage?: Maybe<EstimationConfigTemplateImage>;
  tradeType: TradeTypeEnum;
  tradeTypeCategoryEnumValue: TradeTypeCategoryEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for Template. */
export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Template>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of TemplateCopy. */
export type TemplateCopyPayload = {
  __typename?: 'TemplateCopyPayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** An edge in a connection. */
export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Template>;
};

/** Autogenerated return type of TemplateFromProductionListCreateRequestCreate. */
export type TemplateFromProductionListCreateRequestCreatePayload = {
  __typename?: 'TemplateFromProductionListCreateRequestCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  templateFromProductionListCreateRequest?: Maybe<EstimationConfigTemplateFromProductionListCreateRequest>;
};

export type ThreeDCoordinate = {
  __typename?: 'ThreeDCoordinate';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type ThreeDFormats = {
  __typename?: 'ThreeDFormats';
  gltfUri?: Maybe<Scalars['String']['output']>;
  objUri?: Maybe<Scalars['String']['output']>;
};

export type ThreeDLine = {
  __typename?: 'ThreeDLine';
  end?: Maybe<ThreeDCoordinate>;
  start?: Maybe<ThreeDCoordinate>;
};

export type ThreeDMetaData = {
  __typename?: 'ThreeDMetaData';
  count?: Maybe<Scalars['Int']['output']>;
  formattedPerimeter?: Maybe<Scalars['String']['output']>;
  perimeter?: Maybe<Scalars['Float']['output']>;
};

/** Trade Type */
export type Trade = {
  __typename?: 'Trade';
  tradeTypeCategoryEnumValue: TradeTypeCategoryEnum;
  tradeTypeCategoryName: Scalars['String']['output'];
  tradeTypeEnumValue: TradeTypeEnum;
  tradeTypeName: Scalars['String']['output'];
};

export enum TradeTypeCategoryEnum {
  Generic = 'GENERIC',
  Interior = 'INTERIOR',
  NonSidingWall = 'NON_SIDING_WALL',
  Roof = 'ROOF',
  Siding = 'SIDING'
}

export enum TradeTypeEnum {
  AccentSiding = 'ACCENT_SIDING',
  AdjusterRoof = 'ADJUSTER_ROOF',
  All = 'ALL',
  AsphaltShingleRoof = 'ASPHALT_SHINGLE_ROOF',
  Bath = 'BATH',
  Brick = 'BRICK',
  Cladding = 'CLADDING',
  Cladding_2 = 'CLADDING_2',
  Coatings = 'COATINGS',
  CompositeSiding = 'COMPOSITE_SIDING',
  Decking = 'DECKING',
  Deductibility = 'DEDUCTIBILITY',
  Deductible = 'DEDUCTIBLE',
  Door = 'DOOR',
  Drywall = 'DRYWALL',
  EngineeredWoodSiding = 'ENGINEERED_WOOD_SIDING',
  Fascia = 'FASCIA',
  FiberCementSiding = 'FIBER_CEMENT_SIDING',
  FlatRoofing = 'FLAT_ROOFING',
  Flooring = 'FLOORING',
  Gutters = 'GUTTERS',
  GutterGuard = 'GUTTER_GUARD',
  HipAndRidge = 'HIP_AND_RIDGE',
  IceAndWater = 'ICE_AND_WATER',
  Insulation = 'INSULATION',
  InsuranceRoof = 'INSURANCE_ROOF',
  InteriorPaint = 'INTERIOR_PAINT',
  InteriorTrim = 'INTERIOR_TRIM',
  MetalRoof = 'METAL_ROOF',
  MetalShingleRoof = 'METAL_SHINGLE_ROOF',
  MetalSiding = 'METAL_SIDING',
  OutdoorKitchenPackages = 'OUTDOOR_KITCHEN_PACKAGES',
  Packages = 'PACKAGES',
  Paint = 'PAINT',
  Painting = 'PAINTING',
  Post_1978LeadPaint = 'POST_1978_LEAD_PAINT',
  Pre_1978LeadPaint = 'PRE_1978_LEAD_PAINT',
  Railing = 'RAILING',
  RetailRoof = 'RETAIL_ROOF',
  RetailSiding = 'RETAIL_SIDING',
  Roof = 'ROOF',
  RoofLaborOnly = 'ROOF_LABOR_ONLY',
  RoofRejuvenation = 'ROOF_REJUVENATION',
  RoofRepairs = 'ROOF_REPAIRS',
  RoofSystems = 'ROOF_SYSTEMS',
  Shutters = 'SHUTTERS',
  Siding = 'SIDING',
  Skylights = 'SKYLIGHTS',
  Soffit = 'SOFFIT',
  Solar = 'SOLAR',
  SolarShingles = 'SOLAR_SHINGLES',
  Stone = 'STONE',
  StoneCorners = 'STONE_CORNERS',
  StoneFlats = 'STONE_FLATS',
  StoneOther = 'STONE_OTHER',
  Stucco = 'STUCCO',
  Tarping = 'TARPING',
  TileRoofing = 'TILE_ROOFING',
  TileRoofingRAndR = 'TILE_ROOFING_R_AND_R',
  Trim = 'TRIM',
  Underlayment = 'UNDERLAYMENT',
  Upgrades = 'UPGRADES',
  Ventilation = 'VENTILATION',
  VinylSiding = 'VINYL_SIDING',
  WallInsulation = 'WALL_INSULATION',
  Warranties = 'WARRANTIES',
  Windows = 'WINDOWS'
}

export type TreatmentWithConfig = {
  __typename?: 'TreatmentWithConfig';
  config?: Maybe<Scalars['String']['output']>;
  treatment: Scalars['String']['output'];
};

export type TrimData = {
  __typename?: 'TrimData';
  /** Length of planes' bottom most side. */
  levelStarter?: Maybe<Scalars['Float']['output']>;
  /** Length of slated connection between top of roof and structure. */
  sloped?: Maybe<Scalars['Float']['output']>;
  /** Length of vertical connection between bottom of roof and structure. */
  vertical?: Maybe<Scalars['Float']['output']>;
};

/** Arguments for creating an unregistered user */
export type UnregisteredUserArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  signupType?: InputMaybe<UserSignupTypes>;
};

export type UpchargeBasePrice = ApplicationRecord & {
  __typename?: 'UpchargeBasePrice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  goodType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  partnerSubsidy: Scalars['Int']['output'];
  planId: Scalars['Int']['output'];
  /** Price in cents */
  price: Scalars['Int']['output'];
  upchargeKind: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type UpgradeToProInput = {
  company: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  orgId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  zipCode: Scalars['String']['input'];
};

export type UpgradeUserResponse = {
  __typename?: 'UpgradeUserResponse';
  user: User;
};

export type UploadRequest = {
  __typename?: 'UploadRequest';
  /** Used to look up and associate attachment after succesful upload */
  signedId?: Maybe<Scalars['String']['output']>;
  /** Headers used for upload request */
  uploadHeaders?: Maybe<Scalars['String']['output']>;
  /** URL used for direct upload of image by client */
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** Arguments for creating an upload request */
export type UploadRequestArgs = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type User = ApplicationRecord & UserNames & {
  __typename?: 'User';
  aclAccesses: Array<AclAccess>;
  /**
   * The commerce product active for this user or their org. Possible values:
   * 'estimation', 'ordering_only', 'out_of_the_box_configuration'
   */
  activeCommerceProduct?: Maybe<Scalars['String']['output']>;
  /** A list of capture requests where this user is the capturing user. */
  captureRequests: CaptureRequestPaginatedResults;
  consents: Array<Consent>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  /**
   * All feature flags that are enabled for this user
   * @deprecated Feature flags have moved to a vendor service
   */
  featureFlags: Array<FeatureFlag>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** SHA used for verifying user identification in Intercom communication */
  intercomSha: Scalars['String']['output'];
  isHomeowner?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the user is part of the new onboarding experience or not. This is
   * temporary and will be removed once the new onboarding experience is fully rolled out.
   */
  isNewOnboardingExperience: Scalars['Boolean']['output'];
  /** Indicates if the user account is a test account */
  isTestData?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** The locale of the user in BCP-47 standard, i.e. en-US or en-GB. */
  locale: Locale;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  orgs: Array<Org>;
  /** The user selected persona from a specific list of types. */
  persona?: Maybe<Scalars['String']['output']>;
  /** If `persona` is `other`, this field should contain the user's entered persona. */
  personaDescription?: Maybe<Scalars['String']['output']>;
  /**
   * This field generates a URL which can be used to upload a user's profile
   * picture. Only jpg files are supported. The link expires 600 minutes after being created.
   */
  profilePictureUploadUrl?: Maybe<Scalars['String']['output']>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Returns true if the user is a HOVER prospect and jobs must be approved by an
   * Org admin. Note: HOVER Now is an exception and this field will be ignored.
   */
  requireJobApproval?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<UserStates>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  uploadSecret?: Maybe<Scalars['String']['output']>;
};


export type UserAclAccessesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCaptureRequestsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<CaptureRequestStates>>;
};


export type UserOrgsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Arguments for creating a user */
export type UserArgs = {
  appLogin?: InputMaybe<Scalars['Boolean']['input']>;
  branchMatchIdentifier?: InputMaybe<Scalars['String']['input']>;
  captureRequestIdentifier?: InputMaybe<Scalars['String']['input']>;
  consents?: InputMaybe<Array<ConsentArgs>>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The locale of the user in BCP-47 standard, i.e. en-US or en-GB. */
  locale?: InputMaybe<Locale>;
  marketingCampaign?: InputMaybe<MarketingCampaignArgs>;
  marketingCampaignIdentifier?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  /** Type of user, i.e. estimator, owner, installer. */
  persona?: InputMaybe<UserPersonas>;
  /** Used to allow user to enter their own persona when they specify `other`. */
  personaDescription?: InputMaybe<Scalars['String']['input']>;
  preferredIdentifier?: InputMaybe<Scalars['String']['input']>;
  requireJobApproval?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserBasicInfo = ApplicationRecord & UserNames & {
  __typename?: 'UserBasicInfo';
  /**
   * Return the aclTemplate this user has for the given orgId. Return null if org
   * not found or this user does not have access to this org.
   */
  aclTemplateForOrgId?: Maybe<AclTemplateOptions>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobsCount: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A list of orgs which this user has access to. Basic info only. */
  orgs: OrgBasicInfoPaginatedResults;
  /**
   * Returns true if the user is a HOVER prospect and jobs must be approved by an
   * Org admin. Note: HOVER Now is an exception and this field will be ignored.
   */
  requireJobApproval?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<UserStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type UserBasicInfoAclTemplateForOrgIdArgs = {
  orgId: Scalars['Int']['input'];
};


export type UserBasicInfoOrgsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is provided. */
export type UserBasicInfoPaginatedResults = {
  __typename?: 'UserBasicInfoPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<UserBasicInfo>>;
};

export type UserImpersonator = {
  __typename?: 'UserImpersonator';
  userEmail: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type UserNames = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum UserPersonas {
  Accounting = 'ACCOUNTING',
  Estimator = 'ESTIMATOR',
  Installer = 'INSTALLER',
  Other = 'OTHER',
  Owner = 'OWNER',
  ProductionManager = 'PRODUCTION_MANAGER',
  ProjectManager = 'PROJECT_MANAGER',
  SalesManager = 'SALES_MANAGER',
  SalesRep = 'SALES_REP'
}

export enum UserSignupTypes {
  Homeowner = 'HOMEOWNER',
  Pro = 'PRO'
}

export enum UserStates {
  Activated = 'ACTIVATED',
  Archived = 'ARCHIVED',
  Invited = 'INVITED',
  WaitingActivation = 'WAITING_ACTIVATION'
}

/** Arguments for updating a user. */
export type UserUpdateArgs = {
  consents?: InputMaybe<Array<ConsentArgs>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The locale of the user in BCP-47 standard, i.e. en-US or en-GB. */
  locale?: InputMaybe<Locale>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  officePhone?: InputMaybe<Scalars['String']['input']>;
  /** Type of user, i.e. estimator, owner, installer. */
  persona?: InputMaybe<UserPersonas>;
  /** Used to allow user to enter their own persona when they specify `other`. */
  personaDescription?: InputMaybe<Scalars['String']['input']>;
  requireJobApproval?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Vector3 = {
  __typename?: 'Vector3';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

/** Vendor */
export type Vendor = ApplicationRecord & {
  __typename?: 'Vendor';
  /** the org's account ID with the vendor */
  accountId?: Maybe<Scalars['String']['output']>;
  /** address of this vendor */
  address1?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<DistributionBranch>;
  branchId?: Maybe<Scalars['ID']['output']>;
  /** name of the branch within the vendor */
  branchName: Scalars['String']['output'];
  /** city of this vendor */
  city?: Maybe<Scalars['String']['output']>;
  /** address of this vendor */
  country?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * An optional Distributor. If a vendor is associated with a Distributor then
   * ProjectManagementListItems associated with this Vendor will pull their product
   * information from that Distributor's catalog. Orders associated with the vendor
   * willbe placed with the associated Distributor as well.
   */
  distributor?: Maybe<ProductCatalogDistributor>;
  /** Foreign key to Distributor in the product-catalog service */
  distributorId?: Maybe<Scalars['ID']['output']>;
  /** The unique ID for an estimation_template. A template is a preconfigured set of options to use in crafting an estimate. */
  id: Scalars['Int']['output'];
  /** @deprecated Use the defaultJobAccount field on DistributionBranch instead. */
  jobAccount?: Maybe<DistributionJobAccount>;
  /** main contact email */
  mainContactEmail: Scalars['String']['output'];
  /** main contact fax */
  mainContactFax?: Maybe<Scalars['String']['output']>;
  /** person to contact at this vendor */
  mainContactName: Scalars['String']['output'];
  /** main contact phone */
  mainContactPhone?: Maybe<Scalars['String']['output']>;
  /** id of the org that this vendor belongs to */
  orgId: Scalars['Int']['output'];
  /** state of this vendor */
  state?: Maybe<Scalars['String']['output']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** name of the vendor */
  vendorName: Scalars['String']['output'];
  /** zip code of this vendor */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Vertex = {
  __typename?: 'Vertex';
  /** This id does not persist but is guaranteed to beconsistent as long as the geometry doesn't change. */
  id: Scalars['ID']['output'];
  /** (Unit: inch) */
  x: Scalars['Float']['output'];
  /** (Unit: inch) */
  y: Scalars['Float']['output'];
  /** (Unit: inch) */
  z: Scalars['Float']['output'];
};

/** Only Org admins are authorized to view this. Returns null for other users. */
export type Wallet = ApplicationRecord & {
  __typename?: 'Wallet';
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressLine2?: Maybe<Scalars['String']['output']>;
  billingAddressPostalCode?: Maybe<Scalars['String']['output']>;
  billingAddressRegion?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardExpiresOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** Available wallet balance/HOVER credits. */
  totalBalance?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Arguments for creating or updating a wallet */
export type WalletArgs = {
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingAddressRegion?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpiresOn?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
};

export type WasteData = {
  __typename?: 'WasteData';
  /** Facade by facade breakdown of waste data. */
  facades: Array<WastePercentages>;
  /** Waste data for all facades of given type. */
  total: WastePercentages;
};

/** Properties related to calculating waste factor for a roof */
export type WasteFactorRoof = {
  __typename?: 'WasteFactorRoof';
  /** Predicted waste factor */
  predictedWasteFactor: Scalars['Float']['output'];
};

/** Arguments for calculating a roof's recommended waste factor */
export type WasteFactorRoofInput = {
  hipsLinearFeet: Scalars['Float']['input'];
  rakesLinearFeet: Scalars['Float']['input'];
  roofSquareFeet: Scalars['Float']['input'];
  stepFlashingLinearFeet: Scalars['Float']['input'];
  valleysLinearFeet: Scalars['Float']['input'];
};

export type WastePercentages = {
  __typename?: 'WastePercentages';
  /** label for given facade. */
  facade?: Maybe<Scalars['String']['output']>;
  /** Area of facade with opeings plus 10% additional waste. */
  openingsPlus10Percent: Scalars['Int']['output'];
  /** Area of facade with opeings plus 18% additional waste. */
  openingsPlus18Percent: Scalars['Int']['output'];
  /** Area of facade plus 10% additional waste. */
  plus10Percent: Scalars['Int']['output'];
  /** Area of facade plus 18% additional waste. */
  plus18Percent: Scalars['Int']['output'];
  /** Area of facade with opeings. */
  withOpenings: Scalars['Int']['output'];
  /** Area of facade without additional waste. */
  zero: Scalars['Int']['output'];
};

export type WindowData = {
  __typename?: 'WindowData';
  /** Count of windows in model */
  count: Scalars['Int']['output'];
  /** Count of windows in model */
  perWindow: Array<IndividualWindowData>;
  /** Returns true if there are any features longer than 20ft. */
  totalArea?: Maybe<Scalars['Int']['output']>;
  /** Individual group data */
  totalUnitedInches: Scalars['Int']['output'];
};

export type WindowTexture = {
  __typename?: 'WindowTexture';
  windowColor?: Maybe<Scalars['String']['output']>;
  windowGrille?: Maybe<Scalars['String']['output']>;
  windowProduct?: Maybe<Scalars['Int']['output']>;
};

export enum XactApiStates {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

/** Status of the Xact API */
export type XactApiStatus = {
  __typename?: 'XactAPIStatus';
  /** Availability of the Xact API */
  status: XactApiStates;
};

export type XactIntegration = ApplicationRecord & {
  __typename?: 'XactIntegration';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type XactProject = ApplicationRecord & {
  __typename?: 'XactProject';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** The job that this project is associated with */
  job?: Maybe<Job>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The uploads associated with this project */
  uploads?: Maybe<Array<XactProjectUpload>>;
  /** The user that this project is associated with */
  user?: Maybe<User>;
};

export type XactProjectUpload = ApplicationRecord & {
  __typename?: 'XactProjectUpload';
  /** The time the upload was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The time the upload failed. This will be null if the upload is not in a failed state */
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  /** Whether or not this upload includes a production list */
  includesProductionList?: Maybe<Scalars['Boolean']['output']>;
  /** The job that this upload is associated with */
  job?: Maybe<Job>;
  /** The ID of the production list associated with this upload */
  productionListId?: Maybe<Scalars['Int']['output']>;
  /** The state of the upload */
  state?: Maybe<XactProjectUploadStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Any errors that occurred during the upload. This will be empty unless the upload state is FAILED or COMPLETED_WITH_ERRORS */
  uploadErrors?: Maybe<Array<Scalars['String']['output']>>;
  /** The project that this upload is associated with */
  xactProject?: Maybe<XactProject>;
};

export enum XactProjectUploadStates {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Requested = 'REQUESTED',
  Uploading = 'UPLOADING'
}

export enum XactSchemaState {
  Available = 'AVAILABLE',
  Generating = 'GENERATING',
  Queued = 'QUEUED',
  /** The schema has been replaced by a newer version */
  Stale = 'STALE',
  Unavailable = 'UNAVAILABLE'
}

/** Arguments for generating a schema with line items */
export type XactSchemaWithLineItemGenerationRequestArgs = {
  /** The ID of the Job this request is associated with */
  jobId: Scalars['Int']['input'];
  /** The ID of the Org this request is associated with */
  orgId: Scalars['Int']['input'];
  /** The ID of the production list to use for generating the schema */
  productionListId: Scalars['Int']['input'];
  /** The IDs of production list items to include in the schema */
  productionListItemIds: Array<Scalars['Int']['input']>;
  /** Whether or not to upload the generated schema to the user's Xact project */
  sendToXact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type XactSchemaWithLineItems = {
  __typename?: 'XactSchemaWithLineItems';
  /** The time this schema was last generated */
  lastGeneratedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the production list used to generate the schema */
  productionListId: Scalars['Int']['output'];
  /** The availability state of the schema */
  state: XactSchemaState;
};

export type XactSchemaWithLineItemsGenerationRequestResponse = {
  __typename?: 'XactSchemaWithLineItemsGenerationRequestResponse';
  schemaWithLineItems: XactSchemaWithLineItems;
  xactProjectUpload?: Maybe<XactProjectUpload>;
};

export type AiDisplayImageFragment = { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } };

export type AiGeneratedImageFragment = { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null };

export type AiGeneratedImagePollingConsumerFragment = { __typename?: 'AiGeneratedImage', pollingConsumerId?: string | null };

export type AiGeneratedImageRegionsFragment = { __typename?: 'AiGeneratedImage', regions?: string | null };

export type AiGeneratedImageStatusFragment = { __typename?: 'AiGeneratedImage', status?: string | null };

export type AiGeneratedImageClientStatusFragment = { __typename?: 'AiGeneratedImage', clientStatus?: string | null };

export type AiImageEditsFragment = { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null };

export type AiImageInstanceEditFragment = { __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null };

export type AiImageMaterialEditFragment = { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null };

export type AiImagePaintEditFragment = { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null };

export type AiImageRegionEditsFragment = { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null };

export type AiImageWallEditsFragment = { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null };

export type AiMaterialFragment = { __typename?: 'AiMaterial', id: number, palettes: Array<string>, regions: Array<string>, name: string, hex: string, thumbnail: string, spaceType: string, is3dFusion: boolean };

export type AiOriginalImageFragment = { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null };

export type AlbumFragmentFragment = { __typename?: 'Album', id: string, name: string, createdAt?: string | null, files?: Array<{ __typename?: 'AlbumFile', id: string, file?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string, variants?: { __typename?: 'ImageVariants', thumbnail?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string } | null } | null } | null }> | null };

export type BasicJobInfoFragment = { __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, modelFailureReason?: string | null, createdAt?: string | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null }>, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null } | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null };

export type JobHiDefRenderings_JobFragmentFragment = { __typename?: 'Job', hiDefRenderings?: Array<{ __typename?: 'HiDefRendering', id: number, name?: string | null, uuid: string, canCreateRevision: boolean, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, state?: HiDefRenderingVersionState | null, requestFormUrl: string, submissionUrl?: string | null, versionType?: RenderingVersion | null, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null, byteSize: string, checksum: string, contentType: string, createdAt: string, filename: string }, productVariations?: Array<{ __typename?: 'HiDefRenderingFileProductVariation', productCatalogVariationUuid?: string | null }> | null }> }> }> | null };

export type JobImagesFragmentFragment = { __typename?: 'Job', images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, imageMediumUrl?: string | null, rotatedImageMediumUrl?: string | null, rotatedImageUrl?: string | null, rotatedImageSmallUrl?: string | null, imageVersion: number, cubeFace?: number | null, kind?: JobImageKinds | null, createdAt?: string | null, viewpoint: JobImageViewpoints, autoCaptured?: boolean | null }> };

export type PaginationFragment = { __typename?: 'Pagination', currentPage: number, hasNextPage: boolean };

export type ProjectFragment = { __typename?: 'Project', id: number, name: string, scopeItems: Array<string>, createdAt: string, updatedAt?: string | null, links?: Array<string> | null, org?: { __typename?: 'Org', id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdAt?: string | null, createdFrom: string, favoritedAt?: string | null, id: number, spaceType?: string | null, style?: string | null, updatedAt?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null }, aiOriginalImage?: { __typename?: 'AiOriginalImage', orientation?: string | null } | null }> | null, jobs?: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, modelFailureReason?: string | null, createdAt?: string | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null }>, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null } | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null }> | null, publicOrgInfo?: { __typename?: 'PublicOrgInfo', id: number, displayName: string, brandLogoUrl?: string | null } | null };

export type ActivateMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ActivateMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', refreshToken: string, accessToken: string }, user: { __typename?: 'User', email: string, id: number, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, intercomSha: string, orgs: Array<{ __typename?: 'Org', name?: string | null, id: number, partner?: { __typename?: 'Partner', name: string, id: number } | null }> } } };

export type ApproveJobMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;


export type ApproveJobMutation = { __typename?: 'Mutation', approveJob: { __typename?: 'Job', id: number } };

export type ArchiveJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ArchiveJobMutation = { __typename?: 'Mutation', archiveJob: { __typename?: 'Job', archived: boolean } };

export type AttachScanToProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  scanId: Scalars['Int']['input'];
}>;


export type AttachScanToProjectMutation = { __typename?: 'Mutation', createProjectAsset: { __typename?: 'ProjectAsset', projectId: number, addableId: number, addableType: string } };

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string }, user: { __typename?: 'User', id: number, email: string, isHomeowner?: boolean | null, createdAt?: string | null, intercomSha: string, captureRequests: { __typename?: 'CaptureRequestPaginatedResults', pagination: { __typename?: 'PaginationWithoutCount', currentPage: number, hasNextPage: boolean }, results: Array<{ __typename?: 'CaptureRequest', id: number } | null> }, orgs: Array<{ __typename?: 'Org', partner?: { __typename?: 'Partner', id: number } | null }> } } };

export type AuthenticateWithBeaconTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateWithBeaconTokenMutation = { __typename?: 'Mutation', authenticateWithUserSigninToken: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string }, user: { __typename?: 'User', email: string, id: number } } };

export type AuthenticateWithCookieMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateWithCookieMutation = { __typename?: 'Mutation', authenticateWithCookie: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string }, user: { __typename?: 'User', createdAt?: string | null, email: string, id: number, firstName?: string | null, lastName?: string | null, mobilePhone?: string | null, intercomSha: string, orgs: Array<{ __typename?: 'Org', id: number, name?: string | null, ssoConfig?: { __typename?: 'SsoConfig', ssoEnabled: boolean } | null }> } } };

export type CompleteUserProfileMutationVariables = Exact<{
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteUserProfileMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type CreateAiDisplayImageMutationVariables = Exact<{
  aiGeneratedImageId: Scalars['ID']['input'];
  aiOriginalImageId: Scalars['ID']['input'];
  createdFrom: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  style: Scalars['String']['input'];
}>;


export type CreateAiDisplayImageMutation = { __typename?: 'Mutation', createAiDisplayImage: { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdAt?: string | null, createdFrom: string, favoritedAt?: string | null, id: number, spaceType?: string | null, style?: string | null, updatedAt?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', aiOriginalImageId: number, baseImageId?: number | null, createdAt?: string | null, favorite: boolean, generatedImagePath: string, id: number, imagePath: string, spaceType?: string | null, status?: string | null, style: string, updatedAt?: string | null, is3dFusionCompatible: boolean, fromSample: boolean } } };

export type CreateAiGeneratedImageAsyncMutationVariables = Exact<{
  aiOriginalImageId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
  intensity: Scalars['Int']['input'];
  style: Scalars['String']['input'];
  imageFlexibility: Scalars['Float']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAiGeneratedImageAsyncMutation = { __typename?: 'Mutation', createAiGeneratedImageAsync: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } };

export type CreateAiOriginalImageMutationVariables = Exact<{
  agreedToTerms: Scalars['Boolean']['input'];
  aiOriginalImageId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  imageFlexibility: Scalars['Float']['input'];
  imageSignedId: Scalars['String']['input'];
  intensity: Scalars['Int']['input'];
  style: Scalars['String']['input'];
  project?: InputMaybe<NewProjectArgs>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateAiOriginalImageMutation = { __typename?: 'Mutation', createAiOriginalImage: { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null } };

export type CreateAiOriginalImagePlaceholderMutationVariables = Exact<{
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  spaceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAiOriginalImagePlaceholderMutation = { __typename?: 'Mutation', createAiOriginalImagePlaceholder: { __typename?: 'AiOriginalImagePlaceholder', aiOriginalImageId?: number | null, signedId?: string | null, uploadUrl?: string | null, uploadHeaders?: string | null } };

export type CreateAlbumMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateAlbumMutation = { __typename?: 'Mutation', createAlbum: { __typename?: 'Album', id: string, createdAt?: string | null, name: string, files?: Array<{ __typename?: 'AlbumFile', createdAt?: string | null, id: string }> | null } };

export type CreateBlueprintSubmissionMutationVariables = Exact<{
  fileAttachmentsAttributes: Array<FileAttachmentArgs> | FileAttachmentArgs;
  jobsAttributes?: InputMaybe<Array<JobCreateArgs> | JobCreateArgs>;
  name?: InputMaybe<Scalars['String']['input']>;
  buildAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBlueprintSubmissionMutation = { __typename?: 'Mutation', createBlueprintSubmission: { __typename?: 'BlueprintSubmission', createdAt?: string | null, id: string, name: string, orgId: string, state?: BlueprintSubmissionStates | null, userId: string } };

export type CreateBulkBackgroundJobMutationVariables = Exact<{
  bulkBackgroundJobName: Scalars['String']['input'];
}>;


export type CreateBulkBackgroundJobMutation = { __typename?: 'Mutation', createBulkBackgroundJob: { __typename?: 'BulkBackgroundJob', id: string, presignedUrl: string } };

export type CreateDeliverableChangeRequestMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
  newDeliverableId: Scalars['Int']['input'];
}>;


export type CreateDeliverableChangeRequestMutation = { __typename?: 'Mutation', createDeliverableChangeRequest: { __typename?: 'DeliverableChangeRequest', newDeliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null } };

export type CreateDesignerAnonymousSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDesignerAnonymousSessionMutation = { __typename?: 'Mutation', createDesignerAnonymousSession: { __typename?: 'GmlAnonymousSession', jwt: string } };

export type CreateFileStorageTokenMutationVariables = Exact<{
  storageScope: FileStorageScopes;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  authorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateFileStorageTokenMutation = { __typename?: 'Mutation', createFileStorageToken: { __typename?: 'FileStorageToken', token: string } };

export type CreateHiDefRenderingMutationVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type CreateHiDefRenderingMutation = { __typename?: 'Mutation', createHiDefRendering: { __typename?: 'HiDefRendering', requestFormUrl: string } };

export type CreateHiDefRenderingVersionMutationVariables = Exact<{
  hiDefRenderingId: Scalars['ID']['input'];
  versionType: RenderingVersion;
}>;


export type CreateHiDefRenderingVersionMutation = { __typename?: 'Mutation', createHiDefRenderingVersion: { __typename?: 'HiDefRenderingVersion', hiDefRenderingId?: number | null, requestFormUrl: string, versionType?: RenderingVersion | null, state?: HiDefRenderingVersionState | null } };

export type CreateHomeownerMutationVariables = Exact<{
  distinctId?: InputMaybe<Scalars['String']['input']>;
  orgCode?: InputMaybe<Scalars['String']['input']>;
  user: UserArgs;
}>;


export type CreateHomeownerMutation = { __typename?: 'Mutation', createHomeowner: { __typename?: 'AuthenticationResponse', user: { __typename?: 'User', id: number, email: string, intercomSha: string, captureRequests: { __typename?: 'CaptureRequestPaginatedResults', results: Array<{ __typename?: 'CaptureRequest', id: number } | null> } }, jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string } } };

export type CreateImagePlaceholderMutationVariables = Exact<{
  imageParams: ImagePlaceholderArgs;
  isAdditional?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
}>;


export type CreateImagePlaceholderMutation = { __typename?: 'Mutation', createImagePlaceholder: { __typename?: 'ImageUploadInfo', imageId: number, uploadUrl: string } };

export type CreateInsuranceUserMutationVariables = Exact<{
  org: OrgArgs;
  user: UserArgs;
}>;


export type CreateInsuranceUserMutation = { __typename?: 'Mutation', createInsuranceUser: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string }, user: { __typename?: 'User', id: number, email: string, intercomSha: string } } };

export type CreateJobNoteMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
  note: NoteArgs;
}>;


export type CreateJobNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', id: number } };

export type CreateOrUpdateAlbumWithFilesMutationVariables = Exact<{
  album: CreateOrUpdateAlbumWithFilesArgs;
}>;


export type CreateOrUpdateAlbumWithFilesMutation = { __typename?: 'Mutation', createOrUpdateAlbumWithFiles: { __typename?: 'CreateAlbumFilesPayload', files: Array<{ __typename?: 'AlbumFile' } | { __typename?: 'CreateAlbumFileError', blobId: string, message: string }>, album: { __typename?: 'Album', id: string, name: string, createdAt?: string | null, files?: Array<{ __typename?: 'AlbumFile', id: string, file?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string, variants?: { __typename?: 'ImageVariants', thumbnail?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string } | null } | null } | null }> | null } } };

export type CreateOrgSurveyQualifierMutationVariables = Exact<{
  orgSurveyQualifierCreateArgs: OrgSurveyQualifierCreateArgs;
}>;


export type CreateOrgSurveyQualifierMutation = { __typename?: 'Mutation', createOrgSurveyQualifier: { __typename?: 'OrgSurveyQualifier', org: { __typename?: 'Org', id: number } } };

export type CreateProUserMutationVariables = Exact<{
  org: OrgArgs;
  user: UserArgs;
  parentOrgCode?: InputMaybe<Scalars['String']['input']>;
  signupVersion?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProUserMutation = { __typename?: 'Mutation', createProUser: { __typename?: 'AuthenticationResponse', user: { __typename?: 'User', id: number, email: string, intercomSha: string }, jwt: { __typename?: 'JWT', accessToken: string, refreshToken: string } } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  scopeItems?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: number, name: string, scopeItems: Array<string>, createdAt: string, updatedAt?: string | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } };

export type CreateProjectShareMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CreateProjectShareMutation = { __typename?: 'Mutation', createProjectShare: { __typename?: 'ProjectShare', id: string } };

export type CreateSolvedAiOriginalImageMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;


export type CreateSolvedAiOriginalImageMutation = { __typename?: 'Mutation', createSolvedAiOriginalImage: { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null } };

export type CreateUploadRequestMutationVariables = Exact<{
  fileInfo: UploadRequestArgs;
}>;


export type CreateUploadRequestMutation = { __typename?: 'Mutation', createUploadRequest: { __typename?: 'UploadRequest', signedId?: string | null, uploadHeaders?: string | null, uploadUrl?: string | null } };

export type CustomizeAiImageMutationVariables = Exact<{
  paintColorId?: InputMaybe<Scalars['Int']['input']>;
  materialId?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  instances?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  appId: Scalars['String']['input'];
  aiGeneratedImageId: Scalars['Int']['input'];
  productCatalogVariationUuid?: InputMaybe<Scalars['ID']['input']>;
  aiPromptName?: InputMaybe<Scalars['String']['input']>;
  paintHexColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomizeAiImageMutation = { __typename?: 'Mutation', customizeAiImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } };

export type DeleteAiOriginalImageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAiOriginalImageMutation = { __typename?: 'Mutation', deleteAiOriginalImage: { __typename?: 'AiOriginalImage', id: number, image: string, inputPath: string, spaceType?: string | null } };

export type DeleteAlbumFilesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAlbumFilesMutation = { __typename?: 'Mutation', deleteAlbumFiles: { __typename?: 'DeleteAlbumFilesPayload', files: Array<{ __typename?: 'AlbumFile', id: string }> } };

export type DeleteJobAssignmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteJobAssignmentMutation = { __typename?: 'Mutation', deleteJobAssignment: { __typename?: 'JobAssignment', id: number } };

export type DeleteJobNoteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteJobNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'Note', id: number } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: number } };

export type DeleteProjectAssetMutationVariables = Exact<{
  addableId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
}>;


export type DeleteProjectAssetMutation = { __typename?: 'Mutation', deleteProjectAsset: { __typename?: 'ProjectAsset', addableId: number, addableType: string, createdAt?: string | null, id: number, projectId: number, updatedAt?: string | null } };

export type DetectAiRegionsMutationVariables = Exact<{
  aiGeneratedImageId: Scalars['Int']['input'];
}>;


export type DetectAiRegionsMutation = { __typename?: 'Mutation', detectAiRegions: { __typename?: 'AiGeneratedImage', id: number, aiSegmentation?: { __typename?: 'AiSegmentation', id: number, instanceSvg?: string | null, regionStatistics?: string | null } | null } };

export type FavoriteAiCustomizedImageMutationVariables = Exact<{
  aiGeneratedImageId: Scalars['Int']['input'];
  favorited: Scalars['Boolean']['input'];
}>;


export type FavoriteAiCustomizedImageMutation = { __typename?: 'Mutation', favoriteAiCustomizedImage?: { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } } | null };

export type FinishedUploadingBulkBackgroundJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishedUploadingBulkBackgroundJobMutation = { __typename?: 'Mutation', finishedUploadingBulkBackgroundJob: boolean };

export type GenerateAiImageMutationVariables = Exact<{
  aiOriginalImageId: Scalars['Int']['input'];
  appId: Scalars['String']['input'];
  style: Scalars['String']['input'];
}>;


export type GenerateAiImageMutation = { __typename?: 'Mutation', generateAiImage: { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } } };

export type GenerateDefaultInspectionTemplatesMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type GenerateDefaultInspectionTemplatesMutation = { __typename?: 'Mutation', inspectionConfigChecklistTemplatesDefaultsCreate?: { __typename?: 'ChecklistTemplatesDefaultsCreatePayload', createdChecklistTemplatesCount: number } | null };

export type MagicLinkSigninMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectToUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type MagicLinkSigninMutation = { __typename?: 'Mutation', magicLinkSignin: boolean };

export type OnboardingCreateHomeownerUserMutationVariables = Exact<{
  args: OnboardingCreateHomeownerUserArgs;
}>;


export type OnboardingCreateHomeownerUserMutation = { __typename?: 'Mutation', onboardingCreateHomeownerUser?: { __typename?: 'OnboardingCreateUserResponse', user?: { __typename?: 'User', id: number } | null, jwt?: { __typename?: 'JWT', accessToken: string, refreshToken: string } | null } | null };

export type OnboardingCreateOrgForUserMutationVariables = Exact<{
  createOrgForUserArgs: OnboardingCreateOrgForUserArgs;
}>;


export type OnboardingCreateOrgForUserMutation = { __typename?: 'Mutation', onboardingCreateOrgForUser?: { __typename?: 'OnboardingCreateOrgForUserResponse', org?: { __typename?: 'Org', id: number, name?: string | null } | null } | null };

export type OnboardingCreateOrgUsersMutationVariables = Exact<{
  createOrgUsersArgs: OnboardingCreateOrgUsersArgs;
}>;


export type OnboardingCreateOrgUsersMutation = { __typename?: 'Mutation', onboardingCreateOrgUsers: Array<{ __typename?: 'User', id: number, email: string }> };

export type OnboardingCreateUserMutationVariables = Exact<{
  createUserArgs: OnboardingCreateUserArgs;
}>;


export type OnboardingCreateUserMutation = { __typename?: 'Mutation', onboardingCreateUser?: { __typename?: 'OnboardingCreateUserResponse', user?: { __typename?: 'User', id: number } | null, jwt?: { __typename?: 'JWT', accessToken: string, refreshToken: string } | null } | null };

export type ProcessAdditionalImageMutationVariables = Exact<{
  imageId: Scalars['Int']['input'];
}>;


export type ProcessAdditionalImageMutation = { __typename?: 'Mutation', processAdditionalImage: { __typename?: 'JobImage', rotatedImageUrl?: string | null } };

export type RefreshJwtMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshJwtMutation = { __typename?: 'Mutation', refreshJwt: { __typename?: 'JWT', accessToken: string, refreshToken: string, expiresIn: number } };

export type RemoveScanFromProjectMutationVariables = Exact<{
  projectId: Scalars['Int']['input'];
  scanId: Scalars['Int']['input'];
}>;


export type RemoveScanFromProjectMutation = { __typename?: 'Mutation', deleteProjectAsset: { __typename?: 'ProjectAsset', projectId: number, addableId: number, addableType: string } };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'AuthenticationResponse', jwt: { __typename?: 'JWT', refreshToken: string, accessToken: string }, user: { __typename?: 'User', id: number, email: string, intercomSha: string, isNewOnboardingExperience: boolean, orgs: Array<{ __typename?: 'Org', id: number }> } } };

export type SendRenderingShareEmailMutationVariables = Exact<{
  shareToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type SendRenderingShareEmailMutation = { __typename?: 'Mutation', sendRenderingShareEmail: string };

export type SendResetPasswordInstructionsMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendResetPasswordInstructionsMutation = { __typename?: 'Mutation', sendResetPasswordInstructions: boolean };

export type ShareJobMutationVariables = Exact<{
  jobAssignment: JobAssignmentArgs;
  user: UnregisteredUserArgs;
}>;


export type ShareJobMutation = { __typename?: 'Mutation', shareJob: boolean };

export type StopImpersonationMutationVariables = Exact<{ [key: string]: never; }>;


export type StopImpersonationMutation = { __typename?: 'Mutation', stopImpersonation: { __typename?: 'UserImpersonator', userEmail: string, userId: string } };

export type SubmitDesignOrderResponseMutationVariables = Exact<{
  images?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
  designOrders: Array<DesignOrderInput> | DesignOrderInput;
  hiDefRenderingVersionId: Scalars['ID']['input'];
  packageType?: InputMaybe<Scalars['String']['input']>;
  versionType?: InputMaybe<RenderingVersion>;
}>;


export type SubmitDesignOrderResponseMutation = { __typename?: 'Mutation', submitDesignOrderResponse: { __typename?: 'SubmitDesignOrderResponsePayload', hiDefRenderingVersion?: { __typename?: 'HiDefRenderingVersion', id: number, designOrderResponse?: { __typename?: 'DesignOrderResponse', packageType?: string | null, designOrders?: Array<{ __typename?: 'DesignOrder', style?: string | null, views: Array<string>, additionalDetails?: string | null, scopeItems: Array<{ __typename?: 'ScopeItem', trade: string, additionalDetails?: string | null, images?: Array<string> | null }> }> | null } | null } | null } };

export type UnarchiveJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UnarchiveJobMutation = { __typename?: 'Mutation', unarchiveJob: { __typename?: 'Job', archived: boolean } };

export type UpdateAiDisplayImageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  aiGeneratedImageId?: InputMaybe<Scalars['Int']['input']>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAiDisplayImageMutation = { __typename?: 'Mutation', updateAiDisplayImage: { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } } };

export type UpdateAiGeneratedImageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAiGeneratedImageMutation = { __typename?: 'Mutation', updateAiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  job: JobUpdateArgs;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: number, externalIdentifier?: string | null, name?: string | null } };

export type UpdateJobNoteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  note: NoteArgs;
}>;


export type UpdateJobNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'Note', id: number } };

export type UpdateOrgMutationVariables = Exact<{
  org: OrgArgs;
  orgId: Scalars['Int']['input'];
}>;


export type UpdateOrgMutation = { __typename?: 'Mutation', updateOrg: { __typename?: 'Org', id: number, name?: string | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: number, name: string, scopeItems: Array<string>, updatedAt?: string | null, createdAt: string } };

export type UpdateUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  consents?: InputMaybe<Array<ConsentArgs> | ConsentArgs>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number } };

export type UpgradeToProMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  orgId: Scalars['Int']['input'];
  company: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}>;


export type UpgradeToProMutation = { __typename?: 'Mutation', upgradeToPro: { __typename?: 'UpgradeUserResponse', user: { __typename?: 'User', id: number, email: string, intercomSha: string } } };

export type UploadAiOriginalImageMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
  jobClientIdentifier?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<NewProjectArgs>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UploadAiOriginalImageMutation = { __typename?: 'Mutation', uploadAiOriginalImage: { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null } };

export type XactGenerateSchemaWithLineItemsMutationVariables = Exact<{
  generationArgs: XactSchemaWithLineItemGenerationRequestArgs;
}>;


export type XactGenerateSchemaWithLineItemsMutation = { __typename?: 'Mutation', xactGenerateSchemaWithLineItems: { __typename?: 'XactSchemaWithLineItemsGenerationRequestResponse', xactProjectUpload?: { __typename?: 'XactProjectUpload', id: number, state?: XactProjectUploadStates | null } | null } };

export type DeleteCaptureRequestMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCaptureRequestMutation = { __typename?: 'Mutation', deleteCaptureRequest: { __typename?: 'CaptureRequest', id: number } };

export type SendCaptureRequestNotificationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendCaptureRequestNotificationMutation = { __typename?: 'Mutation', sendCaptureRequestNotification: { __typename?: 'CaptureRequest', id: number } };

export type AffiliatesQueryVariables = Exact<{
  partnerIdentifier: PartnersWithAffiliateOrgsIdentifiers;
  search: Scalars['String']['input'];
}>;


export type AffiliatesQuery = { __typename?: 'Query', affiliateOrgsForPartner: { __typename?: 'OrgBasicInfoPaginatedResults', results: Array<{ __typename?: 'OrgBasicInfo', id: number, customerDisplayName?: string | null, orgCode?: { __typename?: 'OrgCode', code?: string | null } | null } | null> } };

export type AiAvailableConfigurationsQueryVariables = Exact<{
  spaceType?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AiAvailableConfigurationsQuery = { __typename?: 'Query', aiAvailableConfigurations?: { __typename?: 'AiAvailableConfigurations', styles?: Array<string> | null, paintColors: Array<{ __typename?: 'AiPaintColor', id: number, palettes: Array<string>, paintRegions: Array<string>, name: string, hex: string, manufacturer: string, samplizeProductKey?: string | null }>, materials?: Array<{ __typename?: 'AiMaterial', id: number, palettes: Array<string>, regions: Array<string>, name: string, hex: string, thumbnail: string, spaceType: string, is3dFusion: boolean }> | null } | null };

export type AiDisplayImageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AiDisplayImageQuery = { __typename?: 'Query', aiDisplayImage?: { __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } } | null };

export type AiDisplayImagesQueryVariables = Exact<{
  aiOriginalImageId?: InputMaybe<Scalars['Int']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AiDisplayImagesQuery = { __typename?: 'Query', aiDisplayImages?: { __typename?: 'AiDisplayImagePaginatedResults', pagination: { __typename?: 'Pagination', currentPage: number, hasNextPage: boolean }, results: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } } | null> } | null };

export type AiGeneratedImageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiGeneratedImageQuery = { __typename?: 'Query', aiGeneratedImage?: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } | null };

export type AiGeneratedImageRegionsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiGeneratedImageRegionsQuery = { __typename?: 'Query', aiGeneratedImage?: { __typename?: 'AiGeneratedImage', id: number, regions?: string | null } | null };

export type AiGeneratedImageSegmentationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiGeneratedImageSegmentationQuery = { __typename?: 'Query', aiGeneratedImage?: { __typename?: 'AiGeneratedImage', aiSegmentation?: { __typename?: 'AiSegmentation', id: number, instanceSvg?: string | null, regionStatistics?: string | null } | null } | null };

export type AiGeneratedImagesQueryVariables = Exact<{
  aiOriginalImageId?: InputMaybe<Scalars['Int']['input']>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AiGeneratedImagesQuery = { __typename?: 'Query', aiGeneratedImages: { __typename?: 'AiGeneratedImagePaginatedResults', pagination: { __typename?: 'Pagination', currentPage: number, hasNextPage: boolean }, results: Array<{ __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } | null> } };

export type AiGeneratedWatermarkImageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AiGeneratedWatermarkImageQuery = { __typename?: 'Query', aiGeneratedWatermarkImage?: { __typename?: 'AiGeneratedWatermarkImage', id: number, watermarkImageUrl?: string | null } | null };

export type AiOriginalImageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AiOriginalImageQuery = { __typename?: 'Query', aiOriginalImage?: { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, aiDisplayImages?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null } | null };

export type AiOriginalImageAnonymousQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AiOriginalImageAnonymousQuery = { __typename?: 'Query', aiOriginalImageAnonymous?: { __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, aiDisplayImages?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null } | null };

export type GetAiOriginalImageOrientationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAiOriginalImageOrientationQuery = { __typename?: 'Query', aiOriginalImage?: { __typename?: 'AiOriginalImage', orientation?: string | null } | null };

export type AiOriginalImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AiOriginalImagesQuery = { __typename?: 'Query', aiOriginalImages?: Array<{ __typename?: 'AiOriginalImage', createdAt?: string | null, id: number, image: string, inputPath: string, spaceType?: string | null, imagePath: string, originalImagePath: string, orientation?: string | null, status?: string | null, statusDescription?: string | null, thumbnailUrl?: string | null, isSample: boolean, aiGeneratedImages?: Array<{ __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, is3dFusionCompatible: boolean, pollingConsumerId?: string | null, clientStatus?: string | null, fromSample: boolean }> | null, associatedProject?: { __typename?: 'Project', id: number, name: string, createdFrom: string, createdAt: string, scopeItems: Array<string>, publicOrgInfo?: { __typename?: 'PublicOrgInfo', displayName: string, id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdFrom: string, favoritedAt?: string | null, id: number, style?: string | null, spaceType?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null } }> | null } | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, createdAt: string, scopeItems: Array<string>, createdFrom: string }> | null }> | null };

export type AiSpaceTypesQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['Int']['input']>;
  publicIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiSpaceTypesQuery = { __typename?: 'Query', aiSpaceTypes: { __typename?: 'AiSpaceTypes', spaceTypes: Array<string> } };

export type AiStylesMetadataQueryVariables = Exact<{
  spaceType: Scalars['String']['input'];
}>;


export type AiStylesMetadataQuery = { __typename?: 'Query', aiStylesMetadata?: { __typename?: 'AiStyleMetadata', metadata: string } | null };

export type AuthenticationInfoQueryVariables = Exact<{
  email: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthenticationInfoQuery = { __typename?: 'Query', authenticationInfo: { __typename?: 'AuthenticationInfo', ssoEnabled: boolean, ssoSpSigninUrl?: string | null, ssoStrictModeEnabled: boolean, emailInUse: boolean } };

export type BeaconUserQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type BeaconUserQuery = { __typename?: 'Query', beaconUser: { __typename?: 'BeaconUser', response: boolean, beacon_user: boolean, beacon_org: boolean } };

export type DesignOrderSummaryQueryVariables = Exact<{
  hiDefRenderingVersionId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
}>;


export type DesignOrderSummaryQuery = { __typename?: 'Query', designOrderSummary: { __typename?: 'DesignOrderSummary', jobId?: number | null, orderId?: string | null, orgId: number, requestingUserId: number, versionType?: RenderingVersion | null, designOrderResponse?: { __typename?: 'DesignOrderResponse', packageType?: string | null, designOrders?: Array<{ __typename?: 'DesignOrder', colorPalette?: string | null, style?: string | null, views: Array<string>, additionalDetails?: string | null, scopeItems: Array<{ __typename?: 'ScopeItem', additionalDetails?: string | null, images?: Array<string> | null, trade: string, extent?: string | null }> }> | null } | null } };

export type DesignStudioProductDataQueryVariables = Exact<{
  themeName?: InputMaybe<DesignStudioThemeEnum>;
}>;


export type DesignStudioProductDataQuery = { __typename?: 'Query', designStudioProductData?: { __typename?: 'DesignStudioProductData', colors?: Array<{ __typename?: 'DesignStudioColor', color: string, group: string, name: string, trim?: boolean | null }> | null, textures?: Array<{ __typename?: 'DesignStudioTexture', category: string, shape?: string | null, size?: string | null, style?: string | null, textureId: number, type: string, colorGroup?: string | null, hasThumbnail?: boolean | null, isPopular?: boolean | null, name?: string | null, textureType?: string | null, thumbnail?: string | null }> | null, windowColors?: Array<{ __typename?: 'DesignStudioColor', color: string, group: string, name: string, trim?: boolean | null }> | null } | null };

export type DetectUserSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectUserSessionQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user: { __typename?: 'User', id: number, email: string, orgs: Array<{ __typename?: 'Org', createdAt?: string | null, isManaged?: boolean | null, id: number, partner?: { __typename?: 'Partner', kind?: PartnerKind | null } | null }> } } };

export type EstimationEstimateGroupsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EstimationEstimateGroupsQuery = { __typename?: 'Query', estimationEstimateGroups: { __typename?: 'EstimationEstimateGroupConnection', nodes?: Array<{ __typename?: 'EstimationEstimateGroup', id: string, createdAt?: string | null, updatedAt?: string | null, totalCost?: number | null, totalPrice?: number | null, name?: string | null, estimates: Array<{ __typename?: 'Estimate', id: number, name?: string | null }>, salesOpportunity: { __typename?: 'SalesOpportunity', id: number, soldEstimateGroupId?: string | null }, proposalDocuments: Array<{ __typename?: 'ProjectManagementProposalDocument', id: string, createdAt?: string | null, updatedAt?: string | null, totalPrice?: number | null, state: ProjectManagementProposalDocumentStateEnum, signatureRequest?: { __typename?: 'ProjectManagementSignatureRequest', state: ProjectManagementSignatureRequestStateEnum } | null }> } | null> | null } };

export type GenericProductSettingsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type GenericProductSettingsQuery = { __typename?: 'Query', productCatalogConfigGenericProductSetting?: { __typename?: 'ProductCatalogConfigGenericProductSetting', settings?: string | null } | null };

export type GetAlbumsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetAlbumsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, createdAt?: string | null, albums: Array<{ __typename?: 'Album', id: string, name: string, createdAt?: string | null, files?: Array<{ __typename?: 'AlbumFile', id: string, file?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string, variants?: { __typename?: 'ImageVariants', thumbnail?: { __typename?: 'Image', blobUrl: string, width?: number | null, height?: number | null, contentType: string } | null } | null } | null }> | null }>, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, imageMediumUrl?: string | null, rotatedImageMediumUrl?: string | null, rotatedImageUrl?: string | null, rotatedImageSmallUrl?: string | null, imageVersion: number, cubeFace?: number | null, kind?: JobImageKinds | null, createdAt?: string | null, viewpoint: JobImageViewpoints, autoCaptured?: boolean | null }> } | null> } };

export type BlueprintSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BlueprintSubmissionsQuery = { __typename?: 'Query', blueprintSubmissions?: { __typename?: 'BlueprintSubmissionPaginatedResults', pagination: { __typename?: 'Pagination', hasNextPage: boolean }, results: Array<{ __typename?: 'BlueprintSubmission', id: string, name: string, createdAt?: string | null, state?: BlueprintSubmissionStates | null, fileAttachments: Array<{ __typename?: 'FileAttachment', filename?: string | null, url: string, id: number }> } | null> } | null };

export type GetConsentPoliciesQueryVariables = Exact<{
  kinds: Array<ConsentPolicyKinds> | ConsentPolicyKinds;
}>;


export type GetConsentPoliciesQuery = { __typename?: 'Query', consentPolicies: Array<{ __typename?: 'ConsentPolicy', kind: string, summary?: string | null, content: string, id: number } | null> };

export type GetDoorProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDoorProductsQuery = { __typename?: 'Query', productCatalogProductsByTag: { __typename?: 'ProductCatalogProductConnection', nodes?: Array<{ __typename?: 'ProductCatalogProduct', id: string, name: string, labelId?: number | null, variations: Array<{ __typename?: 'ProductCatalogVariation', id: string, name: string, textureId?: number | null, color?: { __typename?: 'ProductCatalogColor', hex: string } | null, texture?: { __typename?: 'ProductCatalogTexture', repeatable: boolean, width?: number | null, height?: number | null } | null }> } | null> | null } };

export type GetEhiFeatureAccessesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEhiFeatureAccessesQuery = { __typename?: 'Query', ehiFeatureAccesses: Array<{ __typename?: 'EHIFeatureAccess', id: number, accessorType?: FeatureAccessAccessor | null, accessorId?: number | null, enabled: boolean, identifier?: EhiFeatureAccessIdentifier | null }> };

export type GetEhiOrgSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEhiOrgSettingsQuery = { __typename?: 'Query', ehiOrgSettings?: { __typename?: 'OrgSettings', id: number, showOrderingFlow?: boolean | null } | null };

export type GetHdfQueryVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;


export type GetHdfQuery = { __typename?: 'Query', estimationSummarizedHdf?: { __typename?: 'EstimationSummarizedHdf', data?: string | null } | null };

export type GetInspectionConfigChecklistTemplatesQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type GetInspectionConfigChecklistTemplatesQuery = { __typename?: 'Query', inspectionConfigChecklistTemplates: { __typename?: 'InspectionConfigChecklistTemplateConnection', nodes?: Array<{ __typename?: 'InspectionConfigChecklistTemplate', id: string, name: string } | null> | null } };

export type GetJobQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, blueprint: boolean, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, orgId?: number | null, partnerId?: number | null, canRequestRendering: boolean, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, imageSmallUrl?: string | null }>, threeDFiles?: { __typename?: 'JobThreeDFiles', geometryUrl?: string | null, metadataUrl?: string | null } | null, captureRequest?: { __typename?: 'CaptureRequest', displayRequestingOrg?: { __typename?: 'OrgBasicInfo', partnerId?: number | null, orgBrandLogoUrl?: string | null, customerDisplayName?: string | null } | null, requestingUser?: { __typename?: 'UserBasicInfo', orgs: { __typename?: 'OrgBasicInfoPaginatedResults', results: Array<{ __typename?: 'OrgBasicInfo', id: number, customerDisplayName?: string | null } | null> } } | null } | null } | null> } };

export type GetJobHomeownerMeasurementsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobHomeownerMeasurementsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, orgId?: number | null, partnerId?: number | null, bestFrontImage?: { __typename?: 'JobImage', imageUrl?: string | null } | null, homeownerMeasurements?: { __typename?: 'HomeownerMeasurements', summaryJson?: string | null, fullJson?: string | null, singleLineAddress?: string | null } | null, threeDFiles?: { __typename?: 'JobThreeDFiles', geometryUrl?: string | null, metadataUrl?: string | null } | null } | null> } };

export type GetJobPaintMeasurementsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobPaintMeasurementsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, orgId?: number | null, partnerId?: number | null, bestFrontImage?: { __typename?: 'JobImage', imageUrl?: string | null } | null, measurements?: { __typename?: 'JobMeasurements', paintMeasurements?: { __typename?: 'PaintMeasurements', summaryJson?: string | null, fullJson?: string | null, singleLineAddress?: string | null } | null } | null, threeDFiles?: { __typename?: 'JobThreeDFiles', geometryUrl?: string | null, metadataUrl?: string | null } | null } | null> } };

export type GetManufacturerPreferencesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetManufacturerPreferencesQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', captureRequest?: { __typename?: 'CaptureRequest', displayRequestingOrg?: { __typename?: 'OrgBasicInfo', id: number, manufacturerIds?: Array<number> | null } | null } | null } | null> } };

export type GetProductVariationsQueryVariables = Exact<{
  variationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetProductVariationsQuery = { __typename?: 'Query', productCatalogVariations: { __typename?: 'ProductCatalogVariationConnection', nodes?: Array<{ __typename?: 'ProductCatalogVariation', name: string, id: string, product: { __typename?: 'ProductCatalogProduct', name: string, displayName?: string | null, manufacturerUrl?: string | null, labelId?: number | null, provider?: { __typename?: 'ProductCatalogProvider', name: string } | null, groupings?: Array<{ __typename?: 'ProductCatalogGrouping', name: string }> | null, label?: { __typename?: 'ProductCatalogLabel', name: string } | null }, color?: { __typename?: 'ProductCatalogColor', name: string, hex: string } | null, variationFacets?: Array<{ __typename?: 'ProductCatalogVariationFacet', facetType: ProductCatalogFacetTypeEnum, value: string }> | null, texture?: { __typename?: 'ProductCatalogTexture', name: string, diffuseMapThumbnail?: { __typename?: 'File', redirectUrl: string } | null } | null } | null> | null } };

export type GetProductionListQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
}>;


export type GetProductionListQuery = { __typename?: 'Query', projectManagementProductionList: { __typename?: 'ProductionList', id: number, updatedAt?: string | null, name?: string | null, totalCost?: number | null, integrationManuallySynced: boolean, integrationLastManuallySyncedAt?: string | null, estimateGroup?: { __typename?: 'EstimationEstimateGroup', estimates: Array<{ __typename?: 'Estimate', template?: { __typename?: 'Template', name: string } | null }> } | null } };

export type GetProductionListByIdQueryVariables = Exact<{
  productionListId: Scalars['ID']['input'];
}>;


export type GetProductionListByIdQuery = { __typename?: 'Query', projectManagementProductionListById: { __typename?: 'ProductionList', id: number, updatedAt?: string | null, name?: string | null, totalCost?: number | null, estimateGroup?: { __typename?: 'EstimationEstimateGroup', estimates: Array<{ __typename?: 'Estimate', template?: { __typename?: 'Template', name: string } | null }> } | null } };

export type GetProductionListsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
}>;


export type GetProductionListsQuery = { __typename?: 'Query', projectManagementProductionLists: { __typename?: 'ProductionListConnection', nodes?: Array<{ __typename?: 'ProductionList', id: number, updatedAt?: string | null, name?: string | null, integrationManuallySynced: boolean, integrationLastManuallySyncedAt?: string | null, integrationExternalLabel?: string | null, totalCost?: number | null, estimateGroup?: { __typename?: 'EstimationEstimateGroup', estimates: Array<{ __typename?: 'Estimate', template?: { __typename?: 'Template', name: string } | null }> } | null } | null> | null } };

export type GetProductsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filterByOrg?: InputMaybe<Scalars['Boolean']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', productCatalogProducts: { __typename?: 'ProductCatalogProductConnection', nodes?: Array<{ __typename?: 'ProductCatalogProduct', id: string, legacyId: number, name: string, productType?: ProductCatalogProductTypeEnum | null, labelId?: number | null, variations: Array<{ __typename?: 'ProductCatalogVariation', textureId?: number | null, legacyId: number, id: string }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetProjectQueryVariables = Exact<{
  projectId: Scalars['Int']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: number, name: string, scopeItems: Array<string>, createdAt: string, updatedAt?: string | null, links?: Array<string> | null, org?: { __typename?: 'Org', id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdAt?: string | null, createdFrom: string, favoritedAt?: string | null, id: number, spaceType?: string | null, style?: string | null, updatedAt?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null }, aiOriginalImage?: { __typename?: 'AiOriginalImage', orientation?: string | null } | null }> | null, jobs?: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, modelFailureReason?: string | null, createdAt?: string | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null }>, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null } | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null }> | null, publicOrgInfo?: { __typename?: 'PublicOrgInfo', id: number, displayName: string, brandLogoUrl?: string | null } | null } | null };

export type GetProjectShareQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectShareQuery = { __typename?: 'Query', projectShare?: { __typename?: 'ProjectShare', id: string, createdAt: string, orgId?: number | null, orgBrandLogoUrl?: string | null, shareCtaPath?: string | null, creatingUser?: { __typename?: 'ProjectShareCreatingUser', name?: string | null, email?: string | null, phone?: string | null } | null, aiDisplayImages: Array<{ __typename?: 'AiDisplayImage', id: number, spaceType?: string | null, aiOriginalImageId: number, createdFrom: string, aiGeneratedImage: { __typename?: 'AiGeneratedImage', watermarkImageUrl?: string | null, id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null }, aiOriginalImage?: { __typename?: 'AiOriginalImage', id: number, originalImagePath: string, image: string, imagePath: string, spaceType?: string | null, inputPath: string, isSample: boolean } | null }> } | null };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: number, name: string, scopeItems: Array<string>, createdAt: string, updatedAt?: string | null, links?: Array<string> | null, org?: { __typename?: 'Org', id: number } | null, addables?: Array<{ __typename?: 'AiDisplayImage', aiOriginalImageId: number, createdAt?: string | null, createdFrom: string, favoritedAt?: string | null, id: number, spaceType?: string | null, style?: string | null, updatedAt?: string | null, aiGeneratedImage: { __typename?: 'AiGeneratedImage', id: number, status?: string | null, style: string, generatedImagePath: string, thumbnailUrl?: string | null, favorite: boolean, aiOriginalImageId: number, baseImageId?: number | null, imagePath: string, spaceType?: string | null, createdAt?: string | null, updatedAt?: string | null, pollingConsumerId?: string | null, clientStatus?: string | null, is3dFusionCompatible: boolean, fromSample: boolean, edits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null, metadata?: { __typename?: 'AiImageMetadata', allEdits?: { __typename?: 'AiImageEdits', schemaVersion: number, walls?: { __typename?: 'AiImageWallEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, ceiling?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, floor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, trim?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, roof?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, fence?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, door?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, garageDoor?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, shutter?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, cabinet?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, windows?: { __typename?: 'AiImageRegionEdits', paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null } | null, instances?: Array<{ __typename?: 'AiImageInstanceEdit', id: string, materialClass: string, surfaceClass: string, material?: { __typename?: 'AiImageMaterialEdit', name: string, palette?: string | null, thumbnail?: string | null, hex?: string | null } | null, paint?: { __typename?: 'AiImagePaintEdit', hex: string, manufacturer?: string | null, name?: string | null, samplizeProductKey?: string | null } | null }> | null } | null } | null, aiSegmentation?: { __typename?: 'AiSegmentation', id: number } | null }, aiOriginalImage?: { __typename?: 'AiOriginalImage', orientation?: string | null } | null }> | null, jobs?: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, modelFailureReason?: string | null, createdAt?: string | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null }>, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null } | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null }> | null, publicOrgInfo?: { __typename?: 'PublicOrgInfo', id: number, displayName: string, brandLogoUrl?: string | null } | null }> | null };

export type GetRenderingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRenderingQuery = { __typename?: 'Query', getHiDefRendering?: { __typename?: 'HiDefRendering', id: number, name?: string | null, uuid: string, viewedAt?: string | null, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, textureScale: number, cryptomatteRegions?: { __typename?: 'CryptomatteRegions', v: number, regions: Array<{ __typename?: 'CryptomatteRegion', regionId: string, category: string }> } | null, uvPass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, combinedLightingPass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, cryptomattePass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null } }> }> } | null };

export type GetRenderingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetRenderingsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, orgId?: number | null, partnerId?: number | null, canRequestRendering: boolean, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, imageSmallUrl?: string | null }>, hiDefRenderings?: Array<{ __typename?: 'HiDefRendering', id: number, name?: string | null, uuid: string, canCreateRevision: boolean, viewedAt?: string | null, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, state?: HiDefRenderingVersionState | null, requestFormUrl: string, submissionUrl?: string | null, versionType?: RenderingVersion | null, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null }, uvPass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, combinedLightingPass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, cryptomattePass?: { __typename?: 'Attachment', id: string, blobUrl: string } | null, productVariations?: Array<{ __typename?: 'HiDefRenderingFileProductVariation', productCatalogVariationUuid?: string | null }> | null }> }> }> | null, captureRequest?: { __typename?: 'CaptureRequest', displayRequestingOrg?: { __typename?: 'OrgBasicInfo', partnerId?: number | null, orgBrandLogoUrl?: string | null, customerDisplayName?: string | null } | null, requestingUser?: { __typename?: 'UserBasicInfo', orgs: { __typename?: 'OrgBasicInfoPaginatedResults', results: Array<{ __typename?: 'OrgBasicInfo', id: number, customerDisplayName?: string | null } | null> } } | null } | null } | null> } };

export type GetScansQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetScansQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, name?: string | null, state?: JobModelStates | null, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, example?: boolean | null, modelFailureReason?: string | null, createdAt?: string | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null }>, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, rotatedImageMediumUrl?: string | null, viewpoint: JobImageViewpoints, cubeFace?: number | null } | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null } | null> } };

export type GetSharedJobPaintMeasurementsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type GetSharedJobPaintMeasurementsQuery = { __typename?: 'Query', jobSharedPaintMeasurements: { __typename?: 'JobSharedPaintMeasurements', paintMeasurements?: { __typename?: 'PaintMeasurements', fullJson?: string | null, summaryJson?: string | null, singleLineAddress?: string | null } | null, jobThreeDFiles?: { __typename?: 'JobThreeDFiles', geometryUrl?: string | null, metadataUrl?: string | null } | null } };

export type GetTreatmentQueryVariables = Exact<{
  flagName: Scalars['String']['input'];
}>;


export type GetTreatmentQuery = { __typename?: 'Query', getTreatment?: string | null };

export type GetTreatmentWithConfigQueryVariables = Exact<{
  flagName: Scalars['String']['input'];
}>;


export type GetTreatmentWithConfigQuery = { __typename?: 'Query', getTreatmentWithConfig?: { __typename?: 'TreatmentWithConfig', treatment: string, config?: string | null } | null };

export type HomeownerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeownerProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user: { __typename?: 'User', intercomSha: string, email: string, name?: string | null, firstName?: string | null, lastName?: string | null, id: number, profilePictureUrl?: string | null } } };

export type InspectionChecklistFragment = { __typename?: 'InspectionChecklist', id: string, name?: string | null, createdAt?: string | null, updatedAt?: string | null, reportPdf?: { __typename?: 'File', redirectUrl: string } | null, sections: Array<{ __typename?: 'InspectionChecklistSection', id: string, name: string, sortOrder: number, questions: Array<{ __typename?: 'InspectionChecklistQuestion', id: string, questionText: string, questionType?: InspectionConfigChecklistQuestionTypeEnum | null, answerValue?: string | null, sortOrder?: number | null, supportsImageUploads: InspectionChecklistQuestionSupportsImageUploadsEnum, options?: Array<{ __typename?: 'InspectionConfigChecklistTemplateQuestionOption', id: string, label: string, sortOrder: number }> | null, images: Array<{ __typename?: 'File', filename: string, redirectUrl: string }> }> }> };

export type InspectionChecklistsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type InspectionChecklistsQuery = { __typename?: 'Query', inspectionChecklists: { __typename?: 'InspectionChecklistConnection', nodes?: Array<{ __typename?: 'InspectionChecklist', id: string, name?: string | null, createdAt?: string | null, updatedAt?: string | null, reportPdf?: { __typename?: 'File', redirectUrl: string } | null, sections: Array<{ __typename?: 'InspectionChecklistSection', id: string, name: string, sortOrder: number, questions: Array<{ __typename?: 'InspectionChecklistQuestion', id: string, questionText: string, questionType?: InspectionConfigChecklistQuestionTypeEnum | null, answerValue?: string | null, sortOrder?: number | null, supportsImageUploads: InspectionChecklistQuestionSupportsImageUploadsEnum, options?: Array<{ __typename?: 'InspectionConfigChecklistTemplateQuestionOption', id: string, label: string, sortOrder: number }> | null, images: Array<{ __typename?: 'File', filename: string, redirectUrl: string }> }> }> } | null> | null } };

export type JobSharedRenderingsQueryVariables = Exact<{
  shareToken: Scalars['String']['input'];
}>;


export type JobSharedRenderingsQuery = { __typename?: 'Query', jobSharedRenderings: { __typename?: 'JobSharedRenderings', id?: number | null, orgId?: number | null, partnerId?: number | null, userId?: number | null, hiDefRenderings?: Array<{ __typename?: 'HiDefRendering', id: number, viewedAt?: string | null, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, state?: HiDefRenderingVersionState | null, versionType?: RenderingVersion | null, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null }, productVariations?: Array<{ __typename?: 'HiDefRenderingFileProductVariation', productCatalogVariationUuid?: string | null }> | null }> }> }> | null, captureRequest?: { __typename?: 'SharedCaptureRequest', displayRequestingOrg?: { __typename?: 'OrgBasicInfo', orgBrandLogoUrl?: string | null, customerDisplayName?: string | null } | null } | null } };

export type JobSharedThreeDFilesQueryVariables = Exact<{
  jobId: Scalars['Int']['input'];
  shareToken: Scalars['String']['input'];
}>;


export type JobSharedThreeDFilesQuery = { __typename?: 'Query', jobSharedThreeDFiles: { __typename?: 'JobSharedThreeDFiles', geometryUrl?: string | null, metadataUrl?: string | null, authToken?: string | null } };

export type JobWithRenderingsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  useHiDefRenderings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JobWithRenderingsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', canRequestRendering: boolean, hiDefRenderings?: Array<{ __typename?: 'HiDefRendering', id: number, name?: string | null, uuid: string, canCreateRevision: boolean, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, state?: HiDefRenderingVersionState | null, requestFormUrl: string, submissionUrl?: string | null, versionType?: RenderingVersion | null, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null, byteSize: string, checksum: string, contentType: string, createdAt: string, filename: string }, productVariations?: Array<{ __typename?: 'HiDefRenderingFileProductVariation', productCatalogVariationUuid?: string | null }> | null }> }> }> | null } | null> } };

export type OrgManufacturerIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgManufacturerIdsQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user: { __typename?: 'User', id: number, orgs: Array<{ __typename?: 'Org', manufacturerIds?: Array<number> | null, isManaged?: boolean | null, partner?: { __typename?: 'Partner', id: number, kind?: PartnerKind | null, identifier?: string | null, name: string } | null }> } } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user: { __typename?: 'User', id: number, email: string, name?: string | null, firstName?: string | null, lastName?: string | null, createdAt?: string | null, activeCommerceProduct?: string | null, isHomeowner?: boolean | null, officePhone?: string | null, mobilePhone?: string | null, intercomSha: string, locale: Locale, orgs: Array<{ __typename?: 'Org', id: number, createdAt?: string | null, name?: string | null, onWaitlist?: boolean | null, custServCity?: string | null, custServLine1?: string | null, custServLine2?: string | null, custServPostalCode?: string | null, custServRegion?: string | null, custServPhone?: string | null, priority?: number | null, isManaged?: boolean | null, preSelectCaptureOnlyForUsers: boolean, ownWalletBillable?: boolean | null, wallet?: { __typename?: 'Wallet', id: number, billingAddressCity?: string | null, billingAddressRegion?: string | null, billingAddressPostalCode?: string | null, billingAddressLine1?: string | null, billingAddressLine2?: string | null, billingEmail?: string | null, totalBalance?: number | null } | null, partner?: { __typename?: 'Partner', id: number, kind?: PartnerKind | null, identifier?: string | null, name: string } | null, featureAccesses?: Array<{ __typename?: 'FeatureAccess', identifier?: FeatureAccessIdentifier | null, accessorId?: number | null, accessorType?: string | null, enabled: boolean, id: number }> | null, availableDeliverables: Array<{ __typename?: 'Deliverable', id: number, name?: string | null }>, billableWallets: Array<{ __typename?: 'BillableWallet', walletId: number, org: { __typename?: 'OrgBasicInfo', customerDisplayName?: string | null, externalIdentifierStrictValidation: boolean, name?: string | null }, partnerAccountIdentifiers?: Array<{ __typename?: 'PartnerAccountIdentifier', accountId: number, id: number }> | null, externalIdentifierPatterns?: Array<{ __typename?: 'ExternalIdentifierPattern', content: string, id: number }> | null }>, brand?: { __typename?: 'Brand', placesLogoUrl?: string | null, primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, paymentBanner?: { __typename?: 'PaymentBanner', body: string, title: string, kind: PaymentBannerKinds } | null, preferences?: { __typename?: 'OrgPreferences', externalIdentifierLabel?: string | null, externalIdentifierRequired?: boolean | null } | null }>, aclAccesses: Array<{ __typename?: 'ACLAccess', id: number, orgId?: number | null, aclTemplate?: AclTemplateOptions | null }> }, impersonator?: { __typename?: 'UserImpersonator', userId: string, userEmail: string } | null } };

export type PropertiesQueryVariables = Exact<{
  filters?: InputMaybe<Array<JobSearchFilters> | JobSearchFilters>;
  jobTypes?: InputMaybe<Array<JobTypeFilters> | JobTypeFilters>;
  deliverableIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  viewableBy?: InputMaybe<JobsViewableBy>;
  orgId: Scalars['ID']['input'];
  example?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<JobSortOrder>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  creatorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  inJobGroup?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PropertiesQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, archived: boolean, approved?: boolean | null, approvedAt?: string | null, name?: string | null, state?: JobModelStates | null, blueprint: boolean, locationLine1?: string | null, locationLine2?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, lastPaymentFailed: boolean, example?: boolean | null, createdAt?: string | null, captureType?: JobCaptureTypes | null, orgId?: number | null, partnerId?: number | null, hasInspectionChecklists?: boolean | null, failedRooms: boolean, interiorFloorPlan: boolean, createdBy?: { __typename?: 'UserBasicInfo', email: string, firstName?: string | null, lastName?: string | null, id: number } | null, captureRequest?: { __typename?: 'CaptureRequest', id: number, state?: CaptureRequestStates | null } | null, bestFrontImage?: { __typename?: 'JobImage', id: number, imageUrl?: string | null, imageSmallUrl?: string | null, rotatedImageMediumUrl?: string | null } | null, jobGroups?: Array<{ __typename?: 'JobGroup', name: string, id: number }> | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null, deliverableChangeRequests: Array<{ __typename?: 'DeliverableChangeRequest', state?: DeliverableChangeRequestStates | null, changedAt?: string | null, newDeliverable?: { __typename?: 'Deliverable', id: number } | null }> } | null>, pagination: { __typename?: 'Pagination', currentPage: number, hasNextPage: boolean } } };

export type PropertyDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  useHiDefRenderings?: InputMaybe<Scalars['Boolean']['input']>;
  usePaintMeasurements?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PropertyDetailsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, name?: string | null, modelingStatus?: string | null, blueprint: boolean, clientIdentifier?: string | null, canAccessRendering: boolean, canRequestRendering: boolean, externalIdentifier?: string | null, is3dAvailable?: boolean | null, locationLine1?: string | null, locationLine2?: string | null, locationLon?: string | null, locationLat?: string | null, locationCity?: string | null, locationRegion?: string | null, locationPostalCode?: string | null, locationCountry?: string | null, state?: JobModelStates | null, createdAt?: string | null, updatedAt?: string | null, estimatedCompletedAt?: string | null, archived: boolean, approved?: boolean | null, example?: boolean | null, captureType?: JobCaptureTypes | null, canUpgrade: boolean, manowarIdentifier?: string | null, lastPaymentFailed: boolean, modelId?: number | null, virtualWalkthroughAvailable?: boolean | null, interiorFloorPlan: boolean, labels: Array<JobLabels>, modelFailureReason?: string | null, failedRooms: boolean, jobAssignments: Array<{ __typename?: 'JobAssignment', createdAt?: string | null, id: number, kind: JobAssignmentKind, shareJobMessage?: string | null, userId: number, user: { __typename?: 'UserBasicInfo', email: string, firstName?: string | null, id: number, lastName?: string | null } }>, paymentOrg?: { __typename?: 'OrgBasicInfo', onInvoicing: boolean, customerDisplayName?: string | null, externalIdentifierStrictValidation: boolean, name?: string | null, id: number, externalIdentifierPatterns?: Array<{ __typename?: 'ExternalIdentifierPattern', id: number, content: string }> | null, expeditedDeliverablesSettings?: Array<{ __typename?: 'ExpeditedDeliverablesSettings', defaultDeliverySpeed: DeliverableDeliverySpeeds, deliverySpeeds: Array<DeliverableDeliverySpeeds>, deliverable: { __typename?: 'Deliverable', id: number, name?: string | null } }> | null } | null, createdBy?: { __typename?: 'UserBasicInfo', firstName?: string | null, lastName?: string | null, email: string } | null, fileAttachments?: Array<{ __typename?: 'FileAttachment', id: number, url: string, filename?: string | null }> | null, deliverable?: { __typename?: 'Deliverable', id: number, name?: string | null } | null, jobGroups?: Array<{ __typename?: 'JobGroup', name: string, jobsCount: number, id: number }> | null, deliverableChangeRequests: Array<{ __typename?: 'DeliverableChangeRequest', state?: DeliverableChangeRequestStates | null, changedAt?: string | null, newDeliverable?: { __typename?: 'Deliverable', id: number } | null }>, bestFrontImage?: { __typename?: 'JobImage', imageMediumUrl?: string | null, rotatedImageMediumUrl?: string | null, imageSmallUrl?: string | null, rotatedImageSmallUrl?: string | null } | null, currentUserContext: { __typename?: 'JobCurrentUserContext', canApprove: boolean, canArchive: boolean, canUpdate: boolean, captureRequestSentByMe: boolean, captureRequestSentToMe: boolean, createdByMe: boolean, assignedToMe: boolean, canChooseDeliverySpeed: boolean }, exports?: { __typename?: 'JobExports', canAccessAdvancedExports: boolean, canAccessEsx: boolean, dxfUrl?: string | null, dwgUrl?: string | null, esxUrl?: string | null, skpUrl?: string | null } | null, captureRequest?: { __typename?: 'CaptureRequest', id: number, identifier: string, capturingUserName: string, capturingUserEmail: string, capturingUserPhone?: string | null, state?: CaptureRequestStates | null, branchLink?: string | null, requestingUser?: { __typename?: 'UserBasicInfo', id: number, firstName?: string | null, lastName?: string | null, state?: UserStates | null, email: string, createdAt?: string | null, orgs: { __typename?: 'OrgBasicInfoPaginatedResults', results: Array<{ __typename?: 'OrgBasicInfo', customerDisplayName?: string | null, onlyDesignProForCaptureRequest: boolean } | null> } } | null, displayRequestingOrg?: { __typename?: 'OrgBasicInfo', customerDisplayName?: string | null, name?: string | null, id: number, expeditedDeliverablesSettings?: Array<{ __typename?: 'ExpeditedDeliverablesSettings', defaultDeliverySpeed: DeliverableDeliverySpeeds, deliverySpeeds: Array<DeliverableDeliverySpeeds>, deliverable: { __typename?: 'Deliverable', id: number, name?: string | null } }> | null } | null } | null, measurements?: { __typename?: 'JobMeasurements', pdfUrl?: string | null, summarizedJsonUrl?: string | null, canAccessMeasurementExports?: boolean | null, symbilityXmlUrl?: string | null, xmlUrl?: string | null, sketchJsonUrl?: string | null, spreadsheetUrl?: string | null, paintMeasurements?: { __typename?: 'PaintMeasurements', summaryJson?: string | null, fullJson?: string | null } | null } | null, threeDFiles?: { __typename?: 'JobThreeDFiles', metadataUrl?: string | null, geometryUrl?: string | null } | null, availableDeliverableUpgrades: Array<{ __typename?: 'Deliverable', id: number, name?: string | null }>, notes: { __typename?: 'NotePaginatedResults', results: Array<{ __typename?: 'Note', id: number, createdAt?: string | null, updatedAt?: string | null, body?: string | null, user?: { __typename?: 'UserBasicInfo', firstName?: string | null, lastName?: string | null } | null, currentUserContext: { __typename?: 'NoteCurrentUserContext', canDeleteNote: boolean, canUpdateNote: boolean } } | null> }, hiDefRenderings?: Array<{ __typename?: 'HiDefRendering', id: number, name?: string | null, uuid: string, canCreateRevision: boolean, versions: Array<{ __typename?: 'HiDefRenderingVersion', id: number, state?: HiDefRenderingVersionState | null, requestFormUrl: string, submissionUrl?: string | null, versionType?: RenderingVersion | null, hiDefRenderingFiles: Array<{ __typename?: 'HiDefRenderingFile', id: number, image: { __typename?: 'Attachment', id: string, blobUrl: string, thumbUrl?: string | null, byteSize: string, checksum: string, contentType: string, createdAt: string, filename: string }, productVariations?: Array<{ __typename?: 'HiDefRenderingFileProductVariation', productCatalogVariationUuid?: string | null }> | null }> }> }> | null, images: Array<{ __typename?: 'JobImage', id: number, imageUrl?: string | null, imageMediumUrl?: string | null, rotatedImageMediumUrl?: string | null, rotatedImageUrl?: string | null, rotatedImageSmallUrl?: string | null, imageVersion: number, cubeFace?: number | null, kind?: JobImageKinds | null, createdAt?: string | null, viewpoint: JobImageViewpoints, autoCaptured?: boolean | null }> } | null> } };

export type PropertyDetailsPaintQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PropertyDetailsPaintQuery = { __typename?: 'Query', jobs: { __typename?: 'JobPaginatedResults', results: Array<{ __typename?: 'Job', id: number, name?: string | null, measurements?: { __typename?: 'JobMeasurements', paintMeasurements?: { __typename?: 'PaintMeasurements', fullJson?: string | null } | null } | null, threeDFiles?: { __typename?: 'JobThreeDFiles', metadataUrl?: string | null, geometryUrl?: string | null } | null } | null> } };

export type PublicOrgInfoQueryVariables = Exact<{
  publicIdentifier: Scalars['String']['input'];
}>;


export type PublicOrgInfoQuery = { __typename?: 'Query', publicOrgInfo?: { __typename?: 'PublicOrgInfo', id: number, displayName: string, brandLogoUrl?: string | null } | null };

export type SearchVariationsByTermQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchVariationsByTermQuery = { __typename?: 'Query', productCatalogVariationSearch: { __typename?: 'ProductCatalogVariationConnection', nodes?: Array<{ __typename?: 'ProductCatalogVariation', id: string } | null> | null } };

export type UpgradeProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UpgradeProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', user: { __typename?: 'User', id: number, email: string, isHomeowner?: boolean | null, orgs: Array<{ __typename?: 'Org', id: number }> } } };

export const AiGeneratedImagePollingConsumerFragmentDoc = gql`
    fragment AiGeneratedImagePollingConsumer on AiGeneratedImage {
  pollingConsumerId @client
}
    `;
export const AiGeneratedImageRegionsFragmentDoc = gql`
    fragment AiGeneratedImageRegions on AiGeneratedImage {
  regions
}
    `;
export const AiGeneratedImageStatusFragmentDoc = gql`
    fragment AiGeneratedImageStatus on AiGeneratedImage {
  status
}
    `;
export const AiGeneratedImageClientStatusFragmentDoc = gql`
    fragment AiGeneratedImageClientStatus on AiGeneratedImage {
  clientStatus @client
}
    `;
export const AiMaterialFragmentDoc = gql`
    fragment AiMaterial on AiMaterial {
  id
  palettes
  regions
  name
  hex
  thumbnail
  spaceType
  is3dFusion
}
    `;
export const AiImageWallEditsFragmentDoc = gql`
    fragment AiImageWallEdits on AiImageWallEdits {
  paint {
    hex
    manufacturer
    name
    samplizeProductKey
  }
  material {
    name
    palette
    thumbnail
    hex
  }
}
    `;
export const AiImagePaintEditFragmentDoc = gql`
    fragment AiImagePaintEdit on AiImagePaintEdit {
  hex
  manufacturer
  name
  samplizeProductKey
}
    `;
export const AiImageMaterialEditFragmentDoc = gql`
    fragment AiImageMaterialEdit on AiImageMaterialEdit {
  name
  palette
  thumbnail
  hex
}
    `;
export const AiImageRegionEditsFragmentDoc = gql`
    fragment AiImageRegionEdits on AiImageRegionEdits {
  paint {
    ...AiImagePaintEdit
  }
  material {
    ...AiImageMaterialEdit
  }
}
    ${AiImagePaintEditFragmentDoc}
${AiImageMaterialEditFragmentDoc}`;
export const AiImageInstanceEditFragmentDoc = gql`
    fragment AiImageInstanceEdit on AiImageInstanceEdit {
  id
  material {
    ...AiImageMaterialEdit
  }
  materialClass
  paint {
    ...AiImagePaintEdit
  }
  surfaceClass
}
    ${AiImageMaterialEditFragmentDoc}
${AiImagePaintEditFragmentDoc}`;
export const AiImageEditsFragmentDoc = gql`
    fragment AiImageEdits on AiImageEdits {
  schemaVersion
  walls {
    ...AiImageWallEdits
  }
  ceiling {
    ...AiImageRegionEdits
  }
  floor {
    ...AiImageRegionEdits
  }
  trim {
    ...AiImageRegionEdits
  }
  roof {
    ...AiImageRegionEdits
  }
  fence {
    ...AiImageRegionEdits
  }
  door {
    ...AiImageRegionEdits
  }
  garageDoor {
    ...AiImageRegionEdits
  }
  shutter {
    ...AiImageRegionEdits
  }
  cabinet {
    ...AiImageRegionEdits
  }
  windows {
    ...AiImageRegionEdits
  }
  instances {
    ...AiImageInstanceEdit
  }
}
    ${AiImageWallEditsFragmentDoc}
${AiImageRegionEditsFragmentDoc}
${AiImageInstanceEditFragmentDoc}`;
export const AiGeneratedImageFragmentDoc = gql`
    fragment AiGeneratedImage on AiGeneratedImage {
  id
  status
  style
  generatedImagePath
  thumbnailUrl
  favorite
  aiOriginalImageId
  baseImageId
  imagePath
  spaceType
  createdAt
  updatedAt
  edits {
    ...AiImageEdits
  }
  metadata {
    allEdits {
      ...AiImageEdits
    }
  }
  aiSegmentation {
    id
  }
  pollingConsumerId @client
  clientStatus @client
  is3dFusionCompatible
  fromSample
}
    ${AiImageEditsFragmentDoc}`;
export const AiDisplayImageFragmentDoc = gql`
    fragment AiDisplayImage on AiDisplayImage {
  aiOriginalImageId
  createdFrom
  favoritedAt
  id
  style
  spaceType
  aiGeneratedImage {
    ...AiGeneratedImage
  }
}
    ${AiGeneratedImageFragmentDoc}`;
export const AiOriginalImageFragmentDoc = gql`
    fragment AiOriginalImage on AiOriginalImage {
  associatedProject {
    id
    name
    createdFrom
    publicOrgInfo {
      displayName
      id
    }
    createdAt
    scopeItems
    addables {
      ...AiDisplayImage
    }
  }
  createdAt
  id
  image
  inputPath
  spaceType
  imagePath
  originalImagePath
  orientation
  status
  statusDescription
  thumbnailUrl
  isSample
  projects {
    id
    name
    createdAt
    scopeItems
    createdFrom
  }
}
    ${AiDisplayImageFragmentDoc}`;
export const AlbumFragmentFragmentDoc = gql`
    fragment AlbumFragment on Album {
  id
  name
  createdAt
  files {
    id
    file {
      ... on Image {
        blobUrl
        width
        height
        contentType
        variants {
          thumbnail: variant(transform: {size: THUMBNAIL}) {
            blobUrl
            width
            height
            contentType
          }
        }
      }
    }
  }
}
    `;
export const JobHiDefRenderings_JobFragmentFragmentDoc = gql`
    fragment JobHiDefRenderings_JobFragment on Job {
  hiDefRenderings {
    id
    name
    uuid
    canCreateRevision
    versions {
      id
      state
      requestFormUrl
      submissionUrl
      versionType
      hiDefRenderingFiles {
        id
        image {
          id
          blobUrl
          thumbUrl
          byteSize
          checksum
          contentType
          createdAt
          filename
        }
        productVariations {
          productCatalogVariationUuid
        }
      }
    }
  }
}
    `;
export const JobImagesFragmentFragmentDoc = gql`
    fragment JobImagesFragment on Job {
  images {
    id
    imageUrl(withSignedUrl: false)
    imageMediumUrl(withSignedUrl: false)
    rotatedImageMediumUrl(withSignedUrl: false)
    rotatedImageUrl(withSignedUrl: false)
    rotatedImageSmallUrl(withSignedUrl: false)
    imageVersion
    cubeFace
    kind
    createdAt
    viewpoint
    autoCaptured
  }
}
    `;
export const PaginationFragmentDoc = gql`
    fragment Pagination on Pagination {
  currentPage
  hasNextPage
}
    `;
export const BasicJobInfoFragmentDoc = gql`
    fragment BasicJobInfo on Job {
  id
  name
  state
  locationLine1
  locationLine2
  locationCity
  locationRegion
  locationPostalCode
  example
  modelFailureReason
  createdAt
  images {
    id
    imageUrl
    rotatedImageMediumUrl
    viewpoint
    cubeFace
  }
  bestFrontImage {
    id
    imageUrl
    rotatedImageMediumUrl
    viewpoint
    cubeFace
  }
  deliverable {
    id
    name
  }
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  name
  scopeItems
  createdAt
  updatedAt
  org {
    id
  }
  addables {
    aiGeneratedImage {
      ...AiGeneratedImage
    }
    aiOriginalImageId
    aiOriginalImage {
      orientation
    }
    createdAt
    createdFrom
    favoritedAt
    id
    spaceType
    style
    updatedAt
  }
  jobs {
    ...BasicJobInfo
  }
  links
  publicOrgInfo {
    id
    displayName
    brandLogoUrl
  }
}
    ${AiGeneratedImageFragmentDoc}
${BasicJobInfoFragmentDoc}`;
export const InspectionChecklistFragmentDoc = gql`
    fragment InspectionChecklist on InspectionChecklist {
  id
  name
  createdAt
  updatedAt
  reportPdf {
    redirectUrl
  }
  sections {
    id
    name
    sortOrder
    questions {
      id
      questionText
      questionType
      answerValue
      sortOrder
      options {
        id
        label
        sortOrder
      }
      supportsImageUploads
      images {
        filename
        redirectUrl
      }
    }
  }
}
    `;
export const ActivateDocument = gql`
    mutation Activate($password: String!, $token: String!) {
  resetPassword(password: $password, resetPasswordToken: $token) {
    jwt {
      refreshToken
      accessToken
    }
    user {
      email
      id
      firstName
      lastName
      mobilePhone
      intercomSha
      orgs {
        name
        id
        partner {
          name
          id
        }
      }
    }
  }
}
    `;
export type ActivateMutationFn = Apollo.MutationFunction<ActivateMutation, ActivateMutationVariables>;

/**
 * __useActivateMutation__
 *
 * To run a mutation, you first call `useActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMutation, { data, loading, error }] = useActivateMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useActivateMutation(baseOptions?: Apollo.MutationHookOptions<ActivateMutation, ActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateMutation, ActivateMutationVariables>(ActivateDocument, options);
      }
export type ActivateMutationHookResult = ReturnType<typeof useActivateMutation>;
export type ActivateMutationResult = Apollo.MutationResult<ActivateMutation>;
export type ActivateMutationOptions = Apollo.BaseMutationOptions<ActivateMutation, ActivateMutationVariables>;
export const ApproveJobDocument = gql`
    mutation ApproveJob($jobId: Int!) {
  approveJob(id: $jobId) {
    id
  }
}
    `;
export type ApproveJobMutationFn = Apollo.MutationFunction<ApproveJobMutation, ApproveJobMutationVariables>;

/**
 * __useApproveJobMutation__
 *
 * To run a mutation, you first call `useApproveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveJobMutation, { data, loading, error }] = useApproveJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useApproveJobMutation(baseOptions?: Apollo.MutationHookOptions<ApproveJobMutation, ApproveJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveJobMutation, ApproveJobMutationVariables>(ApproveJobDocument, options);
      }
export type ApproveJobMutationHookResult = ReturnType<typeof useApproveJobMutation>;
export type ApproveJobMutationResult = Apollo.MutationResult<ApproveJobMutation>;
export type ApproveJobMutationOptions = Apollo.BaseMutationOptions<ApproveJobMutation, ApproveJobMutationVariables>;
export const ArchiveJobDocument = gql`
    mutation ArchiveJob($id: Int!) {
  archiveJob(id: $id) {
    archived
  }
}
    `;
export type ArchiveJobMutationFn = Apollo.MutationFunction<ArchiveJobMutation, ArchiveJobMutationVariables>;

/**
 * __useArchiveJobMutation__
 *
 * To run a mutation, you first call `useArchiveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobMutation, { data, loading, error }] = useArchiveJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveJobMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJobMutation, ArchiveJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJobMutation, ArchiveJobMutationVariables>(ArchiveJobDocument, options);
      }
export type ArchiveJobMutationHookResult = ReturnType<typeof useArchiveJobMutation>;
export type ArchiveJobMutationResult = Apollo.MutationResult<ArchiveJobMutation>;
export type ArchiveJobMutationOptions = Apollo.BaseMutationOptions<ArchiveJobMutation, ArchiveJobMutationVariables>;
export const AttachScanToProjectDocument = gql`
    mutation AttachScanToProject($projectId: ID!, $scanId: Int!) {
  createProjectAsset(assetType: JOB, projectId: $projectId, assetId: $scanId) {
    projectId
    addableId
    addableType
  }
}
    `;
export type AttachScanToProjectMutationFn = Apollo.MutationFunction<AttachScanToProjectMutation, AttachScanToProjectMutationVariables>;

/**
 * __useAttachScanToProjectMutation__
 *
 * To run a mutation, you first call `useAttachScanToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachScanToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachScanToProjectMutation, { data, loading, error }] = useAttachScanToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      scanId: // value for 'scanId'
 *   },
 * });
 */
export function useAttachScanToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AttachScanToProjectMutation, AttachScanToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachScanToProjectMutation, AttachScanToProjectMutationVariables>(AttachScanToProjectDocument, options);
      }
export type AttachScanToProjectMutationHookResult = ReturnType<typeof useAttachScanToProjectMutation>;
export type AttachScanToProjectMutationResult = Apollo.MutationResult<AttachScanToProjectMutation>;
export type AttachScanToProjectMutationOptions = Apollo.BaseMutationOptions<AttachScanToProjectMutation, AttachScanToProjectMutationVariables>;
export const AuthenticateDocument = gql`
    mutation Authenticate($email: String!, $password: String!) {
  authenticate(email: $email, password: $password) {
    jwt {
      accessToken
      refreshToken
    }
    user {
      id
      email
      isHomeowner
      captureRequests {
        pagination {
          currentPage
          hasNextPage
        }
        results {
          id
        }
      }
      orgs {
        partner {
          id
        }
      }
      createdAt
      intercomSha
    }
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const AuthenticateWithBeaconTokenDocument = gql`
    mutation AuthenticateWithBeaconToken($token: String!) {
  authenticateWithUserSigninToken(userSigninToken: $token) {
    jwt {
      accessToken
      refreshToken
    }
    user {
      email
      id
    }
  }
}
    `;
export type AuthenticateWithBeaconTokenMutationFn = Apollo.MutationFunction<AuthenticateWithBeaconTokenMutation, AuthenticateWithBeaconTokenMutationVariables>;

/**
 * __useAuthenticateWithBeaconTokenMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithBeaconTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithBeaconTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithBeaconTokenMutation, { data, loading, error }] = useAuthenticateWithBeaconTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateWithBeaconTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithBeaconTokenMutation, AuthenticateWithBeaconTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithBeaconTokenMutation, AuthenticateWithBeaconTokenMutationVariables>(AuthenticateWithBeaconTokenDocument, options);
      }
export type AuthenticateWithBeaconTokenMutationHookResult = ReturnType<typeof useAuthenticateWithBeaconTokenMutation>;
export type AuthenticateWithBeaconTokenMutationResult = Apollo.MutationResult<AuthenticateWithBeaconTokenMutation>;
export type AuthenticateWithBeaconTokenMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithBeaconTokenMutation, AuthenticateWithBeaconTokenMutationVariables>;
export const AuthenticateWithCookieDocument = gql`
    mutation AuthenticateWithCookie {
  authenticateWithCookie {
    jwt {
      accessToken
      refreshToken
    }
    user {
      createdAt
      email
      id
      firstName
      lastName
      mobilePhone
      intercomSha
      orgs {
        id
        name
        ssoConfig {
          ssoEnabled
        }
      }
    }
  }
}
    `;
export type AuthenticateWithCookieMutationFn = Apollo.MutationFunction<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>;

/**
 * __useAuthenticateWithCookieMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithCookieMutation, { data, loading, error }] = useAuthenticateWithCookieMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateWithCookieMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>(AuthenticateWithCookieDocument, options);
      }
export type AuthenticateWithCookieMutationHookResult = ReturnType<typeof useAuthenticateWithCookieMutation>;
export type AuthenticateWithCookieMutationResult = Apollo.MutationResult<AuthenticateWithCookieMutation>;
export type AuthenticateWithCookieMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>;
export const CompleteUserProfileDocument = gql`
    mutation CompleteUserProfile($mobilePhone: String) {
  updateUser(user: {mobilePhone: $mobilePhone}) {
    id
  }
}
    `;
export type CompleteUserProfileMutationFn = Apollo.MutationFunction<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>;

/**
 * __useCompleteUserProfileMutation__
 *
 * To run a mutation, you first call `useCompleteUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeUserProfileMutation, { data, loading, error }] = useCompleteUserProfileMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useCompleteUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>(CompleteUserProfileDocument, options);
      }
export type CompleteUserProfileMutationHookResult = ReturnType<typeof useCompleteUserProfileMutation>;
export type CompleteUserProfileMutationResult = Apollo.MutationResult<CompleteUserProfileMutation>;
export type CompleteUserProfileMutationOptions = Apollo.BaseMutationOptions<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>;
export const CreateAiDisplayImageDocument = gql`
    mutation CreateAiDisplayImage($aiGeneratedImageId: ID!, $aiOriginalImageId: ID!, $createdFrom: String!, $projectId: ID, $style: String!) {
  createAiDisplayImage(
    aiGeneratedImageId: $aiGeneratedImageId
    aiOriginalImageId: $aiOriginalImageId
    createdFrom: $createdFrom
    projectId: $projectId
    style: $style
  ) {
    aiOriginalImageId
    createdAt
    createdFrom
    favoritedAt
    id
    spaceType
    style
    updatedAt
    aiGeneratedImage {
      aiOriginalImageId
      baseImageId
      createdAt
      favorite
      generatedImagePath
      id
      imagePath
      spaceType
      status
      style
      updatedAt
      is3dFusionCompatible
      fromSample
    }
  }
}
    `;
export type CreateAiDisplayImageMutationFn = Apollo.MutationFunction<CreateAiDisplayImageMutation, CreateAiDisplayImageMutationVariables>;

/**
 * __useCreateAiDisplayImageMutation__
 *
 * To run a mutation, you first call `useCreateAiDisplayImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiDisplayImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiDisplayImageMutation, { data, loading, error }] = useCreateAiDisplayImageMutation({
 *   variables: {
 *      aiGeneratedImageId: // value for 'aiGeneratedImageId'
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      createdFrom: // value for 'createdFrom'
 *      projectId: // value for 'projectId'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useCreateAiDisplayImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiDisplayImageMutation, CreateAiDisplayImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiDisplayImageMutation, CreateAiDisplayImageMutationVariables>(CreateAiDisplayImageDocument, options);
      }
export type CreateAiDisplayImageMutationHookResult = ReturnType<typeof useCreateAiDisplayImageMutation>;
export type CreateAiDisplayImageMutationResult = Apollo.MutationResult<CreateAiDisplayImageMutation>;
export type CreateAiDisplayImageMutationOptions = Apollo.BaseMutationOptions<CreateAiDisplayImageMutation, CreateAiDisplayImageMutationVariables>;
export const CreateAiGeneratedImageAsyncDocument = gql`
    mutation CreateAiGeneratedImageAsync($aiOriginalImageId: ID!, $appId: String!, $intensity: Int!, $style: String!, $imageFlexibility: Float!, $email: String) {
  createAiGeneratedImageAsync(
    aiOriginalImageId: $aiOriginalImageId
    appId: $appId
    intensity: $intensity
    style: $style
    imageFlexibility: $imageFlexibility
    email: $email
  ) {
    ...AiGeneratedImage
  }
}
    ${AiGeneratedImageFragmentDoc}`;
export type CreateAiGeneratedImageAsyncMutationFn = Apollo.MutationFunction<CreateAiGeneratedImageAsyncMutation, CreateAiGeneratedImageAsyncMutationVariables>;

/**
 * __useCreateAiGeneratedImageAsyncMutation__
 *
 * To run a mutation, you first call `useCreateAiGeneratedImageAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiGeneratedImageAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiGeneratedImageAsyncMutation, { data, loading, error }] = useCreateAiGeneratedImageAsyncMutation({
 *   variables: {
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      appId: // value for 'appId'
 *      intensity: // value for 'intensity'
 *      style: // value for 'style'
 *      imageFlexibility: // value for 'imageFlexibility'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateAiGeneratedImageAsyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiGeneratedImageAsyncMutation, CreateAiGeneratedImageAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiGeneratedImageAsyncMutation, CreateAiGeneratedImageAsyncMutationVariables>(CreateAiGeneratedImageAsyncDocument, options);
      }
export type CreateAiGeneratedImageAsyncMutationHookResult = ReturnType<typeof useCreateAiGeneratedImageAsyncMutation>;
export type CreateAiGeneratedImageAsyncMutationResult = Apollo.MutationResult<CreateAiGeneratedImageAsyncMutation>;
export type CreateAiGeneratedImageAsyncMutationOptions = Apollo.BaseMutationOptions<CreateAiGeneratedImageAsyncMutation, CreateAiGeneratedImageAsyncMutationVariables>;
export const CreateAiOriginalImageDocument = gql`
    mutation CreateAiOriginalImage($agreedToTerms: Boolean!, $aiOriginalImageId: ID!, $email: String, $imageFlexibility: Float!, $imageSignedId: String!, $intensity: Int!, $style: String!, $project: NewProjectArgs, $projectId: Int) {
  createAiOriginalImage(
    aiOriginalImage: {agreedToTerms: $agreedToTerms, aiOriginalImageId: $aiOriginalImageId, email: $email, imageFlexibility: $imageFlexibility, imageSignedId: $imageSignedId, intensity: $intensity, style: $style, project: $project, projectId: $projectId}
  ) {
    ...AiOriginalImage
  }
}
    ${AiOriginalImageFragmentDoc}`;
export type CreateAiOriginalImageMutationFn = Apollo.MutationFunction<CreateAiOriginalImageMutation, CreateAiOriginalImageMutationVariables>;

/**
 * __useCreateAiOriginalImageMutation__
 *
 * To run a mutation, you first call `useCreateAiOriginalImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiOriginalImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiOriginalImageMutation, { data, loading, error }] = useCreateAiOriginalImageMutation({
 *   variables: {
 *      agreedToTerms: // value for 'agreedToTerms'
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      email: // value for 'email'
 *      imageFlexibility: // value for 'imageFlexibility'
 *      imageSignedId: // value for 'imageSignedId'
 *      intensity: // value for 'intensity'
 *      style: // value for 'style'
 *      project: // value for 'project'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateAiOriginalImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiOriginalImageMutation, CreateAiOriginalImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiOriginalImageMutation, CreateAiOriginalImageMutationVariables>(CreateAiOriginalImageDocument, options);
      }
export type CreateAiOriginalImageMutationHookResult = ReturnType<typeof useCreateAiOriginalImageMutation>;
export type CreateAiOriginalImageMutationResult = Apollo.MutationResult<CreateAiOriginalImageMutation>;
export type CreateAiOriginalImageMutationOptions = Apollo.BaseMutationOptions<CreateAiOriginalImageMutation, CreateAiOriginalImageMutationVariables>;
export const CreateAiOriginalImagePlaceholderDocument = gql`
    mutation CreateAiOriginalImagePlaceholder($byteSize: Int!, $checksum: String!, $contentType: String!, $filename: String!, $spaceType: String) {
  createAiOriginalImagePlaceholder(
    byteSize: $byteSize
    checksum: $checksum
    contentType: $contentType
    filename: $filename
    spaceType: $spaceType
  ) {
    aiOriginalImageId
    signedId
    uploadUrl
    uploadHeaders
  }
}
    `;
export type CreateAiOriginalImagePlaceholderMutationFn = Apollo.MutationFunction<CreateAiOriginalImagePlaceholderMutation, CreateAiOriginalImagePlaceholderMutationVariables>;

/**
 * __useCreateAiOriginalImagePlaceholderMutation__
 *
 * To run a mutation, you first call `useCreateAiOriginalImagePlaceholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiOriginalImagePlaceholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiOriginalImagePlaceholderMutation, { data, loading, error }] = useCreateAiOriginalImagePlaceholderMutation({
 *   variables: {
 *      byteSize: // value for 'byteSize'
 *      checksum: // value for 'checksum'
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      spaceType: // value for 'spaceType'
 *   },
 * });
 */
export function useCreateAiOriginalImagePlaceholderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiOriginalImagePlaceholderMutation, CreateAiOriginalImagePlaceholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiOriginalImagePlaceholderMutation, CreateAiOriginalImagePlaceholderMutationVariables>(CreateAiOriginalImagePlaceholderDocument, options);
      }
export type CreateAiOriginalImagePlaceholderMutationHookResult = ReturnType<typeof useCreateAiOriginalImagePlaceholderMutation>;
export type CreateAiOriginalImagePlaceholderMutationResult = Apollo.MutationResult<CreateAiOriginalImagePlaceholderMutation>;
export type CreateAiOriginalImagePlaceholderMutationOptions = Apollo.BaseMutationOptions<CreateAiOriginalImagePlaceholderMutation, CreateAiOriginalImagePlaceholderMutationVariables>;
export const CreateAlbumDocument = gql`
    mutation CreateAlbum($jobId: ID!, $name: String!) {
  createAlbum(jobId: $jobId, name: $name) {
    id
    createdAt
    name
    files {
      createdAt
      id
    }
  }
}
    `;
export type CreateAlbumMutationFn = Apollo.MutationFunction<CreateAlbumMutation, CreateAlbumMutationVariables>;

/**
 * __useCreateAlbumMutation__
 *
 * To run a mutation, you first call `useCreateAlbumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlbumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlbumMutation, { data, loading, error }] = useCreateAlbumMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAlbumMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlbumMutation, CreateAlbumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlbumMutation, CreateAlbumMutationVariables>(CreateAlbumDocument, options);
      }
export type CreateAlbumMutationHookResult = ReturnType<typeof useCreateAlbumMutation>;
export type CreateAlbumMutationResult = Apollo.MutationResult<CreateAlbumMutation>;
export type CreateAlbumMutationOptions = Apollo.BaseMutationOptions<CreateAlbumMutation, CreateAlbumMutationVariables>;
export const CreateBlueprintSubmissionDocument = gql`
    mutation CreateBlueprintSubmission($fileAttachmentsAttributes: [FileAttachmentArgs!]!, $jobsAttributes: [JobCreateArgs!], $name: String, $buildAll: Boolean) {
  createBlueprintSubmission(
    fileAttachmentsAttributes: $fileAttachmentsAttributes
    name: $name
    jobsAttributes: $jobsAttributes
    buildAll: $buildAll
  ) {
    createdAt
    id
    name
    orgId
    state
    userId
  }
}
    `;
export type CreateBlueprintSubmissionMutationFn = Apollo.MutationFunction<CreateBlueprintSubmissionMutation, CreateBlueprintSubmissionMutationVariables>;

/**
 * __useCreateBlueprintSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateBlueprintSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlueprintSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlueprintSubmissionMutation, { data, loading, error }] = useCreateBlueprintSubmissionMutation({
 *   variables: {
 *      fileAttachmentsAttributes: // value for 'fileAttachmentsAttributes'
 *      jobsAttributes: // value for 'jobsAttributes'
 *      name: // value for 'name'
 *      buildAll: // value for 'buildAll'
 *   },
 * });
 */
export function useCreateBlueprintSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlueprintSubmissionMutation, CreateBlueprintSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlueprintSubmissionMutation, CreateBlueprintSubmissionMutationVariables>(CreateBlueprintSubmissionDocument, options);
      }
export type CreateBlueprintSubmissionMutationHookResult = ReturnType<typeof useCreateBlueprintSubmissionMutation>;
export type CreateBlueprintSubmissionMutationResult = Apollo.MutationResult<CreateBlueprintSubmissionMutation>;
export type CreateBlueprintSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateBlueprintSubmissionMutation, CreateBlueprintSubmissionMutationVariables>;
export const CreateBulkBackgroundJobDocument = gql`
    mutation CreateBulkBackgroundJob($bulkBackgroundJobName: String!) {
  createBulkBackgroundJob(bulkBackgroundJobName: $bulkBackgroundJobName) {
    id
    presignedUrl
  }
}
    `;
export type CreateBulkBackgroundJobMutationFn = Apollo.MutationFunction<CreateBulkBackgroundJobMutation, CreateBulkBackgroundJobMutationVariables>;

/**
 * __useCreateBulkBackgroundJobMutation__
 *
 * To run a mutation, you first call `useCreateBulkBackgroundJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkBackgroundJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkBackgroundJobMutation, { data, loading, error }] = useCreateBulkBackgroundJobMutation({
 *   variables: {
 *      bulkBackgroundJobName: // value for 'bulkBackgroundJobName'
 *   },
 * });
 */
export function useCreateBulkBackgroundJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkBackgroundJobMutation, CreateBulkBackgroundJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkBackgroundJobMutation, CreateBulkBackgroundJobMutationVariables>(CreateBulkBackgroundJobDocument, options);
      }
export type CreateBulkBackgroundJobMutationHookResult = ReturnType<typeof useCreateBulkBackgroundJobMutation>;
export type CreateBulkBackgroundJobMutationResult = Apollo.MutationResult<CreateBulkBackgroundJobMutation>;
export type CreateBulkBackgroundJobMutationOptions = Apollo.BaseMutationOptions<CreateBulkBackgroundJobMutation, CreateBulkBackgroundJobMutationVariables>;
export const CreateDeliverableChangeRequestDocument = gql`
    mutation CreateDeliverableChangeRequest($jobId: Int!, $newDeliverableId: Int!) {
  createDeliverableChangeRequest(
    jobId: $jobId
    newDeliverableId: $newDeliverableId
  ) {
    newDeliverable {
      id
      name
    }
  }
}
    `;
export type CreateDeliverableChangeRequestMutationFn = Apollo.MutationFunction<CreateDeliverableChangeRequestMutation, CreateDeliverableChangeRequestMutationVariables>;

/**
 * __useCreateDeliverableChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableChangeRequestMutation, { data, loading, error }] = useCreateDeliverableChangeRequestMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      newDeliverableId: // value for 'newDeliverableId'
 *   },
 * });
 */
export function useCreateDeliverableChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableChangeRequestMutation, CreateDeliverableChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableChangeRequestMutation, CreateDeliverableChangeRequestMutationVariables>(CreateDeliverableChangeRequestDocument, options);
      }
export type CreateDeliverableChangeRequestMutationHookResult = ReturnType<typeof useCreateDeliverableChangeRequestMutation>;
export type CreateDeliverableChangeRequestMutationResult = Apollo.MutationResult<CreateDeliverableChangeRequestMutation>;
export type CreateDeliverableChangeRequestMutationOptions = Apollo.BaseMutationOptions<CreateDeliverableChangeRequestMutation, CreateDeliverableChangeRequestMutationVariables>;
export const CreateDesignerAnonymousSessionDocument = gql`
    mutation CreateDesignerAnonymousSession {
  createDesignerAnonymousSession {
    jwt
  }
}
    `;
export type CreateDesignerAnonymousSessionMutationFn = Apollo.MutationFunction<CreateDesignerAnonymousSessionMutation, CreateDesignerAnonymousSessionMutationVariables>;

/**
 * __useCreateDesignerAnonymousSessionMutation__
 *
 * To run a mutation, you first call `useCreateDesignerAnonymousSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignerAnonymousSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignerAnonymousSessionMutation, { data, loading, error }] = useCreateDesignerAnonymousSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDesignerAnonymousSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDesignerAnonymousSessionMutation, CreateDesignerAnonymousSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDesignerAnonymousSessionMutation, CreateDesignerAnonymousSessionMutationVariables>(CreateDesignerAnonymousSessionDocument, options);
      }
export type CreateDesignerAnonymousSessionMutationHookResult = ReturnType<typeof useCreateDesignerAnonymousSessionMutation>;
export type CreateDesignerAnonymousSessionMutationResult = Apollo.MutationResult<CreateDesignerAnonymousSessionMutation>;
export type CreateDesignerAnonymousSessionMutationOptions = Apollo.BaseMutationOptions<CreateDesignerAnonymousSessionMutation, CreateDesignerAnonymousSessionMutationVariables>;
export const CreateFileStorageTokenDocument = gql`
    mutation CreateFileStorageToken($storageScope: FileStorageScopes!, $jobId: ID, $authorId: ID) {
  createFileStorageToken(
    storageScope: $storageScope
    jobId: $jobId
    authorId: $authorId
  ) {
    token
  }
}
    `;
export type CreateFileStorageTokenMutationFn = Apollo.MutationFunction<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>;

/**
 * __useCreateFileStorageTokenMutation__
 *
 * To run a mutation, you first call `useCreateFileStorageTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileStorageTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileStorageTokenMutation, { data, loading, error }] = useCreateFileStorageTokenMutation({
 *   variables: {
 *      storageScope: // value for 'storageScope'
 *      jobId: // value for 'jobId'
 *      authorId: // value for 'authorId'
 *   },
 * });
 */
export function useCreateFileStorageTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>(CreateFileStorageTokenDocument, options);
      }
export type CreateFileStorageTokenMutationHookResult = ReturnType<typeof useCreateFileStorageTokenMutation>;
export type CreateFileStorageTokenMutationResult = Apollo.MutationResult<CreateFileStorageTokenMutation>;
export type CreateFileStorageTokenMutationOptions = Apollo.BaseMutationOptions<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>;
export const CreateHiDefRenderingDocument = gql`
    mutation CreateHiDefRendering($jobId: ID!) {
  createHiDefRendering(jobId: $jobId) {
    requestFormUrl
  }
}
    `;
export type CreateHiDefRenderingMutationFn = Apollo.MutationFunction<CreateHiDefRenderingMutation, CreateHiDefRenderingMutationVariables>;

/**
 * __useCreateHiDefRenderingMutation__
 *
 * To run a mutation, you first call `useCreateHiDefRenderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHiDefRenderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHiDefRenderingMutation, { data, loading, error }] = useCreateHiDefRenderingMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCreateHiDefRenderingMutation(baseOptions?: Apollo.MutationHookOptions<CreateHiDefRenderingMutation, CreateHiDefRenderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHiDefRenderingMutation, CreateHiDefRenderingMutationVariables>(CreateHiDefRenderingDocument, options);
      }
export type CreateHiDefRenderingMutationHookResult = ReturnType<typeof useCreateHiDefRenderingMutation>;
export type CreateHiDefRenderingMutationResult = Apollo.MutationResult<CreateHiDefRenderingMutation>;
export type CreateHiDefRenderingMutationOptions = Apollo.BaseMutationOptions<CreateHiDefRenderingMutation, CreateHiDefRenderingMutationVariables>;
export const CreateHiDefRenderingVersionDocument = gql`
    mutation CreateHiDefRenderingVersion($hiDefRenderingId: ID!, $versionType: RenderingVersion!) {
  createHiDefRenderingVersion(
    hiDefRenderingId: $hiDefRenderingId
    versionType: $versionType
  ) {
    hiDefRenderingId
    requestFormUrl
    versionType
    state
  }
}
    `;
export type CreateHiDefRenderingVersionMutationFn = Apollo.MutationFunction<CreateHiDefRenderingVersionMutation, CreateHiDefRenderingVersionMutationVariables>;

/**
 * __useCreateHiDefRenderingVersionMutation__
 *
 * To run a mutation, you first call `useCreateHiDefRenderingVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHiDefRenderingVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHiDefRenderingVersionMutation, { data, loading, error }] = useCreateHiDefRenderingVersionMutation({
 *   variables: {
 *      hiDefRenderingId: // value for 'hiDefRenderingId'
 *      versionType: // value for 'versionType'
 *   },
 * });
 */
export function useCreateHiDefRenderingVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateHiDefRenderingVersionMutation, CreateHiDefRenderingVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHiDefRenderingVersionMutation, CreateHiDefRenderingVersionMutationVariables>(CreateHiDefRenderingVersionDocument, options);
      }
export type CreateHiDefRenderingVersionMutationHookResult = ReturnType<typeof useCreateHiDefRenderingVersionMutation>;
export type CreateHiDefRenderingVersionMutationResult = Apollo.MutationResult<CreateHiDefRenderingVersionMutation>;
export type CreateHiDefRenderingVersionMutationOptions = Apollo.BaseMutationOptions<CreateHiDefRenderingVersionMutation, CreateHiDefRenderingVersionMutationVariables>;
export const CreateHomeownerDocument = gql`
    mutation CreateHomeowner($distinctId: String, $orgCode: String, $user: UserArgs!) {
  createHomeowner(distinctId: $distinctId, orgCode: $orgCode, user: $user) {
    user {
      id
      email
      captureRequests {
        results {
          id
        }
      }
      intercomSha
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type CreateHomeownerMutationFn = Apollo.MutationFunction<CreateHomeownerMutation, CreateHomeownerMutationVariables>;

/**
 * __useCreateHomeownerMutation__
 *
 * To run a mutation, you first call `useCreateHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHomeownerMutation, { data, loading, error }] = useCreateHomeownerMutation({
 *   variables: {
 *      distinctId: // value for 'distinctId'
 *      orgCode: // value for 'orgCode'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateHomeownerMutation(baseOptions?: Apollo.MutationHookOptions<CreateHomeownerMutation, CreateHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHomeownerMutation, CreateHomeownerMutationVariables>(CreateHomeownerDocument, options);
      }
export type CreateHomeownerMutationHookResult = ReturnType<typeof useCreateHomeownerMutation>;
export type CreateHomeownerMutationResult = Apollo.MutationResult<CreateHomeownerMutation>;
export type CreateHomeownerMutationOptions = Apollo.BaseMutationOptions<CreateHomeownerMutation, CreateHomeownerMutationVariables>;
export const CreateImagePlaceholderDocument = gql`
    mutation CreateImagePlaceholder($imageParams: ImagePlaceholderArgs!, $isAdditional: Boolean, $jobId: Int!) {
  createImagePlaceholder(
    imageParams: $imageParams
    isAdditional: $isAdditional
    jobId: $jobId
  ) {
    imageId
    uploadUrl
  }
}
    `;
export type CreateImagePlaceholderMutationFn = Apollo.MutationFunction<CreateImagePlaceholderMutation, CreateImagePlaceholderMutationVariables>;

/**
 * __useCreateImagePlaceholderMutation__
 *
 * To run a mutation, you first call `useCreateImagePlaceholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImagePlaceholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImagePlaceholderMutation, { data, loading, error }] = useCreateImagePlaceholderMutation({
 *   variables: {
 *      imageParams: // value for 'imageParams'
 *      isAdditional: // value for 'isAdditional'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCreateImagePlaceholderMutation(baseOptions?: Apollo.MutationHookOptions<CreateImagePlaceholderMutation, CreateImagePlaceholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImagePlaceholderMutation, CreateImagePlaceholderMutationVariables>(CreateImagePlaceholderDocument, options);
      }
export type CreateImagePlaceholderMutationHookResult = ReturnType<typeof useCreateImagePlaceholderMutation>;
export type CreateImagePlaceholderMutationResult = Apollo.MutationResult<CreateImagePlaceholderMutation>;
export type CreateImagePlaceholderMutationOptions = Apollo.BaseMutationOptions<CreateImagePlaceholderMutation, CreateImagePlaceholderMutationVariables>;
export const CreateInsuranceUserDocument = gql`
    mutation CreateInsuranceUser($org: OrgArgs!, $user: UserArgs!) {
  createInsuranceUser(org: $org, user: $user) {
    jwt {
      accessToken
      refreshToken
    }
    user {
      id
      email
      intercomSha
    }
  }
}
    `;
export type CreateInsuranceUserMutationFn = Apollo.MutationFunction<CreateInsuranceUserMutation, CreateInsuranceUserMutationVariables>;

/**
 * __useCreateInsuranceUserMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceUserMutation, { data, loading, error }] = useCreateInsuranceUserMutation({
 *   variables: {
 *      org: // value for 'org'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateInsuranceUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceUserMutation, CreateInsuranceUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceUserMutation, CreateInsuranceUserMutationVariables>(CreateInsuranceUserDocument, options);
      }
export type CreateInsuranceUserMutationHookResult = ReturnType<typeof useCreateInsuranceUserMutation>;
export type CreateInsuranceUserMutationResult = Apollo.MutationResult<CreateInsuranceUserMutation>;
export type CreateInsuranceUserMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceUserMutation, CreateInsuranceUserMutationVariables>;
export const CreateJobNoteDocument = gql`
    mutation CreateJobNote($jobId: Int!, $note: NoteArgs!) {
  createNote(jobId: $jobId, note: $note) {
    id
  }
}
    `;
export type CreateJobNoteMutationFn = Apollo.MutationFunction<CreateJobNoteMutation, CreateJobNoteMutationVariables>;

/**
 * __useCreateJobNoteMutation__
 *
 * To run a mutation, you first call `useCreateJobNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobNoteMutation, { data, loading, error }] = useCreateJobNoteMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateJobNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobNoteMutation, CreateJobNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobNoteMutation, CreateJobNoteMutationVariables>(CreateJobNoteDocument, options);
      }
export type CreateJobNoteMutationHookResult = ReturnType<typeof useCreateJobNoteMutation>;
export type CreateJobNoteMutationResult = Apollo.MutationResult<CreateJobNoteMutation>;
export type CreateJobNoteMutationOptions = Apollo.BaseMutationOptions<CreateJobNoteMutation, CreateJobNoteMutationVariables>;
export const CreateOrUpdateAlbumWithFilesDocument = gql`
    mutation CreateOrUpdateAlbumWithFiles($album: CreateOrUpdateAlbumWithFilesArgs!) {
  createOrUpdateAlbumWithFiles(album: $album) {
    files {
      ... on CreateAlbumFileError {
        blobId
        message
      }
    }
    album {
      ...AlbumFragment
    }
  }
}
    ${AlbumFragmentFragmentDoc}`;
export type CreateOrUpdateAlbumWithFilesMutationFn = Apollo.MutationFunction<CreateOrUpdateAlbumWithFilesMutation, CreateOrUpdateAlbumWithFilesMutationVariables>;

/**
 * __useCreateOrUpdateAlbumWithFilesMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAlbumWithFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAlbumWithFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAlbumWithFilesMutation, { data, loading, error }] = useCreateOrUpdateAlbumWithFilesMutation({
 *   variables: {
 *      album: // value for 'album'
 *   },
 * });
 */
export function useCreateOrUpdateAlbumWithFilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAlbumWithFilesMutation, CreateOrUpdateAlbumWithFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAlbumWithFilesMutation, CreateOrUpdateAlbumWithFilesMutationVariables>(CreateOrUpdateAlbumWithFilesDocument, options);
      }
export type CreateOrUpdateAlbumWithFilesMutationHookResult = ReturnType<typeof useCreateOrUpdateAlbumWithFilesMutation>;
export type CreateOrUpdateAlbumWithFilesMutationResult = Apollo.MutationResult<CreateOrUpdateAlbumWithFilesMutation>;
export type CreateOrUpdateAlbumWithFilesMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAlbumWithFilesMutation, CreateOrUpdateAlbumWithFilesMutationVariables>;
export const CreateOrgSurveyQualifierDocument = gql`
    mutation CreateOrgSurveyQualifier($orgSurveyQualifierCreateArgs: OrgSurveyQualifierCreateArgs!) {
  createOrgSurveyQualifier(orgSurveyQualifier: $orgSurveyQualifierCreateArgs) {
    org {
      id
    }
  }
}
    `;
export type CreateOrgSurveyQualifierMutationFn = Apollo.MutationFunction<CreateOrgSurveyQualifierMutation, CreateOrgSurveyQualifierMutationVariables>;

/**
 * __useCreateOrgSurveyQualifierMutation__
 *
 * To run a mutation, you first call `useCreateOrgSurveyQualifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgSurveyQualifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgSurveyQualifierMutation, { data, loading, error }] = useCreateOrgSurveyQualifierMutation({
 *   variables: {
 *      orgSurveyQualifierCreateArgs: // value for 'orgSurveyQualifierCreateArgs'
 *   },
 * });
 */
export function useCreateOrgSurveyQualifierMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrgSurveyQualifierMutation, CreateOrgSurveyQualifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrgSurveyQualifierMutation, CreateOrgSurveyQualifierMutationVariables>(CreateOrgSurveyQualifierDocument, options);
      }
export type CreateOrgSurveyQualifierMutationHookResult = ReturnType<typeof useCreateOrgSurveyQualifierMutation>;
export type CreateOrgSurveyQualifierMutationResult = Apollo.MutationResult<CreateOrgSurveyQualifierMutation>;
export type CreateOrgSurveyQualifierMutationOptions = Apollo.BaseMutationOptions<CreateOrgSurveyQualifierMutation, CreateOrgSurveyQualifierMutationVariables>;
export const CreateProUserDocument = gql`
    mutation CreateProUser($org: OrgArgs!, $user: UserArgs!, $parentOrgCode: String, $signupVersion: String) {
  createProUser(
    org: $org
    user: $user
    parentOrgCode: $parentOrgCode
    signupVersion: $signupVersion
  ) {
    user {
      id
      email
      intercomSha
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type CreateProUserMutationFn = Apollo.MutationFunction<CreateProUserMutation, CreateProUserMutationVariables>;

/**
 * __useCreateProUserMutation__
 *
 * To run a mutation, you first call `useCreateProUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProUserMutation, { data, loading, error }] = useCreateProUserMutation({
 *   variables: {
 *      org: // value for 'org'
 *      user: // value for 'user'
 *      parentOrgCode: // value for 'parentOrgCode'
 *      signupVersion: // value for 'signupVersion'
 *   },
 * });
 */
export function useCreateProUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateProUserMutation, CreateProUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProUserMutation, CreateProUserMutationVariables>(CreateProUserDocument, options);
      }
export type CreateProUserMutationHookResult = ReturnType<typeof useCreateProUserMutation>;
export type CreateProUserMutationResult = Apollo.MutationResult<CreateProUserMutation>;
export type CreateProUserMutationOptions = Apollo.BaseMutationOptions<CreateProUserMutation, CreateProUserMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($name: String!, $orgId: Int, $scopeItems: [String!]) {
  createProject(name: $name, orgId: $orgId, scopeItems: $scopeItems) {
    id
    name
    scopeItems
    createdAt
    updatedAt
    addables {
      ...AiDisplayImage
    }
  }
}
    ${AiDisplayImageFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *      scopeItems: // value for 'scopeItems'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateProjectShareDocument = gql`
    mutation CreateProjectShare($projectId: ID!) {
  createProjectShare(projectId: $projectId) {
    id
  }
}
    `;
export type CreateProjectShareMutationFn = Apollo.MutationFunction<CreateProjectShareMutation, CreateProjectShareMutationVariables>;

/**
 * __useCreateProjectShareMutation__
 *
 * To run a mutation, you first call `useCreateProjectShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectShareMutation, { data, loading, error }] = useCreateProjectShareMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectShareMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectShareMutation, CreateProjectShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectShareMutation, CreateProjectShareMutationVariables>(CreateProjectShareDocument, options);
      }
export type CreateProjectShareMutationHookResult = ReturnType<typeof useCreateProjectShareMutation>;
export type CreateProjectShareMutationResult = Apollo.MutationResult<CreateProjectShareMutation>;
export type CreateProjectShareMutationOptions = Apollo.BaseMutationOptions<CreateProjectShareMutation, CreateProjectShareMutationVariables>;
export const CreateSolvedAiOriginalImageDocument = gql`
    mutation CreateSolvedAiOriginalImage($jobId: Int!) {
  createSolvedAiOriginalImage(jobId: $jobId) {
    ...AiOriginalImage
  }
}
    ${AiOriginalImageFragmentDoc}`;
export type CreateSolvedAiOriginalImageMutationFn = Apollo.MutationFunction<CreateSolvedAiOriginalImageMutation, CreateSolvedAiOriginalImageMutationVariables>;

/**
 * __useCreateSolvedAiOriginalImageMutation__
 *
 * To run a mutation, you first call `useCreateSolvedAiOriginalImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSolvedAiOriginalImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSolvedAiOriginalImageMutation, { data, loading, error }] = useCreateSolvedAiOriginalImageMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCreateSolvedAiOriginalImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSolvedAiOriginalImageMutation, CreateSolvedAiOriginalImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSolvedAiOriginalImageMutation, CreateSolvedAiOriginalImageMutationVariables>(CreateSolvedAiOriginalImageDocument, options);
      }
export type CreateSolvedAiOriginalImageMutationHookResult = ReturnType<typeof useCreateSolvedAiOriginalImageMutation>;
export type CreateSolvedAiOriginalImageMutationResult = Apollo.MutationResult<CreateSolvedAiOriginalImageMutation>;
export type CreateSolvedAiOriginalImageMutationOptions = Apollo.BaseMutationOptions<CreateSolvedAiOriginalImageMutation, CreateSolvedAiOriginalImageMutationVariables>;
export const CreateUploadRequestDocument = gql`
    mutation CreateUploadRequest($fileInfo: UploadRequestArgs!) {
  createUploadRequest(fileInfo: $fileInfo) {
    signedId
    uploadHeaders
    uploadUrl
  }
}
    `;
export type CreateUploadRequestMutationFn = Apollo.MutationFunction<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;

/**
 * __useCreateUploadRequestMutation__
 *
 * To run a mutation, you first call `useCreateUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadRequestMutation, { data, loading, error }] = useCreateUploadRequestMutation({
 *   variables: {
 *      fileInfo: // value for 'fileInfo'
 *   },
 * });
 */
export function useCreateUploadRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>(CreateUploadRequestDocument, options);
      }
export type CreateUploadRequestMutationHookResult = ReturnType<typeof useCreateUploadRequestMutation>;
export type CreateUploadRequestMutationResult = Apollo.MutationResult<CreateUploadRequestMutation>;
export type CreateUploadRequestMutationOptions = Apollo.BaseMutationOptions<CreateUploadRequestMutation, CreateUploadRequestMutationVariables>;
export const CustomizeAiImageDocument = gql`
    mutation CustomizeAiImage($paintColorId: Int, $materialId: Int, $region: String!, $instances: [String!], $appId: String!, $aiGeneratedImageId: Int!, $productCatalogVariationUuid: ID, $aiPromptName: String, $paintHexColor: String) {
  customizeAiImage(
    params: {paintColorId: $paintColorId, materialId: $materialId, region: $region, instances: $instances, appId: $appId, aiGeneratedImageId: $aiGeneratedImageId, productCatalogVariationUuid: $productCatalogVariationUuid, aiPromptName: $aiPromptName, paintHexColor: $paintHexColor}
  ) {
    ...AiGeneratedImage
  }
}
    ${AiGeneratedImageFragmentDoc}`;
export type CustomizeAiImageMutationFn = Apollo.MutationFunction<CustomizeAiImageMutation, CustomizeAiImageMutationVariables>;

/**
 * __useCustomizeAiImageMutation__
 *
 * To run a mutation, you first call `useCustomizeAiImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomizeAiImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customizeAiImageMutation, { data, loading, error }] = useCustomizeAiImageMutation({
 *   variables: {
 *      paintColorId: // value for 'paintColorId'
 *      materialId: // value for 'materialId'
 *      region: // value for 'region'
 *      instances: // value for 'instances'
 *      appId: // value for 'appId'
 *      aiGeneratedImageId: // value for 'aiGeneratedImageId'
 *      productCatalogVariationUuid: // value for 'productCatalogVariationUuid'
 *      aiPromptName: // value for 'aiPromptName'
 *      paintHexColor: // value for 'paintHexColor'
 *   },
 * });
 */
export function useCustomizeAiImageMutation(baseOptions?: Apollo.MutationHookOptions<CustomizeAiImageMutation, CustomizeAiImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomizeAiImageMutation, CustomizeAiImageMutationVariables>(CustomizeAiImageDocument, options);
      }
export type CustomizeAiImageMutationHookResult = ReturnType<typeof useCustomizeAiImageMutation>;
export type CustomizeAiImageMutationResult = Apollo.MutationResult<CustomizeAiImageMutation>;
export type CustomizeAiImageMutationOptions = Apollo.BaseMutationOptions<CustomizeAiImageMutation, CustomizeAiImageMutationVariables>;
export const DeleteAiOriginalImageDocument = gql`
    mutation DeleteAiOriginalImage($id: Int!) {
  deleteAiOriginalImage(id: $id) {
    id
    image
    inputPath
    spaceType
  }
}
    `;
export type DeleteAiOriginalImageMutationFn = Apollo.MutationFunction<DeleteAiOriginalImageMutation, DeleteAiOriginalImageMutationVariables>;

/**
 * __useDeleteAiOriginalImageMutation__
 *
 * To run a mutation, you first call `useDeleteAiOriginalImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiOriginalImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiOriginalImageMutation, { data, loading, error }] = useDeleteAiOriginalImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAiOriginalImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiOriginalImageMutation, DeleteAiOriginalImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiOriginalImageMutation, DeleteAiOriginalImageMutationVariables>(DeleteAiOriginalImageDocument, options);
      }
export type DeleteAiOriginalImageMutationHookResult = ReturnType<typeof useDeleteAiOriginalImageMutation>;
export type DeleteAiOriginalImageMutationResult = Apollo.MutationResult<DeleteAiOriginalImageMutation>;
export type DeleteAiOriginalImageMutationOptions = Apollo.BaseMutationOptions<DeleteAiOriginalImageMutation, DeleteAiOriginalImageMutationVariables>;
export const DeleteAlbumFilesDocument = gql`
    mutation DeleteAlbumFiles($ids: [ID!]!) {
  deleteAlbumFiles(ids: $ids) {
    files {
      id
    }
  }
}
    `;
export type DeleteAlbumFilesMutationFn = Apollo.MutationFunction<DeleteAlbumFilesMutation, DeleteAlbumFilesMutationVariables>;

/**
 * __useDeleteAlbumFilesMutation__
 *
 * To run a mutation, you first call `useDeleteAlbumFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlbumFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlbumFilesMutation, { data, loading, error }] = useDeleteAlbumFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAlbumFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlbumFilesMutation, DeleteAlbumFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlbumFilesMutation, DeleteAlbumFilesMutationVariables>(DeleteAlbumFilesDocument, options);
      }
export type DeleteAlbumFilesMutationHookResult = ReturnType<typeof useDeleteAlbumFilesMutation>;
export type DeleteAlbumFilesMutationResult = Apollo.MutationResult<DeleteAlbumFilesMutation>;
export type DeleteAlbumFilesMutationOptions = Apollo.BaseMutationOptions<DeleteAlbumFilesMutation, DeleteAlbumFilesMutationVariables>;
export const DeleteJobAssignmentDocument = gql`
    mutation DeleteJobAssignment($id: Int!) {
  deleteJobAssignment(id: $id) {
    id
  }
}
    `;
export type DeleteJobAssignmentMutationFn = Apollo.MutationFunction<DeleteJobAssignmentMutation, DeleteJobAssignmentMutationVariables>;

/**
 * __useDeleteJobAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteJobAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobAssignmentMutation, { data, loading, error }] = useDeleteJobAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobAssignmentMutation, DeleteJobAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobAssignmentMutation, DeleteJobAssignmentMutationVariables>(DeleteJobAssignmentDocument, options);
      }
export type DeleteJobAssignmentMutationHookResult = ReturnType<typeof useDeleteJobAssignmentMutation>;
export type DeleteJobAssignmentMutationResult = Apollo.MutationResult<DeleteJobAssignmentMutation>;
export type DeleteJobAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteJobAssignmentMutation, DeleteJobAssignmentMutationVariables>;
export const DeleteJobNoteDocument = gql`
    mutation DeleteJobNote($id: Int!) {
  deleteNote(id: $id) {
    id
  }
}
    `;
export type DeleteJobNoteMutationFn = Apollo.MutationFunction<DeleteJobNoteMutation, DeleteJobNoteMutationVariables>;

/**
 * __useDeleteJobNoteMutation__
 *
 * To run a mutation, you first call `useDeleteJobNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobNoteMutation, { data, loading, error }] = useDeleteJobNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobNoteMutation, DeleteJobNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobNoteMutation, DeleteJobNoteMutationVariables>(DeleteJobNoteDocument, options);
      }
export type DeleteJobNoteMutationHookResult = ReturnType<typeof useDeleteJobNoteMutation>;
export type DeleteJobNoteMutationResult = Apollo.MutationResult<DeleteJobNoteMutation>;
export type DeleteJobNoteMutationOptions = Apollo.BaseMutationOptions<DeleteJobNoteMutation, DeleteJobNoteMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: Int!) {
  deleteProject(id: $id) {
    id
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteProjectAssetDocument = gql`
    mutation DeleteProjectAsset($addableId: Int!, $projectId: Int!) {
  deleteProjectAsset(addableId: $addableId, projectId: $projectId) {
    addableId
    addableType
    createdAt
    id
    projectId
    updatedAt
  }
}
    `;
export type DeleteProjectAssetMutationFn = Apollo.MutationFunction<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>;

/**
 * __useDeleteProjectAssetMutation__
 *
 * To run a mutation, you first call `useDeleteProjectAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectAssetMutation, { data, loading, error }] = useDeleteProjectAssetMutation({
 *   variables: {
 *      addableId: // value for 'addableId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>(DeleteProjectAssetDocument, options);
      }
export type DeleteProjectAssetMutationHookResult = ReturnType<typeof useDeleteProjectAssetMutation>;
export type DeleteProjectAssetMutationResult = Apollo.MutationResult<DeleteProjectAssetMutation>;
export type DeleteProjectAssetMutationOptions = Apollo.BaseMutationOptions<DeleteProjectAssetMutation, DeleteProjectAssetMutationVariables>;
export const DetectAiRegionsDocument = gql`
    mutation DetectAiRegions($aiGeneratedImageId: Int!) {
  detectAiRegions(aiGeneratedImageId: $aiGeneratedImageId) {
    id
    aiSegmentation {
      id
      instanceSvg
      regionStatistics
    }
  }
}
    `;
export type DetectAiRegionsMutationFn = Apollo.MutationFunction<DetectAiRegionsMutation, DetectAiRegionsMutationVariables>;

/**
 * __useDetectAiRegionsMutation__
 *
 * To run a mutation, you first call `useDetectAiRegionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectAiRegionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectAiRegionsMutation, { data, loading, error }] = useDetectAiRegionsMutation({
 *   variables: {
 *      aiGeneratedImageId: // value for 'aiGeneratedImageId'
 *   },
 * });
 */
export function useDetectAiRegionsMutation(baseOptions?: Apollo.MutationHookOptions<DetectAiRegionsMutation, DetectAiRegionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetectAiRegionsMutation, DetectAiRegionsMutationVariables>(DetectAiRegionsDocument, options);
      }
export type DetectAiRegionsMutationHookResult = ReturnType<typeof useDetectAiRegionsMutation>;
export type DetectAiRegionsMutationResult = Apollo.MutationResult<DetectAiRegionsMutation>;
export type DetectAiRegionsMutationOptions = Apollo.BaseMutationOptions<DetectAiRegionsMutation, DetectAiRegionsMutationVariables>;
export const FavoriteAiCustomizedImageDocument = gql`
    mutation FavoriteAiCustomizedImage($aiGeneratedImageId: Int!, $favorited: Boolean!) {
  favoriteAiCustomizedImage(
    aiGeneratedImageId: $aiGeneratedImageId
    favorited: $favorited
  ) {
    ...AiDisplayImage
  }
}
    ${AiDisplayImageFragmentDoc}`;
export type FavoriteAiCustomizedImageMutationFn = Apollo.MutationFunction<FavoriteAiCustomizedImageMutation, FavoriteAiCustomizedImageMutationVariables>;

/**
 * __useFavoriteAiCustomizedImageMutation__
 *
 * To run a mutation, you first call `useFavoriteAiCustomizedImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteAiCustomizedImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteAiCustomizedImageMutation, { data, loading, error }] = useFavoriteAiCustomizedImageMutation({
 *   variables: {
 *      aiGeneratedImageId: // value for 'aiGeneratedImageId'
 *      favorited: // value for 'favorited'
 *   },
 * });
 */
export function useFavoriteAiCustomizedImageMutation(baseOptions?: Apollo.MutationHookOptions<FavoriteAiCustomizedImageMutation, FavoriteAiCustomizedImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavoriteAiCustomizedImageMutation, FavoriteAiCustomizedImageMutationVariables>(FavoriteAiCustomizedImageDocument, options);
      }
export type FavoriteAiCustomizedImageMutationHookResult = ReturnType<typeof useFavoriteAiCustomizedImageMutation>;
export type FavoriteAiCustomizedImageMutationResult = Apollo.MutationResult<FavoriteAiCustomizedImageMutation>;
export type FavoriteAiCustomizedImageMutationOptions = Apollo.BaseMutationOptions<FavoriteAiCustomizedImageMutation, FavoriteAiCustomizedImageMutationVariables>;
export const FinishedUploadingBulkBackgroundJobDocument = gql`
    mutation FinishedUploadingBulkBackgroundJob($id: ID!) {
  finishedUploadingBulkBackgroundJob(bulkBackgroundJobId: $id)
}
    `;
export type FinishedUploadingBulkBackgroundJobMutationFn = Apollo.MutationFunction<FinishedUploadingBulkBackgroundJobMutation, FinishedUploadingBulkBackgroundJobMutationVariables>;

/**
 * __useFinishedUploadingBulkBackgroundJobMutation__
 *
 * To run a mutation, you first call `useFinishedUploadingBulkBackgroundJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishedUploadingBulkBackgroundJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishedUploadingBulkBackgroundJobMutation, { data, loading, error }] = useFinishedUploadingBulkBackgroundJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishedUploadingBulkBackgroundJobMutation(baseOptions?: Apollo.MutationHookOptions<FinishedUploadingBulkBackgroundJobMutation, FinishedUploadingBulkBackgroundJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishedUploadingBulkBackgroundJobMutation, FinishedUploadingBulkBackgroundJobMutationVariables>(FinishedUploadingBulkBackgroundJobDocument, options);
      }
export type FinishedUploadingBulkBackgroundJobMutationHookResult = ReturnType<typeof useFinishedUploadingBulkBackgroundJobMutation>;
export type FinishedUploadingBulkBackgroundJobMutationResult = Apollo.MutationResult<FinishedUploadingBulkBackgroundJobMutation>;
export type FinishedUploadingBulkBackgroundJobMutationOptions = Apollo.BaseMutationOptions<FinishedUploadingBulkBackgroundJobMutation, FinishedUploadingBulkBackgroundJobMutationVariables>;
export const GenerateAiImageDocument = gql`
    mutation GenerateAiImage($aiOriginalImageId: Int!, $appId: String!, $style: String!) {
  generateAiImage(
    generateAiImageParams: {aiOriginalImageId: $aiOriginalImageId, appId: $appId, style: $style}
  ) {
    ...AiDisplayImage
  }
}
    ${AiDisplayImageFragmentDoc}`;
export type GenerateAiImageMutationFn = Apollo.MutationFunction<GenerateAiImageMutation, GenerateAiImageMutationVariables>;

/**
 * __useGenerateAiImageMutation__
 *
 * To run a mutation, you first call `useGenerateAiImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiImageMutation, { data, loading, error }] = useGenerateAiImageMutation({
 *   variables: {
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      appId: // value for 'appId'
 *      style: // value for 'style'
 *   },
 * });
 */
export function useGenerateAiImageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAiImageMutation, GenerateAiImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAiImageMutation, GenerateAiImageMutationVariables>(GenerateAiImageDocument, options);
      }
export type GenerateAiImageMutationHookResult = ReturnType<typeof useGenerateAiImageMutation>;
export type GenerateAiImageMutationResult = Apollo.MutationResult<GenerateAiImageMutation>;
export type GenerateAiImageMutationOptions = Apollo.BaseMutationOptions<GenerateAiImageMutation, GenerateAiImageMutationVariables>;
export const GenerateDefaultInspectionTemplatesDocument = gql`
    mutation GenerateDefaultInspectionTemplates($orgId: ID!) {
  inspectionConfigChecklistTemplatesDefaultsCreate(orgId: $orgId) {
    createdChecklistTemplatesCount
  }
}
    `;
export type GenerateDefaultInspectionTemplatesMutationFn = Apollo.MutationFunction<GenerateDefaultInspectionTemplatesMutation, GenerateDefaultInspectionTemplatesMutationVariables>;

/**
 * __useGenerateDefaultInspectionTemplatesMutation__
 *
 * To run a mutation, you first call `useGenerateDefaultInspectionTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDefaultInspectionTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDefaultInspectionTemplatesMutation, { data, loading, error }] = useGenerateDefaultInspectionTemplatesMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGenerateDefaultInspectionTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDefaultInspectionTemplatesMutation, GenerateDefaultInspectionTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDefaultInspectionTemplatesMutation, GenerateDefaultInspectionTemplatesMutationVariables>(GenerateDefaultInspectionTemplatesDocument, options);
      }
export type GenerateDefaultInspectionTemplatesMutationHookResult = ReturnType<typeof useGenerateDefaultInspectionTemplatesMutation>;
export type GenerateDefaultInspectionTemplatesMutationResult = Apollo.MutationResult<GenerateDefaultInspectionTemplatesMutation>;
export type GenerateDefaultInspectionTemplatesMutationOptions = Apollo.BaseMutationOptions<GenerateDefaultInspectionTemplatesMutation, GenerateDefaultInspectionTemplatesMutationVariables>;
export const MagicLinkSigninDocument = gql`
    mutation MagicLinkSignin($email: String!, $redirectToUrl: String) {
  magicLinkSignin(email: $email, redirectTo: $redirectToUrl)
}
    `;
export type MagicLinkSigninMutationFn = Apollo.MutationFunction<MagicLinkSigninMutation, MagicLinkSigninMutationVariables>;

/**
 * __useMagicLinkSigninMutation__
 *
 * To run a mutation, you first call `useMagicLinkSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLinkSigninMutation, { data, loading, error }] = useMagicLinkSigninMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectToUrl: // value for 'redirectToUrl'
 *   },
 * });
 */
export function useMagicLinkSigninMutation(baseOptions?: Apollo.MutationHookOptions<MagicLinkSigninMutation, MagicLinkSigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MagicLinkSigninMutation, MagicLinkSigninMutationVariables>(MagicLinkSigninDocument, options);
      }
export type MagicLinkSigninMutationHookResult = ReturnType<typeof useMagicLinkSigninMutation>;
export type MagicLinkSigninMutationResult = Apollo.MutationResult<MagicLinkSigninMutation>;
export type MagicLinkSigninMutationOptions = Apollo.BaseMutationOptions<MagicLinkSigninMutation, MagicLinkSigninMutationVariables>;
export const OnboardingCreateHomeownerUserDocument = gql`
    mutation onboardingCreateHomeownerUser($args: OnboardingCreateHomeownerUserArgs!) {
  onboardingCreateHomeownerUser(args: $args) {
    user {
      id
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type OnboardingCreateHomeownerUserMutationFn = Apollo.MutationFunction<OnboardingCreateHomeownerUserMutation, OnboardingCreateHomeownerUserMutationVariables>;

/**
 * __useOnboardingCreateHomeownerUserMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateHomeownerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateHomeownerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateHomeownerUserMutation, { data, loading, error }] = useOnboardingCreateHomeownerUserMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useOnboardingCreateHomeownerUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateHomeownerUserMutation, OnboardingCreateHomeownerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateHomeownerUserMutation, OnboardingCreateHomeownerUserMutationVariables>(OnboardingCreateHomeownerUserDocument, options);
      }
export type OnboardingCreateHomeownerUserMutationHookResult = ReturnType<typeof useOnboardingCreateHomeownerUserMutation>;
export type OnboardingCreateHomeownerUserMutationResult = Apollo.MutationResult<OnboardingCreateHomeownerUserMutation>;
export type OnboardingCreateHomeownerUserMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateHomeownerUserMutation, OnboardingCreateHomeownerUserMutationVariables>;
export const OnboardingCreateOrgForUserDocument = gql`
    mutation OnboardingCreateOrgForUser($createOrgForUserArgs: OnboardingCreateOrgForUserArgs!) {
  onboardingCreateOrgForUser(createOrgForUserArgs: $createOrgForUserArgs) {
    org {
      id
      name
    }
  }
}
    `;
export type OnboardingCreateOrgForUserMutationFn = Apollo.MutationFunction<OnboardingCreateOrgForUserMutation, OnboardingCreateOrgForUserMutationVariables>;

/**
 * __useOnboardingCreateOrgForUserMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateOrgForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateOrgForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateOrgForUserMutation, { data, loading, error }] = useOnboardingCreateOrgForUserMutation({
 *   variables: {
 *      createOrgForUserArgs: // value for 'createOrgForUserArgs'
 *   },
 * });
 */
export function useOnboardingCreateOrgForUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateOrgForUserMutation, OnboardingCreateOrgForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateOrgForUserMutation, OnboardingCreateOrgForUserMutationVariables>(OnboardingCreateOrgForUserDocument, options);
      }
export type OnboardingCreateOrgForUserMutationHookResult = ReturnType<typeof useOnboardingCreateOrgForUserMutation>;
export type OnboardingCreateOrgForUserMutationResult = Apollo.MutationResult<OnboardingCreateOrgForUserMutation>;
export type OnboardingCreateOrgForUserMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateOrgForUserMutation, OnboardingCreateOrgForUserMutationVariables>;
export const OnboardingCreateOrgUsersDocument = gql`
    mutation OnboardingCreateOrgUsers($createOrgUsersArgs: OnboardingCreateOrgUsersArgs!) {
  onboardingCreateOrgUsers(createOrgUsersArgs: $createOrgUsersArgs) {
    id
    email
  }
}
    `;
export type OnboardingCreateOrgUsersMutationFn = Apollo.MutationFunction<OnboardingCreateOrgUsersMutation, OnboardingCreateOrgUsersMutationVariables>;

/**
 * __useOnboardingCreateOrgUsersMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateOrgUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateOrgUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateOrgUsersMutation, { data, loading, error }] = useOnboardingCreateOrgUsersMutation({
 *   variables: {
 *      createOrgUsersArgs: // value for 'createOrgUsersArgs'
 *   },
 * });
 */
export function useOnboardingCreateOrgUsersMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateOrgUsersMutation, OnboardingCreateOrgUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateOrgUsersMutation, OnboardingCreateOrgUsersMutationVariables>(OnboardingCreateOrgUsersDocument, options);
      }
export type OnboardingCreateOrgUsersMutationHookResult = ReturnType<typeof useOnboardingCreateOrgUsersMutation>;
export type OnboardingCreateOrgUsersMutationResult = Apollo.MutationResult<OnboardingCreateOrgUsersMutation>;
export type OnboardingCreateOrgUsersMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateOrgUsersMutation, OnboardingCreateOrgUsersMutationVariables>;
export const OnboardingCreateUserDocument = gql`
    mutation onboardingCreateUser($createUserArgs: OnboardingCreateUserArgs!) {
  onboardingCreateUser(createUserArgs: $createUserArgs) {
    user {
      id
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type OnboardingCreateUserMutationFn = Apollo.MutationFunction<OnboardingCreateUserMutation, OnboardingCreateUserMutationVariables>;

/**
 * __useOnboardingCreateUserMutation__
 *
 * To run a mutation, you first call `useOnboardingCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingCreateUserMutation, { data, loading, error }] = useOnboardingCreateUserMutation({
 *   variables: {
 *      createUserArgs: // value for 'createUserArgs'
 *   },
 * });
 */
export function useOnboardingCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingCreateUserMutation, OnboardingCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingCreateUserMutation, OnboardingCreateUserMutationVariables>(OnboardingCreateUserDocument, options);
      }
export type OnboardingCreateUserMutationHookResult = ReturnType<typeof useOnboardingCreateUserMutation>;
export type OnboardingCreateUserMutationResult = Apollo.MutationResult<OnboardingCreateUserMutation>;
export type OnboardingCreateUserMutationOptions = Apollo.BaseMutationOptions<OnboardingCreateUserMutation, OnboardingCreateUserMutationVariables>;
export const ProcessAdditionalImageDocument = gql`
    mutation ProcessAdditionalImage($imageId: Int!) {
  processAdditionalImage(imageId: $imageId) {
    rotatedImageUrl
  }
}
    `;
export type ProcessAdditionalImageMutationFn = Apollo.MutationFunction<ProcessAdditionalImageMutation, ProcessAdditionalImageMutationVariables>;

/**
 * __useProcessAdditionalImageMutation__
 *
 * To run a mutation, you first call `useProcessAdditionalImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAdditionalImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAdditionalImageMutation, { data, loading, error }] = useProcessAdditionalImageMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useProcessAdditionalImageMutation(baseOptions?: Apollo.MutationHookOptions<ProcessAdditionalImageMutation, ProcessAdditionalImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessAdditionalImageMutation, ProcessAdditionalImageMutationVariables>(ProcessAdditionalImageDocument, options);
      }
export type ProcessAdditionalImageMutationHookResult = ReturnType<typeof useProcessAdditionalImageMutation>;
export type ProcessAdditionalImageMutationResult = Apollo.MutationResult<ProcessAdditionalImageMutation>;
export type ProcessAdditionalImageMutationOptions = Apollo.BaseMutationOptions<ProcessAdditionalImageMutation, ProcessAdditionalImageMutationVariables>;
export const RefreshJwtDocument = gql`
    mutation RefreshJwt($refreshToken: String!) {
  refreshJwt(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    expiresIn
  }
}
    `;
export type RefreshJwtMutationFn = Apollo.MutationFunction<RefreshJwtMutation, RefreshJwtMutationVariables>;

/**
 * __useRefreshJwtMutation__
 *
 * To run a mutation, you first call `useRefreshJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshJwtMutation, { data, loading, error }] = useRefreshJwtMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshJwtMutation(baseOptions?: Apollo.MutationHookOptions<RefreshJwtMutation, RefreshJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshJwtMutation, RefreshJwtMutationVariables>(RefreshJwtDocument, options);
      }
export type RefreshJwtMutationHookResult = ReturnType<typeof useRefreshJwtMutation>;
export type RefreshJwtMutationResult = Apollo.MutationResult<RefreshJwtMutation>;
export type RefreshJwtMutationOptions = Apollo.BaseMutationOptions<RefreshJwtMutation, RefreshJwtMutationVariables>;
export const RemoveScanFromProjectDocument = gql`
    mutation RemoveScanFromProject($projectId: Int!, $scanId: Int!) {
  deleteProjectAsset(projectId: $projectId, addableId: $scanId) {
    projectId
    addableId
    addableType
  }
}
    `;
export type RemoveScanFromProjectMutationFn = Apollo.MutationFunction<RemoveScanFromProjectMutation, RemoveScanFromProjectMutationVariables>;

/**
 * __useRemoveScanFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveScanFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScanFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScanFromProjectMutation, { data, loading, error }] = useRemoveScanFromProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      scanId: // value for 'scanId'
 *   },
 * });
 */
export function useRemoveScanFromProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScanFromProjectMutation, RemoveScanFromProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScanFromProjectMutation, RemoveScanFromProjectMutationVariables>(RemoveScanFromProjectDocument, options);
      }
export type RemoveScanFromProjectMutationHookResult = ReturnType<typeof useRemoveScanFromProjectMutation>;
export type RemoveScanFromProjectMutationResult = Apollo.MutationResult<RemoveScanFromProjectMutation>;
export type RemoveScanFromProjectMutationOptions = Apollo.BaseMutationOptions<RemoveScanFromProjectMutation, RemoveScanFromProjectMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($password: String!, $token: String!) {
  resetPassword(password: $password, resetPasswordToken: $token) {
    jwt {
      refreshToken
      accessToken
    }
    user {
      id
      email
      intercomSha
      isNewOnboardingExperience
      orgs {
        id
      }
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendRenderingShareEmailDocument = gql`
    mutation SendRenderingShareEmail($shareToken: String!, $email: String!) {
  sendRenderingShareEmail(shareToken: $shareToken, email: $email)
}
    `;
export type SendRenderingShareEmailMutationFn = Apollo.MutationFunction<SendRenderingShareEmailMutation, SendRenderingShareEmailMutationVariables>;

/**
 * __useSendRenderingShareEmailMutation__
 *
 * To run a mutation, you first call `useSendRenderingShareEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRenderingShareEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRenderingShareEmailMutation, { data, loading, error }] = useSendRenderingShareEmailMutation({
 *   variables: {
 *      shareToken: // value for 'shareToken'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendRenderingShareEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendRenderingShareEmailMutation, SendRenderingShareEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRenderingShareEmailMutation, SendRenderingShareEmailMutationVariables>(SendRenderingShareEmailDocument, options);
      }
export type SendRenderingShareEmailMutationHookResult = ReturnType<typeof useSendRenderingShareEmailMutation>;
export type SendRenderingShareEmailMutationResult = Apollo.MutationResult<SendRenderingShareEmailMutation>;
export type SendRenderingShareEmailMutationOptions = Apollo.BaseMutationOptions<SendRenderingShareEmailMutation, SendRenderingShareEmailMutationVariables>;
export const SendResetPasswordInstructionsDocument = gql`
    mutation SendResetPasswordInstructions($email: String!) {
  sendResetPasswordInstructions(email: $email)
}
    `;
export type SendResetPasswordInstructionsMutationFn = Apollo.MutationFunction<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>;

/**
 * __useSendResetPasswordInstructionsMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordInstructionsMutation, { data, loading, error }] = useSendResetPasswordInstructionsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>(SendResetPasswordInstructionsDocument, options);
      }
export type SendResetPasswordInstructionsMutationHookResult = ReturnType<typeof useSendResetPasswordInstructionsMutation>;
export type SendResetPasswordInstructionsMutationResult = Apollo.MutationResult<SendResetPasswordInstructionsMutation>;
export type SendResetPasswordInstructionsMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>;
export const ShareJobDocument = gql`
    mutation ShareJob($jobAssignment: JobAssignmentArgs!, $user: UnregisteredUserArgs!) {
  shareJob(jobAssignment: $jobAssignment, user: $user)
}
    `;
export type ShareJobMutationFn = Apollo.MutationFunction<ShareJobMutation, ShareJobMutationVariables>;

/**
 * __useShareJobMutation__
 *
 * To run a mutation, you first call `useShareJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareJobMutation, { data, loading, error }] = useShareJobMutation({
 *   variables: {
 *      jobAssignment: // value for 'jobAssignment'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useShareJobMutation(baseOptions?: Apollo.MutationHookOptions<ShareJobMutation, ShareJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareJobMutation, ShareJobMutationVariables>(ShareJobDocument, options);
      }
export type ShareJobMutationHookResult = ReturnType<typeof useShareJobMutation>;
export type ShareJobMutationResult = Apollo.MutationResult<ShareJobMutation>;
export type ShareJobMutationOptions = Apollo.BaseMutationOptions<ShareJobMutation, ShareJobMutationVariables>;
export const StopImpersonationDocument = gql`
    mutation StopImpersonation {
  stopImpersonation {
    userEmail
    userId
  }
}
    `;
export type StopImpersonationMutationFn = Apollo.MutationFunction<StopImpersonationMutation, StopImpersonationMutationVariables>;

/**
 * __useStopImpersonationMutation__
 *
 * To run a mutation, you first call `useStopImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImpersonationMutation, { data, loading, error }] = useStopImpersonationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopImpersonationMutation(baseOptions?: Apollo.MutationHookOptions<StopImpersonationMutation, StopImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopImpersonationMutation, StopImpersonationMutationVariables>(StopImpersonationDocument, options);
      }
export type StopImpersonationMutationHookResult = ReturnType<typeof useStopImpersonationMutation>;
export type StopImpersonationMutationResult = Apollo.MutationResult<StopImpersonationMutation>;
export type StopImpersonationMutationOptions = Apollo.BaseMutationOptions<StopImpersonationMutation, StopImpersonationMutationVariables>;
export const SubmitDesignOrderResponseDocument = gql`
    mutation SubmitDesignOrderResponse($images: [Upload!], $designOrders: [DesignOrderInput!]!, $hiDefRenderingVersionId: ID!, $packageType: String, $versionType: RenderingVersion) {
  submitDesignOrderResponse(
    designOrderResponse: {images: $images, designOrders: $designOrders, packageType: $packageType}
    hiDefRenderingVersionId: $hiDefRenderingVersionId
    versionType: $versionType
  ) {
    hiDefRenderingVersion {
      id
      designOrderResponse {
        designOrders {
          style
          views
          additionalDetails
          scopeItems {
            trade
            additionalDetails
            images
          }
        }
        packageType
      }
    }
  }
}
    `;
export type SubmitDesignOrderResponseMutationFn = Apollo.MutationFunction<SubmitDesignOrderResponseMutation, SubmitDesignOrderResponseMutationVariables>;

/**
 * __useSubmitDesignOrderResponseMutation__
 *
 * To run a mutation, you first call `useSubmitDesignOrderResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDesignOrderResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDesignOrderResponseMutation, { data, loading, error }] = useSubmitDesignOrderResponseMutation({
 *   variables: {
 *      images: // value for 'images'
 *      designOrders: // value for 'designOrders'
 *      hiDefRenderingVersionId: // value for 'hiDefRenderingVersionId'
 *      packageType: // value for 'packageType'
 *      versionType: // value for 'versionType'
 *   },
 * });
 */
export function useSubmitDesignOrderResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDesignOrderResponseMutation, SubmitDesignOrderResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDesignOrderResponseMutation, SubmitDesignOrderResponseMutationVariables>(SubmitDesignOrderResponseDocument, options);
      }
export type SubmitDesignOrderResponseMutationHookResult = ReturnType<typeof useSubmitDesignOrderResponseMutation>;
export type SubmitDesignOrderResponseMutationResult = Apollo.MutationResult<SubmitDesignOrderResponseMutation>;
export type SubmitDesignOrderResponseMutationOptions = Apollo.BaseMutationOptions<SubmitDesignOrderResponseMutation, SubmitDesignOrderResponseMutationVariables>;
export const UnarchiveJobDocument = gql`
    mutation UnarchiveJob($id: Int!) {
  unarchiveJob(id: $id) {
    archived
  }
}
    `;
export type UnarchiveJobMutationFn = Apollo.MutationFunction<UnarchiveJobMutation, UnarchiveJobMutationVariables>;

/**
 * __useUnarchiveJobMutation__
 *
 * To run a mutation, you first call `useUnarchiveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveJobMutation, { data, loading, error }] = useUnarchiveJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveJobMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveJobMutation, UnarchiveJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveJobMutation, UnarchiveJobMutationVariables>(UnarchiveJobDocument, options);
      }
export type UnarchiveJobMutationHookResult = ReturnType<typeof useUnarchiveJobMutation>;
export type UnarchiveJobMutationResult = Apollo.MutationResult<UnarchiveJobMutation>;
export type UnarchiveJobMutationOptions = Apollo.BaseMutationOptions<UnarchiveJobMutation, UnarchiveJobMutationVariables>;
export const UpdateAiDisplayImageDocument = gql`
    mutation UpdateAiDisplayImage($id: Int!, $aiGeneratedImageId: Int, $favorited: Boolean) {
  updateAiDisplayImage(
    id: $id
    aiGeneratedImageId: $aiGeneratedImageId
    favorited: $favorited
  ) {
    ...AiDisplayImage
  }
}
    ${AiDisplayImageFragmentDoc}`;
export type UpdateAiDisplayImageMutationFn = Apollo.MutationFunction<UpdateAiDisplayImageMutation, UpdateAiDisplayImageMutationVariables>;

/**
 * __useUpdateAiDisplayImageMutation__
 *
 * To run a mutation, you first call `useUpdateAiDisplayImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiDisplayImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiDisplayImageMutation, { data, loading, error }] = useUpdateAiDisplayImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aiGeneratedImageId: // value for 'aiGeneratedImageId'
 *      favorited: // value for 'favorited'
 *   },
 * });
 */
export function useUpdateAiDisplayImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiDisplayImageMutation, UpdateAiDisplayImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiDisplayImageMutation, UpdateAiDisplayImageMutationVariables>(UpdateAiDisplayImageDocument, options);
      }
export type UpdateAiDisplayImageMutationHookResult = ReturnType<typeof useUpdateAiDisplayImageMutation>;
export type UpdateAiDisplayImageMutationResult = Apollo.MutationResult<UpdateAiDisplayImageMutation>;
export type UpdateAiDisplayImageMutationOptions = Apollo.BaseMutationOptions<UpdateAiDisplayImageMutation, UpdateAiDisplayImageMutationVariables>;
export const UpdateAiGeneratedImageDocument = gql`
    mutation UpdateAiGeneratedImage($id: Int!, $favorite: Boolean) {
  updateAiGeneratedImage(id: $id, favorite: $favorite) {
    ...AiGeneratedImage
  }
}
    ${AiGeneratedImageFragmentDoc}`;
export type UpdateAiGeneratedImageMutationFn = Apollo.MutationFunction<UpdateAiGeneratedImageMutation, UpdateAiGeneratedImageMutationVariables>;

/**
 * __useUpdateAiGeneratedImageMutation__
 *
 * To run a mutation, you first call `useUpdateAiGeneratedImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiGeneratedImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiGeneratedImageMutation, { data, loading, error }] = useUpdateAiGeneratedImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useUpdateAiGeneratedImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiGeneratedImageMutation, UpdateAiGeneratedImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiGeneratedImageMutation, UpdateAiGeneratedImageMutationVariables>(UpdateAiGeneratedImageDocument, options);
      }
export type UpdateAiGeneratedImageMutationHookResult = ReturnType<typeof useUpdateAiGeneratedImageMutation>;
export type UpdateAiGeneratedImageMutationResult = Apollo.MutationResult<UpdateAiGeneratedImageMutation>;
export type UpdateAiGeneratedImageMutationOptions = Apollo.BaseMutationOptions<UpdateAiGeneratedImageMutation, UpdateAiGeneratedImageMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: Int!, $job: JobUpdateArgs!) {
  updateJob(id: $id, job: $job) {
    id
    externalIdentifier
    name
  }
}
    `;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      job: // value for 'job'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const UpdateJobNoteDocument = gql`
    mutation UpdateJobNote($id: Int!, $note: NoteArgs!) {
  updateNote(id: $id, note: $note) {
    id
  }
}
    `;
export type UpdateJobNoteMutationFn = Apollo.MutationFunction<UpdateJobNoteMutation, UpdateJobNoteMutationVariables>;

/**
 * __useUpdateJobNoteMutation__
 *
 * To run a mutation, you first call `useUpdateJobNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobNoteMutation, { data, loading, error }] = useUpdateJobNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateJobNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobNoteMutation, UpdateJobNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobNoteMutation, UpdateJobNoteMutationVariables>(UpdateJobNoteDocument, options);
      }
export type UpdateJobNoteMutationHookResult = ReturnType<typeof useUpdateJobNoteMutation>;
export type UpdateJobNoteMutationResult = Apollo.MutationResult<UpdateJobNoteMutation>;
export type UpdateJobNoteMutationOptions = Apollo.BaseMutationOptions<UpdateJobNoteMutation, UpdateJobNoteMutationVariables>;
export const UpdateOrgDocument = gql`
    mutation UpdateOrg($org: OrgArgs!, $orgId: Int!) {
  updateOrg(org: $org, orgId: $orgId) {
    id
    name
  }
}
    `;
export type UpdateOrgMutationFn = Apollo.MutationFunction<UpdateOrgMutation, UpdateOrgMutationVariables>;

/**
 * __useUpdateOrgMutation__
 *
 * To run a mutation, you first call `useUpdateOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgMutation, { data, loading, error }] = useUpdateOrgMutation({
 *   variables: {
 *      org: // value for 'org'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useUpdateOrgMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgMutation, UpdateOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgMutation, UpdateOrgMutationVariables>(UpdateOrgDocument, options);
      }
export type UpdateOrgMutationHookResult = ReturnType<typeof useUpdateOrgMutation>;
export type UpdateOrgMutationResult = Apollo.MutationResult<UpdateOrgMutation>;
export type UpdateOrgMutationOptions = Apollo.BaseMutationOptions<UpdateOrgMutation, UpdateOrgMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $name: String) {
  updateProject(id: $id, name: $name) {
    id
    name
    scopeItems
    updatedAt
    createdAt
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($firstName: String, $mobilePhone: String, $consents: [ConsentArgs!]) {
  updateUser(
    user: {firstName: $firstName, mobilePhone: $mobilePhone, consents: $consents}
  ) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      mobilePhone: // value for 'mobilePhone'
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpgradeToProDocument = gql`
    mutation UpgradeToPro($userId: Int!, $orgId: Int!, $company: String!, $mobilePhone: String!, $zipCode: String!) {
  upgradeToPro(
    input: {company: $company, mobilePhone: $mobilePhone, zipCode: $zipCode, orgId: $orgId, userId: $userId}
  ) @rest(type: "UpgradeUser", path: "/orgs/{args.input.orgId}/users/{args.input.userId}/upgrade_to_pro", method: "POST", bodySerializer: "upgrade-to-pro") {
    user {
      id
      email
      intercomSha
    }
  }
}
    `;
export type UpgradeToProMutationFn = Apollo.MutationFunction<UpgradeToProMutation, UpgradeToProMutationVariables>;

/**
 * __useUpgradeToProMutation__
 *
 * To run a mutation, you first call `useUpgradeToProMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeToProMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeToProMutation, { data, loading, error }] = useUpgradeToProMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *      company: // value for 'company'
 *      mobilePhone: // value for 'mobilePhone'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpgradeToProMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeToProMutation, UpgradeToProMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeToProMutation, UpgradeToProMutationVariables>(UpgradeToProDocument, options);
      }
export type UpgradeToProMutationHookResult = ReturnType<typeof useUpgradeToProMutation>;
export type UpgradeToProMutationResult = Apollo.MutationResult<UpgradeToProMutation>;
export type UpgradeToProMutationOptions = Apollo.BaseMutationOptions<UpgradeToProMutation, UpgradeToProMutationVariables>;
export const UploadAiOriginalImageDocument = gql`
    mutation UploadAiOriginalImage($image: Upload!, $email: String, $spaceType: String, $jobClientIdentifier: String, $marketingConsent: String, $project: NewProjectArgs, $projectId: Int) {
  uploadAiOriginalImage(
    image: $image
    email: $email
    jobClientIdentifier: $jobClientIdentifier
    marketingConsent: $marketingConsent
    spaceType: $spaceType
    project: $project
    projectId: $projectId
  ) {
    ...AiOriginalImage
  }
}
    ${AiOriginalImageFragmentDoc}`;
export type UploadAiOriginalImageMutationFn = Apollo.MutationFunction<UploadAiOriginalImageMutation, UploadAiOriginalImageMutationVariables>;

/**
 * __useUploadAiOriginalImageMutation__
 *
 * To run a mutation, you first call `useUploadAiOriginalImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAiOriginalImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAiOriginalImageMutation, { data, loading, error }] = useUploadAiOriginalImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      email: // value for 'email'
 *      spaceType: // value for 'spaceType'
 *      jobClientIdentifier: // value for 'jobClientIdentifier'
 *      marketingConsent: // value for 'marketingConsent'
 *      project: // value for 'project'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUploadAiOriginalImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadAiOriginalImageMutation, UploadAiOriginalImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAiOriginalImageMutation, UploadAiOriginalImageMutationVariables>(UploadAiOriginalImageDocument, options);
      }
export type UploadAiOriginalImageMutationHookResult = ReturnType<typeof useUploadAiOriginalImageMutation>;
export type UploadAiOriginalImageMutationResult = Apollo.MutationResult<UploadAiOriginalImageMutation>;
export type UploadAiOriginalImageMutationOptions = Apollo.BaseMutationOptions<UploadAiOriginalImageMutation, UploadAiOriginalImageMutationVariables>;
export const XactGenerateSchemaWithLineItemsDocument = gql`
    mutation XactGenerateSchemaWithLineItems($generationArgs: XactSchemaWithLineItemGenerationRequestArgs!) {
  xactGenerateSchemaWithLineItems(generationArgs: $generationArgs) {
    xactProjectUpload {
      id
      state
    }
  }
}
    `;
export type XactGenerateSchemaWithLineItemsMutationFn = Apollo.MutationFunction<XactGenerateSchemaWithLineItemsMutation, XactGenerateSchemaWithLineItemsMutationVariables>;

/**
 * __useXactGenerateSchemaWithLineItemsMutation__
 *
 * To run a mutation, you first call `useXactGenerateSchemaWithLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useXactGenerateSchemaWithLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [xactGenerateSchemaWithLineItemsMutation, { data, loading, error }] = useXactGenerateSchemaWithLineItemsMutation({
 *   variables: {
 *      generationArgs: // value for 'generationArgs'
 *   },
 * });
 */
export function useXactGenerateSchemaWithLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<XactGenerateSchemaWithLineItemsMutation, XactGenerateSchemaWithLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<XactGenerateSchemaWithLineItemsMutation, XactGenerateSchemaWithLineItemsMutationVariables>(XactGenerateSchemaWithLineItemsDocument, options);
      }
export type XactGenerateSchemaWithLineItemsMutationHookResult = ReturnType<typeof useXactGenerateSchemaWithLineItemsMutation>;
export type XactGenerateSchemaWithLineItemsMutationResult = Apollo.MutationResult<XactGenerateSchemaWithLineItemsMutation>;
export type XactGenerateSchemaWithLineItemsMutationOptions = Apollo.BaseMutationOptions<XactGenerateSchemaWithLineItemsMutation, XactGenerateSchemaWithLineItemsMutationVariables>;
export const DeleteCaptureRequestDocument = gql`
    mutation deleteCaptureRequest($id: Int!) {
  deleteCaptureRequest(id: $id) {
    id
  }
}
    `;
export type DeleteCaptureRequestMutationFn = Apollo.MutationFunction<DeleteCaptureRequestMutation, DeleteCaptureRequestMutationVariables>;

/**
 * __useDeleteCaptureRequestMutation__
 *
 * To run a mutation, you first call `useDeleteCaptureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaptureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaptureRequestMutation, { data, loading, error }] = useDeleteCaptureRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCaptureRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaptureRequestMutation, DeleteCaptureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaptureRequestMutation, DeleteCaptureRequestMutationVariables>(DeleteCaptureRequestDocument, options);
      }
export type DeleteCaptureRequestMutationHookResult = ReturnType<typeof useDeleteCaptureRequestMutation>;
export type DeleteCaptureRequestMutationResult = Apollo.MutationResult<DeleteCaptureRequestMutation>;
export type DeleteCaptureRequestMutationOptions = Apollo.BaseMutationOptions<DeleteCaptureRequestMutation, DeleteCaptureRequestMutationVariables>;
export const SendCaptureRequestNotificationDocument = gql`
    mutation sendCaptureRequestNotification($id: Int!) {
  sendCaptureRequestNotification(id: $id) {
    id
  }
}
    `;
export type SendCaptureRequestNotificationMutationFn = Apollo.MutationFunction<SendCaptureRequestNotificationMutation, SendCaptureRequestNotificationMutationVariables>;

/**
 * __useSendCaptureRequestNotificationMutation__
 *
 * To run a mutation, you first call `useSendCaptureRequestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCaptureRequestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCaptureRequestNotificationMutation, { data, loading, error }] = useSendCaptureRequestNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendCaptureRequestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendCaptureRequestNotificationMutation, SendCaptureRequestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCaptureRequestNotificationMutation, SendCaptureRequestNotificationMutationVariables>(SendCaptureRequestNotificationDocument, options);
      }
export type SendCaptureRequestNotificationMutationHookResult = ReturnType<typeof useSendCaptureRequestNotificationMutation>;
export type SendCaptureRequestNotificationMutationResult = Apollo.MutationResult<SendCaptureRequestNotificationMutation>;
export type SendCaptureRequestNotificationMutationOptions = Apollo.BaseMutationOptions<SendCaptureRequestNotificationMutation, SendCaptureRequestNotificationMutationVariables>;
export const AffiliatesDocument = gql`
    query Affiliates($partnerIdentifier: PartnersWithAffiliateOrgsIdentifiers!, $search: String!) {
  affiliateOrgsForPartner(partnerIdentifier: $partnerIdentifier, search: $search) {
    results {
      id
      customerDisplayName
      orgCode {
        code
      }
    }
  }
}
    `;

/**
 * __useAffiliatesQuery__
 *
 * To run a query within a React component, call `useAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatesQuery({
 *   variables: {
 *      partnerIdentifier: // value for 'partnerIdentifier'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAffiliatesQuery(baseOptions: Apollo.QueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliatesQuery, AffiliatesQueryVariables>(AffiliatesDocument, options);
      }
export function useAffiliatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliatesQuery, AffiliatesQueryVariables>(AffiliatesDocument, options);
        }
export type AffiliatesQueryHookResult = ReturnType<typeof useAffiliatesQuery>;
export type AffiliatesLazyQueryHookResult = ReturnType<typeof useAffiliatesLazyQuery>;
export type AffiliatesQueryResult = Apollo.QueryResult<AffiliatesQuery, AffiliatesQueryVariables>;
export const AiAvailableConfigurationsDocument = gql`
    query AiAvailableConfigurations($spaceType: String, $orgId: Int) {
  aiAvailableConfigurations(spaceType: $spaceType, orgId: $orgId) {
    styles
    paintColors {
      id
      palettes
      paintRegions
      name
      hex
      manufacturer
      samplizeProductKey
    }
    materials {
      ...AiMaterial
    }
  }
}
    ${AiMaterialFragmentDoc}`;

/**
 * __useAiAvailableConfigurationsQuery__
 *
 * To run a query within a React component, call `useAiAvailableConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAvailableConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiAvailableConfigurationsQuery({
 *   variables: {
 *      spaceType: // value for 'spaceType'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAiAvailableConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<AiAvailableConfigurationsQuery, AiAvailableConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiAvailableConfigurationsQuery, AiAvailableConfigurationsQueryVariables>(AiAvailableConfigurationsDocument, options);
      }
export function useAiAvailableConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiAvailableConfigurationsQuery, AiAvailableConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiAvailableConfigurationsQuery, AiAvailableConfigurationsQueryVariables>(AiAvailableConfigurationsDocument, options);
        }
export type AiAvailableConfigurationsQueryHookResult = ReturnType<typeof useAiAvailableConfigurationsQuery>;
export type AiAvailableConfigurationsLazyQueryHookResult = ReturnType<typeof useAiAvailableConfigurationsLazyQuery>;
export type AiAvailableConfigurationsQueryResult = Apollo.QueryResult<AiAvailableConfigurationsQuery, AiAvailableConfigurationsQueryVariables>;
export const AiDisplayImageDocument = gql`
    query AiDisplayImage($id: Int!) {
  aiDisplayImage(id: $id) {
    ...AiDisplayImage
  }
}
    ${AiDisplayImageFragmentDoc}`;

/**
 * __useAiDisplayImageQuery__
 *
 * To run a query within a React component, call `useAiDisplayImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDisplayImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDisplayImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiDisplayImageQuery(baseOptions: Apollo.QueryHookOptions<AiDisplayImageQuery, AiDisplayImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiDisplayImageQuery, AiDisplayImageQueryVariables>(AiDisplayImageDocument, options);
      }
export function useAiDisplayImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiDisplayImageQuery, AiDisplayImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiDisplayImageQuery, AiDisplayImageQueryVariables>(AiDisplayImageDocument, options);
        }
export type AiDisplayImageQueryHookResult = ReturnType<typeof useAiDisplayImageQuery>;
export type AiDisplayImageLazyQueryHookResult = ReturnType<typeof useAiDisplayImageLazyQuery>;
export type AiDisplayImageQueryResult = Apollo.QueryResult<AiDisplayImageQuery, AiDisplayImageQueryVariables>;
export const AiDisplayImagesDocument = gql`
    query AiDisplayImages($aiOriginalImageId: Int, $favorite: Boolean, $page: Int, $perPage: Int) {
  aiDisplayImages(
    aiOriginalImageId: $aiOriginalImageId
    favorite: $favorite
    page: $page
    perPage: $perPage
  ) {
    pagination {
      ...Pagination
    }
    results {
      ...AiDisplayImage
    }
  }
}
    ${PaginationFragmentDoc}
${AiDisplayImageFragmentDoc}`;

/**
 * __useAiDisplayImagesQuery__
 *
 * To run a query within a React component, call `useAiDisplayImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiDisplayImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiDisplayImagesQuery({
 *   variables: {
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      favorite: // value for 'favorite'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAiDisplayImagesQuery(baseOptions?: Apollo.QueryHookOptions<AiDisplayImagesQuery, AiDisplayImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiDisplayImagesQuery, AiDisplayImagesQueryVariables>(AiDisplayImagesDocument, options);
      }
export function useAiDisplayImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiDisplayImagesQuery, AiDisplayImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiDisplayImagesQuery, AiDisplayImagesQueryVariables>(AiDisplayImagesDocument, options);
        }
export type AiDisplayImagesQueryHookResult = ReturnType<typeof useAiDisplayImagesQuery>;
export type AiDisplayImagesLazyQueryHookResult = ReturnType<typeof useAiDisplayImagesLazyQuery>;
export type AiDisplayImagesQueryResult = Apollo.QueryResult<AiDisplayImagesQuery, AiDisplayImagesQueryVariables>;
export const AiGeneratedImageDocument = gql`
    query AiGeneratedImage($id: String!) {
  aiGeneratedImage(id: $id) {
    ...AiGeneratedImage
  }
}
    ${AiGeneratedImageFragmentDoc}`;

/**
 * __useAiGeneratedImageQuery__
 *
 * To run a query within a React component, call `useAiGeneratedImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiGeneratedImageQuery(baseOptions: Apollo.QueryHookOptions<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>(AiGeneratedImageDocument, options);
      }
export function useAiGeneratedImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>(AiGeneratedImageDocument, options);
        }
export type AiGeneratedImageQueryHookResult = ReturnType<typeof useAiGeneratedImageQuery>;
export type AiGeneratedImageLazyQueryHookResult = ReturnType<typeof useAiGeneratedImageLazyQuery>;
export type AiGeneratedImageQueryResult = Apollo.QueryResult<AiGeneratedImageQuery, AiGeneratedImageQueryVariables>;
export const AiGeneratedImageRegionsDocument = gql`
    query AiGeneratedImageRegions($id: String!) {
  aiGeneratedImage(id: $id) {
    id
    regions
  }
}
    `;

/**
 * __useAiGeneratedImageRegionsQuery__
 *
 * To run a query within a React component, call `useAiGeneratedImageRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedImageRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedImageRegionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiGeneratedImageRegionsQuery(baseOptions: Apollo.QueryHookOptions<AiGeneratedImageRegionsQuery, AiGeneratedImageRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGeneratedImageRegionsQuery, AiGeneratedImageRegionsQueryVariables>(AiGeneratedImageRegionsDocument, options);
      }
export function useAiGeneratedImageRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGeneratedImageRegionsQuery, AiGeneratedImageRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGeneratedImageRegionsQuery, AiGeneratedImageRegionsQueryVariables>(AiGeneratedImageRegionsDocument, options);
        }
export type AiGeneratedImageRegionsQueryHookResult = ReturnType<typeof useAiGeneratedImageRegionsQuery>;
export type AiGeneratedImageRegionsLazyQueryHookResult = ReturnType<typeof useAiGeneratedImageRegionsLazyQuery>;
export type AiGeneratedImageRegionsQueryResult = Apollo.QueryResult<AiGeneratedImageRegionsQuery, AiGeneratedImageRegionsQueryVariables>;
export const AiGeneratedImageSegmentationDocument = gql`
    query AiGeneratedImageSegmentation($id: String!) {
  aiGeneratedImage(id: $id) {
    aiSegmentation {
      id
      instanceSvg
      regionStatistics
    }
  }
}
    `;

/**
 * __useAiGeneratedImageSegmentationQuery__
 *
 * To run a query within a React component, call `useAiGeneratedImageSegmentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedImageSegmentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedImageSegmentationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiGeneratedImageSegmentationQuery(baseOptions: Apollo.QueryHookOptions<AiGeneratedImageSegmentationQuery, AiGeneratedImageSegmentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGeneratedImageSegmentationQuery, AiGeneratedImageSegmentationQueryVariables>(AiGeneratedImageSegmentationDocument, options);
      }
export function useAiGeneratedImageSegmentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGeneratedImageSegmentationQuery, AiGeneratedImageSegmentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGeneratedImageSegmentationQuery, AiGeneratedImageSegmentationQueryVariables>(AiGeneratedImageSegmentationDocument, options);
        }
export type AiGeneratedImageSegmentationQueryHookResult = ReturnType<typeof useAiGeneratedImageSegmentationQuery>;
export type AiGeneratedImageSegmentationLazyQueryHookResult = ReturnType<typeof useAiGeneratedImageSegmentationLazyQuery>;
export type AiGeneratedImageSegmentationQueryResult = Apollo.QueryResult<AiGeneratedImageSegmentationQuery, AiGeneratedImageSegmentationQueryVariables>;
export const AiGeneratedImagesDocument = gql`
    query AiGeneratedImages($aiOriginalImageId: Int, $favorite: Boolean, $page: Int, $perPage: Int) {
  aiGeneratedImages(
    aiOriginalImageId: $aiOriginalImageId
    favorite: $favorite
    page: $page
    perPage: $perPage
  ) {
    pagination {
      ...Pagination
    }
    results {
      ...AiGeneratedImage
    }
  }
}
    ${PaginationFragmentDoc}
${AiGeneratedImageFragmentDoc}`;

/**
 * __useAiGeneratedImagesQuery__
 *
 * To run a query within a React component, call `useAiGeneratedImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedImagesQuery({
 *   variables: {
 *      aiOriginalImageId: // value for 'aiOriginalImageId'
 *      favorite: // value for 'favorite'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAiGeneratedImagesQuery(baseOptions?: Apollo.QueryHookOptions<AiGeneratedImagesQuery, AiGeneratedImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGeneratedImagesQuery, AiGeneratedImagesQueryVariables>(AiGeneratedImagesDocument, options);
      }
export function useAiGeneratedImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGeneratedImagesQuery, AiGeneratedImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGeneratedImagesQuery, AiGeneratedImagesQueryVariables>(AiGeneratedImagesDocument, options);
        }
export type AiGeneratedImagesQueryHookResult = ReturnType<typeof useAiGeneratedImagesQuery>;
export type AiGeneratedImagesLazyQueryHookResult = ReturnType<typeof useAiGeneratedImagesLazyQuery>;
export type AiGeneratedImagesQueryResult = Apollo.QueryResult<AiGeneratedImagesQuery, AiGeneratedImagesQueryVariables>;
export const AiGeneratedWatermarkImageDocument = gql`
    query AiGeneratedWatermarkImage($id: String!) {
  aiGeneratedWatermarkImage(id: $id) {
    id
    watermarkImageUrl
  }
}
    `;

/**
 * __useAiGeneratedWatermarkImageQuery__
 *
 * To run a query within a React component, call `useAiGeneratedWatermarkImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGeneratedWatermarkImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGeneratedWatermarkImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiGeneratedWatermarkImageQuery(baseOptions: Apollo.QueryHookOptions<AiGeneratedWatermarkImageQuery, AiGeneratedWatermarkImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGeneratedWatermarkImageQuery, AiGeneratedWatermarkImageQueryVariables>(AiGeneratedWatermarkImageDocument, options);
      }
export function useAiGeneratedWatermarkImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGeneratedWatermarkImageQuery, AiGeneratedWatermarkImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGeneratedWatermarkImageQuery, AiGeneratedWatermarkImageQueryVariables>(AiGeneratedWatermarkImageDocument, options);
        }
export type AiGeneratedWatermarkImageQueryHookResult = ReturnType<typeof useAiGeneratedWatermarkImageQuery>;
export type AiGeneratedWatermarkImageLazyQueryHookResult = ReturnType<typeof useAiGeneratedWatermarkImageLazyQuery>;
export type AiGeneratedWatermarkImageQueryResult = Apollo.QueryResult<AiGeneratedWatermarkImageQuery, AiGeneratedWatermarkImageQueryVariables>;
export const AiOriginalImageDocument = gql`
    query AiOriginalImage($id: String, $style: String, $featured: Boolean = false) {
  aiOriginalImage(id: $id) {
    ...AiOriginalImage
    aiDisplayImages(style: $style, featured: $featured) {
      ...AiDisplayImage
    }
  }
}
    ${AiOriginalImageFragmentDoc}
${AiDisplayImageFragmentDoc}`;

/**
 * __useAiOriginalImageQuery__
 *
 * To run a query within a React component, call `useAiOriginalImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOriginalImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOriginalImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      style: // value for 'style'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useAiOriginalImageQuery(baseOptions?: Apollo.QueryHookOptions<AiOriginalImageQuery, AiOriginalImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiOriginalImageQuery, AiOriginalImageQueryVariables>(AiOriginalImageDocument, options);
      }
export function useAiOriginalImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiOriginalImageQuery, AiOriginalImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiOriginalImageQuery, AiOriginalImageQueryVariables>(AiOriginalImageDocument, options);
        }
export type AiOriginalImageQueryHookResult = ReturnType<typeof useAiOriginalImageQuery>;
export type AiOriginalImageLazyQueryHookResult = ReturnType<typeof useAiOriginalImageLazyQuery>;
export type AiOriginalImageQueryResult = Apollo.QueryResult<AiOriginalImageQuery, AiOriginalImageQueryVariables>;
export const AiOriginalImageAnonymousDocument = gql`
    query AiOriginalImageAnonymous($id: String, $style: String, $featured: Boolean = false) {
  aiOriginalImageAnonymous(id: $id) {
    ...AiOriginalImage
    aiDisplayImages(style: $style, featured: $featured) {
      ...AiDisplayImage
    }
  }
}
    ${AiOriginalImageFragmentDoc}
${AiDisplayImageFragmentDoc}`;

/**
 * __useAiOriginalImageAnonymousQuery__
 *
 * To run a query within a React component, call `useAiOriginalImageAnonymousQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOriginalImageAnonymousQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOriginalImageAnonymousQuery({
 *   variables: {
 *      id: // value for 'id'
 *      style: // value for 'style'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useAiOriginalImageAnonymousQuery(baseOptions?: Apollo.QueryHookOptions<AiOriginalImageAnonymousQuery, AiOriginalImageAnonymousQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiOriginalImageAnonymousQuery, AiOriginalImageAnonymousQueryVariables>(AiOriginalImageAnonymousDocument, options);
      }
export function useAiOriginalImageAnonymousLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiOriginalImageAnonymousQuery, AiOriginalImageAnonymousQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiOriginalImageAnonymousQuery, AiOriginalImageAnonymousQueryVariables>(AiOriginalImageAnonymousDocument, options);
        }
export type AiOriginalImageAnonymousQueryHookResult = ReturnType<typeof useAiOriginalImageAnonymousQuery>;
export type AiOriginalImageAnonymousLazyQueryHookResult = ReturnType<typeof useAiOriginalImageAnonymousLazyQuery>;
export type AiOriginalImageAnonymousQueryResult = Apollo.QueryResult<AiOriginalImageAnonymousQuery, AiOriginalImageAnonymousQueryVariables>;
export const GetAiOriginalImageOrientationDocument = gql`
    query GetAiOriginalImageOrientation($id: String!) {
  aiOriginalImage(id: $id) {
    orientation
  }
}
    `;

/**
 * __useGetAiOriginalImageOrientationQuery__
 *
 * To run a query within a React component, call `useGetAiOriginalImageOrientationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiOriginalImageOrientationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiOriginalImageOrientationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiOriginalImageOrientationQuery(baseOptions: Apollo.QueryHookOptions<GetAiOriginalImageOrientationQuery, GetAiOriginalImageOrientationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiOriginalImageOrientationQuery, GetAiOriginalImageOrientationQueryVariables>(GetAiOriginalImageOrientationDocument, options);
      }
export function useGetAiOriginalImageOrientationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiOriginalImageOrientationQuery, GetAiOriginalImageOrientationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiOriginalImageOrientationQuery, GetAiOriginalImageOrientationQueryVariables>(GetAiOriginalImageOrientationDocument, options);
        }
export type GetAiOriginalImageOrientationQueryHookResult = ReturnType<typeof useGetAiOriginalImageOrientationQuery>;
export type GetAiOriginalImageOrientationLazyQueryHookResult = ReturnType<typeof useGetAiOriginalImageOrientationLazyQuery>;
export type GetAiOriginalImageOrientationQueryResult = Apollo.QueryResult<GetAiOriginalImageOrientationQuery, GetAiOriginalImageOrientationQueryVariables>;
export const AiOriginalImagesDocument = gql`
    query AiOriginalImages {
  aiOriginalImages {
    ...AiOriginalImage
    aiGeneratedImages(first: 1) {
      id
      status
      style
      generatedImagePath
      thumbnailUrl
      favorite
      aiOriginalImageId
      baseImageId
      imagePath
      spaceType
      createdAt
      updatedAt
      is3dFusionCompatible
      pollingConsumerId @client
      clientStatus @client
      fromSample
    }
  }
}
    ${AiOriginalImageFragmentDoc}`;

/**
 * __useAiOriginalImagesQuery__
 *
 * To run a query within a React component, call `useAiOriginalImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiOriginalImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiOriginalImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiOriginalImagesQuery(baseOptions?: Apollo.QueryHookOptions<AiOriginalImagesQuery, AiOriginalImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiOriginalImagesQuery, AiOriginalImagesQueryVariables>(AiOriginalImagesDocument, options);
      }
export function useAiOriginalImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiOriginalImagesQuery, AiOriginalImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiOriginalImagesQuery, AiOriginalImagesQueryVariables>(AiOriginalImagesDocument, options);
        }
export type AiOriginalImagesQueryHookResult = ReturnType<typeof useAiOriginalImagesQuery>;
export type AiOriginalImagesLazyQueryHookResult = ReturnType<typeof useAiOriginalImagesLazyQuery>;
export type AiOriginalImagesQueryResult = Apollo.QueryResult<AiOriginalImagesQuery, AiOriginalImagesQueryVariables>;
export const AiSpaceTypesDocument = gql`
    query AiSpaceTypes($orgId: Int, $publicIdentifier: String) {
  aiSpaceTypes(orgId: $orgId, publicIdentifier: $publicIdentifier) {
    spaceTypes
  }
}
    `;

/**
 * __useAiSpaceTypesQuery__
 *
 * To run a query within a React component, call `useAiSpaceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSpaceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSpaceTypesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      publicIdentifier: // value for 'publicIdentifier'
 *   },
 * });
 */
export function useAiSpaceTypesQuery(baseOptions?: Apollo.QueryHookOptions<AiSpaceTypesQuery, AiSpaceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiSpaceTypesQuery, AiSpaceTypesQueryVariables>(AiSpaceTypesDocument, options);
      }
export function useAiSpaceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiSpaceTypesQuery, AiSpaceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiSpaceTypesQuery, AiSpaceTypesQueryVariables>(AiSpaceTypesDocument, options);
        }
export type AiSpaceTypesQueryHookResult = ReturnType<typeof useAiSpaceTypesQuery>;
export type AiSpaceTypesLazyQueryHookResult = ReturnType<typeof useAiSpaceTypesLazyQuery>;
export type AiSpaceTypesQueryResult = Apollo.QueryResult<AiSpaceTypesQuery, AiSpaceTypesQueryVariables>;
export const AiStylesMetadataDocument = gql`
    query AiStylesMetadata($spaceType: String!) {
  aiStylesMetadata(spaceType: $spaceType) {
    metadata
  }
}
    `;

/**
 * __useAiStylesMetadataQuery__
 *
 * To run a query within a React component, call `useAiStylesMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiStylesMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiStylesMetadataQuery({
 *   variables: {
 *      spaceType: // value for 'spaceType'
 *   },
 * });
 */
export function useAiStylesMetadataQuery(baseOptions: Apollo.QueryHookOptions<AiStylesMetadataQuery, AiStylesMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiStylesMetadataQuery, AiStylesMetadataQueryVariables>(AiStylesMetadataDocument, options);
      }
export function useAiStylesMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiStylesMetadataQuery, AiStylesMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiStylesMetadataQuery, AiStylesMetadataQueryVariables>(AiStylesMetadataDocument, options);
        }
export type AiStylesMetadataQueryHookResult = ReturnType<typeof useAiStylesMetadataQuery>;
export type AiStylesMetadataLazyQueryHookResult = ReturnType<typeof useAiStylesMetadataLazyQuery>;
export type AiStylesMetadataQueryResult = Apollo.QueryResult<AiStylesMetadataQuery, AiStylesMetadataQueryVariables>;
export const AuthenticationInfoDocument = gql`
    query AuthenticationInfo($email: String!, $redirectPath: String) {
  authenticationInfo(email: $email, redirectPath: $redirectPath) {
    ssoEnabled
    ssoSpSigninUrl
    ssoStrictModeEnabled
    emailInUse
  }
}
    `;

/**
 * __useAuthenticationInfoQuery__
 *
 * To run a query within a React component, call `useAuthenticationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *      redirectPath: // value for 'redirectPath'
 *   },
 * });
 */
export function useAuthenticationInfoQuery(baseOptions: Apollo.QueryHookOptions<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>(AuthenticationInfoDocument, options);
      }
export function useAuthenticationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>(AuthenticationInfoDocument, options);
        }
export type AuthenticationInfoQueryHookResult = ReturnType<typeof useAuthenticationInfoQuery>;
export type AuthenticationInfoLazyQueryHookResult = ReturnType<typeof useAuthenticationInfoLazyQuery>;
export type AuthenticationInfoQueryResult = Apollo.QueryResult<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>;
export const BeaconUserDocument = gql`
    query BeaconUser($email: String!) {
  beaconUser(input: {email: $email}) @rest(type: "BeaconUser", path: "/beacon/user_exists.json", method: "POST", endpoint: "partners", bodySerializer: "form-url") {
    response
    beacon_user
    beacon_org
  }
}
    `;

/**
 * __useBeaconUserQuery__
 *
 * To run a query within a React component, call `useBeaconUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeaconUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeaconUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useBeaconUserQuery(baseOptions: Apollo.QueryHookOptions<BeaconUserQuery, BeaconUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeaconUserQuery, BeaconUserQueryVariables>(BeaconUserDocument, options);
      }
export function useBeaconUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeaconUserQuery, BeaconUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeaconUserQuery, BeaconUserQueryVariables>(BeaconUserDocument, options);
        }
export type BeaconUserQueryHookResult = ReturnType<typeof useBeaconUserQuery>;
export type BeaconUserLazyQueryHookResult = ReturnType<typeof useBeaconUserLazyQuery>;
export type BeaconUserQueryResult = Apollo.QueryResult<BeaconUserQuery, BeaconUserQueryVariables>;
export const DesignOrderSummaryDocument = gql`
    query DesignOrderSummary($hiDefRenderingVersionId: Int!, $token: String!) {
  designOrderSummary(id: $hiDefRenderingVersionId, token: $token) {
    designOrderResponse {
      designOrders {
        scopeItems {
          additionalDetails
          images
          trade
          extent
        }
        colorPalette
        style
        views
        additionalDetails
      }
      packageType
    }
    jobId
    orderId
    orgId
    requestingUserId
    versionType
  }
}
    `;

/**
 * __useDesignOrderSummaryQuery__
 *
 * To run a query within a React component, call `useDesignOrderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignOrderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignOrderSummaryQuery({
 *   variables: {
 *      hiDefRenderingVersionId: // value for 'hiDefRenderingVersionId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDesignOrderSummaryQuery(baseOptions: Apollo.QueryHookOptions<DesignOrderSummaryQuery, DesignOrderSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignOrderSummaryQuery, DesignOrderSummaryQueryVariables>(DesignOrderSummaryDocument, options);
      }
export function useDesignOrderSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignOrderSummaryQuery, DesignOrderSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignOrderSummaryQuery, DesignOrderSummaryQueryVariables>(DesignOrderSummaryDocument, options);
        }
export type DesignOrderSummaryQueryHookResult = ReturnType<typeof useDesignOrderSummaryQuery>;
export type DesignOrderSummaryLazyQueryHookResult = ReturnType<typeof useDesignOrderSummaryLazyQuery>;
export type DesignOrderSummaryQueryResult = Apollo.QueryResult<DesignOrderSummaryQuery, DesignOrderSummaryQueryVariables>;
export const DesignStudioProductDataDocument = gql`
    query DesignStudioProductData($themeName: DesignStudioThemeEnum) {
  designStudioProductData(themeName: $themeName) {
    colors {
      color
      group
      name
      trim
    }
    textures {
      category
      shape
      size
      style
      textureId
      type
      colorGroup
      hasThumbnail
      isPopular
      name
      textureType
      thumbnail
    }
    windowColors {
      color
      group
      name
      trim
    }
  }
}
    `;

/**
 * __useDesignStudioProductDataQuery__
 *
 * To run a query within a React component, call `useDesignStudioProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignStudioProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignStudioProductDataQuery({
 *   variables: {
 *      themeName: // value for 'themeName'
 *   },
 * });
 */
export function useDesignStudioProductDataQuery(baseOptions?: Apollo.QueryHookOptions<DesignStudioProductDataQuery, DesignStudioProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignStudioProductDataQuery, DesignStudioProductDataQueryVariables>(DesignStudioProductDataDocument, options);
      }
export function useDesignStudioProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignStudioProductDataQuery, DesignStudioProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignStudioProductDataQuery, DesignStudioProductDataQueryVariables>(DesignStudioProductDataDocument, options);
        }
export type DesignStudioProductDataQueryHookResult = ReturnType<typeof useDesignStudioProductDataQuery>;
export type DesignStudioProductDataLazyQueryHookResult = ReturnType<typeof useDesignStudioProductDataLazyQuery>;
export type DesignStudioProductDataQueryResult = Apollo.QueryResult<DesignStudioProductDataQuery, DesignStudioProductDataQueryVariables>;
export const DetectUserSessionDocument = gql`
    query DetectUserSession {
  profile {
    user {
      id
      email
      orgs(first: 1) {
        createdAt
        isManaged
        id
        partner {
          kind
        }
      }
    }
  }
}
    `;

/**
 * __useDetectUserSessionQuery__
 *
 * To run a query within a React component, call `useDetectUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectUserSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectUserSessionQuery(baseOptions?: Apollo.QueryHookOptions<DetectUserSessionQuery, DetectUserSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectUserSessionQuery, DetectUserSessionQueryVariables>(DetectUserSessionDocument, options);
      }
export function useDetectUserSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectUserSessionQuery, DetectUserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectUserSessionQuery, DetectUserSessionQueryVariables>(DetectUserSessionDocument, options);
        }
export type DetectUserSessionQueryHookResult = ReturnType<typeof useDetectUserSessionQuery>;
export type DetectUserSessionLazyQueryHookResult = ReturnType<typeof useDetectUserSessionLazyQuery>;
export type DetectUserSessionQueryResult = Apollo.QueryResult<DetectUserSessionQuery, DetectUserSessionQueryVariables>;
export const EstimationEstimateGroupsDocument = gql`
    query EstimationEstimateGroups($jobId: ID, $active: Boolean = true) {
  estimationEstimateGroups(jobId: $jobId) {
    nodes {
      id
      createdAt
      updatedAt
      totalCost
      totalPrice
      name
      estimates(active: $active) {
        id
        name
      }
      salesOpportunity {
        id
        soldEstimateGroupId
      }
      proposalDocuments {
        id
        createdAt
        updatedAt
        totalPrice
        state
        signatureRequest {
          state
        }
      }
    }
  }
}
    `;

/**
 * __useEstimationEstimateGroupsQuery__
 *
 * To run a query within a React component, call `useEstimationEstimateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimationEstimateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimationEstimateGroupsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useEstimationEstimateGroupsQuery(baseOptions?: Apollo.QueryHookOptions<EstimationEstimateGroupsQuery, EstimationEstimateGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimationEstimateGroupsQuery, EstimationEstimateGroupsQueryVariables>(EstimationEstimateGroupsDocument, options);
      }
export function useEstimationEstimateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimationEstimateGroupsQuery, EstimationEstimateGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimationEstimateGroupsQuery, EstimationEstimateGroupsQueryVariables>(EstimationEstimateGroupsDocument, options);
        }
export type EstimationEstimateGroupsQueryHookResult = ReturnType<typeof useEstimationEstimateGroupsQuery>;
export type EstimationEstimateGroupsLazyQueryHookResult = ReturnType<typeof useEstimationEstimateGroupsLazyQuery>;
export type EstimationEstimateGroupsQueryResult = Apollo.QueryResult<EstimationEstimateGroupsQuery, EstimationEstimateGroupsQueryVariables>;
export const GenericProductSettingsDocument = gql`
    query GenericProductSettings($orgId: ID!) {
  productCatalogConfigGenericProductSetting(orgId: $orgId) {
    settings
  }
}
    `;

/**
 * __useGenericProductSettingsQuery__
 *
 * To run a query within a React component, call `useGenericProductSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericProductSettingsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGenericProductSettingsQuery(baseOptions: Apollo.QueryHookOptions<GenericProductSettingsQuery, GenericProductSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericProductSettingsQuery, GenericProductSettingsQueryVariables>(GenericProductSettingsDocument, options);
      }
export function useGenericProductSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericProductSettingsQuery, GenericProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericProductSettingsQuery, GenericProductSettingsQueryVariables>(GenericProductSettingsDocument, options);
        }
export type GenericProductSettingsQueryHookResult = ReturnType<typeof useGenericProductSettingsQuery>;
export type GenericProductSettingsLazyQueryHookResult = ReturnType<typeof useGenericProductSettingsLazyQuery>;
export type GenericProductSettingsQueryResult = Apollo.QueryResult<GenericProductSettingsQuery, GenericProductSettingsQueryVariables>;
export const GetAlbumsDocument = gql`
    query GetAlbums($id: Int!) {
  jobs(ids: [$id]) {
    results {
      id
      createdAt
      albums {
        ...AlbumFragment
      }
      ...JobImagesFragment
    }
  }
}
    ${AlbumFragmentFragmentDoc}
${JobImagesFragmentFragmentDoc}`;

/**
 * __useGetAlbumsQuery__
 *
 * To run a query within a React component, call `useGetAlbumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlbumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlbumsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlbumsQuery(baseOptions: Apollo.QueryHookOptions<GetAlbumsQuery, GetAlbumsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlbumsQuery, GetAlbumsQueryVariables>(GetAlbumsDocument, options);
      }
export function useGetAlbumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlbumsQuery, GetAlbumsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlbumsQuery, GetAlbumsQueryVariables>(GetAlbumsDocument, options);
        }
export type GetAlbumsQueryHookResult = ReturnType<typeof useGetAlbumsQuery>;
export type GetAlbumsLazyQueryHookResult = ReturnType<typeof useGetAlbumsLazyQuery>;
export type GetAlbumsQueryResult = Apollo.QueryResult<GetAlbumsQuery, GetAlbumsQueryVariables>;
export const BlueprintSubmissionsDocument = gql`
    query blueprintSubmissions {
  blueprintSubmissions(states: [CREATED, FAILED]) {
    pagination {
      hasNextPage
    }
    results {
      id
      name
      createdAt
      state
      fileAttachments {
        filename
        url
        id
      }
    }
  }
}
    `;

/**
 * __useBlueprintSubmissionsQuery__
 *
 * To run a query within a React component, call `useBlueprintSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBlueprintSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<BlueprintSubmissionsQuery, BlueprintSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintSubmissionsQuery, BlueprintSubmissionsQueryVariables>(BlueprintSubmissionsDocument, options);
      }
export function useBlueprintSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintSubmissionsQuery, BlueprintSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintSubmissionsQuery, BlueprintSubmissionsQueryVariables>(BlueprintSubmissionsDocument, options);
        }
export type BlueprintSubmissionsQueryHookResult = ReturnType<typeof useBlueprintSubmissionsQuery>;
export type BlueprintSubmissionsLazyQueryHookResult = ReturnType<typeof useBlueprintSubmissionsLazyQuery>;
export type BlueprintSubmissionsQueryResult = Apollo.QueryResult<BlueprintSubmissionsQuery, BlueprintSubmissionsQueryVariables>;
export const GetConsentPoliciesDocument = gql`
    query GetConsentPolicies($kinds: [ConsentPolicyKinds!]!) {
  consentPolicies(kinds: $kinds) {
    kind
    summary
    content
    id
  }
}
    `;

/**
 * __useGetConsentPoliciesQuery__
 *
 * To run a query within a React component, call `useGetConsentPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsentPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsentPoliciesQuery({
 *   variables: {
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useGetConsentPoliciesQuery(baseOptions: Apollo.QueryHookOptions<GetConsentPoliciesQuery, GetConsentPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsentPoliciesQuery, GetConsentPoliciesQueryVariables>(GetConsentPoliciesDocument, options);
      }
export function useGetConsentPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsentPoliciesQuery, GetConsentPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsentPoliciesQuery, GetConsentPoliciesQueryVariables>(GetConsentPoliciesDocument, options);
        }
export type GetConsentPoliciesQueryHookResult = ReturnType<typeof useGetConsentPoliciesQuery>;
export type GetConsentPoliciesLazyQueryHookResult = ReturnType<typeof useGetConsentPoliciesLazyQuery>;
export type GetConsentPoliciesQueryResult = Apollo.QueryResult<GetConsentPoliciesQuery, GetConsentPoliciesQueryVariables>;
export const GetDoorProductsDocument = gql`
    query GetDoorProducts {
  productCatalogProductsByTag(tag: "design-studio-doors") {
    nodes {
      id
      name
      labelId
      variations {
        id
        name
        color {
          hex
        }
        textureId
        texture {
          repeatable
          width
          height
        }
      }
    }
  }
}
    `;

/**
 * __useGetDoorProductsQuery__
 *
 * To run a query within a React component, call `useGetDoorProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDoorProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDoorProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDoorProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetDoorProductsQuery, GetDoorProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDoorProductsQuery, GetDoorProductsQueryVariables>(GetDoorProductsDocument, options);
      }
export function useGetDoorProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDoorProductsQuery, GetDoorProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDoorProductsQuery, GetDoorProductsQueryVariables>(GetDoorProductsDocument, options);
        }
export type GetDoorProductsQueryHookResult = ReturnType<typeof useGetDoorProductsQuery>;
export type GetDoorProductsLazyQueryHookResult = ReturnType<typeof useGetDoorProductsLazyQuery>;
export type GetDoorProductsQueryResult = Apollo.QueryResult<GetDoorProductsQuery, GetDoorProductsQueryVariables>;
export const GetEhiFeatureAccessesDocument = gql`
    query GetEhiFeatureAccesses {
  ehiFeatureAccesses {
    id
    accessorType
    accessorId
    enabled
    identifier
  }
}
    `;

/**
 * __useGetEhiFeatureAccessesQuery__
 *
 * To run a query within a React component, call `useGetEhiFeatureAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEhiFeatureAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEhiFeatureAccessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEhiFeatureAccessesQuery(baseOptions?: Apollo.QueryHookOptions<GetEhiFeatureAccessesQuery, GetEhiFeatureAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEhiFeatureAccessesQuery, GetEhiFeatureAccessesQueryVariables>(GetEhiFeatureAccessesDocument, options);
      }
export function useGetEhiFeatureAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEhiFeatureAccessesQuery, GetEhiFeatureAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEhiFeatureAccessesQuery, GetEhiFeatureAccessesQueryVariables>(GetEhiFeatureAccessesDocument, options);
        }
export type GetEhiFeatureAccessesQueryHookResult = ReturnType<typeof useGetEhiFeatureAccessesQuery>;
export type GetEhiFeatureAccessesLazyQueryHookResult = ReturnType<typeof useGetEhiFeatureAccessesLazyQuery>;
export type GetEhiFeatureAccessesQueryResult = Apollo.QueryResult<GetEhiFeatureAccessesQuery, GetEhiFeatureAccessesQueryVariables>;
export const GetEhiOrgSettingsDocument = gql`
    query GetEhiOrgSettings {
  ehiOrgSettings {
    id
    showOrderingFlow
  }
}
    `;

/**
 * __useGetEhiOrgSettingsQuery__
 *
 * To run a query within a React component, call `useGetEhiOrgSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEhiOrgSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEhiOrgSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEhiOrgSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetEhiOrgSettingsQuery, GetEhiOrgSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEhiOrgSettingsQuery, GetEhiOrgSettingsQueryVariables>(GetEhiOrgSettingsDocument, options);
      }
export function useGetEhiOrgSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEhiOrgSettingsQuery, GetEhiOrgSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEhiOrgSettingsQuery, GetEhiOrgSettingsQueryVariables>(GetEhiOrgSettingsDocument, options);
        }
export type GetEhiOrgSettingsQueryHookResult = ReturnType<typeof useGetEhiOrgSettingsQuery>;
export type GetEhiOrgSettingsLazyQueryHookResult = ReturnType<typeof useGetEhiOrgSettingsLazyQuery>;
export type GetEhiOrgSettingsQueryResult = Apollo.QueryResult<GetEhiOrgSettingsQuery, GetEhiOrgSettingsQueryVariables>;
export const GetHdfDocument = gql`
    query GetHdf($jobId: Int!) {
  estimationSummarizedHdf(jobId: $jobId) @rest(type: "EstimationSummarizedHdf", path: "/api/v2/jobs/{args.jobId}/estimation_summarized_hdf.json") {
    data @type(name: "Hdf_{args.jobId}")
  }
}
    `;

/**
 * __useGetHdfQuery__
 *
 * To run a query within a React component, call `useGetHdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHdfQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetHdfQuery(baseOptions: Apollo.QueryHookOptions<GetHdfQuery, GetHdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHdfQuery, GetHdfQueryVariables>(GetHdfDocument, options);
      }
export function useGetHdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHdfQuery, GetHdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHdfQuery, GetHdfQueryVariables>(GetHdfDocument, options);
        }
export type GetHdfQueryHookResult = ReturnType<typeof useGetHdfQuery>;
export type GetHdfLazyQueryHookResult = ReturnType<typeof useGetHdfLazyQuery>;
export type GetHdfQueryResult = Apollo.QueryResult<GetHdfQuery, GetHdfQueryVariables>;
export const GetInspectionConfigChecklistTemplatesDocument = gql`
    query getInspectionConfigChecklistTemplates($orgId: ID!) {
  inspectionConfigChecklistTemplates(orgId: $orgId, first: 100) {
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetInspectionConfigChecklistTemplatesQuery__
 *
 * To run a query within a React component, call `useGetInspectionConfigChecklistTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionConfigChecklistTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionConfigChecklistTemplatesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetInspectionConfigChecklistTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetInspectionConfigChecklistTemplatesQuery, GetInspectionConfigChecklistTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectionConfigChecklistTemplatesQuery, GetInspectionConfigChecklistTemplatesQueryVariables>(GetInspectionConfigChecklistTemplatesDocument, options);
      }
export function useGetInspectionConfigChecklistTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectionConfigChecklistTemplatesQuery, GetInspectionConfigChecklistTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectionConfigChecklistTemplatesQuery, GetInspectionConfigChecklistTemplatesQueryVariables>(GetInspectionConfigChecklistTemplatesDocument, options);
        }
export type GetInspectionConfigChecklistTemplatesQueryHookResult = ReturnType<typeof useGetInspectionConfigChecklistTemplatesQuery>;
export type GetInspectionConfigChecklistTemplatesLazyQueryHookResult = ReturnType<typeof useGetInspectionConfigChecklistTemplatesLazyQuery>;
export type GetInspectionConfigChecklistTemplatesQueryResult = Apollo.QueryResult<GetInspectionConfigChecklistTemplatesQuery, GetInspectionConfigChecklistTemplatesQueryVariables>;
export const GetJobDocument = gql`
    query GetJob($id: Int!) {
  jobs(ids: [$id]) {
    results {
      id
      name
      state
      blueprint
      locationLine1
      locationLine2
      locationCity
      locationRegion
      locationPostalCode
      example
      images {
        id
        imageUrl
        imageSmallUrl
      }
      threeDFiles {
        geometryUrl
        metadataUrl
      }
      orgId
      partnerId
      canRequestRendering
      captureRequest {
        displayRequestingOrg {
          partnerId
          orgBrandLogoUrl
          customerDisplayName
        }
        requestingUser {
          orgs {
            results {
              id
              customerDisplayName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetJobHomeownerMeasurementsDocument = gql`
    query GetJobHomeownerMeasurements($id: Int!) {
  jobs(ids: [$id]) {
    results {
      state
      locationLine1
      locationLine2
      locationCity
      locationRegion
      locationPostalCode
      bestFrontImage {
        imageUrl
      }
      homeownerMeasurements {
        summaryJson
        fullJson
        singleLineAddress
      }
      orgId
      partnerId
      threeDFiles {
        geometryUrl
        metadataUrl
      }
    }
  }
}
    `;

/**
 * __useGetJobHomeownerMeasurementsQuery__
 *
 * To run a query within a React component, call `useGetJobHomeownerMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobHomeownerMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobHomeownerMeasurementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobHomeownerMeasurementsQuery(baseOptions: Apollo.QueryHookOptions<GetJobHomeownerMeasurementsQuery, GetJobHomeownerMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobHomeownerMeasurementsQuery, GetJobHomeownerMeasurementsQueryVariables>(GetJobHomeownerMeasurementsDocument, options);
      }
export function useGetJobHomeownerMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobHomeownerMeasurementsQuery, GetJobHomeownerMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobHomeownerMeasurementsQuery, GetJobHomeownerMeasurementsQueryVariables>(GetJobHomeownerMeasurementsDocument, options);
        }
export type GetJobHomeownerMeasurementsQueryHookResult = ReturnType<typeof useGetJobHomeownerMeasurementsQuery>;
export type GetJobHomeownerMeasurementsLazyQueryHookResult = ReturnType<typeof useGetJobHomeownerMeasurementsLazyQuery>;
export type GetJobHomeownerMeasurementsQueryResult = Apollo.QueryResult<GetJobHomeownerMeasurementsQuery, GetJobHomeownerMeasurementsQueryVariables>;
export const GetJobPaintMeasurementsDocument = gql`
    query GetJobPaintMeasurements($id: Int!) {
  jobs(ids: [$id]) {
    results {
      state
      locationLine1
      locationLine2
      locationCity
      locationRegion
      locationPostalCode
      bestFrontImage {
        imageUrl
      }
      measurements {
        paintMeasurements {
          summaryJson
          fullJson
          singleLineAddress
        }
      }
      orgId
      partnerId
      threeDFiles {
        geometryUrl
        metadataUrl
      }
    }
  }
}
    `;

/**
 * __useGetJobPaintMeasurementsQuery__
 *
 * To run a query within a React component, call `useGetJobPaintMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPaintMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPaintMeasurementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPaintMeasurementsQuery(baseOptions: Apollo.QueryHookOptions<GetJobPaintMeasurementsQuery, GetJobPaintMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPaintMeasurementsQuery, GetJobPaintMeasurementsQueryVariables>(GetJobPaintMeasurementsDocument, options);
      }
export function useGetJobPaintMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPaintMeasurementsQuery, GetJobPaintMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPaintMeasurementsQuery, GetJobPaintMeasurementsQueryVariables>(GetJobPaintMeasurementsDocument, options);
        }
export type GetJobPaintMeasurementsQueryHookResult = ReturnType<typeof useGetJobPaintMeasurementsQuery>;
export type GetJobPaintMeasurementsLazyQueryHookResult = ReturnType<typeof useGetJobPaintMeasurementsLazyQuery>;
export type GetJobPaintMeasurementsQueryResult = Apollo.QueryResult<GetJobPaintMeasurementsQuery, GetJobPaintMeasurementsQueryVariables>;
export const GetManufacturerPreferencesDocument = gql`
    query GetManufacturerPreferences($id: Int!) {
  jobs(ids: [$id]) {
    results {
      captureRequest {
        displayRequestingOrg {
          id
          manufacturerIds
        }
      }
    }
  }
}
    `;

/**
 * __useGetManufacturerPreferencesQuery__
 *
 * To run a query within a React component, call `useGetManufacturerPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturerPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturerPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManufacturerPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetManufacturerPreferencesQuery, GetManufacturerPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManufacturerPreferencesQuery, GetManufacturerPreferencesQueryVariables>(GetManufacturerPreferencesDocument, options);
      }
export function useGetManufacturerPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManufacturerPreferencesQuery, GetManufacturerPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManufacturerPreferencesQuery, GetManufacturerPreferencesQueryVariables>(GetManufacturerPreferencesDocument, options);
        }
export type GetManufacturerPreferencesQueryHookResult = ReturnType<typeof useGetManufacturerPreferencesQuery>;
export type GetManufacturerPreferencesLazyQueryHookResult = ReturnType<typeof useGetManufacturerPreferencesLazyQuery>;
export type GetManufacturerPreferencesQueryResult = Apollo.QueryResult<GetManufacturerPreferencesQuery, GetManufacturerPreferencesQueryVariables>;
export const GetProductVariationsDocument = gql`
    query getProductVariations($variationIds: [ID!]) {
  productCatalogVariations(ids: $variationIds) {
    nodes {
      product {
        provider {
          name
        }
        groupings {
          name
        }
        name
        displayName
        manufacturerUrl
        labelId
        label {
          name
        }
      }
      name
      id
      color {
        name
        hex
      }
      variationFacets {
        facetType
        value
      }
      texture {
        name
        diffuseMapThumbnail {
          redirectUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductVariationsQuery__
 *
 * To run a query within a React component, call `useGetProductVariationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVariationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVariationsQuery({
 *   variables: {
 *      variationIds: // value for 'variationIds'
 *   },
 * });
 */
export function useGetProductVariationsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductVariationsQuery, GetProductVariationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductVariationsQuery, GetProductVariationsQueryVariables>(GetProductVariationsDocument, options);
      }
export function useGetProductVariationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductVariationsQuery, GetProductVariationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductVariationsQuery, GetProductVariationsQueryVariables>(GetProductVariationsDocument, options);
        }
export type GetProductVariationsQueryHookResult = ReturnType<typeof useGetProductVariationsQuery>;
export type GetProductVariationsLazyQueryHookResult = ReturnType<typeof useGetProductVariationsLazyQuery>;
export type GetProductVariationsQueryResult = Apollo.QueryResult<GetProductVariationsQuery, GetProductVariationsQueryVariables>;
export const GetProductionListDocument = gql`
    query getProductionList($jobId: ID!, $orgId: ID!) {
  projectManagementProductionList(jobId: $jobId, orgId: $orgId) {
    id
    updatedAt
    name
    totalCost
    integrationManuallySynced
    integrationLastManuallySyncedAt
    estimateGroup {
      estimates(active: true) {
        template {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductionListQuery__
 *
 * To run a query within a React component, call `useGetProductionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionListQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProductionListQuery(baseOptions: Apollo.QueryHookOptions<GetProductionListQuery, GetProductionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionListQuery, GetProductionListQueryVariables>(GetProductionListDocument, options);
      }
export function useGetProductionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionListQuery, GetProductionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionListQuery, GetProductionListQueryVariables>(GetProductionListDocument, options);
        }
export type GetProductionListQueryHookResult = ReturnType<typeof useGetProductionListQuery>;
export type GetProductionListLazyQueryHookResult = ReturnType<typeof useGetProductionListLazyQuery>;
export type GetProductionListQueryResult = Apollo.QueryResult<GetProductionListQuery, GetProductionListQueryVariables>;
export const GetProductionListByIdDocument = gql`
    query getProductionListById($productionListId: ID!) {
  projectManagementProductionListById(id: $productionListId) {
    id
    updatedAt
    name
    totalCost
    estimateGroup {
      estimates(active: true) {
        template {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductionListByIdQuery__
 *
 * To run a query within a React component, call `useGetProductionListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionListByIdQuery({
 *   variables: {
 *      productionListId: // value for 'productionListId'
 *   },
 * });
 */
export function useGetProductionListByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductionListByIdQuery, GetProductionListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionListByIdQuery, GetProductionListByIdQueryVariables>(GetProductionListByIdDocument, options);
      }
export function useGetProductionListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionListByIdQuery, GetProductionListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionListByIdQuery, GetProductionListByIdQueryVariables>(GetProductionListByIdDocument, options);
        }
export type GetProductionListByIdQueryHookResult = ReturnType<typeof useGetProductionListByIdQuery>;
export type GetProductionListByIdLazyQueryHookResult = ReturnType<typeof useGetProductionListByIdLazyQuery>;
export type GetProductionListByIdQueryResult = Apollo.QueryResult<GetProductionListByIdQuery, GetProductionListByIdQueryVariables>;
export const GetProductionListsDocument = gql`
    query getProductionLists($jobId: ID!, $orgId: ID!) {
  projectManagementProductionLists(jobId: $jobId, orgId: $orgId) {
    nodes {
      id
      updatedAt
      name
      integrationManuallySynced
      integrationLastManuallySyncedAt
      integrationExternalLabel
      totalCost
      estimateGroup {
        estimates(active: true) {
          template {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductionListsQuery__
 *
 * To run a query within a React component, call `useGetProductionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionListsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetProductionListsQuery(baseOptions: Apollo.QueryHookOptions<GetProductionListsQuery, GetProductionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionListsQuery, GetProductionListsQueryVariables>(GetProductionListsDocument, options);
      }
export function useGetProductionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionListsQuery, GetProductionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionListsQuery, GetProductionListsQueryVariables>(GetProductionListsDocument, options);
        }
export type GetProductionListsQueryHookResult = ReturnType<typeof useGetProductionListsQuery>;
export type GetProductionListsLazyQueryHookResult = ReturnType<typeof useGetProductionListsLazyQuery>;
export type GetProductionListsQueryResult = Apollo.QueryResult<GetProductionListsQuery, GetProductionListsQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($activeOnly: Boolean, $filterByOrg: Boolean, $labelIds: [ID!], $after: String) {
  productCatalogProducts(
    activeOnly: $activeOnly
    filterByOrg: $filterByOrg
    labelIds: $labelIds
    after: $after
  ) {
    nodes {
      id
      legacyId
      name
      productType
      labelId
      variations {
        textureId
        legacyId
        id
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      filterByOrg: // value for 'filterByOrg'
 *      labelIds: // value for 'labelIds'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($projectId: Int!) {
  project(id: $projectId) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectShareDocument = gql`
    query GetProjectShare($id: ID!) {
  projectShare(id: $id) {
    id
    createdAt
    orgId
    orgBrandLogoUrl
    shareCtaPath
    creatingUser {
      name
      email
      phone
    }
    aiDisplayImages {
      id
      spaceType
      aiOriginalImageId
      createdFrom
      aiGeneratedImage {
        ...AiGeneratedImage
        watermarkImageUrl
      }
      aiOriginalImage {
        id
        originalImagePath
        image
        imagePath
        spaceType
        inputPath
        isSample
      }
    }
  }
}
    ${AiGeneratedImageFragmentDoc}`;

/**
 * __useGetProjectShareQuery__
 *
 * To run a query within a React component, call `useGetProjectShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectShareQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectShareQuery(baseOptions: Apollo.QueryHookOptions<GetProjectShareQuery, GetProjectShareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectShareQuery, GetProjectShareQueryVariables>(GetProjectShareDocument, options);
      }
export function useGetProjectShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectShareQuery, GetProjectShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectShareQuery, GetProjectShareQueryVariables>(GetProjectShareDocument, options);
        }
export type GetProjectShareQueryHookResult = ReturnType<typeof useGetProjectShareQuery>;
export type GetProjectShareLazyQueryHookResult = ReturnType<typeof useGetProjectShareLazyQuery>;
export type GetProjectShareQueryResult = Apollo.QueryResult<GetProjectShareQuery, GetProjectShareQueryVariables>;
export const GetProjectsDocument = gql`
    query GetProjects {
  projects {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetRenderingDocument = gql`
    query GetRendering($id: ID!) {
  getHiDefRendering(hiDefRenderingId: $id) {
    id
    name
    uuid
    viewedAt
    versions {
      id
      hiDefRenderingFiles {
        id
        textureScale
        cryptomatteRegions {
          v
          regions {
            regionId
            category
          }
        }
        uvPass {
          id
          blobUrl
        }
        combinedLightingPass {
          id
          blobUrl
        }
        cryptomattePass {
          id
          blobUrl
        }
        image {
          id
          blobUrl
          thumbUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetRenderingQuery__
 *
 * To run a query within a React component, call `useGetRenderingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRenderingQuery(baseOptions: Apollo.QueryHookOptions<GetRenderingQuery, GetRenderingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderingQuery, GetRenderingQueryVariables>(GetRenderingDocument, options);
      }
export function useGetRenderingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderingQuery, GetRenderingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderingQuery, GetRenderingQueryVariables>(GetRenderingDocument, options);
        }
export type GetRenderingQueryHookResult = ReturnType<typeof useGetRenderingQuery>;
export type GetRenderingLazyQueryHookResult = ReturnType<typeof useGetRenderingLazyQuery>;
export type GetRenderingQueryResult = Apollo.QueryResult<GetRenderingQuery, GetRenderingQueryVariables>;
export const GetRenderingsDocument = gql`
    query GetRenderings($id: Int!) {
  jobs(ids: [$id]) {
    results {
      id
      name
      state
      locationLine1
      locationLine2
      locationCity
      locationRegion
      locationPostalCode
      example
      images {
        id
        imageUrl
        imageSmallUrl
      }
      hiDefRenderings {
        id
        name
        uuid
        canCreateRevision
        viewedAt
        versions {
          id
          state
          requestFormUrl
          submissionUrl
          versionType
          hiDefRenderingFiles {
            id
            image {
              id
              blobUrl
              thumbUrl
            }
            uvPass {
              id
              blobUrl
            }
            combinedLightingPass {
              id
              blobUrl
            }
            cryptomattePass {
              id
              blobUrl
            }
            productVariations {
              productCatalogVariationUuid
            }
          }
        }
      }
      orgId
      partnerId
      canRequestRendering
      captureRequest {
        displayRequestingOrg {
          partnerId
          orgBrandLogoUrl
          customerDisplayName
        }
        requestingUser {
          orgs {
            results {
              id
              customerDisplayName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRenderingsQuery__
 *
 * To run a query within a React component, call `useGetRenderingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRenderingsQuery(baseOptions: Apollo.QueryHookOptions<GetRenderingsQuery, GetRenderingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderingsQuery, GetRenderingsQueryVariables>(GetRenderingsDocument, options);
      }
export function useGetRenderingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderingsQuery, GetRenderingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderingsQuery, GetRenderingsQueryVariables>(GetRenderingsDocument, options);
        }
export type GetRenderingsQueryHookResult = ReturnType<typeof useGetRenderingsQuery>;
export type GetRenderingsLazyQueryHookResult = ReturnType<typeof useGetRenderingsLazyQuery>;
export type GetRenderingsQueryResult = Apollo.QueryResult<GetRenderingsQuery, GetRenderingsQueryVariables>;
export const GetScansDocument = gql`
    query GetScans($archived: Boolean) {
  jobs(archived: $archived) {
    results {
      ...BasicJobInfo
    }
  }
}
    ${BasicJobInfoFragmentDoc}`;

/**
 * __useGetScansQuery__
 *
 * To run a query within a React component, call `useGetScansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScansQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetScansQuery(baseOptions?: Apollo.QueryHookOptions<GetScansQuery, GetScansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScansQuery, GetScansQueryVariables>(GetScansDocument, options);
      }
export function useGetScansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScansQuery, GetScansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScansQuery, GetScansQueryVariables>(GetScansDocument, options);
        }
export type GetScansQueryHookResult = ReturnType<typeof useGetScansQuery>;
export type GetScansLazyQueryHookResult = ReturnType<typeof useGetScansLazyQuery>;
export type GetScansQueryResult = Apollo.QueryResult<GetScansQuery, GetScansQueryVariables>;
export const GetSharedJobPaintMeasurementsDocument = gql`
    query GetSharedJobPaintMeasurements($id: Int!, $shareToken: String!) {
  jobSharedPaintMeasurements(jobId: $id, shareToken: $shareToken) {
    paintMeasurements {
      fullJson
      summaryJson
      singleLineAddress
    }
    jobThreeDFiles {
      geometryUrl
      metadataUrl
    }
  }
}
    `;

/**
 * __useGetSharedJobPaintMeasurementsQuery__
 *
 * To run a query within a React component, call `useGetSharedJobPaintMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedJobPaintMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedJobPaintMeasurementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shareToken: // value for 'shareToken'
 *   },
 * });
 */
export function useGetSharedJobPaintMeasurementsQuery(baseOptions: Apollo.QueryHookOptions<GetSharedJobPaintMeasurementsQuery, GetSharedJobPaintMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedJobPaintMeasurementsQuery, GetSharedJobPaintMeasurementsQueryVariables>(GetSharedJobPaintMeasurementsDocument, options);
      }
export function useGetSharedJobPaintMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedJobPaintMeasurementsQuery, GetSharedJobPaintMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedJobPaintMeasurementsQuery, GetSharedJobPaintMeasurementsQueryVariables>(GetSharedJobPaintMeasurementsDocument, options);
        }
export type GetSharedJobPaintMeasurementsQueryHookResult = ReturnType<typeof useGetSharedJobPaintMeasurementsQuery>;
export type GetSharedJobPaintMeasurementsLazyQueryHookResult = ReturnType<typeof useGetSharedJobPaintMeasurementsLazyQuery>;
export type GetSharedJobPaintMeasurementsQueryResult = Apollo.QueryResult<GetSharedJobPaintMeasurementsQuery, GetSharedJobPaintMeasurementsQueryVariables>;
export const GetTreatmentDocument = gql`
    query GetTreatment($flagName: String!) {
  getTreatment(flagName: $flagName) @client
}
    `;

/**
 * __useGetTreatmentQuery__
 *
 * To run a query within a React component, call `useGetTreatmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatmentQuery({
 *   variables: {
 *      flagName: // value for 'flagName'
 *   },
 * });
 */
export function useGetTreatmentQuery(baseOptions: Apollo.QueryHookOptions<GetTreatmentQuery, GetTreatmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreatmentQuery, GetTreatmentQueryVariables>(GetTreatmentDocument, options);
      }
export function useGetTreatmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreatmentQuery, GetTreatmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreatmentQuery, GetTreatmentQueryVariables>(GetTreatmentDocument, options);
        }
export type GetTreatmentQueryHookResult = ReturnType<typeof useGetTreatmentQuery>;
export type GetTreatmentLazyQueryHookResult = ReturnType<typeof useGetTreatmentLazyQuery>;
export type GetTreatmentQueryResult = Apollo.QueryResult<GetTreatmentQuery, GetTreatmentQueryVariables>;
export const GetTreatmentWithConfigDocument = gql`
    query GetTreatmentWithConfig($flagName: String!) {
  getTreatmentWithConfig(flagName: $flagName) @client {
    treatment
    config
  }
}
    `;

/**
 * __useGetTreatmentWithConfigQuery__
 *
 * To run a query within a React component, call `useGetTreatmentWithConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatmentWithConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatmentWithConfigQuery({
 *   variables: {
 *      flagName: // value for 'flagName'
 *   },
 * });
 */
export function useGetTreatmentWithConfigQuery(baseOptions: Apollo.QueryHookOptions<GetTreatmentWithConfigQuery, GetTreatmentWithConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreatmentWithConfigQuery, GetTreatmentWithConfigQueryVariables>(GetTreatmentWithConfigDocument, options);
      }
export function useGetTreatmentWithConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreatmentWithConfigQuery, GetTreatmentWithConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreatmentWithConfigQuery, GetTreatmentWithConfigQueryVariables>(GetTreatmentWithConfigDocument, options);
        }
export type GetTreatmentWithConfigQueryHookResult = ReturnType<typeof useGetTreatmentWithConfigQuery>;
export type GetTreatmentWithConfigLazyQueryHookResult = ReturnType<typeof useGetTreatmentWithConfigLazyQuery>;
export type GetTreatmentWithConfigQueryResult = Apollo.QueryResult<GetTreatmentWithConfigQuery, GetTreatmentWithConfigQueryVariables>;
export const HomeownerProfileDocument = gql`
    query HomeownerProfile {
  profile {
    user {
      intercomSha
      email
      name
      firstName
      lastName
      id
      profilePictureUrl
    }
  }
}
    `;

/**
 * __useHomeownerProfileQuery__
 *
 * To run a query within a React component, call `useHomeownerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownerProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeownerProfileQuery(baseOptions?: Apollo.QueryHookOptions<HomeownerProfileQuery, HomeownerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeownerProfileQuery, HomeownerProfileQueryVariables>(HomeownerProfileDocument, options);
      }
export function useHomeownerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeownerProfileQuery, HomeownerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeownerProfileQuery, HomeownerProfileQueryVariables>(HomeownerProfileDocument, options);
        }
export type HomeownerProfileQueryHookResult = ReturnType<typeof useHomeownerProfileQuery>;
export type HomeownerProfileLazyQueryHookResult = ReturnType<typeof useHomeownerProfileLazyQuery>;
export type HomeownerProfileQueryResult = Apollo.QueryResult<HomeownerProfileQuery, HomeownerProfileQueryVariables>;
export const InspectionChecklistsDocument = gql`
    query inspectionChecklists($jobId: ID!) {
  inspectionChecklists(jobId: $jobId) {
    nodes {
      ...InspectionChecklist
    }
  }
}
    ${InspectionChecklistFragmentDoc}`;

/**
 * __useInspectionChecklistsQuery__
 *
 * To run a query within a React component, call `useInspectionChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionChecklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionChecklistsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useInspectionChecklistsQuery(baseOptions: Apollo.QueryHookOptions<InspectionChecklistsQuery, InspectionChecklistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionChecklistsQuery, InspectionChecklistsQueryVariables>(InspectionChecklistsDocument, options);
      }
export function useInspectionChecklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionChecklistsQuery, InspectionChecklistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionChecklistsQuery, InspectionChecklistsQueryVariables>(InspectionChecklistsDocument, options);
        }
export type InspectionChecklistsQueryHookResult = ReturnType<typeof useInspectionChecklistsQuery>;
export type InspectionChecklistsLazyQueryHookResult = ReturnType<typeof useInspectionChecklistsLazyQuery>;
export type InspectionChecklistsQueryResult = Apollo.QueryResult<InspectionChecklistsQuery, InspectionChecklistsQueryVariables>;
export const JobSharedRenderingsDocument = gql`
    query JobSharedRenderings($shareToken: String!) {
  jobSharedRenderings(shareToken: $shareToken) {
    id
    orgId
    partnerId
    userId
    hiDefRenderings {
      id
      viewedAt
      versions {
        id
        state
        versionType
        hiDefRenderingFiles {
          id
          image {
            id
            blobUrl
            thumbUrl
          }
          productVariations {
            productCatalogVariationUuid
          }
        }
      }
    }
    captureRequest {
      displayRequestingOrg {
        orgBrandLogoUrl
        customerDisplayName
      }
    }
  }
}
    `;

/**
 * __useJobSharedRenderingsQuery__
 *
 * To run a query within a React component, call `useJobSharedRenderingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSharedRenderingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSharedRenderingsQuery({
 *   variables: {
 *      shareToken: // value for 'shareToken'
 *   },
 * });
 */
export function useJobSharedRenderingsQuery(baseOptions: Apollo.QueryHookOptions<JobSharedRenderingsQuery, JobSharedRenderingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSharedRenderingsQuery, JobSharedRenderingsQueryVariables>(JobSharedRenderingsDocument, options);
      }
export function useJobSharedRenderingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSharedRenderingsQuery, JobSharedRenderingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSharedRenderingsQuery, JobSharedRenderingsQueryVariables>(JobSharedRenderingsDocument, options);
        }
export type JobSharedRenderingsQueryHookResult = ReturnType<typeof useJobSharedRenderingsQuery>;
export type JobSharedRenderingsLazyQueryHookResult = ReturnType<typeof useJobSharedRenderingsLazyQuery>;
export type JobSharedRenderingsQueryResult = Apollo.QueryResult<JobSharedRenderingsQuery, JobSharedRenderingsQueryVariables>;
export const JobSharedThreeDFilesDocument = gql`
    query JobSharedThreeDFiles($jobId: Int!, $shareToken: String!) {
  jobSharedThreeDFiles(jobId: $jobId, shareToken: $shareToken) {
    geometryUrl
    metadataUrl
    authToken
  }
}
    `;

/**
 * __useJobSharedThreeDFilesQuery__
 *
 * To run a query within a React component, call `useJobSharedThreeDFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSharedThreeDFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSharedThreeDFilesQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      shareToken: // value for 'shareToken'
 *   },
 * });
 */
export function useJobSharedThreeDFilesQuery(baseOptions: Apollo.QueryHookOptions<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>(JobSharedThreeDFilesDocument, options);
      }
export function useJobSharedThreeDFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>(JobSharedThreeDFilesDocument, options);
        }
export type JobSharedThreeDFilesQueryHookResult = ReturnType<typeof useJobSharedThreeDFilesQuery>;
export type JobSharedThreeDFilesLazyQueryHookResult = ReturnType<typeof useJobSharedThreeDFilesLazyQuery>;
export type JobSharedThreeDFilesQueryResult = Apollo.QueryResult<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>;
export const JobWithRenderingsDocument = gql`
    query JobWithRenderings($id: Int!, $useHiDefRenderings: Boolean = false) {
  jobs(ids: [$id]) {
    results {
      ...JobHiDefRenderings_JobFragment @include(if: $useHiDefRenderings)
      canRequestRendering
    }
  }
}
    ${JobHiDefRenderings_JobFragmentFragmentDoc}`;

/**
 * __useJobWithRenderingsQuery__
 *
 * To run a query within a React component, call `useJobWithRenderingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobWithRenderingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobWithRenderingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useHiDefRenderings: // value for 'useHiDefRenderings'
 *   },
 * });
 */
export function useJobWithRenderingsQuery(baseOptions: Apollo.QueryHookOptions<JobWithRenderingsQuery, JobWithRenderingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobWithRenderingsQuery, JobWithRenderingsQueryVariables>(JobWithRenderingsDocument, options);
      }
export function useJobWithRenderingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobWithRenderingsQuery, JobWithRenderingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobWithRenderingsQuery, JobWithRenderingsQueryVariables>(JobWithRenderingsDocument, options);
        }
export type JobWithRenderingsQueryHookResult = ReturnType<typeof useJobWithRenderingsQuery>;
export type JobWithRenderingsLazyQueryHookResult = ReturnType<typeof useJobWithRenderingsLazyQuery>;
export type JobWithRenderingsQueryResult = Apollo.QueryResult<JobWithRenderingsQuery, JobWithRenderingsQueryVariables>;
export const OrgManufacturerIdsDocument = gql`
    query OrgManufacturerIds {
  profile {
    user {
      id
      orgs(first: 1) {
        manufacturerIds
        isManaged
        partner {
          id
          kind
          identifier
          name
        }
      }
    }
  }
}
    `;

/**
 * __useOrgManufacturerIdsQuery__
 *
 * To run a query within a React component, call `useOrgManufacturerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgManufacturerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgManufacturerIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgManufacturerIdsQuery(baseOptions?: Apollo.QueryHookOptions<OrgManufacturerIdsQuery, OrgManufacturerIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgManufacturerIdsQuery, OrgManufacturerIdsQueryVariables>(OrgManufacturerIdsDocument, options);
      }
export function useOrgManufacturerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgManufacturerIdsQuery, OrgManufacturerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgManufacturerIdsQuery, OrgManufacturerIdsQueryVariables>(OrgManufacturerIdsDocument, options);
        }
export type OrgManufacturerIdsQueryHookResult = ReturnType<typeof useOrgManufacturerIdsQuery>;
export type OrgManufacturerIdsLazyQueryHookResult = ReturnType<typeof useOrgManufacturerIdsLazyQuery>;
export type OrgManufacturerIdsQueryResult = Apollo.QueryResult<OrgManufacturerIdsQuery, OrgManufacturerIdsQueryVariables>;
export const ProfileDocument = gql`
    query Profile {
  profile {
    user {
      id
      email
      name
      firstName
      lastName
      createdAt
      activeCommerceProduct
      isHomeowner
      officePhone
      mobilePhone
      intercomSha
      locale
      orgs(first: 1) {
        id
        createdAt
        name
        onWaitlist
        custServCity
        custServLine1
        custServLine2
        custServPostalCode
        custServRegion
        custServPhone
        priority
        isManaged
        wallet {
          id
          billingAddressCity
          billingAddressRegion
          billingAddressPostalCode
          billingAddressLine1
          billingAddressLine2
          billingEmail
          totalBalance
        }
        partner {
          id
          kind
          identifier
          name
        }
        featureAccesses {
          identifier
          accessorId
          accessorType
          enabled
          id
        }
        availableDeliverables {
          id
          name
        }
        preSelectCaptureOnlyForUsers
        ownWalletBillable
        billableWallets {
          walletId
          org {
            customerDisplayName
            externalIdentifierStrictValidation
            name
          }
          partnerAccountIdentifiers {
            accountId
            id
          }
          externalIdentifierPatterns {
            content
            id
          }
        }
        brand {
          placesLogoUrl
          primaryColor
          secondaryColor
          logoUrl
        }
        paymentBanner {
          body
          title
          kind
        }
        preferences {
          externalIdentifierLabel
          externalIdentifierRequired
        }
      }
      aclAccesses {
        id
        orgId
        aclTemplate
      }
    }
    impersonator {
      userId
      userEmail
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const PropertiesDocument = gql`
    query Properties($filters: [JobSearchFilters!], $jobTypes: [JobTypeFilters!], $deliverableIds: [ID!] = [], $page: Int, $perPage: Int, $search: String, $viewableBy: JobsViewableBy, $orgId: ID!, $example: Boolean, $archived: Boolean, $sortOrder: JobSortOrder, $createdAfter: ISO8601DateTime, $createdBefore: ISO8601DateTime, $creatorIds: [ID!], $inJobGroup: ID) {
  jobs(
    filters: $filters
    jobTypes: $jobTypes
    deliverableIds: $deliverableIds
    page: $page
    perPage: $perPage
    search: $search
    viewableBy: $viewableBy
    example: $example
    archived: $archived
    sortOrder: $sortOrder
    createdAfter: $createdAfter
    createdBefore: $createdBefore
    creatorIds: $creatorIds
    inJobGroup: $inJobGroup
  ) {
    results {
      id
      archived
      approved
      approvedAt
      name
      state
      blueprint
      locationLine1
      locationLine2
      locationCity
      locationRegion
      locationPostalCode
      lastPaymentFailed
      example
      createdAt
      createdBy {
        email
        firstName
        lastName
        id
      }
      captureType
      captureRequest {
        id
        state
      }
      bestFrontImage {
        id
        imageUrl
        imageSmallUrl
        rotatedImageMediumUrl
      }
      orgId
      partnerId
      jobGroups {
        name
        id
      }
      deliverable {
        id
        name
      }
      deliverableChangeRequests {
        newDeliverable {
          id
        }
        state
        changedAt
      }
      hasInspectionChecklists(orgId: $orgId)
      failedRooms
      interiorFloorPlan
    }
    pagination {
      currentPage
      hasNextPage
    }
  }
}
    `;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      jobTypes: // value for 'jobTypes'
 *      deliverableIds: // value for 'deliverableIds'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      viewableBy: // value for 'viewableBy'
 *      orgId: // value for 'orgId'
 *      example: // value for 'example'
 *      archived: // value for 'archived'
 *      sortOrder: // value for 'sortOrder'
 *      createdAfter: // value for 'createdAfter'
 *      createdBefore: // value for 'createdBefore'
 *      creatorIds: // value for 'creatorIds'
 *      inJobGroup: // value for 'inJobGroup'
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const PropertyDetailsDocument = gql`
    query PropertyDetails($id: Int!, $useHiDefRenderings: Boolean = false, $usePaintMeasurements: Boolean = false) {
  jobs(ids: [$id]) {
    results {
      ...JobHiDefRenderings_JobFragment @include(if: $useHiDefRenderings)
      id
      jobAssignments {
        createdAt
        id
        kind
        shareJobMessage
        userId
        user {
          email
          firstName
          id
          lastName
        }
      }
      name
      modelingStatus
      blueprint
      clientIdentifier
      canAccessRendering
      canRequestRendering
      externalIdentifier
      is3dAvailable
      locationLine1
      locationLine2
      locationLon
      locationLat
      locationCity
      locationRegion
      locationPostalCode
      locationCountry
      state
      createdAt
      updatedAt
      estimatedCompletedAt
      archived
      approved
      blueprint
      example
      captureType
      canUpgrade
      manowarIdentifier
      lastPaymentFailed
      modelId
      virtualWalkthroughAvailable
      paymentOrg {
        onInvoicing
      }
      createdBy {
        firstName
        lastName
        email
      }
      fileAttachments {
        id
        url
        filename
      }
      interiorFloorPlan
      deliverable {
        id
        name
      }
      jobGroups {
        name
        jobsCount
        id
      }
      deliverableChangeRequests {
        newDeliverable {
          id
        }
        state
        changedAt
      }
      bestFrontImage {
        imageMediumUrl(withSignedUrl: false)
        rotatedImageMediumUrl(withSignedUrl: false)
        imageSmallUrl(withSignedUrl: false)
        rotatedImageSmallUrl(withSignedUrl: false)
      }
      currentUserContext {
        canApprove
        canArchive
        canUpdate
        captureRequestSentByMe
        captureRequestSentToMe
        createdByMe
        assignedToMe
        canChooseDeliverySpeed
      }
      exports {
        canAccessAdvancedExports
        canAccessEsx
        dxfUrl
        dwgUrl
        esxUrl
        skpUrl
      }
      paymentOrg {
        customerDisplayName
        externalIdentifierPatterns {
          id
          content
        }
        expeditedDeliverablesSettings {
          defaultDeliverySpeed
          deliverable {
            id
            name
          }
          deliverySpeeds
        }
        externalIdentifierStrictValidation
        name
        id
      }
      captureRequest {
        id
        identifier
        capturingUserName
        capturingUserEmail
        capturingUserPhone
        state
        branchLink
        requestingUser {
          id
          firstName
          lastName
          state
          email
          createdAt
          orgs {
            results {
              customerDisplayName
              onlyDesignProForCaptureRequest
            }
          }
        }
        displayRequestingOrg {
          customerDisplayName
          expeditedDeliverablesSettings {
            defaultDeliverySpeed
            deliverable {
              id
              name
            }
            deliverySpeeds
          }
          name
          id
        }
      }
      labels
      measurements {
        pdfUrl
        summarizedJsonUrl
        canAccessMeasurementExports
        symbilityXmlUrl
        xmlUrl
        sketchJsonUrl
        spreadsheetUrl
        paintMeasurements @include(if: $usePaintMeasurements) {
          summaryJson
          fullJson
        }
      }
      threeDFiles {
        metadataUrl
        geometryUrl
      }
      ...JobImagesFragment
      availableDeliverableUpgrades {
        id
        name
      }
      modelFailureReason
      notes {
        results {
          id
          user {
            firstName
            lastName
          }
          createdAt
          updatedAt
          body
          currentUserContext {
            canDeleteNote
            canUpdateNote
          }
        }
      }
      failedRooms
    }
  }
}
    ${JobHiDefRenderings_JobFragmentFragmentDoc}
${JobImagesFragmentFragmentDoc}`;

/**
 * __usePropertyDetailsQuery__
 *
 * To run a query within a React component, call `usePropertyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useHiDefRenderings: // value for 'useHiDefRenderings'
 *      usePaintMeasurements: // value for 'usePaintMeasurements'
 *   },
 * });
 */
export function usePropertyDetailsQuery(baseOptions: Apollo.QueryHookOptions<PropertyDetailsQuery, PropertyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyDetailsQuery, PropertyDetailsQueryVariables>(PropertyDetailsDocument, options);
      }
export function usePropertyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyDetailsQuery, PropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyDetailsQuery, PropertyDetailsQueryVariables>(PropertyDetailsDocument, options);
        }
export type PropertyDetailsQueryHookResult = ReturnType<typeof usePropertyDetailsQuery>;
export type PropertyDetailsLazyQueryHookResult = ReturnType<typeof usePropertyDetailsLazyQuery>;
export type PropertyDetailsQueryResult = Apollo.QueryResult<PropertyDetailsQuery, PropertyDetailsQueryVariables>;
export const PropertyDetailsPaintDocument = gql`
    query PropertyDetailsPaint($id: Int!) {
  jobs(ids: [$id]) {
    results {
      id
      name
      measurements {
        paintMeasurements {
          fullJson
        }
      }
      threeDFiles {
        metadataUrl
        geometryUrl
      }
    }
  }
}
    `;

/**
 * __usePropertyDetailsPaintQuery__
 *
 * To run a query within a React component, call `usePropertyDetailsPaintQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDetailsPaintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDetailsPaintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDetailsPaintQuery(baseOptions: Apollo.QueryHookOptions<PropertyDetailsPaintQuery, PropertyDetailsPaintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyDetailsPaintQuery, PropertyDetailsPaintQueryVariables>(PropertyDetailsPaintDocument, options);
      }
export function usePropertyDetailsPaintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyDetailsPaintQuery, PropertyDetailsPaintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyDetailsPaintQuery, PropertyDetailsPaintQueryVariables>(PropertyDetailsPaintDocument, options);
        }
export type PropertyDetailsPaintQueryHookResult = ReturnType<typeof usePropertyDetailsPaintQuery>;
export type PropertyDetailsPaintLazyQueryHookResult = ReturnType<typeof usePropertyDetailsPaintLazyQuery>;
export type PropertyDetailsPaintQueryResult = Apollo.QueryResult<PropertyDetailsPaintQuery, PropertyDetailsPaintQueryVariables>;
export const PublicOrgInfoDocument = gql`
    query PublicOrgInfo($publicIdentifier: String!) {
  publicOrgInfo(identifier: $publicIdentifier) {
    id
    displayName
    brandLogoUrl
  }
}
    `;

/**
 * __usePublicOrgInfoQuery__
 *
 * To run a query within a React component, call `usePublicOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOrgInfoQuery({
 *   variables: {
 *      publicIdentifier: // value for 'publicIdentifier'
 *   },
 * });
 */
export function usePublicOrgInfoQuery(baseOptions: Apollo.QueryHookOptions<PublicOrgInfoQuery, PublicOrgInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOrgInfoQuery, PublicOrgInfoQueryVariables>(PublicOrgInfoDocument, options);
      }
export function usePublicOrgInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOrgInfoQuery, PublicOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOrgInfoQuery, PublicOrgInfoQueryVariables>(PublicOrgInfoDocument, options);
        }
export type PublicOrgInfoQueryHookResult = ReturnType<typeof usePublicOrgInfoQuery>;
export type PublicOrgInfoLazyQueryHookResult = ReturnType<typeof usePublicOrgInfoLazyQuery>;
export type PublicOrgInfoQueryResult = Apollo.QueryResult<PublicOrgInfoQuery, PublicOrgInfoQueryVariables>;
export const SearchVariationsByTermDocument = gql`
    query SearchVariationsByTerm($searchTerm: String!) {
  productCatalogVariationSearch(searchTerm: $searchTerm, renderable: true) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useSearchVariationsByTermQuery__
 *
 * To run a query within a React component, call `useSearchVariationsByTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVariationsByTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVariationsByTermQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchVariationsByTermQuery(baseOptions: Apollo.QueryHookOptions<SearchVariationsByTermQuery, SearchVariationsByTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVariationsByTermQuery, SearchVariationsByTermQueryVariables>(SearchVariationsByTermDocument, options);
      }
export function useSearchVariationsByTermLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVariationsByTermQuery, SearchVariationsByTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVariationsByTermQuery, SearchVariationsByTermQueryVariables>(SearchVariationsByTermDocument, options);
        }
export type SearchVariationsByTermQueryHookResult = ReturnType<typeof useSearchVariationsByTermQuery>;
export type SearchVariationsByTermLazyQueryHookResult = ReturnType<typeof useSearchVariationsByTermLazyQuery>;
export type SearchVariationsByTermQueryResult = Apollo.QueryResult<SearchVariationsByTermQuery, SearchVariationsByTermQueryVariables>;
export const UpgradeProfileDocument = gql`
    query UpgradeProfile {
  profile {
    user {
      id
      email
      isHomeowner
      orgs(first: 1) {
        id
      }
    }
  }
}
    `;

/**
 * __useUpgradeProfileQuery__
 *
 * To run a query within a React component, call `useUpgradeProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpgradeProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpgradeProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpgradeProfileQuery(baseOptions?: Apollo.QueryHookOptions<UpgradeProfileQuery, UpgradeProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpgradeProfileQuery, UpgradeProfileQueryVariables>(UpgradeProfileDocument, options);
      }
export function useUpgradeProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpgradeProfileQuery, UpgradeProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpgradeProfileQuery, UpgradeProfileQueryVariables>(UpgradeProfileDocument, options);
        }
export type UpgradeProfileQueryHookResult = ReturnType<typeof useUpgradeProfileQuery>;
export type UpgradeProfileLazyQueryHookResult = ReturnType<typeof useUpgradeProfileLazyQuery>;
export type UpgradeProfileQueryResult = Apollo.QueryResult<UpgradeProfileQuery, UpgradeProfileQueryVariables>;